<template>
    <div>

        <!-- Onboarding checklist UI: render only after status is known AND a step is pending -->
        <div v-if="isOnboardingStatusLoaded && hasPendingOnboardingSteps && userType=='usertype02'">
            <!-- Checklist Icon -->
            <button type="button"
                    class="checklist-icon"
                    :class="{ 'is-dragging': isDragging, 'is-draggable': isDraggableViewport }"
                    :style="checklistPosition"
                    aria-label="Open onboarding checklist"
                    @click="handleChecklistClick"
                    @mouseenter="preloadChecklistFrame"
                    @focus="preloadChecklistFrame"
                    @touchstart.passive="onDragStart"
                    @touchmove.passive="onDragMove"
                    @touchend="onDragEnd"
                    @touchcancel="onDragEnd">
                <img class="checklist-icon__gif"
                     :src="checklistFloatGif"
                     alt=""
                     width="80"
                     height="80"
                     draggable="false" />
            </button>
            <!-- Checklist Window -->
            <div v-show="isChecklistOpen"
                 class="checklist-container"
                 :class="{ 'checklist-container--visible': isChecklistOpen }">
                <div class="checklist-header">
                    <div class="checklist-title-wrap">
                        <span class="checklist-header-icon" aria-hidden="true">
                            <i class="fa fa-list-check"></i>
                        </span>
                        <div>
                            <div class="title">Onboarding Checklist</div>
                            <small class="checklist-subtitle">Track and complete your onboarding tasks</small>
                        </div>
                    </div>
                    <button type="button" class="checklist-close-btn" @click="toggleChecklist" aria-label="Close checklist">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="checklist-body">
                    <div v-if="checklistFrameLoading" class="checklist-body__loading" aria-busy="true" aria-live="polite">
                        <div class="checklist-body__spinner"></div>
                        <span>Loading checklist…</span>
                    </div>
                    <iframe v-if="checklistFrameMounted"
                            v-show="checklistFrameLoaded"
                            ref="checklistFrame"
                            class="checklist-frame"
                            :src="checklistUrl"
                            title="Onboarding Checklist"
                            @load="onChecklistFrameLoad"></iframe>
                </div>
            </div>
        </div>
        <!-- Chat Icon -->
        <div class="chat-bot-icon"
             v-if="hasPurchasedAsset"
             :class="{ 'is-dragging': chatIsDragging, 'is-draggable': isDraggableViewport }"
             :style="chatBotPosition"
             @click="handleChatClick"
             @touchstart.passive="onChatDragStart"
             @touchmove.passive="onChatDragMove"
             @touchend="onChatDragEnd"
             @touchcancel="onChatDragEnd">
            <img src="../../assets/images/Robot.jpg" class="bot-icon" draggable="false" />
        </div>
        <!-- Chat Window -->
        <div class="chat-container" v-if="isOpen">

            <!-- HEADER -->
            <div class="chat-header">
                <img src="../../assets/images/Robot.jpg" class="bot-avatar">
                <div class="title">
                    👋Hello SpliytGenie!!
                    <span class="status">
                        <i class="online-dot"></i> Online Now
                    </span>
                </div>
                <button class="close-btn" @click="toggleChat">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <!-- MESSAGES -->
            <div class="chat-messages" ref="chatMessages">

                <div v-for="(msg, index) in messages" :key="index">

                    <!-- WELCOME -->
                    <!--<div v-if="msg.type === 'welcome'" class="welcome-card">
                        <img src="../../assets/images/Robot.jpg" class="welcome-bot-img">
                        <p>{{ msg.text }}</p>
                    </div>-->
                    <!-- WELCOME — always renders first if type === welcome -->
                    <div v-if="msg.type === 'welcome'" class="welcome-card">
                        <img src="../../assets/images/Robot.jpg" class="welcome-bot-img">
                        <div class="welcome-card-content">
                            <p>{{ msg.text }}</p>
                        </div>
                    </div>


                    <!-- BOT -->
                    <div v-else-if="msg.from === 'bot' && msg.type !== 'welcome'" class="message-row message bot">

                        <img src="../../assets/images/Robot.jpg" class="bot-avatar-msg">
                        <!-- Ticket Creation Restricted Card -->



                        <div v-if="msg.type === 'Hotel_search'" class="mainbasediv">
                            <div v-for="(hotel, hotelId) in groupedHotels(msg.payload)" :key="hotelId" class="hotel-card">
                                <div class="hotel-header">
                                    <h5>🏨 {{ hotel.hotel_name }}</h5>
                                    <p class="hotel-location">📍 {{ hotel.location }}</p>
                                    <p class="hotel-amenities">🎉 {{ hotel.amenities || 'Amenities not specified' }}</p>
                                </div>
                                <div :id="`carousel_${hotelId}`" class="carousel slide">
                                    <div class="carousel-inner">
                                        <div v-for="(room, i) in hotel.rooms" :key="i"
                                             class="carousel-item" :class="{ active: i === 0 }">
                                            <div class="room-info">
                                                <h6>{{ room.room_type }}</h6>
                                                <p>({{ room.bed_type }})</p>
                                                <p class="availability">Available: {{ room.availability === 1 ? 'YES' : 'NO' }}</p>
                                                <p class="price">💰 ${{ room.price }} / night</p>
                                            </div>
                                            <div class="room-images">
                                                <img v-for="(img, idx) in room.images" :key="idx"
                                                     :src="img" class="carousel-image"
                                                     @click="openImagePopup(img)" />
                                            </div>
                                            <button v-if="room.availability !== 1" class="btn-soldout">SOLD OUT</button>
                                            <button v-else class="btn-book"
                                                    @click="handleBookingClick(room, hotel)">
                                                Book now for ${{ room.price }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="msg.type === 'ticket_creation_restricted'" class="ticket-preview-card">
                            <div class="ticket-preview-header" style="background: linear-gradient(135deg, #dc2626, #991b1b);">
                                <span class="tp-icon">🚫</span>
                                <div>
                                    <h4>Ticket Creation Restricted</h4>
                                    <p>You are not authorized to create tickets.</p>
                                </div>
                                <span class="ticket-preview-number tp-error-badge">⛔ Restricted</span>
                            </div>
                            <div class="ticket-preview-body ticket-not-found-body">
                                <div class="ticket-not-found-icon">🔒</div>
                                <p class="ticket-not-found-title">Access Denied</p>
                                <p class="ticket-not-found-desc">
                                    {{ msg.payload?.response || 'You do not have permission to create tickets at this time.' }}
                                </p>
                                <div class="ticket-not-found-hint">
                                    💡 Please contact your administrator for assistance.
                                </div>
                            </div>
                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-failed">✖ Not Allowed</span>
                            </div>
                        </div>
                        <!-- View Meetings List Card -->
                        <!--Meeting flow html-->
                        <!-- 5. Meeting Preview (Success / Error) -->
                        <div v-else-if="msg.type === 'meeting_created' || msg.type === 'meeting_api_error'" class="meeting-preview-card">

                            <!-- HEADER -->
                            <div class="meeting-preview-header">
                                <span class="mp-icon">📅</span>
                                <div>
                                    <h4>{{ msg.type === 'meeting_api_error' ? 'Meeting Details' : 'Meeting Scheduled!' }}</h4>
                                    <p>{{ msg.type === 'meeting_api_error' ? 'Submission failed — see details below.' : 'Your meeting has been booked.' }}</p>
                                </div>
                                <!--<span v-if="msg.payload?.meeting_data?.meetingId" class="meeting-preview-number">
                                    #{{ msg.payload.meeting_data.meetingId }}
                                </span>-->
                            </div>

                            <!-- BODY -->
                            <div class="meeting-preview-body">

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Status</span>
                                    <span class="mp-value">
                                        <span v-if="msg.type === 'meeting_api_error'" class="mp-status-badge mp-status-failed">⚠ Failed</span>
                                        <span v-else class="mp-status-badge">✅ Submitted</span>
                                    </span>
                                </div>

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Title</span>
                                    <span class="mp-value">{{ msg.payload?.meeting_data?.meetingTitle || '—' }}</span>
                                </div>

                                <div class="meeting-preview-row" v-if="msg.payload?.meeting_data?.assetName">
                                    <span class="mp-label">Asset</span>
                                    <span class="mp-value">{{ msg.payload?.meeting_data?.assetName || '—' }}</span>
                                </div>

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Participants</span>
                                    <span class="mp-value">
                                        <template v-if="getMeetingParticipantsList(msg).length <= 5">
                                            <span v-for="(p, i) in getMeetingParticipantsList(msg)" :key="i" class="mp-participant-chip">
                                                {{ p }}
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span v-for="(p, i) in getMeetingParticipantsList(msg).slice(0, _expandedMeetingParticipants[messages.indexOf(msg)] ? undefined : 5)"
                                                  :key="i" class="mp-participant-chip">
                                                {{ p }}
                                            </span>
                                            <button class="mp-read-more-btn" @click="toggleMeetingParticipantsExpand(messages.indexOf(msg))">
                                                {{ _expandedMeetingParticipants[messages.indexOf(msg)] ? '▲ Show less' : `▼ +${getMeetingParticipantsList(msg).length - 5} more` }}
                                            </button>
                                        </template>
                                    </span>
                                </div>

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Date</span>
                                    <span class="mp-value">{{ formatDateMDY(msg.payload?.meeting_data?.meetingDateTime) || '—' }}</span>
                                </div>

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Time</span>
                                    <span class="mp-value">
                                        {{
 convertUTCToLocalTime(
            extractTimeFromDateTime(msg.payload?.meeting_data?.meetingDateTime),
            extractDateFromDateTime(msg.payload?.meeting_data?.meetingDateTime))
                                        }}
                                    </span>
                                </div>

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Duration</span>
                                    <span class="mp-value">
                                        {{ msg.payload?.meeting_data?.durationMinutes ? msg.payload.meeting_data.durationMinutes + ' minutes' : '—' }}
                                    </span>
                                </div>

                                <!-- <div class="meeting-preview-row">
                                    <span class="mp-label">Description</span>
                                    <span class="mp-value">{{ msg.payload?.meeting_data?.description || '—' }}</span>
                                </div>-->
                                <!-- <div class="meeting-preview-row">
                                    <span class="mp-label">Meeting ID</span>
                                    <span class="mp-value">{{ msg.payload?.meeting_data?.meetingId || '—' }}</span>
                                </div>-->

                                <div v-if="msg.payload?.meeting_data?.zoomJoinUrl" class="meeting-preview-row">
                                    <span class="mp-label">Join Link</span>
                                    <span class="mp-value">
                                        <a :href="msg.payload.meeting_data.zoomJoinUrl" target="_blank" class="mp-zoom-btn">
                                            🎥 Join Meeting
                                        </a>
                                    </span>
                                </div>

                            </div>

                            <!-- ERROR BLOCK -->
                            <div v-if="msg.type === 'meeting_api_error'" class="meeting-preview-error">
                                <span class="mp-err-icon">⚠️</span>
                                <p>
                                    <strong>Error:</strong> {{ msg.payload?.meeting_data?.api?.error || 'Submission failed.' }}
                                </p>
                            </div>

                            <!-- FOOTER -->
                            <div class="meeting-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span v-if="msg.type === 'meeting_api_error'" class="mp-failed">✖ Not Submitted</span>
                                <span v-else class="mp-check">✅ Submitted</span>
                            </div>
                        </div>
                        <div v-else-if="msg.type === 'view_meetings'" class="meeting-preview-card">

                            <!-- HEADER -->
                            <div class="meeting-preview-header">
                                <span class="mp-icon">📅</span>
                                <div>
                                    <h4>{{ msg.payload?.meeting_data?.heading || 'Scheduled Meetings' }}</h4>
                                    <p>{{ (msg.payload?.meeting_data?.meetings || []).length }} meeting{{ (msg.payload?.meeting_data?.meetings || []).length !== 1 ? 's' : '' }} found</p>
                                </div>
                            </div>

                            <!-- EMPTY STATE -->
                            <div v-if="!msg.payload?.meeting_data?.meetings?.length"
                                 class="meeting-preview-body"
                                 style="text-align:center; padding:30px 20px; color:#94a3b8; font-size:14px;">
                                📭 No meetings scheduled for this period.
                            </div>

                            <!-- MEETING LIST -->
                            <div v-for="(meeting, i) in msg.payload.meeting_data.meetings"
                                 :key="i"
                                 class="meeting-list-item"
                                 :style="i < msg.payload.meeting_data.meetings.length - 1 ? 'border-bottom: 1px solid #f0f0f0;' : ''">

                                <div class="ml-item-header">
                                    <div class="ml-item-main">
                                        <strong class="ml-item-title">{{ meeting.title || 'Untitled Meeting' }}</strong>
                                        <span class="ml-item-time">

                                            📅 {{meeting.start_time_utc }} &nbsp;
                                            <!-- ✅ Status badge inline -->
                                            <span style="display:contents" :style="getMeetingStatusStyle(meeting.status)">
                                                {{ getMeetingStatusLabel(meeting.status) }}
                                            </span>
                                        </span>
                                    </div>
                                    <button class="ml-toggle-btn"
                                            @click="toggleMeetingListItem(msg, i)">
                                        {{ isMeetingListItemOpen(msg, i) ? '▲ Hide' : '▼ Details' }}
                                    </button>
                                </div>

                                <!-- Expandable Details -->
                                <div v-if="isMeetingListItemOpen(msg, i)" class="ml-item-details">

                                    <div class="meeting-preview-row" style="padding:4px 0; border:none;">
                                        <span class="mp-label">Asset</span>
                                        <span class="mp-value">{{ meeting.asset_name || '—' }}</span>
                                    </div>

                                    <div class="meeting-preview-row" style="padding:4px 0; border:none;">
                                        <span class="mp-label">Duration</span>
                                        <span class="mp-value">
                                            {{ meeting.duration_minutes ? meeting.duration_minutes + ' min' : '—' }}
                                        </span>
                                    </div>

                                    <!-- ✅ Status row in details -->
                                    <div class="meeting-preview-row" style="padding:4px 0; border:none;">
                                        <span class="mp-label">Status</span>
                                        <span class="mp-value">
                                            <span :style="getMeetingStatusStyle(meeting.status)">
                                                {{ getMeetingStatusLabel(meeting.status) }}
                                            </span>
                                        </span>
                                    </div>

                                    <div v-if="meeting.description" class="meeting-preview-row" style="padding:4px 0; border:none;">
                                        <span class="mp-label">Description</span>
                                        <span class="mp-value">{{ meeting.description }}</span>
                                    </div>

                                    <!-- ✅ Join button disabled when completed -->
                                    <div v-if="meeting.zoom_link" class="meeting-preview-row" style="padding:4px 0; border:none;">
                                        <span class="mp-label">Join Link</span>
                                        <span class="mp-value">
                                            <!-- Completed — disabled button -->
                                            <span v-if="isMeetingCompleted(meeting.status)"
                                                  style="
                          display:inline-flex;
                          align-items:center;
                          gap:4px;
                          background:#e2e8f0;
                          color:#94a3b8;
                          padding:4px 10px;
                          border-radius:12px;
                          font-size:11px;
                          font-weight:600;
                          cursor:not-allowed;
                          text-decoration:none;">
                                                🎥 Meeting Completed
                                            </span>
                                            <!-- Active — clickable link -->
                                            <a v-else
                                               :href="meeting.zoom_link"
                                               target="_blank"
                                               class="mp-zoom-btn">
                                                🎥 Join Meeting
                                            </a>
                                        </span>
                                    </div>

                                </div>
                            </div>

                            <!-- FOOTER -->
                            <div class="meeting-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="mp-check">✔ Loaded</span>
                            </div>

                        </div>
                        <!-- Meeting Failed Card -->
                        <div v-else-if="msg.type === 'meeting_failed'" class="ticket-preview-card">

                            <!-- HEADER -->
                            <div class="ticket-preview-header" style="background: linear-gradient(135deg, #dc2626, #991b1b);">
                                <span class="tp-icon">📅</span>
                                <div>
                                    <h4>Meeting Creation Failed</h4>
                                    <p>Something went wrong while booking.</p>
                                </div>
                                <span class="ticket-preview-number tp-error-badge">⚠ Failed</span>
                            </div>

                            <!-- BODY -->
                            <div class="ticket-preview-body">

                                <div class="ticket-preview-row" v-if="msg.payload?.meeting_data?.meetingTitle">
                                    <span class="tp-label">Title</span>
                                    <span class="tp-value">{{ msg.payload.meeting_data.meetingTitle }}</span>
                                </div>

                                <div class="ticket-preview-row" v-if="msg.payload?.meeting_data?.durationMinutes">
                                    <span class="tp-label">Duration</span>
                                    <span class="tp-value">{{ msg.payload.meeting_data.durationMinutes }} min</span>
                                </div>

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Status</span>
                                    <span class="tp-value">
                                        <span class="tp-status-badge tp-status-failed">⚠ Failed</span>
                                    </span>
                                </div>

                            </div>

                            <!-- ERROR BLOCK -->
                            <div class="ticket-preview-error tp-error-simple">
                                <span class="tp-err-icon">⚠️</span>
                                <p>
                                    Oops! We couldn't create your meeting.
                                    Please <strong>try scheduling again</strong>.
                                </p>
                            </div>

                            <!-- FOOTER -->
                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-failed">✖ Not Created</span>
                            </div>

                        </div>
                        <div v-else-if="msg.type === 'meeting_form_preview'" class="meeting-preview-card">

                            <!-- HEADER -->
                            <div class="meeting-preview-header">
                                <span class="mp-icon">📝</span>
                                <div>
                                    <h4>Review Meeting Details</h4>
                                    <p>{{ msg.payload?.response || 'Please review and confirm to book.' }}</p>
                                </div>
                            </div>

                            <!-- BODY -->
                            <div class="meeting-preview-body">

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Title</span>
                                    <span class="mp-value">
                                        {{ msg.payload?.meeting_data?.prefilled?.meeting_title || '—' }}
                                    </span>
                                </div>

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Asset</span>
                                    <span class="mp-value">
                                        {{ msg.payload?.meeting_data?.prefilled?.asset_name || '—' }}
                                    </span>
                                </div>

                                <!-- Participants as checkboxes -->
                                <div class="meeting-preview-row"
                                     style="flex-direction: column; align-items: flex-start; gap: 6px;">
                                    <span class="mp-label" style="margin-bottom: 4px;">Participants</span>

                                    <!-- Loading -->
                                    <div v-if="getMeetingPreviewParticipantList(msg).loading"
                                         style="font-size:12px; color:#999;">
                                        ⏳ Loading participants…
                                    </div>

                                    <!-- No participants -->
                                    <div v-else-if="!getMeetingPreviewParticipantList(msg).users.length"
                                         style="font-size:12px; color:#999; font-style:italic;">
                                        No co-owners found for this asset.
                                    </div>

                                    <!-- Checkbox list -->
                                    <!-- Checkbox list -->
                                    <div v-else style="width:100%;">
                                        <!-- Select All -->
                                        <label class="mp-participant-row"
                                               style="border-bottom: 2px solid #e2e8f0; margin-bottom: 4px; font-weight: 600;">
                                            <input type="checkbox"
                                                   :checked="isAllMeetingPreviewSelected(msg)"
                                                   @change="toggleAllMeetingPreviewParticipants(msg, $event)"
                                                   :ref="el => { if(el) el.indeterminate = isSomeMeetingPreviewSelected(msg) }"
                                                   class="mp-participant-cb" />
                                            <span>Select All ({{ (msg._previewParticipants || []).length }}/{{ getMeetingPreviewParticipantList(msg).users.length }})</span>
                                        </label>

                                        <div style="max-height: 130px; overflow-y: auto; padding: 4px 0;">
                                            <label v-for="u in getMeetingPreviewParticipantList(msg).users"
                                                   :key="u.value"
                                                   class="mp-participant-row">
                                                <input type="checkbox"
                                                       :checked="isMeetingPreviewParticipantChecked(msg, u.value)"
                                                       @change="toggleMeetingPreviewParticipant(msg, u)"
                                                       class="mp-participant-cb" />
                                                <span>{{ u.label }}</span>
                                            </label>
                                        </div>

                                        <div class="mp-participant-hint">
                                            <span v-if="!(msg._previewParticipants || []).length"
                                                  style="color: #dc2626; font-weight: 600;">
                                                ⚠️ Please select at least one participant to confirm.
                                            </span>
                                            <span v-else>
                                                {{
            isAllMeetingPreviewSelected(msg)
                ? '✅ All co-owners selected.'
                : `${(msg._previewParticipants || []).length} of ${getMeetingPreviewParticipantList(msg).users.length} selected.`
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Date</span>
                                    <span class="mp-value">
                                        {{ formatDateMDY(msg.payload?.meeting_data?.prefilled?.meeting_date) }}
                                    </span>
                                </div>

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Time</span>
                                    <span class="mp-value">
                                        {{ formatTo12Hours(msg.payload?.meeting_data?.prefilled?.meeting_time) }}
                                    </span>
                                </div>

                                <div class="meeting-preview-row">
                                    <span class="mp-label">Duration</span>
                                    <span class="mp-value">
                                        {{
                    msg.payload?.meeting_data?.prefilled?.duration_minutes
                        ? msg.payload.meeting_data.prefilled.duration_minutes + ' min'
                        : '—'
                                        }}
                                    </span>
                                </div>

                                <div class="meeting-preview-row"
                                     v-if="msg.payload?.meeting_data?.prefilled?.description">
                                    <span class="mp-label">Description</span>
                                    <span class="mp-value">
                                        {{ msg.payload.meeting_data.prefilled.description }}
                                    </span>
                                </div>

                            </div>

                            <!-- ACTION BUTTONS -->
                            <!-- ACTION BUTTONS -->
                            <div class="meeting-preview-actions">
                                <button class="meeting-confirm-btn"
                                        :disabled="!msg._previewParticipants?.length || isCardDisabled(msg)"
                                        :style="{
                opacity: (!msg._previewParticipants?.length || isCardDisabled(msg)) ? '0.5' : '1',
                cursor:  (!msg._previewParticipants?.length || isCardDisabled(msg)) ? 'not-allowed' : 'pointer'
            }"
                                        @click="confirmMeetingPreviewWithParticipants(msg)">
                                    <span v-if="isCardDisabled(msg)">✔ Confirm &amp; Book</span>
                                    <span v-else>✔ Confirm &amp; Book</span>
                                </button>
                                <button class="meeting-cancel-btn"
                                        :disabled="isCardDisabled(msg)"
                                        :style="{ opacity: isCardDisabled(msg) ? '0.5' : '1', cursor: isCardDisabled(msg) ? 'not-allowed' : 'pointer' }"
                                        @click="cancelMeetingPreview()">
                                    ✖ Cancel
                                </button>
                            </div>

                            <!-- FOOTER -->
                            <div class="meeting-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="mp-failed">Pending Confirmation</span>
                            </div>

                        </div>
                        <!-- ✅ Schedule Conflict Card -->
                        <template v-else-if="isMeetingConflictPrompt(msg.payload?.response)">
                            <div class="meeting-conflict-card">
                                <div class="mc-header">
                                    <span class="mc-icon">⚠️</span>
                                    <div>
                                        <h4>Schedule Conflict Detected</h4>
                                        <p>The following meetings are already booked at this time:</p>
                                    </div>
                                </div>

                                Conflict List
                                <div class="mc-conflict-list">
                                    <div v-for="(c, i) in parseMeetingConflicts(msg.payload?.response)"
                                         :key="i"
                                         class="mc-conflict-row">
                                        <span class="mc-conflict-icon">📅</span>
                                        <div>
                                            <strong class="mc-conflict-title">{{ c.title }}</strong>
                                            <p class="mc-conflict-details">{{ c.details }}</p>
                                        </div>
                                    </div>
                                </div>

                                Suggestion Text
                                <div class="mc-suggestion">
                                    <span>💬</span>
                                    <p>Reply <strong>"Proceed  Anyway"</strong> to confirm or <strong>"Try Different Time"</strong> to pick a new slot.</p>
                                </div>
                            </div>
                        </template>

                        <!-- Meeting Flow -->
                        <div v-else-if="msg.type === 'meeting_flow'"
                             class="meeting-reprompt-card">

                            <div class="mr-header">

                                <div>
                                    <!-- Title only for datetime reprompt -->
                                    <h4 v-if="isDateTimeReprompt(msg.payload?.response)">
                                        Reschedule Meeting
                                    </h4>

                                    <!-- Normal response -->
                                    <p class="meeting-text" v-if="isDateTimeReprompt(msg.payload?.response)" v-html="formatMessage(msg.payload?.response)">

                                    </p>

                                    <!-- Generic meeting flow -->
                                    <h4 v-else v-html="formatMessage(msg.payload?.response)">
                                    </h4>
                                </div>

                            </div>

                        </div>
                        <!--ticket flow html-->
                        <!-- view_tickets -->
                        <div v-else-if="msg.type === 'view_tickets'" class="ticket-preview-card">

                            <!-- HEADER -->
                            <div class="ticket-preview-header">
                                <div>
                                    <h4>{{ msg.payload?.ticket_data?.heading || 'Your Tickets' }}</h4>
                                </div>
                                <span class="ticket-preview-number" v-if="(msg.payload?.ticket_data?.tickets || []).length">
                                    {{ msg.payload.ticket_data.tickets.length }} ticket{{ msg.payload.ticket_data.tickets.length !== 1 ? 's' : '' }}
                                </span>
                            </div>

                            <!-- EMPTY STATE -->
                            <div v-if="!(msg.payload?.ticket_data?.tickets || []).length"
                                 class="ticket-preview-body"
                                 style="text-align:center; padding:16px;">
                                No tickets found.
                            </div>

                            <!-- TICKET LIST -->
                            <!-- TICKET LIST -->
                            <div v-else class="ticket-preview-body" style="padding: 0 16px 8px;">
                                <div v-for="(t, idx) in getVisibleTickets(msg)" :key="idx"
                                     :style="idx < getVisibleTickets(msg).length - 1 ? 'border-bottom: 1px solid var(--clr-border); padding: 10px 0;' : 'padding: 10px 0;'">

                                    <!-- TOP ROW: number + subject + details button -->
                                    <div style="display:flex; justify-content:space-between; align-items:flex-start; gap:8px;">
                                        <div style="flex:1;">
                                            <div style="font-weight:600; font-size:13px;">
                                                <span style="color:var(--clr-accent); font-size:11px; font-weight:700;">#{{ t.ticketNumber || '?' }}</span>
                                                &nbsp;{{ t.subject || 'No Subject' }}
                                            </div>
                                            <div style="margin-top:4px; display:flex; gap:6px; flex-wrap:wrap;">
                                                <span :style="`background:${getTicketStatusColor(t.status)}1a; color:${getTicketStatusColor(t.status)}; border:1px solid ${getTicketStatusColor(t.status)}55; padding:1px 8px; border-radius:10px; font-size:10px; font-weight:600;`">
                                                    {{ t.status || 'Open' }}
                                                </span>
                                            </div>
                                        </div>

                                        <button @click="toggleTicketListItem(msg, idx)"
                                                style="background:none; border:none; color:var(--clr-accent); font-size:11px; font-weight:600; cursor:pointer; padding:4px 8px; display:flex; align-items:center; gap:4px;">
                                            <span>{{ isTicketListItemOpen(msg, idx) ? 'Hide' : 'Details' }}</span>
                                            <span style="font-size:8px; transition:transform 0.2s;"
                                                  :style="isTicketListItemOpen(msg, idx) ? 'transform:rotate(180deg)' : ''">▼</span>
                                        </button>
                                    </div>

                                    <!-- EXPANDABLE DETAILS -->
                                    <div v-if="isTicketListItemOpen(msg, idx)"
                                         style="padding-top:8px; margin-top:8px; border-top:1px dashed var(--clr-border);">
                                        <div style="display:flex; gap:6px; padding:3px 0; font-size:11px;">
                                            <span style="color:var(--clr-text-muted); min-width:70px;">Work Type</span>
                                            <span>{{ t.workType || '—' }}</span>
                                        </div>
                                        <div style="display:flex; gap:6px; padding:3px 0; font-size:11px;">
                                            <span style="color:var(--clr-text-muted); min-width:70px;">Created</span>
                                            <span>{{ t.createdAt || '—' }}</span>
                                        </div>
                                    </div>

                                </div>

                                <!-- ✅ VIEW MORE / SHOW LESS -->
                                <button v-if="(msg.payload?.ticket_data?.tickets || []).length > 5"
                                        class="mp-read-more-btn"
                                        style="margin-top:6px;"
                                        @click="toggleTicketListExpand(messages.indexOf(msg))">
                                    {{
 isTicketListExpanded(messages.indexOf(msg))
            ? '▲ Show less'
            : `▼ View more (+${msg.payload.ticket_data.tickets.length - 5})`
                                    }}
                                </button>
                            </div>
                        </div>

                        <!-- view_tickets_empty / view_tickets_failed — plain text fallback -->
                        <div v-else-if="msg.type === 'view_tickets_empty' || msg.type === 'view_tickets_failed'"
                             class="ticket-flow-card">
                            <div class="ticket-flow-header" v-html="formatBotResponse(msg.text)"></div>
                        </div>
                        <div v-else-if="msg.type === 'ticket_form'" class="expense-form-card">

                            <!-- HEADER -->
                            <div class="ef-form-header" style="background: linear-gradient(135deg, rgb(30, 45, 69), rgb(18, 35, 65))">
                                <span class="ef-form-icon">🎫</span>
                                <div>
                                    <h4>Create Ticket</h4>
                                    <p>{{ msg.payload?.response }}</p>
                                </div>
                            </div>

                            <div class="ef-form-body">

                                <!-- Subject -->
                                <div class="ef-form-field ef-form-full">
                                    <label>Subject <span class="ef-required">*</span></label>
                                    <input v-model="ticketForm.subject"
                                           type="text"
                                           placeholder="Enter subject"
                                           class="ef-input" />
                                </div>

                                <!-- Work Type + Priority -->
                                <div class="ef-form-row">
                                    <div class="ef-form-field ef-form-full">
                                        <label>Work Type <span class="ef-required">*</span></label>
                                        <select v-model="ticketForm.workTypeId" class="ef-input">
                                            <option value="">Select Work Type</option>
                                            <option v-for="w in getTicketFormWorktypes(msg)"
                                                    :key="w.value" :value="w.value">
                                                {{ w.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="ef-form-field" style="display:none">
                                        <label>Priority <span class="ef-required">*</span></label>
                                        <select v-model="ticketForm.priorityId" class="ef-input">
                                            <option value="">Select Priority</option>
                                            <option v-for="p in getTicketFormPriorities(msg)"
                                                    :key="p.value" :value="p.value">
                                                {{ getPriorityIcon(p.text) }} {{ p.text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <!-- Asset -->
                                <div class="ef-form-field ef-form-full">
                                    <label>Asset <span class="ef-required">*</span></label>
                                    <select v-model="ticketForm.assetId" class="ef-input">
                                        <option value="">Select Asset</option>
                                        <option v-for="a in getTicketFormAssets(msg)"
                                                :key="a.Id" :value="a.Id">
                                            {{ a.Name }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Description -->
                                <div class="ef-form-field ef-form-full">
                                    <label>Description</label>
                                    <textarea v-model="ticketForm.description"
                                              class="ef-input ef-textarea"
                                              placeholder="Describe the issue..."
                                              rows="4">
            </textarea>
                                    <div class="exp-desc-meta" style="margin-top:4px;">
                                        <span :class="ticketForm.description.trim().split(/\s+/).filter(w=>w).length < 5 && ticketForm.description.length > 0 ? 'exp-wc-danger' : 'exp-wc-ok'">
                                            {{ ticketForm.description.trim().split(/\s+/).filter(w => w.length > 0).length }} words
                                        </span>
                                    </div>
                                </div>

                                <!-- Error -->
                                <p v-if="ticketFormError" class="ef-form-error">⚠️ {{ ticketFormError }}</p>

                                <!-- Submit -->
                                <button class="ef-form-submit"
                                        :disabled="ticketFormSubmitting"
                                        @click="submitTicketFormCard(msg)">
                                    <span v-if="ticketFormSubmitting">⏳ Submitting...</span>
                                    <span v-else>🎫 Create Ticket</span>
                                </button>

                            </div>
                        </div>
                        <!-- Ticket Menu Card -->
                        <div v-else-if="msg.type === 'ticket_menu'" class="ticket-menu-card">
                            <p>{{ msg.payload?.response || "How would you like to proceed?" }}</p>

                            <div class="ticket-menu-actions">
                                <button class="ticket-menu-btn btn-guide" @click="sendTicketGuide">
                                    <span class="btn-icon">📋</span> Ticket Guide
                                </button>

                                <button class="ticket-menu-btn btn-create" @click="startTicketCreation">
                                    <span class="btn-icon">🎫</span> Create Ticket
                                </button>
                            </div>
                        </div>
                        <!-- Ticket Details Ask (ask for ticket number) -->
                        <div v-else-if="msg.type === 'ticket_details'" class="ticket-flow-card">
                            <div class="ticket-flow-header">
                                <span>{{ msg.payload?.response }}</span>
                            </div>

                        </div>
                        <div v-else-if="msg.type === 'ticket_status'" class="ticket-flow-card">
                            <div class="ticket-flow-header">

                                <span>{{ msg.payload?.response }}</span>
                            </div>

                        </div>
                        <!-- Ticket Details Result -->
                        <div v-else-if="msg.type === 'ticket_details_result'" class="ticket-preview-card">

                            <div class="ticket-preview-header">
                                <span class="tp-icon">🎫</span>
                                <div>
                                    <h4>Ticket Details</h4>
                                    <p>{{ extractTicketNumber(msg.payload?.response) !== '—' ? extractTicketNumber(msg.payload?.response) : '' }}</p>
                                </div>
                                <span class="ticket-preview-number" v-if="extractTicketNumber(msg.payload?.response) !== '—'">
                                    {{ extractTicketNumber(msg.payload?.response) }}
                                </span>
                            </div>

                            <div class="ticket-preview-body">

                                <!-- ✅ If structured Key: Value fields exist, show them -->
                                <template v-if="parseTicketDetails(msg.payload?.response).length">
                                    <div v-for="(field, i) in parseTicketDetails(msg.payload?.response)"
                                         :key="i"
                                         class="ticket-preview-row">
                                        <span class="tp-label">{{ field.label }}</span>
                                        <span class="tp-value">{{ field.value }}</span>
                                    </div>
                                </template>

                                <!-- ✅ Plain text response — styled as info box -->
                                <template v-else>
                                    <div class="tp-info-box">
                                        <span class="tp-info-icon">ℹ️</span>
                                        <p>{{ cleanTicketDetailResponse(msg.payload?.response) }}</p>
                                    </div>
                                </template>

                            </div>

                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-check">✔ Found</span>
                            </div>

                        </div>

                        <!-- Ticket Status -->
                        <div v-else-if="msg.type === 'ticket_status_result'" class="ticket-preview-card">
                            <div class="ticket-preview-header">
                                <span class="tp-icon">📊</span>
                                <div>
                                    <h4>Ticket Status</h4>
                                    <p class="tp-subtitle">Ticket #{{ extractTicketNumber(msg.payload?.response) }}</p>
                                </div>
                            </div>

                            <div class="ticket-preview-body">
                                <div class="ticket-preview-row">
                                    <span class="tp-label">Ticket Number</span>
                                    <span class="tp-value">#{{ extractTicketNumber(msg.payload?.response) }}</span>
                                </div>
                                <div class="ticket-preview-row">
                                    <span class="tp-label">Status</span>
                                    <span class="tp-value">
                                        <span :class="'tp-status-badge tp-ticket-status-' + extractTicketStatus(msg.payload?.response).toLowerCase()">
                                            {{ extractTicketStatus(msg.payload?.response) }}
                                        </span>
                                    </span>
                                </div>
                            </div>

                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-check">✔ Found</span>
                            </div>
                        </div>

                        <!-- Ticket Vendor -->
                        <div v-else-if="msg.type === 'ticket_vendor_result'" class="ticket-preview-card">
                            <div class="ticket-preview-header">
                                <span class="tp-icon">🏢</span>
                                <div>
                                    <h4>Vendor Assignment</h4>
                                    <p class="tp-subtitle">Ticket #{{ extractTicketNumber(msg.payload?.response) }}</p>
                                </div>
                            </div>

                            <div class="ticket-preview-body">
                                <div class="ticket-preview-row">
                                    <span class="tp-label">Ticket Number</span>
                                    <span class="tp-value">#{{ extractTicketNumber(msg.payload?.response) }}</span>
                                </div>
                                <div class="ticket-preview-row">
                                    <span class="tp-label">Vendor</span>
                                    <span class="tp-value">
                                        <span :class="extractVendor(msg) === 'Not Assigned' ? 'tp-status-badge tp-ticket-status-unassigned' : 'tp-status-badge tp-ticket-status-assigned'">
                                            {{ extractVendor(msg) }}
                                        </span>
                                    </span>
                                </div>
                                <div class="ticket-preview-row">
                                    <span class="tp-label">Status</span>
                                    <span class="tp-value">
                                        <span :class="['tp-status-badge', getTicketStatusClass(extractTicketStatus(msg.payload?.response))]">
                                            {{ extractVendorStatus(msg) }}
                                        </span>
                                    </span>
                                </div>
                                <div v-if="msg.payload?.ticket_data?.email" class="ticket-preview-row">
                                    <span class="tp-label">Email</span>
                                    <span class="tp-value">{{ msg.payload.ticket_data.email }}</span>
                                </div>
                                <div v-if="msg.payload?.ticket_data?.phone" class="ticket-preview-row">
                                    <span class="tp-label">Phone</span>
                                    <span class="tp-value">{{ msg.payload.ticket_data.phone }}</span>
                                </div>
                            </div>

                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-check">✔ Found</span>
                            </div>
                        </div>
                        <!-- Ticket Status Failed -->
                        <div v-else-if="msg.type === 'ticket_status_failed'" class="ticket-preview-card">
                            <div class="ticket-preview-header" style="background: linear-gradient(135deg, #dc2626, #991b1b);">
                                <span class="tp-icon">📊</span>
                                <div>
                                    <h4>Ticket Status</h4>
                                    <p class="tp-subtitle">Lookup Failed</p>
                                </div>
                            </div>

                            <div class="ticket-preview-body ticket-not-found-body">
                                <div class="ticket-not-found-icon">🔍</div>
                                <p class="ticket-not-found-title">Ticket Not Found</p>
                                <p class="ticket-not-found-desc">
                                    We couldn't find any ticket matching your request.
                                    Please check the ticket number and try again.
                                </p>
                                <div class="ticket-not-found-hint">
                                    💡 Try asking: <strong>"status of ticket #1034"</strong>
                                </div>
                            </div>

                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-failed">✖ Not Found</span>
                            </div>
                        </div>

                        <!-- Ticket Vendor Failed -->
                        <div v-else-if="msg.type === 'ticket_vendor_failed'" class="ticket-preview-card">
                            <div class="ticket-preview-header" style="background: linear-gradient(135deg, #dc2626, #991b1b);">
                                <span class="tp-icon">🏢</span>
                                <div>
                                    <h4>Vendor Assignment</h4>
                                    <p class="tp-subtitle">Lookup Failed</p>
                                </div>
                            </div>

                            <div class="ticket-preview-body ticket-not-found-body">
                                <div class="ticket-not-found-icon">🔍</div>
                                <p class="ticket-not-found-title">No Vendor Details Found</p>
                                <p class="ticket-not-found-desc">
                                    We couldn't retrieve vendor information for this ticket.
                                    The ticket may not exist or has no vendor assigned yet.
                                </p>
                                <div class="ticket-not-found-hint">
                                    💡 Try asking: <strong>"vendor for ticket #1034"</strong>
                                </div>
                            </div>

                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-failed">✖ Not Found</span>
                            </div>
                        </div>
                        <div v-else-if="msg.type === 'ticket_flow'" class="ticket-flow-card">
                            <div class="ticket-flow-header">
                                <span v-html="formatMessage(msg.payload?.response)"></span>
                            </div>
                        </div>
                        <!-- Ticket Preview / Summary Card -->
                        <div v-else-if="msg.type === 'ticket_preview'" class="ticket-preview-card">

                            <!-- HEADER -->
                            <div class="ticket-preview-header">
                                <div>
                                    <h4>Ticket Summary</h4>
                                    <p>Please review before submitting</p>
                                </div>
                            </div>

                            <!-- BODY -->
                            <div class="ticket-preview-body">

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Subject</span>
                                    <span class="tp-value">
                                        {{ msg.payload?.ticket_data?.prefilled?.subject || '—' }}
                                    </span>
                                </div>

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Asset</span>
                                    <span class="tp-value">
                                        {{ msg.payload?.ticket_data?.prefilled?.assetName || '—' }}
                                    </span>
                                </div>

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Work Type</span>
                                    <span class="tp-value tp-worktype-edit-wrap">
                                        <select class="tp-worktype-edit-select"
                                                :value="getTicketPreviewWorkTypeValue(msg)"
                                                :disabled="_ticketPreviewSubmitting || isCardDisabled(msg)"
                                                @focus="loadTicketPreviewWorkTypes(msg)"
                                                @mousedown="loadTicketPreviewWorkTypes(msg)"
                                                @change="onTicketPreviewWorkTypeChange(msg, $event)">

                                            <!-- Always keep backend-selected Work Type visible by default -->
                                            <option v-if="shouldShowTicketPreviewCurrentWorkType(msg)"
                                                    :value="getTicketPreviewWorkTypeValue(msg)">
                                                {{ getTicketPreviewCurrentWorkTypeName(msg) }}
                                            </option>

                                            <option v-for="w in _ticketPreviewWorkTypes"
                                                    :key="w.value"
                                                    :value="w.value">
                                                {{ w.text }}
                                            </option>

                                            <option v-if="_ticketPreviewWorkTypesLoading"
                                                    disabled
                                                    value="__loading__">
                                                Loading Work Types...
                                            </option>
                                        </select>

                                        <small v-if="_ticketPreviewWorkTypesError"
                                               class="tp-worktype-edit-error">
                                            {{ _ticketPreviewWorkTypesError }}
                                        </small>
                                    </span>
                                </div>

                                <div v-if="msg.payload?.ticket_data?.prefilled?.description"
                                     class="ticket-preview-row">
                                    <span class="tp-label">Description</span>
                                    <span class="tp-value">
                                        {{ msg.payload.ticket_data.prefilled.description }}
                                    </span>
                                </div>

                                <!-- Attachment -->
                                <div class="ticket-preview-row"
                                     style="flex-direction: column; align-items: flex-start; gap: 8px;">
                                    <span class="tp-label">Attachment <span style="color:#94a3b8;">(optional)</span></span>

                                    <label class="au-file-label" style="width:100%;">
                                        <input type="file"
                                               accept=".png,.gif,.jpeg,.jpg"
                                               class="au-file-input"
                                               ref="ticketPreviewFileInput"
                                               @change="onAttachmentFileChange"
                                               :disabled="_ticketPreviewSubmitting || isCardDisabled(msg)" />

                                        <span class="au-file-btn"
                                              style="width:100%; text-align:center; display:block; box-sizing:border-box;">
                                            Choose File
                                        </span>
                                    </label>

                                    <div v-if="_attachmentPreviews.length" class="au-thumb-preview">
                                        <div v-for="(p, i) in _attachmentPreviews"
                                             :key="i"
                                             class="au-thumb-wrap">
                                            <img v-if="p.type === 'image'"
                                                 :src="p.thumb"
                                                 :alt="p.name"
                                                 class="au-thumb-img" />
                                            <span class="au-thumb-name">{{ p.name }}</span>
                                        </div>
                                    </div>

                                    <div v-else-if="_attachmentFiles.length" class="au-file-preview">
                                        <span v-for="(f, i) in _attachmentFiles"
                                              :key="i"
                                              class="au-file-chip">
                                            {{ f.name }}
                                        </span>
                                    </div>

                                    <p v-if="_attachmentError" class="au-error">
                                        {{ _attachmentError }}
                                    </p>

                                    <small class="au-note">
                                        PNG, GIF, JPEG, JPG &nbsp;|&nbsp; Max 5MB
                                    </small>
                                </div>

                            </div>

                            <!-- ACTION BUTTONS -->
                            <div class="meeting-preview-actions">
                                <button class="meeting-confirm-btn"
                                        :disabled="_ticketPreviewSubmitting || isCardDisabled(msg)"
                                        :style="{
                                            opacity: (_ticketPreviewSubmitting || isCardDisabled(msg)) ? '0.5' : '1',
                                            cursor: (_ticketPreviewSubmitting || isCardDisabled(msg)) ? 'not-allowed' : 'pointer'
                                        }"
                                        @click="confirmAndSubmitTicketPreview(msg)">
                                    <span v-if="_ticketPreviewSubmitting">Submitting...</span>
                                    <span v-else>Confirm &amp; Submit</span>
                                </button>

                                <button class="meeting-cancel-btn"
                                        :disabled="_ticketPreviewSubmitting || isCardDisabled(msg)"
                                        :style="{
                                            opacity: (_ticketPreviewSubmitting || isCardDisabled(msg)) ? '0.5' : '1',
                                            cursor: (_ticketPreviewSubmitting || isCardDisabled(msg)) ? 'not-allowed' : 'pointer'
                                        }"
                                        @click="cancelTicketPreview()">
                                    Cancel
                                </button>
                            </div>

                            <!-- FOOTER -->
                            <div class="ticket-preview-footer">
                                <span>{{ currentDate }}</span>
                                <span class="mp-failed" style="color:#f59e0b;">
                                    Pending
                                </span>
                            </div>

                        </div>
                        <!-- Ticket Preview -->
                        <div v-else-if="msg.type === 'ticket_created' || msg.type === 'ticket_api_error'" class="ticket-preview-card">

                            <!-- HEADER -->
                            <div class="ticket-preview-header">
                                <span class="tp-icon">🎫</span>
                                <div>
                                    <h4>{{ msg.type === 'ticket_api_error' ? 'Ticket Submission Failed' : 'Ticket Created!' }}</h4>
                                    <p>{{ msg.type === 'ticket_api_error' ? 'Please try again or start a new ticket.' : 'Our team will be in touch shortly.' }}</p>
                                </div>

                                <!-- ✅ Show ticket number for success, "Error" badge for failure -->
                                <span v-if="msg.type === 'ticket_api_error'" class="ticket-preview-number tp-error-badge">
                                    ⚠ Failed
                                </span>
                                <span v-else class="ticket-preview-number">
                                    #{{ msg.payload?.ticket_data?.ticketNumber || msg.payload?.ticket_data?.api?.raw?.ticket_Number || '—' }}
                                </span>
                            </div>

                            <!-- BODY -->
                            <div class="ticket-preview-body">

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Status</span>
                                    <span class="tp-value">
                                        <span v-if="msg.type === 'ticket_api_error'" class="tp-status-badge tp-status-failed">⚠ Failed</span>
                                        <span v-else class="tp-status-badge">Open</span>
                                    </span>
                                </div>

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Subject</span>
                                    <span class="tp-value">{{ msg.payload?.ticket_data?.subject || '—' }}</span>
                                </div>

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Work Type</span>
                                    <span class="tp-value">
                                        {{
 msg.payload.ticket_data.workTypeName
       || msg.payload.ticket_data.workType
       || _lastSelectedWorkType.name
       || '—'
                                        }}
                                    </span>
                                </div>

                                <!--<div class="ticket-preview-row">
                                    <span class="tp-label">Priority</span>
                                    <span class="tp-value">
                                        <span :class="`tp-priority-badge tp-priority-${(msg.payload?.ticket_data?.priority || '').toLowerCase()}`">
                                            {{ getPriorityIcon(msg.payload?.ticket_data?.priority) }}
                                            {{ msg.payload?.ticket_data?.priority || '—' }}
                                        </span>
                                    </span>
                                </div>-->

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Asset</span>
                                    <span class="tp-value">{{ msg.payload?.ticket_data?.assetName || '—' }}</span>
                                </div>

                                <div v-if="String(msg.payload?.ticket_data?.description || '').trim()"
                                     class="ticket-preview-row">
                                    <span class="tp-label">Description</span>
                                    <span class="tp-value">{{ msg.payload.ticket_data.description }}</span>
                                </div>

                            </div>

                            <!-- ✅ ERROR BLOCK — simple message only, no technical details -->
                            <div v-if="msg.type === 'ticket_api_error'" class="ticket-preview-error tp-error-simple">
                                <span class="tp-err-icon">⚠️</span>
                                <p>
                                    Oops! We couldn’t submit your ticket right now.
                                    Please <strong>start a new ticket</strong> and try again.
                                </p>
                            </div>

                            <!-- FOOTER -->
                            <div class="ticket-preview-footer">
                                <span>{{ currentDate }}</span>
                                <!-- ✅ No "Not Submitted" for errors — just show submitted for success -->
                                <span v-if="msg.type !== 'ticket_api_error'" class="tp-check">✔ Submitted</span>
                            </div>

                        </div>
                        <!-- Ticket Lookup Pending — numbered choice card -->
                        <div v-else-if="msg.type === 'ticket_lookup_pending'" class="ticket-flow-card">

                            <div class="ticket-flow-header headerforstatus">
                                <span class="tf-icon">🔍</span>
                                <span>{{ getTicketLookupQuestion(msg.payload?.response) }}</span>
                            </div>

                            <div class="ticket-asset-options" v-if="getTicketLookupOptions(msg.payload?.response).length">
                                <button v-for="(opt, i) in getTicketLookupOptions(msg.payload?.response)"
                                        :key="i"
                                        class="ticket-option-btn ticket-asset-card"
                                        :disabled="isCardDisabled(msg)"
                                        :style="{
            opacity: isCardDisabled(msg) ? '0.5' : '1',
            cursor: isCardDisabled(msg) ? 'not-allowed' : 'pointer'
        }"
                                        @click="sendTicketLookupChoice(opt.number, opt.label)">
                                    <span>{{ opt.number }}. {{ opt.label }}</span>
                                    <span class="tf-arrow">→</span>
                                </button>
                            </div>

                        </div>
                        <!-- Meeting Form Card -->
                        <div v-else-if="msg.type === 'meeting_preview'" class="expense-form-card">

                            <!-- HEADER -->
                            <div class="ef-form-header" style="background: linear-gradient(135deg, #1a2744, #243566);">
                                <span class="ef-form-icon">📅</span>
                                <div>
                                    <h4>Schedule meeting</h4>
                                    <p>{{ msg.payload?.response }}</p>
                                </div>
                            </div>

                            <div class="ef-form-body">

                                <!-- Row 1: Title + Duration -->
                                <div class="ef-form-row">
                                    <div class="ef-form-field">
                                        <label>Meeting title <span class="ef-required">*</span></label>
                                        <input v-model="meetingForm.title"
                                               type="text"
                                               placeholder="Enter meeting title"
                                               class="ef-input" />
                                    </div>
                                    <div class="ef-form-field">
                                        <label>Duration <span class="ef-required">*</span></label>
                                        <select v-model="meetingForm.durationMinutes" class="ef-input">
                                            <option value="">Select duration</option>
                                            <option v-for="opt in getMeetingDurationOptions()"
                                                    :key="opt.value" :value="opt.value">
                                                {{ opt.label }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <!-- Row 2: Date + Time -->
                                <div class="ef-form-row">
                                    <div class="ef-form-field">
                                        <label>Meeting date <span class="ef-required">*</span></label>
                                        <Calendar v-model="meetingForm.meetingDate"
                                                  dateFormat="mm-dd-yy"
                                                  placeholder="mm-dd-yyyy"
                                                  :minDate="new Date()"
                                                  :manualInput="false"
                                                  class="expense-calendar-input w-100"
                                                  inputClass="ef-input w-100" />
                                    </div>
                                    <div class="ef-form-field">
                                        <label>Meeting time <span class="ef-required">*</span></label>
                                        <input type="time"
                                               class="ef-input meeting-time-input"
                                               v-model="meetingForm.meetingTime"
                                               step="900"
                                               list="mf-time-datalist" />
                                        <datalist id="mf-time-datalist">
                                            <option v-for="t in getMeetingTimeDatalist(meetingForm.meetingDate)"
                                                    :key="t" :value="t" />
                                        </datalist>
                                    </div>
                                </div>

                                <!-- Asset -->
                                <div class="ef-form-field ef-form-full">
                                    <label>Asset <span class="ef-form-optional">(optional)</span></label>
                                    <select v-model="meetingForm.assetId"
                                            class="ef-input"
                                            @change="onMeetingFormAssetChange(msg)">
                                        <option v-for="a in getMeetingFormAssets(msg)"
                                                :key="a.value" :value="a.value">
                                            {{ a.label }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Participants MultiSelect -->
                                <div class="ef-form-field ef-form-full">
                                    <label>Participants <span class="ef-required">*</span></label>

                                    <div v-if="msg._loadingParticipants"
                                         style="font-size:12px; color:var(--text-muted); padding:8px 0;">
                                        <i class="pi pi-spin pi-spinner" style="font-size:12px;"></i>
                                        Loading participants...
                                    </div>

                                    <MultiSelect v-else
                                                 v-model="meetingForm.participantIds"
                                                 :options="getMeetingFormParticipants(msg)"
                                                 optionLabel="label"
                                                 optionValue="value"
                                                 placeholder="Select participant(s)"
                                                 filter
                                                 showClear
                                                 class="w-100"
                                                 style="max-width:100%;" />

                                    <small style="font-size:11px; color:var(--text-muted); margin-top:4px; display:block;">
                                        Search and select one or more participants
                                    </small>
                                </div>

                                <!-- Error -->
                                <p v-if="meetingFormError" class="ef-form-error">⚠️ {{ meetingFormError }}</p>

                                <!-- Submit -->
                                <button class="ef-form-submit"
                                        :disabled="meetingFormSubmitting"
                                        @click="submitMeetingFormCard(msg)">
                                    <span v-if="meetingFormSubmitting">⏳ Submitting...</span>
                                    <span v-else>📅 Schedule meeting</span>
                                </button>

                            </div>
                        </div>
                        <!-- Meeting Conflict Card -->
                        <div v-else-if="msg.type === 'meeting_conflict'" class="expense-form-card">

                            <!-- HEADER -->
                            <div class="ef-form-header" style="background: linear-gradient(135deg, #b91c1c, #7f1d1d);">
                                <span class="ef-form-icon">⚠️</span>
                                <div>
                                    <h4>Slot conflict detected</h4>
                                    <p>This time is already booked</p>
                                </div>
                            </div>

                            <div class="ef-form-body">

                                <!-- Conflict messages -->
                                <ul style="margin: 0 0 16px 0; padding-left: 18px; font-size: 13px; color: var(--color-text-secondary); line-height: 1.8;">
                                    <li v-for="(m, i) in (msg.payload?.meeting_data?.conflictMessages || [])"
                                        :key="i">
                                        {{ m }}
                                    </li>
                                    <li v-if="!msg.payload?.meeting_data?.conflictMessages?.length">
                                        A meeting already exists at the chosen time.
                                    </li>
                                </ul>

                                <!-- Actions -->
                                <div style="display: flex; gap: 10px;">
                                    <button class="ef-form-submit"
                                            style="flex: 1; margin: 0;"
                                            @click="meetingConflictReschedule(msg)">
                                        📅 Choose another time
                                    </button>
                                    <button class="ef-form-submit"
                                            style="flex: 0 0 auto; margin: 0;
                           background: transparent;
                           border: 1.5px solid #0f3460;
                           color: #0f3460;"
                                            @click="meetingConflictProceed(msg)">
                                        Proceed anyway
                                    </button>
                                </div>

                            </div>
                        </div>


                        <div v-else-if="msg.type === 'meeting_no_participants'" class="meeting-blocked-card">
                            <div class="mb-header">
                                <span class="mb-icon">🚫</span>
                                <div>
                                    <h4>Meeting Cannot Be Created</h4>
                                    <p>No participants available</p>
                                </div>
                            </div>
                            <div class="mb-body">
                                <p>{{ msg.payload?.reason }}</p>
                            </div>
                            <div class="mb-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="mb-badge">✖ Cancelled</span>
                            </div>
                        </div>

                        <!--newupdates-->
                        <div v-else-if="msg.type === 'cancel_meeting_empty'" class="ticket-preview-card">
                            <div class="ticket-preview-header" style="background: linear-gradient(135deg, #0f66b8, #122341);">
                                <span class="tp-icon">📅</span>
                                <div>
                                    <h4>Cancel Meeting</h4>
                                    <p>No meetings found.</p>
                                </div>
                            </div>
                            <div class="ticket-preview-body ticket-not-found-body">
                                <div class="ticket-not-found-icon">📭</div>
                                <p class="ticket-not-found-desc">
                                    {{ msg.payload?.response || msg.text }}
                                </p>
                            </div>
                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-check">✔ Checked</span>
                            </div>
                        </div>

                        <!-- Cancel Meeting List (shows list of meetings user can cancel) -->
                        <!-- Cancel Meeting List (shows list of meetings user can cancel) -->
                        <div v-else-if="msg.type === 'cancel_meeting_list'" class="ticket-preview-card">

                            <!-- HEADER -->
                            <div class="ticket-preview-header" style="background: linear-gradient(135deg, #0f66b8, #122341);">
                                <span class="tp-icon">📅</span>
                                <div>
                                    <h4>Cancel a Meeting</h4>
                                    <p>Select a meeting to cancel</p>
                                </div>
                            </div>
                            <!-- ✅ Only show error/warning text, not the full response -->
                            <div v-if="getFirstCancelMeetingError(msg.payload?.response)"
                                 style="background:#fff3cd; border-left:4px solid #f59e0b; padding:10px 14px; font-size:12px; color:#92400e; line-height:1.5;">
                                ⚠️ {{ getFirstCancelMeetingError(msg.payload?.response) }}
                            </div>
                            <!-- MEETING LIST -->
                            <div class="ticket-preview-body" style="display:flex; flex-direction:column; gap:10px;">

                                <div style="font-size:12px; font-weight:600; color:var(--clr-text-muted);">
                                    Upcoming meetings that can be cancelled:
                                </div>

                                <!-- Parse numbered list from response text -->
                                <template v-for="(line, i) in parseCancelMeetingList(msg.payload?.response || msg.text)" :key="i">
                                    <div style="background:#f8fafc; border:1px solid var(--clr-border); border-radius:10px; padding:12px 14px; display:flex; align-items:center; gap:10px;">
                                        <div style="background:#dbeafe; color:#1d4ed8; border-radius:50%; width:28px; height:28px; display:flex; align-items:center; justify-content:center; font-size:13px; font-weight:700; flex-shrink:0;">
                                            {{ line.number }}
                                        </div>
                                        <div style="flex:1;">
                                            <div style="font-size:13px; font-weight:600; color:var(--clr-text);">{{ line.title }}</div>
                                            <div v-if="line.time" style="font-size:11px; color:var(--clr-text-muted); margin-top:2px;">🕐 {{ line.time }}</div>
                                        </div>
                                        <span style="background:#dbeafe; color:#1d4ed8; font-size:10px; font-weight:600; padding:3px 8px; border-radius:20px; white-space:nowrap;">Upcoming</span>
                                    </div>
                                </template>

                                <!-- Instruction hint -->
                                <div style="background:#fefce8; border:1px solid #fde68a; border-radius:8px; padding:10px 12px; font-size:12px; color:#92400e; line-height:1.5;">
                                    💡 Reply with the <strong>meeting number</strong> or <strong>exact meeting title</strong> to cancel.
                                    Type <strong>"No"</strong> to keep all meetings.
                                </div>

                            </div>

                            <!-- FOOTER -->
                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-check">✔ Loaded</span>
                            </div>

                        </div>
                        <div v-else-if="msg.type === 'meeting_cancelled' || msg.type === 'cancel_meeting_cancelled'" class="ticket-preview-card">
                            <!--<div class="ticket-preview-header" style="background: linear-gradient(135deg, #0f66b8, #122341);">-->
                            <!--<span class="tp-icon">{{ isMeetingCancelAborted(msg.payload?.response) ? '🚫' : '✅' }}</span>-->
                            <!--<div>
                                <h4>{{ isMeetingCancelAborted(msg.payload?.response) ? 'Cancellation Stopped' : 'Meeting Cancelled' }}</h4>
                            </div>-->
                            <!--<span class="ticket-preview-number" style="background: rgba(255,255,255,0.15);">
                                    {{ isMeetingCancelAborted(msg.payload?.response) ? 'Aborted' : 'Done' }}
                                </span>
                            </div>-->
                            <div class="ticket-preview-body">

                                <!--<span class="tp-info-icon">{{ isMeetingCancelAborted(msg.payload?.response) ? '🚫' : '✅' }}</span>-->
                                <p>{{ msg.payload?.response || msg.text || 'Meeting cancelled successfully.' }}</p>

                            </div>
                            <!--<div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-check">{{ isMeetingCancelAborted(msg.payload?.response) ? '✖ Aborted' : '✔ Cancelled' }}</span>
                            </div>-->
                        </div>

                        <!-- Cancel Failed -->
                        <div v-else-if="msg.type === 'cancel_failed'" class="ticket-preview-card">
                            <div class="ticket-preview-header" style="background: linear-gradient(135deg, #dc2626, #991b1b);">
                                <span class="tp-icon">❌</span>
                                <div>
                                    <h4>Cancellation Failed</h4>
                                    <p>We couldn't cancel your meeting.</p>
                                </div>
                                <span class="ticket-preview-number tp-error-badge">⚠ Failed</span>
                            </div>
                            <div class="ticket-preview-body ticket-not-found-body">
                                <div class="ticket-not-found-icon">⚠️</div>
                                <p class="ticket-not-found-title">Could Not Cancel</p>
                                <p class="ticket-not-found-desc">
                                    {{ msg.payload?.response || msg.text || 'Something went wrong. Please try again.' }}
                                </p>
                                <div class="ticket-not-found-hint">
                                    💡 Please try again or contact support.
                                </div>
                            </div>
                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-failed">✖ Not Cancelled</span>
                            </div>
                        </div>

                        <!-- Ticket Status Update Flow -->
                        <div v-else-if="msg.type === 'ticket_status_update_flow'"
                             class="ticket-status-update-form">

                            <div class="ticket-status-update-form__header">
                                Update Ticket Status
                            </div>

                            <div class="ticket-status-update-form__body">

                                <div class="ticket-status-update-question"
                                     v-html="formatBotResponse(getTicketLookupQuestion(msg.payload?.response || msg.text))">
                                </div>

                                <div class="ticket-status-update-options"
                                     v-if="getTicketLookupOptions(msg.payload?.response || msg.text).length">

                                    <button v-for="(opt, i) in getTicketLookupOptions(msg.payload?.response || msg.text)"
                                            :key="i"
                                            type="button"
                                            class="ticket-status-update-option"
                                            :disabled="!!msg._confirmed"
                                            :style="{
                                                opacity: msg._confirmed ? '0.5' : '1',
                                                cursor: msg._confirmed ? 'not-allowed' : 'pointer'
                                            }"
                                            @click="sendTicketStatusUpdateChoice(opt.number, opt.label, msg)">

                                        <span>{{ opt.number }}. {{ opt.label }}</span>
                                        <span class="ticket-status-update-option__arrow">→</span>
                                    </button>

                                </div>

                            </div>
                        </div>

                        <!-- Ticket Status Updated Successfully -->
                        <!-- Ticket Status Updated Successfully -->
                        <div v-else-if="msg.type === 'ticket_status_updated'" class="ticket-preview-card">
                            <div class="ticket-preview-header" style="background: linear-gradient(135deg, #0f66b8, #122341);">
                                <span class="tp-icon">🔄</span>
                                <div>
                                    <h4>Status Updated!</h4>
                                    <p>Ticket status has been changed.</p>
                                </div>
                                <span class="ticket-preview-number" style="background: rgba(255,255,255,0.15);">✔</span>
                            </div>
                            <div class="ticket-preview-body">
                                <div class="tp-info-box">
                                    <span class="tp-info-icon">✅</span>
                                    <p v-html="formatBotResponse(msg.payload?.response || msg.text)"></p>
                                </div>
                            </div>
                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-check">✔ Updated</span>
                            </div>
                        </div>

                        <!-- Ticket Status Update Failed -->
                        <div v-else-if="msg.type === 'ticket_status_update_failed'" class="ticket-preview-card">
                            <div class="ticket-preview-header" style="background: linear-gradient(135deg, #dc2626, #991b1b);">
                                <span class="tp-icon">🔄</span>
                                <div>
                                    <h4>Status Update Failed</h4>
                                    <p>We couldn't update the ticket status.</p>
                                </div>
                                <span class="ticket-preview-number tp-error-badge">⚠ Failed</span>
                            </div>
                            <div class="ticket-preview-body ticket-not-found-body">
                                <div class="ticket-not-found-icon">⚠️</div>
                                <p class="ticket-not-found-title">Update Failed</p>
                                <p class="ticket-not-found-desc">
                                    {{ msg.payload?.response || msg.text || 'Something went wrong updating the ticket status.' }}
                                </p>
                                <div class="ticket-not-found-hint">
                                    💡 Please try again or contact support.
                                </div>
                            </div>
                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-failed">✖ Not Updated</span>
                            </div>
                        </div>

                        <!-- Due Expense Voting List -->
                        <!-- Due Expense Voting List -->
                        <div v-else-if="msg.type === 'due_expense_voting_list'" class="due-expense-wrapper">
                            <div class="due-expense-list-header">
                                <span>🗳️</span>
                                <span>{{ msg.payload?.expense_data?.heading || 'Approval / Voting Expenses' }}</span>
                                <span class="due-expense-count">{{ getVotingExpenses(msg.payload).length }}</span>
                            </div>

                            <div v-if="!getVotingExpenses(msg.payload).length"
                                 style="text-align:center; padding:20px; color:var(--clr-text-muted); font-size:13px;">
                                No expenses pending approval/voting.
                            </div>

                            <div v-for="(expense, i) in getVotingExpenses(msg.payload)"
                                 :key="i"
                                 class="due-expense-card">

                                <!-- HEADER -->
                                <div class="due-expense-header">
                                    <span class="due-expense-icon">🗳️</span>
                                    <div class="due-expense-header-text">
                                        <h4>{{ expense.title }}</h4>
                                        <p>📍 {{ expense.asset }}</p>
                                    </div>
                                    <!-- Status: show actual status (Failed/Passed) -->
                                    <span class="due-expense-status-badge"
                                          :style="getVotingStatusBadgeStyle(expense.status)">
                                        {{ expense.status }}
                                    </span>
                                </div>

                                <div class="due-expense-body">

                                    <!-- Category -->
                                    <div class="due-expense-row">
                                        <span class="due-expense-label">Category</span>
                                        <span class="due-expense-value">{{ expense.category || '—' }}</span>
                                    </div>

                                    <!-- Amount -->
                                    <div class="due-expense-row">
                                        <span class="due-expense-label">Amount</span>
                                        <span class="due-expense-value due-expense-total">${{ expense.amount }}</span>
                                    </div>

                                    <!-- Deadline — formatted -->
                                    <div class="due-expense-row">
                                        <span class="due-expense-label">Deadline</span>
                                        <span class="due-expense-value">📅 {{ formatVotingDate(expense.deadline) }}</span>
                                    </div>

                                    <!-- Threshold -->
                                    <div class="due-expense-row">
                                        <span class="due-expense-label">Threshold</span>
                                        <span class="due-expense-value">{{ expense.thresholdPercent || '—' }}</span>
                                    </div>

                                    <!-- Votes -->
                                    <div class="due-expense-row">
                                        <span class="due-expense-label">Votes</span>
                                        <span class="due-expense-value">{{ expense.totalVotes || 0 }}/{{ expense.requiredVotes || '—' }}</span>
                                    </div>

                                    <!-- In Favor progress -->
                                    <div style="padding: 4px 0;">
                                        <div style="display:flex; justify-content:space-between; font-size:11px; margin-bottom:3px;">
                                            <span style="color:#16a34a; font-weight:600;">In Favor</span>
                                            <span style="color:#16a34a; font-weight:600;">{{ expense.inFavorPercent || 0 }}%</span>
                                        </div>
                                        <div style="background:#e5e7eb; border-radius:20px; height:6px; overflow:hidden;">
                                            <div :style="`width:${expense.inFavorPercent || 0}%; background:#16a34a; height:100%; border-radius:20px;`"></div>
                                        </div>
                                    </div>

                                    <!-- Against progress -->
                                    <div style="padding: 4px 0;">
                                        <div style="display:flex; justify-content:space-between; font-size:11px; margin-bottom:3px;">
                                            <span style="color:#dc2626; font-weight:600;">Against</span>
                                            <span style="color:#dc2626; font-weight:600;">{{ expense.againstPercent || 0 }}%</span>
                                        </div>
                                        <div style="background:#e5e7eb; border-radius:20px; height:6px; overflow:hidden;">
                                            <div :style="`width:${expense.againstPercent || 0}%; background:#dc2626; height:100%; border-radius:20px;`"></div>
                                        </div>
                                    </div>

                                    <!-- Abstain progress -->
                                    <div style="padding: 4px 0;">
                                        <div style="display:flex; justify-content:space-between; font-size:11px; margin-bottom:3px;">
                                            <span style="color:#f59e0b; font-weight:600;">Abstain</span>
                                            <span style="color:#f59e0b; font-weight:600;">{{ expense.abstainPercent || 0 }}%</span>
                                        </div>
                                        <div style="background:#e5e7eb; border-radius:20px; height:6px; overflow:hidden;">
                                            <div :style="`width:${expense.abstainPercent || 0}%; background:#f59e0b; height:100%; border-radius:20px;`"></div>
                                        </div>
                                    </div>

                                    <!-- Your Vote -->
                                    <div class="due-expense-row" style="margin-top:4px;">
                                        <span class="due-expense-label">Your Vote</span>
                                        <span class="due-expense-value">
                                            <span v-if="expense.userHasVoted"
                                                  style="background:#dcfce7;color:#16a34a;padding:2px 10px;border-radius:10px;font-size:11px;font-weight:600;">
                                                ✔ Voted
                                            </span>
                                            <span v-else
                                                  style="background:#fef3c7;color:#b45309;padding:2px 10px;border-radius:10px;font-size:11px;font-weight:600;">
                                                ⏳ Pending
                                            </span>
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <!-- Due Expense Voting Empty -->
                        <div v-else-if="msg.type === 'due_expense_voting_empty'" class="ticket-flow-card">
                            <div class="ticket-flow-header">
                                <span class="tf-icon">🗳️</span>
                                <span>{{ msg.payload?.response || msg.text || 'You have no expenses pending approval/voting at the moment.' }}</span>
                            </div>
                        </div>

                        <!-- Due Expense Voting Failed -->
                        <div v-else-if="msg.type === 'due_expense_voting_failed'" class="ticket-preview-card">
                            <div class="ticket-preview-header" style="background: linear-gradient(135deg, #dc2626, #991b1b);">
                                <span class="tp-icon">🗳️</span>
                                <div>
                                    <h4>Could Not Load Voting Expenses</h4>
                                    <p>Something went wrong.</p>
                                </div>
                            </div>
                            <div class="ticket-preview-body ticket-not-found-body">
                                <div class="ticket-not-found-icon">⚠️</div>
                                <p class="ticket-not-found-title">Fetch Failed</p>
                                <p class="ticket-not-found-desc">
                                    {{ msg.payload?.response || msg.text || 'Unable to retrieve approval voting expenses right now. Please try again or contact support.' }}
                                </p>
                            </div>
                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-failed">✖ Failed</span>
                            </div>
                        </div>
                        <!--newupdates-->
                        <!-- Hotel Menu -->
                        <div v-else-if="msg.type === 'Hotel_Menu'" class="menu-container">
                            <h3>🍽️ Today's Menu</h3>
                            <p>Hotel Menu rendering coming soon...</p>
                        </div>

                        <!-- Cart Search -->
                        <div v-else-if="msg.type === 'cart_search'" class="cart-container">
                            <h3>Available Carts for Rent</h3>
                            <div v-for="(cart, i) in parseCarts(msg.payload)" :key="i" class="cart-card">
                                <h4>{{ cart.name }}</h4>
                                <button class="btn-book" @click="bookCart(cart)">Book Now</button>
                            </div>
                        </div>
                        <div v-else-if="(msg.type || msg.Intent) === 'combined_dues_list'"
                             class="combined-dues-card">

                            <div class="combined-dues-header">
                                <div>
                                    <h4>Pending Dues</h4>
                                    <p>Expenses and chores requiring attention</p>
                                </div>

                                <span class="combined-dues-count">
                                    {{
                (msg.payload?.expense_data?.expenses?.length || 0) +
                (msg.payload?.chore_data?.chores?.length || 0)
                                    }}
                                </span>
                            </div>

                            <div class="combined-dues-body">

                                <div class="dues-section">
                                    <div class="dues-section-header">
                                        <span>Pending Expenses</span>
                                        <span>
                                            {{ msg.payload?.expense_data?.expenses?.length || 0 }}
                                        </span>
                                    </div>

                                    <div v-for="(expense, index) in
                    (msg.payload?.expense_data?.expenses || [])"
                                         :key="'due-expense-' + index"
                                         class="dues-item"
                                         style="display:flex;justify-content:space-between;gap:10px;">

                                        <div class="dues-item-left">
                                            <strong>{{ expense.title || 'Expense' }}</strong>

                                            <small>
                                                Due {{ formatDateMDY(expense.dueDate) || '—' }}
                                            </small>
                                        </div>

                                        <div class="dues-amount">
                                            ${{ Number(expense.amount || 0).toFixed(2) }}
                                        </div>

                                    </div>
                                </div>


                                <div class="dues-section">
                                    <div class="dues-section-header">
                                        <span>Pending Chores</span>
                                        <span>
                                            {{ msg.payload?.chore_data?.chores?.length || 0 }}
                                        </span>
                                    </div>

                                    <div v-for="(chore, index) in
                    (msg.payload?.chore_data?.chores || [])"
                                         :key="'due-chore-' + index"
                                         class="dues-item">

                                        <div class="dues-item-left">

                                            <strong>
                                                {{ chore.title || 'Chore' }}
                                            </strong>

                                            <small v-if="chore.assignedUserName">
                                                {{ chore.assignedUserName }}
                                            </small>

                                            <small>
                                                Due {{ formatDateMDY(chore.dueDate) || '—' }}
                                            </small>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- Household Expense Flow -->
                        <HouseholdExpenseFlow v-else-if="isHouseholdExpenseCardIntent(msg.type)"
                                              :key="'household-expense-' + messages.indexOf(msg) + '-' + msg.type"
                                              :msg="msg"
                                              :disabled="isCardDisabled(msg)"
                                              :current-date="currentDate"
                                              @choose-type="chooseHouseholdExpenseType"
                                              @choose-option="chooseHouseholdExpenseOption"
                                              @submit-expense="submitHouseholdExpense"
                                              @cancel="cancelHouseholdExpense" />

                        <ManageGuestGroups v-else-if="isManageGuestGroupCardIntent(msg.type)"
                                           :msg="msg"
                                           :disabled="isCardDisabled(msg)"
                                           :current-date="currentDate"
                                           :guest-draft="getGuestGroupDraft(msg)"
                                           @confirm-group="confirmGuestGroup"
                                           @group-detail="viewGuestGroupDetail"
                                           @add-guest="addGuestToGroup"
                                           @remove-guest="removeGuestFromGroup"
                                           @phone-validity-change="onGuestGroupPhoneValidityChange"
                                           @phone-submit="submitGuestPhoneNumber" />

                        <NotificationsChatbot v-else-if="isNotificationChatbotIntent(msg.type)"
                                              :key="'notification-' + messages.indexOf(msg)"
                                              :msg="msg"
                                              :disabled="isCardDisabled(msg)"
                                              :current-date="currentDate"
                                              :loading-more="notificationLoadingMore"
                                              @load-more="loadMoreNotifications" />




                        <HouseholdExpenseFlow v-else-if="isHouseholdExpenseCardIntent(msg.type)"
                                              :msg="msg"
                                              :disabled="isCardDisabled(msg)"
                                              :current-date="currentDate"
                                              @choose-type="chooseHouseholdExpenseType"
                                              @choose-option="chooseHouseholdExpenseOption"
                                              @submit-expense="submitHouseholdExpense"
                                              @cancel="cancelHouseholdExpense" />


                        <ManageVendors v-else-if="
    ['vendor_preview', 'vendor_created', 'vendor_failed', 'vendor_list', 'vendor_list_failed',
     'vendor_status_updated', 'vendor_status_update_failed']
        .includes(msg.type || msg.Intent)
    ||
    (
        (msg.type || msg.Intent) === 'vendor_flow' &&
        isManageVendorPhonePrompt(msg)
    )
"
                                       :key="'manage-vendor-' + messages.indexOf(msg)"
                                       :msg="msg"
                                       :disabled="isCardDisabled(msg)"
                                       :current-date="currentDate"
                                       :country-code-list="countryCodeList"
                                       @confirm-vendor="confirmManageVendor"
                                       @cancel="cancelManageVendor"
                                       @toggle-status="toggleManageVendorStatus"
                                       @phone-validity-change="onManageVendorPhoneValidityChange"
                                       @phone-submit="submitManageVendorPhone" />

                        <AddRoomate v-else-if="
        isRoommateCardIntent(msg.type || msg.Intent) ||
        (
            (msg.type || msg.Intent) === 'roommate_flow' &&
            isRoommatePhonePrompt(msg)
        )
    "
                                    :mode="getRoommateMode(msg.type || msg.Intent, msg)"
                                    :message="msg.payload?.response || msg.response || ''"
                                    :roommate-data="msg.payload?.roommate_data || msg.roommate_data || {}"
                                    :country-code-list="countryCodeList"
                                    :selected-country-code-text="roommateSelectedCountryCodeText"
                                    :loading="isLoading"
                                    :is-error="(msg.type || msg.Intent) === 'roommate_failed'"
                                    @submit="submitRoommate"
                                    @phone-submit="submitRoommatePhone"
                                    @phone-validity-change="value => onRoommatePhoneValidityChange(value, msg)"
                                    @cancel="cancelRoommate"
                                    @delete-roommate="removeRoommate" />
                        <!-- Expense Form html -->
                        <div v-else-if="msg.type === 'expense_form'" class="expense-form-card">



                            <!-- Header -->
                            <div class="ef-header">
                                <span class="ef-icon">💰</span>
                                <div>
                                    <h4>Expense Summary</h4>
                                    <p class="ef-subtitle">Please review before submitting</p>
                                </div>
                            </div>

                            <div class="ef-body">

                                <!-- Read-only rows -->
                                <div class="ef-row">
                                    <span class="ef-label">Title</span>
                                    <span class="ef-value">{{ msg.payload?.expense_data?.prefilled?.expenseTitle || '—' }}</span>
                                </div>
                                <div class="ef-row">
                                    <span class="ef-label">Amount</span>
                                    <span class="ef-value">${{ msg.payload?.expense_data?.prefilled?.amount ?? '—' }}</span>
                                </div>
                                <div class="ef-row">
                                    <span class="ef-label">Payment Date</span>
                                    <span class="ef-value">{{ formatExpenseDate(msg.payload?.expense_data?.prefilled?.expensePaymentDate) }}</span>
                                </div>

                                <!-- Asset — read-only if prefilled, dropdown if not -->
                                <div class="ef-row">
                                    <span class="ef-label">
                                        Asset
                                        <!--<span class="ef-required">*</span>-->
                                    </span>
                                    <span class="ef-value" v-if="msg.payload?.expense_data?.prefilled?.assetID">
                                        {{ msg.payload.expense_data.prefilled.assetName }}
                                    </span>
                                    <select v-else v-model="expenseForm.assetId" class="ef-select">
                                        <option value="">Select asset…</option>
                                        <option v-for="a in (msg.payload?.expense_data?.assets || [])"
                                                :key="a.Id" :value="a.Id">
                                            {{ a.Name }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Category — read-only if prefilled, dropdown if not -->
                                <div class="ef-row">
                                    <span class="ef-label">
                                        Category
                                        <!-- <span class="ef-required">*</span>-->
                                    </span>
                                    <span class="ef-value" v-if="msg.payload?.expense_data?.prefilled?.categoryId">
                                        {{ msg.payload.expense_data.prefilled.categoryName }}
                                    </span>
                                    <select v-else v-model="expenseForm.categoryId" class="ef-select">
                                        <option value="">Select category…</option>
                                        <option v-for="c in getExpenseFormCategories(msg)"
                                                :key="c.value" :value="c.value">
                                            {{ c.text }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Vendor — always optional dropdown -->
                                <div class="ef-row" v-if="(msg.payload?.expense_data?.vendors || []).length">
                                    <span class="ef-label">Vendor <span class="ef-optional">(opt)</span></span>
                                    <span class="ef-value" v-if="msg.payload?.expense_data?.prefilled?.vendorId">
                                        {{ msg.payload.expense_data.prefilled.vendorName }}
                                    </span>
                                    <select v-else v-model="expenseForm.vendorId" class="ef-select">
                                        <option value="">None</option>
                                        <option v-for="v in (msg.payload?.expense_data?.vendors || [])"
                                                :key="v.value" :value="v.value">
                                            {{ v.text }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Voting section — only when amount > 500 -->
                                <div class="ef-voting-section"
                                     v-if="msg.payload?.expense_data?.prefilled?.amount > 500">
                                    <div class="ef-voting-banner">
                                        ⚡ Amount over $500 — Approval voting required
                                    </div>
                                    <div class="ef-row">
                                        <span class="ef-label">Threshold <span class="ef-required">*</span></span>
                                        <span class="ef-value" v-if="msg.payload?.expense_data?.prefilled?.thresholdId">
                                            {{ msg.payload.expense_data.prefilled.thresholdName }}
                                        </span>
                                        <select v-else v-model="expenseForm.thresholdId" class="ef-select">
                                            <option value="">Select threshold…</option>
                                            <option v-for="t in (msg.payload?.expense_data?.thresholds || [])"
                                                    :key="t.value" :value="t.value">
                                                {{ t.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="ef-row" v-if="msg.payload?.expense_data?.prefilled?.votingTitle">
                                        <span class="ef-label">Voting Title</span>
                                        <span class="ef-value">{{ msg.payload.expense_data.prefilled.votingTitle }}</span>
                                    </div>
                                    <div class="ef-input-group" v-else>
                                        <label class="ef-input-label">Voting Title <span class="ef-required">*</span></label>
                                        <input v-model="expenseForm.votingTitle"
                                               type="text"
                                               placeholder="Enter voting title"
                                               class="ef-input" />
                                    </div>
                                    <div class="ef-row" v-if="msg.payload?.expense_data?.prefilled?.votingDeadline">
                                        <span class="ef-label">Deadline</span>
                                        <span class="ef-value">{{ msg.payload.expense_data.prefilled.votingDeadline }}</span>
                                    </div>
                                    <div class="ef-input-group" v-else>
                                        <label class="ef-input-label">Voting Deadline <span class="ef-required">*</span></label>
                                        <input v-model="expenseForm.votingDeadline"
                                               type="date"
                                               class="ef-input" />
                                    </div>
                                    <div class="ef-input-group">
                                        <label class="ef-input-label">Justification</label>
                                        <textarea v-model="expenseForm.votingJustification"
                                                  placeholder="Why is voting required for this expense?"
                                                  class="ef-textarea"
                                                  rows="2"></textarea>
                                    </div>
                                </div>

                                <!-- Description -->
                                <div class="ef-input-group" style="margin-top: 4px;">
                                    <label class="ef-input-label">Description</label>
                                    <textarea v-model="expenseForm.description"
                                              placeholder="Enter description"
                                              class="ef-textarea"
                                              rows="3"
                                              :style="{
                                              borderColor: getExpenseDescWordCount()> 200 ? '#dc2626' : '#e2e8f0',
                  background: getExpenseDescWordCount() > 200 ? '#fff5f5' : '#f8fafc'
              }"></textarea>

                                    <!-- Word count row -->
                                    <div style="display:flex; justify-content:flex-end; align-items:center; margin-top:4px; gap:6px;">
                                        <span v-if="getExpenseDescWordCount() > 200"
                                              style="font-size:10px; color:#dc2626; font-weight:600; flex:1;">
                                            Max 200 words allowed
                                        </span>
                                        <span :style="{
                                              fontSize: '11px' ,
                                              fontWeight: '600' ,
                                              color: getExpenseDescWordCount()>
                                            200 ? '#dc2626'
                                            : getExpenseDescWordCount() > 180 ? '#f59e0b'
                                            : '#94a3b8'
                                            }">
                                            {{ getExpenseDescWordCount() }}/200
                                        </span>
                                    </div>
                                </div>

                                <div class="ef-attach-section">
                                    <button class="ef-attach-btn"
                                            type="button"
                                            @click="$refs['expenseFile_' + messages.indexOf(msg)][0].click()">
                                        📎 Attach Receipt / Invoice
                                        <span class="ef-attach-optional">(optional)</span>
                                    </button>
                                    <input :ref="'expenseFile_' + messages.indexOf(msg)"
                                           type="file"
                                           multiple
                                           accept=".pdf,.xlsx,.csv,.docx,.doc,.pptx,.ppt,.txt,.xls,.png,.jpg,.jpeg,.gif"
                                           style="display:none"
                                           @change="onExpenseFormFileChange" />

                                    <!-- File list -->
                                    <div v-if="expenseFormFiles.length" class="ef-file-list">
                                        <div v-for="(file, i) in expenseFormFiles"
                                             :key="i"
                                             class="ef-file-item">
                                            <span class="ef-file-name">{{ file.name }}</span>
                                            <button class="ef-file-remove"
                                                    type="button"
                                                    @click="removeExpenseFormFile(i)">
                                                ✕
                                            </button>
                                        </div>
                                    </div>

                                    <p v-if="expenseFormFileError" class="ef-error">{{ expenseFormFileError }}</p>
                                </div>

                                <!-- Error -->
                                <p v-if="expenseFormError" class="ef-error">{{ expenseFormError }}</p>

                            </div>

                            <!-- Footer actions -->
                            <div class="ef-footer">
                                <button class="ef-submit-btn"
                                        :disabled="expenseFormSubmitting || expenseFormUploading || isCardDisabled(msg) || getExpenseDescWordCount() > 200"
                                        :style="{
                                        opacity: (expenseFormSubmitting || expenseFormUploading || isCardDisabled(msg) || getExpenseDescWordCount()>
                                    200) ? '0.5' : '1',
                                    cursor: (expenseFormSubmitting || expenseFormUploading || isCardDisabled(msg) || getExpenseDescWordCount() > 200) ? 'not-allowed' : 'pointer'
                                    }"
                                    @click="submitExpenseFormCard(msg)">
                                    <span v-if="expenseFormUploading">Uploading…</span>
                                    <span v-else-if="expenseFormSubmitting">Submitting…</span>
                                    <span v-else>Confirm &amp; Submit</span>
                                </button>
                                <button class="ef-cancel-btn" type="button"
                                        :disabled="expenseFormSubmitting || isCardDisabled(msg)"
                                        :style="{
                opacity: (expenseFormSubmitting || isCardDisabled(msg)) ? '0.5' : '1',
                cursor: (expenseFormSubmitting || isCardDisabled(msg)) ? 'not-allowed' : 'pointer'
            }"
                                        @click="cancelExpenseForm()">
                                    Cancel
                                </button>
                            </div>

                        </div>
                        <div v-else-if="msg.type === 'expense_flow'" class="ticket-flow-card">
                            <div class="ticket-flow-header">
                                <span v-html="formatMessage(msg.payload?.response)"></span>
                            </div>

                            <div v-if="msg._optionError" class="ticket-asset-error">
                                {{ msg._optionError }}
                            </div>
                        </div>

                        <!-- Due Expense List -->
                        <div v-else-if="msg.type === 'due_expense_list'" class="due-expense-wrapper">

                            <div class="due-expense-list-header">

                                <span>{{ msg.payload?.expense_data?.heading || 'Due Expenses' }}</span>
                                <span class="due-expense-count">{{ getDueExpenses(msg.payload).length }}</span>
                            </div>

                            <div v-for="(expense, i) in getDueExpenses(msg.payload)"
                                 :key="i"
                                 class="due-expense-card">

                                <!-- HEADER -->
                                <div class="due-expense-header">

                                    <div class="due-expense-header-text">
                                        <h4>{{ expense.description }}</h4>
                                        <p>{{ expense.asset }}</p>
                                    </div>
                                    <span class="due-expense-status-badge"
                                          :class="'due-expense-status-' + expense.status.toLowerCase()">
                                        {{ expense.status }}
                                    </span>
                                </div>

                                <!-- BODY -->
                                <div class="due-expense-body">

                                    <div class="due-expense-row">
                                        <span class="due-expense-label">Total Amount</span>
                                        <span class="due-expense-value due-expense-total">{{ expense.totalAmount }}</span>
                                    </div>

                                    <div class="due-expense-row">
                                        <span class="due-expense-label">My Share</span>
                                        <span class="due-expense-value due-expense-share">{{ expense.myShare }}</span>
                                    </div>

                                    <div class="due-expense-row">
                                        <span class="due-expense-label">Due Date</span>
                                        <span class="due-expense-value"> {{ formatDueDate(expense.dueDate) }}</span>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <!-- 7. Expense Attachment Upload -->
                        <div v-else-if="msg.type === 'expense_attachment_upload'" class="attachment-upload-card">

                            <!-- HEADER -->
                            <div class="attachment-upload-header">

                                <div>
                                    <h4>Upload Document</h4>
                                    <p>{{ msg.payload?.response || 'Please upload your document below.' }}</p>
                                </div>
                            </div>

                            <!-- COLLECTED SUMMARY -->
                            <div class="attachment-upload-summary" v-if="msg.payload?.expense_data?.collected">
                                <div class="au-summary-row">
                                    <span class="au-summary-label">Expense</span>
                                    <span class="au-summary-value">{{ msg.payload.expense_data.collected.expenseTitle }}</span>
                                </div>
                                <div class="au-summary-row">
                                    <span class="au-summary-label">Asset</span>
                                    <span class="au-summary-value">{{ msg.payload.expense_data.collected.assetName }}</span>
                                </div>
                                <div class="au-summary-row">
                                    <span class="au-summary-label">Amount</span>
                                    <span class="au-summary-value">${{ msg.payload.expense_data.collected.amount }}</span>
                                </div>
                            </div>

                            <!-- FILE INPUT -->
                            <div class="attachment-upload-body">
                                <label class="au-file-label">
                                    <input type="file"
                                           multiple
                                           accept=".pdf,.xlsx,.csv,.docx,.doc,.pptx,.ppt,.txt,.xls"
                                           class="au-file-input"
                                           @change="onExpenseAttachmentFileChange"
                                           :disabled="_expenseAttachmentUploading" />
                                    <span class="au-file-btn">
                                        📁 Choose Documents
                                    </span>
                                </label>

                                <!-- Selected file names preview -->
                                <div v-if="_expenseAttachmentFiles.length" class="au-file-preview">
                                    <span v-for="(f, i) in _expenseAttachmentFiles"
                                          :key="i"
                                          class="au-file-chip au-file-chip--green">
                                        {{ f.name }}
                                    </span>
                                </div>

                                <!-- Error -->
                                <p v-if="_expenseAttachmentError" class="au-error">
                                    {{ _expenseAttachmentError }}
                                </p>

                                <!-- Note -->
                                <small class="au-note">
                                    Allowed: PDF, XLSX, CSV, DOCX, DOC, PPTX, PPT, TXT, XLS &nbsp;|&nbsp; Max: 20MB
                                </small>
                            </div>

                            <!-- ACTIONS -->
                            <div class="attachment-upload-footer">
                                <button class="au-submit-btn au-submit-btn--green"
                                        @click="submitExpenseAttachment"
                                        :disabled="_expenseAttachmentUploading || !_expenseAttachmentFiles.length">
                                    <span v-if="_expenseAttachmentUploading"> Uploading...</span>
                                    <span v-else>⬆ Upload</span>
                                </button>


                            </div>

                        </div>

                        <!--for subscription-->
                        <!-- View Subscription Card -->
                        <!-- View Subscription Card -->
                        <div v-else-if="msg.type === 'view_subscription'"
                             style="padding:0;background:transparent;box-shadow:none;min-width:300px;max-width:380px;">
                            <div style="background:#fff;border-radius:16px;box-shadow:0 4px 18px rgba(0,0,0,0.12);overflow:hidden;font-family:inherit;width:100%;">

                                <!-- Header — matches ticket/meeting/expense blue gradient -->
                                <div style="background:linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65));color:#fff;padding:14px 18px;">
                                    <div style="display:flex;justify-content:space-between;align-items:center;">
                                        <div>
                                            <div style="font-size:11px;opacity:0.8;">Current Plan</div>
                                            <div style="font-size:16px;font-weight:700;margin-top:2px;">
                                                {{ msg.payload?.subscription_data?.title || msg.payload?.subscription_data?.planName || 'N/A' }}
                                            </div>
                                        </div>
                                        <!-- Status badge matching tp-status-badge style -->
                                        <!-- <span :style="{
                                            background: (msg.payload?.subscription_data?.isActive) ? '#dbeafe' : '#fee2e2',
                                            color: (msg.payload?.subscription_data?.isActive) ? '#1d4ed8' : '#dc2626',
                                            padding: '3px 12px',
                                            borderRadius: '20px',
                                            fontSize: '11px',
                                            fontWeight: '700',
                                            border: '1.5px solid ' + ((msg.payload?.subscription_data?.isActive) ? '#93c5fd' : '#fca5a5')
                                        }">-->
                                        <!--                                            {{ msg.payload?.subscription_data?.isActive ? '✔ Active' : '✖ Inactive' }}
                                        -->
                                        <!--</span>-->
                                    </div>

                                </div>



                                <!-- Body — matches ticket-preview-body style -->
                                <div style="padding:14px 16px;">



                                    <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid var(--clr-border,#e2ddd6);padding:7px 0;">
                                        <span style="font-weight:600;color:var(--clr-text-muted,#6b7280);font-size:11px;min-width:90px;">Company</span>
                                        <span style="font-size:12px;font-weight:600;color:var(--clr-text,#1a1f2e);">
                                            {{ msg.payload?.subscription_data?.companyName || msg.payload?.subscription_data?.company || 'N/A' }}
                                        </span>
                                    </div>

                                    <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid var(--clr-border,#e2ddd6);padding:7px 0;">
                                        <span style="font-weight:600;color:var(--clr-text-muted,#6b7280);font-size:11px;min-width:90px;">Price</span>
                                        <span style="font-size:14px;font-weight:700;color:rgb(15,102,184);">
                                            ${{ msg.payload?.subscription_data?.price || '0.00' }}
                                        </span>
                                    </div>

                                    <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid var(--clr-border,#e2ddd6);padding:7px 0;">
                                        <span style="font-weight:600;color:var(--clr-text-muted,#6b7280);font-size:11px;min-width:90px;">Billing Cycle</span>
                                        <span style="font-size:12px;font-weight:600;color:var(--clr-text,#1a1f2e);">
                                            {{ msg.payload?.subscription_data?.modeId || msg.payload?.subscription_data?.billingCycle || 'N/A' }}
                                        </span>
                                    </div>

                                    <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid var(--clr-border,#e2ddd6);padding:7px 0;">
                                        <span style="font-weight:600;color:var(--clr-text-muted,#6b7280);font-size:11px;min-width:90px;">Payment Status</span>
                                        <span style="font-size:12px;font-weight:600;color:var(--clr-text,#1a1f2e);">
                                            {{ msg.payload?.subscription_data?.paymentStatus || 'N/A' }}
                                        </span>
                                    </div>

                                    <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid var(--clr-border,#e2ddd6);padding:7px 0;">
                                        <span style="font-weight:600;color:var(--clr-text-muted,#6b7280);font-size:11px;min-width:90px;">Next Due</span>
                                        <span style="font-size:12px;font-weight:600;color:var(--clr-text,#1a1f2e);">
                                            {{ msg.payload?.subscription_data?.paymentNextDueDate || msg.payload?.subscription_data?.nextDueDate || 'N/A' }}
                                        </span>
                                    </div>

                                    <div style="display:flex;justify-content:space-between;align-items:center;padding:7px 0;"
                                         :style="getSubscriptionFeatures(msg.payload?.subscription_data?.description).length ? 'border-bottom:1px solid var(--clr-border,#e2ddd6);' : ''">
                                        <span style="font-weight:600;color:var(--clr-text-muted,#6b7280);font-size:11px;min-width:90px;">Free Trial</span>
                                        <span style="font-size:12px;font-weight:600;color:var(--clr-text,#1a1f2e);">
                                            {{ msg.payload?.subscription_data?.isFreeTrial ? 'Yes' : 'No' }}
                                        </span>
                                    </div>

                                    <!-- Features section -->
                                    <div v-if="getSubscriptionFeatures(msg.payload?.subscription_data?.description).length"
                                         style="padding-top:10px;margin-top:2px;">
                                        <div style="font-size:11px;font-weight:600;color:var(--clr-text-muted,#6b7280);margin-bottom:6px;">Features</div>
                                        <div v-for="(feature, i) in getSubscriptionFeatures(msg.payload?.subscription_data?.description)"
                                             :key="i"
                                             style="display:flex;align-items:flex-start;gap:8px;padding:4px 0;font-size:12px;color:var(--clr-text,#1a1f2e);">
                                            <span style="color:rgb(15,102,184);font-weight:700;flex-shrink:0;">✓</span>
                                            <span>{{ feature }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Footer — matches ticket-preview-footer style -->
                                <div style="background:#f8f6f2;padding:10px 16px;display:flex;align-items:center;justify-content:space-between;border-top:1px solid var(--clr-border,#e2ddd6);">
                                    <span style="font-size:11px;color:var(--clr-text-muted,#6b7280);">📅 {{ currentDate }}</span>
                                    <span style="color:#16a34a;font-weight:700;font-size:13px;">✔ Loaded</span>
                                </div>
                            </div>
                        </div>

                        <!-- Subscription Failed -->
                        <div v-else-if="msg.type === 'view_subscription_failed'" class="ticket-preview-card">
                            <div class="ticket-preview-header" style="background:linear-gradient(135deg,#dc2626,#991b1b);">
                                <span class="tp-icon">💳</span>
                                <div>
                                    <h4>Subscription Details</h4>
                                    <p>Could not load subscription info.</p>
                                </div>
                                <span class="ticket-preview-number tp-error-badge">⚠ Failed</span>
                            </div>
                            <div class="ticket-preview-body ticket-not-found-body">
                                <div class="ticket-not-found-icon">⚠️</div>
                                <p class="ticket-not-found-title">Fetch Failed</p>
                                <p class="ticket-not-found-desc">
                                    {{ msg.text || "Sorry, I couldn't fetch your subscription details. Please try again." }}
                                </p>
                                <div class="ticket-not-found-hint">
                                    💡 Please try again or contact support.
                                </div>
                            </div>
                            <div class="ticket-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="tp-failed">✖ Failed</span>
                            </div>
                        </div>
                        <!--booking div start -->
                        <!-- Booking Preview Card -->
                        <div v-else-if="msg.type === 'booking_preview'" class="booking-preview-card">
                            <div class="booking-preview-header">
                                <span class="bp-icon">🏠</span>
                                <div>
                                    <h4 style="color:white">Booking Summary</h4>

                                </div>
                            </div>
                            <div class="booking-preview-body">
                                <div class="booking-preview-row">
                                    <span class="bp-label">Asset</span>
                                    <span class="bp-value">{{ msg.payload?.booking_data?.prefilled?.assetName || msg.payload?.booking_data?.assetName || '—' }}</span>
                                </div>
                                <div class="booking-preview-row">
                                    <span class="bp-label">Check-in</span>
                                    <span class="bp-value">{{ formatDateMDY(msg.payload?.booking_data?.prefilled?.checkinDate || msg.payload?.booking_data?.checkinDate) }}</span>
                                </div>
                                <div class="booking-preview-row">
                                    <span class="bp-label">Check-out</span>
                                    <span class="bp-value">{{ formatDateMDY(msg.payload?.booking_data?.prefilled?.checkoutDate || msg.payload?.booking_data?.checkoutDate) }}</span>
                                </div>
                                <div class="booking-preview-row">
                                    <span class="bp-label">Duration</span>
                                    <span class="bp-value">{{ getBookingNights(msg.payload?.booking_data?.prefilled || msg.payload?.booking_data) }} night(s)</span>
                                </div>
                                <div class="booking-preview-row" v-if="(msg.payload?.booking_data?.prefilled?.message || msg.payload?.booking_data?.message)">
                                    <span class="bp-label">Message</span>
                                    <span class="bp-value">{{ msg.payload?.booking_data?.prefilled?.message || msg.payload?.booking_data?.message }}</span>
                                </div>
                            </div>
                            <div class="meeting-preview-actions">
                                <button class="meeting-confirm-btn"
                                        :disabled="isCardDisabled(msg)"
                                        :style="{ opacity: isCardDisabled(msg) ? '0.5' : '1', cursor: isCardDisabled(msg) ? 'not-allowed' : 'pointer' }"
                                        @click="confirmBookingPreview(msg)">
                                    ✅ Confirm &amp; Book
                                </button>
                                <button class="meeting-cancel-btn"
                                        :disabled="isCardDisabled(msg)"
                                        :style="{ opacity: isCardDisabled(msg) ? '0.5' : '1', cursor: isCardDisabled(msg) ? 'not-allowed' : 'pointer' }"
                                        @click="cancelBookingPreview()">
                                    ✕ Cancel
                                </button>
                            </div>
                            <div class="booking-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="bp-pending">⏳ Pending Confirmation</span>
                            </div>
                        </div>

                        <!-- Booking Created / Failed Card -->
                        <div v-else-if="msg.type === 'booking_created' || msg.type === 'booking_failed'" class="booking-preview-card">
                            <div class="booking-preview-header" :style="msg.type === 'booking_failed' ? 'background: linear-gradient(135deg, #dc2626, #991b1b);' : ''">
                                <span class="bp-icon">🏠</span>
                                <div>
                                    <h4 style="color:white">{{ msg.type === 'booking_failed' ? 'Booking Failed' : 'Booking Confirmed! 🎉' }}</h4>
                                    <p>{{ msg.type === 'booking_failed' ? 'Something went wrong.' : 'A confirmation email will be sent shortly.' }}</p>
                                </div>
                                <span v-if="msg.type === 'booking_created' && msg.payload?.booking_data?.bookingId" class="booking-preview-number">
                                    #{{ msg.payload.booking_data.bookingId }}
                                </span>
                                <span v-else-if="msg.type === 'booking_failed'" class="booking-preview-number bp-error-badge">
                                    ⚠ Failed
                                </span>
                            </div>
                            <div class="booking-preview-body">
                                <div class="booking-preview-row">
                                    <span class="bp-label">Asset</span>
                                    <span class="bp-value">{{ msg.payload?.booking_data?.assetName || '—' }}</span>
                                </div>
                                <div class="booking-preview-row">
                                    <span class="bp-label">Check-in</span>
                                    <span class="bp-value">{{ formatDateMDY(msg.payload?.booking_data?.checkinDate) }}</span>
                                </div>
                                <div class="booking-preview-row">
                                    <span class="bp-label">Check-out</span>
                                    <span class="bp-value">{{ formatDateMDY(msg.payload?.booking_data?.checkoutDate) }}</span>
                                </div>
                                <div class="booking-preview-row">
                                    <span class="bp-label">Duration</span>
                                    <span class="bp-value">{{ msg.payload?.booking_data?.nights || '—' }} night(s)</span>
                                </div>
                            </div>
                            <div v-if="msg.type === 'booking_failed'" class="booking-preview-error">
                                <span class="bp-err-icon">⚠️</span>
                                <p>{{ msg.payload?.booking_data?.error || 'Booking failed. Please try again.' }}</p>
                            </div>
                            <div class="booking-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span v-if="msg.type === 'booking_failed'" class="bp-failed">✖ Not Submitted</span>
                                <span v-else class="bp-check">✔ Submitted</span>
                            </div>
                        </div>

                        <!-- Booking Dates Blocked -->
                        <div v-else-if="msg.type === 'booking_dates_blocked'" class="ticket-flow-card">
                            <div class="ticket-flow-header">
                                <span v-html="msg.text"></span>
                            </div>
                        </div>

                        <!-- View Bookings List -->
                        <div v-else-if="msg.type === 'view_bookings'" class="booking-preview-card">
                            <div class="booking-preview-header">
                                <span class="bp-icon">🏠</span>
                                <div>
                                    <h4 style="color: white">{{ msg.payload?.booking_data?.heading || 'Your Bookings' }}</h4>
                                </div>
                                <span class="booking-preview-number" v-if="(msg.payload?.booking_data?.bookings || []).length">
                                    {{ msg.payload.booking_data.bookings.length }} booking{{ msg.payload.booking_data.bookings.length !== 1 ? 's' : '' }}
                                </span>
                            </div>

                            <div v-if="!(msg.payload?.booking_data?.bookings || []).length"
                                 class="booking-preview-body"
                                 style="text-align:center; padding:16px;">
                                No bookings found.
                            </div>

                            <div v-else class="booking-preview-body" style="padding: 0 16px 8px;">
                                <div v-for="(b, idx) in msg.payload.booking_data.bookings" :key="idx"
                                     :style="idx < msg.payload.booking_data.bookings.length - 1 ? 'border-bottom: 1px solid var(--clr-border); padding: 10px 0;' : 'padding: 10px 0;'">
                                    <div style="display:flex; justify-content:space-between; align-items:flex-start; gap:8px;">
                                        <div style="flex:1;">
                                            <div style="font-weight:600; font-size:13px;">{{ b.assetName }}</div>
                                            <div style="font-size:11px; color:var(--clr-text-muted); margin-top:3px;">
                                                <!--📅checkinDate → checkoutDate-->
                                                {{ formatDateMDY(b.checkinDate) }} → {{ formatDateMDY(b.checkoutDate) }}
                                            </div>
                                            <div style="margin-top:4px;">
                                                <span :style="`background:${getBookingStatusColor(b.status)}1a; color:${getBookingStatusColor(b.status)}; border:1px solid ${getBookingStatusColor(b.status)}55; padding:1px 8px; border-radius:10px; font-size:10px; font-weight:600;`">
                                                    {{ b.status }}
                                                </span>
                                            </div>
                                            di
                                        </div>
                                        <!--<span style="color:rgb(15,102,184); font-size:11px; font-weight:600;">#{{ b.bookingId }}</span>-->
                                    </div>
                                </div>
                            </div>
                            <div class="booking-preview-footer">
                                <span>📅 {{ currentDate }}</span>
                                <span class="bp-check">✔ Loaded</span>


                                /d
                            </div>


                        </div>


                        <!-- View Bookings Empty / Failed / Cancelled — plain text -->
                        <div v-else-if="msg.type === 'view_bookings_empty' || msg.type === 'view_bookings_failed' || msg.type === 'booking_cancelled'"
                             class="ticket-flow-card">
                            <div class="ticket-flow-header">
                                <span class="tf-icon">🏠</span>
                                <span>{{ msg.payload?.response || msg.text }}</span>
                            </div>
                        </div>
                        <!--booking div end-->
                        <!-- Subscription Empty -->
                        <div v-else-if="msg.type === 'view_subscription_empty'" class="ticket-flow-card">
                            <div class="ticket-flow-header">
                                <span class="tf-icon">💳</span>
                                <span v-html="formatBotResponse(msg.text || 'You don\'t have an active subscription at the moment.')"></span>
                            </div>
                        </div>
                        <!-- Expense Created Card -->
                        <div v-else-if="msg.type === 'expense_created' || msg.type === 'expense_api_error'" class="ticket-preview-card">



                            <!-- HEADER -->
                            <div class="ticket-preview-header">
                                <span class="tp-icon">💰</span>
                                <div>
                                    <h4>{{ msg.type === 'expense_api_error' ? 'Expense Details' : 'Expense Created!' }}</h4>
                                    <p>{{ msg.type === 'expense_api_error' ? 'Submission failed — see details below.' : 'Your expense has been recorded.' }}</p>
                                    /p
                                </div>
                                /p
                                <!--<span class="ticket-preview-number">
                                    #{{ msg.payload?.expense_data?.expenseId || '—' }}
                                </span>-->
                            </div>

                            <!-- BODY -->
                            <div class="ticket-preview-body">



                                ck

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Status</span>

                                    <span class="tp-value">
                                        <span v-if="msg.type === 'expense_api_error'"
                                              class="tp-status-badge tp-status-failed">
                                            Failed
                                        </span>

                                        <span v-else
                                              class="tp-status-badge">
                                            Submitted
                                        </span>
                                    </span>
                                </div>

                                <!--<div class="ticket-preview-row">
                                                                    <span class="tp-label">Expense ID</span>
                                                                    <span class="tp-value">#{{ msg.payload?.expense_data?.expenseId || '—' }}</span>
                                                                </div>
                                -->
                                <div class="ticket-preview-row">
                                    <span class="tp-label">
                                        Title
                                    </span>
                                    <span class="tp-value">{{ msg.payload?.expense_data?.expenseTitle || '—' }}</span>
                                </div>

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Asset</span>
                                    <span class="tp-value">{{ msg.payload?.expense_data?.assetName || '—' }}</span>
                                </div>

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Category</span>
                                    <span class="tp-value">{{ msg.payload?.expense_data?.categoryName || '—' }}</span>
                                </div>

                                <div class="ticket-preview-row">
                                    <span class="tp-label">Amount</span>
                                    <span class="tp-value" style="color:#1e2d45; font-weight:600;">  ${{ formatCurrencyUS(msg.payload?.expense_data?.amount) }}</span>
                                </div>

                                <!--<div class="ticket-preview-row">
                                                                    <span class="tp-label">Vendor</span>
                                                                    <span class="tp-value">{{ msg.payload?.expense_data?.vendorName || '—' }}</span>
                                                                </div>
                                -->
                                <div class="ticket-preview-row">
                                    pa
                                    <span class="tp-label">Payment Datepa</span>
                                    <span class="tp-value">{{ formatDateMDY(msg.payload?.expense_data?.expensePaymentDate) }}</span>

                                    se


                                </div>




                            </div>

                            <!-- ERROR BLOCK -->
                            <div v-if="msg.type === 'expense_api_error'" class="ticket-preview-error">
                                <span class="tp-err-icon">
                                    ⚠️
                                </span>
                                <p>
                                    <strong>Error:</strong>
                                    {{ msg.payload?.expense_data?.error || 'Submission failed. Please try again later.' }}
                                    <br>Please try again later or contact support.
                                </p>
                            </div>

                            <!-- FOOTER -->
                            <div class="ticket-preview-footer">
                                <span> {{ currentDate }}</span>
                                <span v-if="msg.type === 'expense_api_error'" class="tp-failed"> Not Submitted</span>
                                <span v-else class="tp-check"> Submitted</span>
                            </div>

                        </div>
                        <!-- Document Vault: generic flow message -->
                        <!-- Generic flow message (e.g. "What's the Document Title?") -->
                        <div v-else-if="msg.type === 'document_vault_flow'" class="ticket-flow-card">
                            <div class="ticket-flow-header">
                                <!--<span class="tf-icon">📄</span>-->
                                <span v-html="formatBotResponse(msg.payload?.response)"></span>
                            </div>
                        </div>
                        <!-- Document type picker -->
                        <div v-else-if="msg.type === 'document_vault_doctype_prompt'" class="ticket-flow-card">
                            <div class="ticket-flow-header document-vault-blue-header">
                                <span>{{ msg.payload?.response }}</span>
                            </div>
                            <div class="ticket-asset-options" v-if="getDocTypeOptions(msg).length">
                                <button v-for="(dt, i) in getDocTypeOptions(msg)"
                                        :key="i"
                                        class="ticket-option-btn ticket-asset-card"
                                        :disabled="isCardDisabled(msg)"
                                        :style="{ opacity: isCardDisabled(msg) ? '0.5' : '1', cursor: isCardDisabled(msg) ? 'not-allowed' : 'pointer' }"
                                        @click="submitDocTypePick(dt.name, dt.id)">
                                    <span>{{ dt.name }}</span>
                                    <span class="tf-arrow">→</span>
                                </button>
                            </div>
                            <div v-else class="ticket-flow-hint">No document types found.</div>
                        </div>
                        <!-- Initial file upload -->
                        <div v-else-if="msg.type === 'document_vault_upload_prompt'" class="attachment-upload-card">
                            <div class="attachment-upload-header">

                                <div>
                                    <h4>Upload Document</h4>
                                    <p>{{ msg.payload?.response || 'Please choose a file to upload.' }}</p>
                                </div>
                            </div>
                            <div class="attachment-upload-body">
                                <label class="au-file-label">
                                    <input type="file"
                                           accept=".pdf,.xlsx,.csv,.docx,.doc,.pptx,.ppt,.txt,.xls"
                                           class="au-file-input"
                                           @change="onDocVaultFileChange($event, msg)"
                                           :disabled="msg._docUploading || isCardDisabled(msg)" />
                                    <span class="au-file-btn"> Choose File</span>
                                </label>
                                <div v-if="msg._docFile" class="au-file-preview">
                                    <span class="au-file-chip"> {{ msg._docFile.name }}</span>
                                </div>
                                <p v-if="msg._docFileError" class="au-error"> {{ msg._docFileError }}</p>
                                <small class="au-note">PDF, XLSX, CSV, DOCX, PPT, TXT, XLS &nbsp;|&nbsp; Max 8MB</small>
                            </div>
                            <div class="attachment-upload-footer">
                                <button class="au-submit-btn"
                                        :disabled="!msg._docFile || msg._docUploading || isCardDisabled(msg)"
                                        @click="submitDocVaultFile(msg)">
                                    <span v-if="msg._docUploading"> Uploading...</span>
                                    <span v-else>⬆ Upload File</span>
                                </button>
                            </div>
                        </div>
                        <!-- Co-owner picker -->
                        <div v-else-if="msg.type === 'document_vault_coowner_prompt'" class="ticket-flow-card">
                            <div class="ticket-flow-header document-vault-blue-header">
                                <span>{{ msg.payload?.response }}</span>
                            </div>
                            <div class="ticket-asset-options">
                                <button class="ticket-option-btn ticket-asset-card"
                                        :disabled="isCardDisabled(msg)"
                                        :style="{ opacity: isCardDisabled(msg) ? '0.5' : '1', cursor: isCardDisabled(msg) ? 'not-allowed' : 'pointer' }"
                                        @click="submitDocCoOwnerPick('Select All co-owners', 'all')">
                                    <span>Select All co-owners</span>
                                    <span class="tf-arrow">→</span>
                                </button>
                                <button v-for="(u, i) in getDocCoOwnerOptions(msg)"
                                        :key="i"
                                        class="ticket-option-btn ticket-asset-card"
                                        :disabled="isCardDisabled(msg)"
                                        :style="{ opacity: isCardDisabled(msg) ? '0.5' : '1', cursor: isCardDisabled(msg) ? 'not-allowed' : 'pointer' }"
                                        @click="submitDocCoOwnerPick(u.label, u.label)">
                                    <span>{{ u.label }}</span>
                                    <span class="tf-arrow">→</span>
                                </button>
                            </div>
                        </div>

                        <!-- Summary / preview card (eSign + Active toggles, attach, save) -->
                        <div v-else-if="msg.type === 'document_vault_preview'" class="meeting-preview-card">
                            <div class="meeting-preview-header">

                                <div>
                                    <h4>Document Summary</h4>
                                    <p>{{ msg.payload?.response || 'Please review before saving' }}</p>
                                </div>
                            </div>

                            <div class="meeting-preview-body">
                                <div class="meeting-preview-row">
                                    <span class="mp-label">Title</span>
                                    <span class="mp-value">{{ getDocPrefilled(msg).docTitle || '—' }}</span>
                                </div>
                                <div class="meeting-preview-row">
                                    <span class="mp-label">Asset</span>
                                    <span class="mp-value">{{ getDocPrefilled(msg).assetName || '—' }}</span>
                                </div>
                                <div class="meeting-preview-row">
                                    <span class="mp-label">Document Type</span>
                                    <span class="mp-value">{{ getDocPrefilled(msg).documentTypeName || '—' }}</span>
                                </div>
                                <div class="meeting-preview-row">
                                    <span class="mp-label">Co-owners</span>
                                    <span class="mp-value">{{ getDocCoOwnerText(msg) }}</span>
                                </div>
                                <div class="meeting-preview-row">
                                    <span class="mp-label">Is eSign Mandatory?</span>
                                    <span class="mp-value">
                                        <input type="checkbox" v-model="msg._docEsign" class="mp-participant-cb" />
                                    </span>
                                </div>
                                <div class="meeting-preview-row">
                                    <span class="mp-label">Is Active?</span>
                                    <span class="mp-value">
                                        <input type="checkbox" v-model="msg._docActive" class="mp-participant-cb" />
                                    </span>
                                </div>

                                <div v-if="msg._docShowAttach"
                                     class="meeting-preview-row"
                                     style="flex-direction: column; align-items: flex-start; gap: 8px;">
                                    <span class="mp-label"> Attach File</span>
                                    <label class="au-file-label" style="width:100%;">
                                        <input type="file"
                                               accept=".pdf,.xlsx,.csv,.docx,.doc,.pptx,.ppt,.txt,.xls"
                                               class="au-file-input"
                                               @change="onDocPreviewFileChange($event, msg)" />
                                        <span class="au-file-btn" style="width:100%; text-align:center; display:block; box-sizing:border-box;">
                                            Choose File
                                        </span>
                                    </label>
                                    <div v-if="msg._docAttachFile" class="au-file-preview">
                                        <span class="au-file-chip au-file-chip--green"> {{ msg._docAttachFile.name }}</span>
                                    </div>
                                    <small class="au-note">
                                        PDF, XLSX, CSV, DOCX, PPT, TXT, XLS &nbsp;|&nbsp; Max 8MB
                                    </small>
                                </div>
                            </div>

                            <div class="meeting-preview-actions">
                                <button v-if="!msg._docShowAttach"
                                        class="meeting-confirm-btn"
                                        :disabled="isCardDisabled(msg)"
                                        @click="msg._docShowAttach = true">
                                    Attach File
                                </button>
                                <button v-else
                                        class="meeting-confirm-btn"
                                        :disabled="!msg._docAttachFile || isCardDisabled(msg)"
                                        :style="{ opacity: (!msg._docAttachFile || isCardDisabled(msg)) ? '0.5' : '1', cursor: (!msg._docAttachFile || isCardDisabled(msg)) ? 'not-allowed' : 'pointer' }"
                                        @click="confirmDocVaultSave(msg)">
                                    Save &amp; Upload
                                </button>
                                <button class="meeting-cancel-btn"
                                        :disabled="isCardDisabled(msg)"
                                        @click="cancelDocVaultPreview(msg)">
                                    Cancel
                                </button>
                            </div>

                            <div class="meeting-preview-footer">
                                <span> {{ currentDate }}</span>
                                <span class="mp-failed">Pending Confirmation</span>
                            </div>
                        </div>
                        <!-- Upload result: success / failure -->
                        <div v-else-if="msg.type === 'document_vault_created' || msg.type === 'document_vault_failed'" class="ticket-preview-card">
                            <div class="ticket-preview-header"
                                 :style="msg.type === 'document_vault_failed'
            ? 'background: linear-gradient(135deg, #dc2626, #991b1b);'
            : 'background: linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65));'">

                                <div>
                                    <h4>{{ msg.type === 'document_vault_failed' ? 'Upload Failed' : 'Document Uploaded! 🎉' }}</h4>
                                    <p>{{ msg.type === 'document_vault_failed' ? 'Something went wrong.' : 'Your document has been saved.' }}</p>
                                </div>
                            </div>
                            <div class="ticket-preview-body">
                                <div class="ticket-preview-row">
                                    <span class="tp-label">Title</span>
                                    <span class="tp-value">{{ msg.payload?.document_vault_data?.docTitle || '—' }}</span>
                                </div>
                                <div class="ticket-preview-row">
                                    <span class="tp-label">Asset</span>
                                    <span class="tp-value">{{ msg.payload?.document_vault_data?.assetName || '—' }}</span>
                                </div>
                                <div class="ticket-preview-row">
                                    <span class="tp-label">Type</span>
                                    <span class="tp-value">{{ msg.payload?.document_vault_data?.documentTypeName || '—' }}</span>
                                </div>
                                <div class="ticket-preview-row">
                                    <span class="tp-label">File</span>
                                    <span class="tp-value">{{ msg.payload?.document_vault_data?.fileName || '—' }}</span>
                                </div>
                                <div class="ticket-preview-row">
                                    <span class="tp-label">eSign Mandatory</span>
                                    <span class="tp-value">{{ msg.payload?.document_vault_data?.isSignMandatory ? 'Yes' : 'No' }}</span>
                                </div>
                                <div class="ticket-preview-row">
                                    <span class="tp-label">Is Active</span>
                                    <span class="tp-value">{{ msg.payload?.document_vault_data?.isActive !== false ? 'Yes' : 'No' }}</span>
                                </div>
                                <div class="ticket-preview-row">
                                    <span class="tp-label">Co-owners</span>
                                    <span class="tp-value" style="text-align:end;">
                                        {{
                    (msg.payload?.document_vault_data?.coOwnerNames || []).length
                        ? msg.payload.document_vault_data.coOwnerNames.join(', ')
                        : (msg.payload?.document_vault_data?.isAllCoOwners ? 'All co-owners' : '—')
                                        }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="msg.type === 'document_vault_failed'" class="ticket-preview-error">
                                <span class="tp-err-icon">⚠️</span>
                                <p><strong>Error:</strong> {{ msg.payload?.document_vault_data?.error || 'Please try again.' }}</p>
                            </div>
                            <div class="ticket-preview-footer">
                                <span> {{ currentDate }}</span>
                                <span v-if="msg.type === 'document_vault_failed'" class="tp-failed"> Not Saved</span>
                                <span v-else class="tp-check"> Saved</span>
                            </div>
                        </div>

                        <!-- Upload cancelled -->
                        <div v-else-if="msg.type === 'document_vault_cancelled'" class="ticket-flow-card">
                            <div class="ticket-flow-header">

                                <span>{{ msg.payload?.response || msg.text || 'Document upload cancelled.' }}</span>
                            </div>
                        </div>

                        <!-- List view -->
                        <div v-else-if="msg.type === 'view_documents'" class="ticket-preview-card">
                            <div class="ticket-preview-header">

                                <div>
                                    <h4>{{ msg.payload?.document_vault_data?.heading || 'Document Vault' }}</h4>
                                </div>
                                <span class="ticket-preview-number" v-if="getDocuments(msg).length">
                                    {{ getDocuments(msg).length }} document{{ getDocuments(msg).length !== 1 ? 's' : '' }}
                                </span>
                            </div>

                            <div v-if="!getDocuments(msg).length" class="ticket-preview-body" style="text-align:center; padding:16px;">
                                No documents found.
                            </div>

                            <div v-else class="ticket-preview-body" style="padding: 0 16px 8px;">
                                <div v-for="(d, idx) in getDocuments(msg)" :key="idx"
                                     :style="idx < getDocuments(msg).length - 1 ? 'border-bottom: 1px solid var(--clr-border); padding: 12px 0;' : 'padding: 12px 0;'">

                                    <div style="display:flex; justify-content:space-between; align-items:flex-start; gap:8px;">
                                        <div style="flex:1;">
                                            <div style="font-weight:600; font-size:13px;">{{ d.docTitle }}</div>
                                            <div style="font-size:11px; color:var(--clr-text-muted); margin-top:3px;">
                                                {{ d.documentType }} &nbsp;|&nbsp;  {{ d.assetName }}
                                            </div>
                                            <div style="margin-top:4px; display:flex; gap:4px; flex-wrap:wrap; align-items:center;">
                                                <button @click="confirmDocumentStatusToggle(d)"
                                                        :disabled="isCardDisabled(msg)"
                                                        :style="`background:${d.isActive !== false ? '#16a34a' : '#dc2626'}1a; color:${d.isActive !== false ? '#16a34a' : '#dc2626'}; border:1px solid ${d.isActive !== false ? '#16a34a' : '#dc2626'}55; padding:1px 8px; border-radius:10px; font-size:10px; font-weight:600; cursor:${isCardDisabled(msg) ? 'not-allowed' : 'pointer'}; opacity:${isCardDisabled(msg) ? '0.5' : '1'};`">
                                                    {{ d.isActive !== false ? 'Active' : 'Inactive' }}
                                                </button>

                                                <!-- eSign Mandatory / Optional badge like reference UI -->
                                                <button type="button"
                                                        class="doc-esign-mandatory-btn"
                                                        :class="d.isSignMandatory
                                                            ? 'doc-esign-mandatory-btn--yes'
                                                            : 'doc-esign-mandatory-btn--no'"
                                                        :disabled="isCardDisabled(msg)"
                                                        @click="showDocumentEsignMandatoryPopup(d)">
                                                    {{ d.isSignMandatory ? 'eSign Mandatory' : 'eSign Optional' }}
                                                </button>

                                                <!-- Existing eSign status remains separate -->
                                                <span v-if="d.isSignMandatory"
                                                      :style="d.isEsigned
                                ? 'background:#dcfce71a;color:#16a34a;border:1px solid #16a34a55;padding:1px 8px;border-radius:10px;font-size:10px;font-weight:600;'
                                : 'background:#fef3c71a;color:#b45309;border:1px solid #b4530955;padding:1px 8px;border-radius:10px;font-size:10px;font-weight:600;'">
                                                    {{ d.isEsigned ? 'eSigned' : 'eSign Pending' }}
                                                </span>
                                            </div>
                                        </div>

                                        <button @click="toggleDocumentListItem(msg, idx)"
                                                :disabled="isCardDisabled(msg)"
                                                :style="{ opacity: isCardDisabled(msg) ? '0.5' : '1', cursor: isCardDisabled(msg) ? 'not-allowed' : 'pointer', background:'none', border:'none', color:'var(--clr-accent)', fontSize:'11px', fontWeight:'600', padding:'4px 8px' }">
                                            {{ isDocumentListItemOpen(msg, idx) ? 'Hide' : 'Details' }}
                                        </button>

                                        <button @click="confirmDocumentDelete(d)"
                                                :disabled="isCardDisabled(msg)"
                                                :style="{ opacity: isCardDisabled(msg) ? '0.5' : '1', cursor: isCardDisabled(msg) ? 'not-allowed' : 'pointer', background:'none', border:'none', color:'#dc2626', fontSize:'11px', fontWeight:'600', padding:'4px 8px' }">
                                            Delete
                                        </button>
                                    </div>

                                    <div v-if="isDocumentListItemOpen(msg, idx)"
                                         style="padding-top:8px; margin-top:8px; border-top:1px dashed var(--clr-border);">
                                        <div style="display:flex; gap:6px; padding:3px 0; font-size:11px;">
                                            <span style="color:var(--clr-text-muted); min-width:110px;">Title</span><span>{{ d.docTitle }}</span>
                                        </div>
                                        <div style="display:flex; gap:6px; padding:3px 0; font-size:11px;">
                                            <span style="color:var(--clr-text-muted); min-width:110px;">Asset</span><span>{{ d.assetName }}</span>
                                        </div>
                                        <div style="display:flex; gap:6px; padding:3px 0; font-size:11px;">
                                            <span style="color:var(--clr-text-muted); min-width:110px;">Type</span><span>{{ d.documentType }}</span>
                                        </div>
                                        <div style="display:flex; gap:6px; padding:3px 0; font-size:11px;">
                                            <span style="color:var(--clr-text-muted); min-width:110px;">Created On</span><span>{{ d.createdOn }}</span>
                                        </div>
                                        <div style="display:flex; gap:6px; padding:3px 0; font-size:11px;">
                                            <span style="color:var(--clr-text-muted); min-width:110px;">eSign Mandatory</span><span>{{ d.isSignMandatory ? 'Yes' : 'No' }}</span>
                                        </div>
                                        <div style="display:flex; gap:6px; padding:3px 0; font-size:11px;">
                                            <span style="color:var(--clr-text-muted); min-width:110px;">Is Active</span><span>{{ d.isActive !== false ? 'Yes' : 'No' }}</span>
                                        </div>
                                        <div v-if="d.fileName" style="display:flex; gap:6px; padding:3px 0; font-size:11px; align-items:center;">
                                            <span style="color:var(--clr-text-muted); min-width:110px;">File</span>
                                            <a :href="getDocumentDownloadUrl(d)" target="_blank" rel="noopener"
                                               style="background:#0b4a3f; color:#fff; padding:3px 10px; border-radius:10px; font-size:11px; font-weight:600; text-decoration:none;">
                                                ⬇ Download
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="ticket-preview-footer">
                                <span> {{ currentDate }}</span>
                                <span class="tp-check">✔ Loaded</span>
                            </div>
                        </div>

                        <!-- Empty list -->
                        <div v-else-if="msg.type === 'view_documents_empty'" class="ticket-flow-card">
                            <div class="ticket-flow-header">

                                <span>{{ msg.payload?.response || msg.text || 'You have no documents yet.' }}</span>
                            </div>
                        </div>

                        <!-- Delete / status-toggle results (bold markdown now renders via formatMessage) -->
                        <div v-else-if="msg.type === 'document_deleted' || msg.type === 'document_status_updated'" class="ticket-flow-card">
                            <div class="ticket-flow-header">
                                <!--<span class="tf-icon">✅</span>-->
                                <span v-html="formatBotResponse(msg.payload?.response || msg.text)"></span>
                            </div>
                        </div>
                        <div v-else-if="msg.type === 'document_delete_failed' || msg.type === 'document_status_update_failed'" class="ticket-flow-card">
                            <div class="ticket-flow-header">

                                <span v-html="formatMessage(msg.payload?.response || msg.text)"></span>
                            </div>
                        </div>


                        <!-- Chores & Events (isolated) -->
                        <ChatbotChoresEvents v-else-if="choresEventsEnabled && (isChoresEventsCardIntent(msg.type) || ['event_flow', 'event_guest_source_prompt', 'event_guest_roommate_prompt', 'view_events_guestlist', 'view_events_duplicate', 'event_guest_invite_prompt', 'chore_status_update_flow'].includes(msg.type))"
                                             :msg="msg"
                                             :disabled="isCardDisabled(msg)"
                                             :current-date="currentDate"
                                             @confirm-chore="confirmChorePreview"
                                             @delete-chore="deleteChoreItem"
                                             @confirm-event="confirmEventPreview"
                                             @cancel="cancelChoresEventsCard"
                                             @add-guest="addEventGuest"
                                             @event-detail="viewEventDetail"
                                             @cancel-event="cancelEventItem"
                                             @delete-event="deleteEventItem"
                                             @delete-event-guest="deleteEventGuest"
                                             @duplicate-event="duplicateEventItem"
                                             @select-event-guest-invite="selectEventGuestInvite"
                                             @select-event-guest-source="selectEventGuestSource"
                                             @select-event-guest-roommate="selectEventGuestRoommate"
                                             @event-guest-phone-validity-change="onEventGuestPhoneValidityChange"
                                             @select-chore-frequency="selectChoreFrequency"
                                             @select-chore-roommates="selectChoreRoommates"
                                             @select-chore-status-update="selectChoreStatusUpdate"
                                             @submit-event-guest-phone="submitEventGuestPhone" />


                        <div v-else class="message bot-message" v-html="msg.text">
                        </div>
                    </div>

                    <!-- USER -->
                    <div v-if="msg.from === 'user'" class="message-row user">
                        <div class="message user-message">{{ msg.text }}</div>
                    </div>

                </div>

                <!-- Typing -->
                <div v-if="isTyping" class="typing-indicator">
                    <img src="../../assets/images/Robot.jpg" class="bot-avatar-msg">
                    <span></span><span></span><span></span>
                </div>

            </div>

            <!-- INPUT -->
            <div class="chat-input" :class="{ 'chat-input-disabled': isInputDisabled }">
                <textarea v-model="userInput"
                          placeholder="Type your message..."
                          :disabled="isInputDisabled"
                          :placeholder="isInputDisabled ? '⬆ Please use the options above...' : 'Type your message...'"
                          @keydown="handleKeyDown">
                </textarea>

                <button class="send-btn"
                        :disabled="isInputDisabled"
                        @click="sendMessage()">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                        <path d="M2 21l21-9L2 3v7l15 2-15 2z" />
                    </svg>
                </button>
            </div>

        </div>

        <!-- Document Vault confirmation modal - single page-level instance -->
        <div v-if="_confirmModal.show"
             class="confirm-modal-overlay"
             @click.self="closeConfirmModal">
            <div class="confirm-modal-card" @click.stop>
                <div class="confirm-modal-header">
                    {{ _confirmModal.title || 'Confirmation' }}
                </div>

                <div class="confirm-modal-body">
                    <p class="confirm-modal-message">{{ _confirmModal.message }}</p>

                    <div class="confirm-modal-actions">
                        <button type="button"
                                class="confirm-modal-btn confirm-modal-ok"
                                @click="acceptConfirmModal">
                            Ok
                        </button>
                        <button type="button"
                                class="confirm-modal-btn confirm-modal-cancel"
                                @click="closeConfirmModal">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Image Popup Modal with Zoom -->
        <div v-if="showImagePopup" class="image-popup-overlay" @click="closeImagePopup">
            <div class="image-popup-container" @click.stop>
                <button class="image-popup-close" @click="closeImagePopup">×</button>
                <div class="image-popup-content">
                    <img ref="popupImage"
                         :src="activeImage"
                         alt="Zoomed view"
                         :style="imageZoomStyle"
                         @wheel.prevent="handleWheelZoom" />
                </div>
                <div class="image-popup-zoom-controls">
                    <button class="zoom-btn" @click="zoomIn">+</button>
                    <button class="reset-btn" @click="resetZoom">Reset</button>
                    <button class="zoom-btn" @click="zoomOut">-</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import UserService from '@/service/user.service.js';
    import axios from "axios";
    import MarkdownIt from 'markdown-it';
    import FrondEndService from '@/service/CompanyUserServices/CompanyUserService.js';
    import CommonUses from '@/views/shared/common/commonuses';
    import ManageAssetsService from "@/service/crmservice/manageassetsservice";
    import onboardingService from '@/service/onboarding.service';
    import { CHECKLIST_PROGRESS_EVENT, CHECKLIST_AUTO_OPEN_REQUEST_EVENT, recordChecklistCloseTime, shouldAutoOpenChecklist } from '@/helpers/checklistCompletion';
    import checklistFloatGif from '@/assets/images/onboarding-checklist-float.gif';
    import ChatbotChoresEvents from './ChatbotChoresEvents.vue';
    import AddRoomate from './AddRoomate.vue';
    import VendorChatbot from './VendorChatbot.vue';
    import ManageVendors from './ManageVendors.vue';
    import Dropdown from 'primevue/dropdown';
    import {
        CHORES_EVENTS_ENABLED,
        CHORES_EVENTS_CARD_INTENTS,
        CHORES_EVENTS_OUTCOME_TYPES,
        isChoresEventsCardIntent,

        NOTIFICATIONS_CHATBOT_ENABLED,
        NOTIFICATION_CARD_INTENTS,
        NOTIFICATION_OUTCOME_TYPES,
        isNotificationCardIntent,
        isNotificationIntent,

        ROOMMATE_CHATBOT_ENABLED,
        ROOMMATE_CARD_INTENTS,
        ROOMMATE_OUTCOME_TYPES,
        isRoommateCardIntent,
        isRoommateIntent,

        VENDOR_CHATBOT_ENABLED,
        VENDOR_CARD_INTENTS,
        VENDOR_OUTCOME_TYPES,
        isVendorCardIntent,
        isVendorIntent,


        MANAGE_VENDORS_ENABLED,
        MANAGE_VENDOR_CARD_INTENTS,
        MANAGE_VENDOR_OUTCOME_TYPES,
        isManageVendorCardIntent,
        isManageVendorIntent,

    } from './choresEvents.constants';
    import HouseholdExpenseFlow from './HouseholdExpenseFlow.vue';
    import ManageGuestGroups from './ManageGuestGroups.vue';
    import NotificationsChatbot from './NotificationsChatbot.vue';

    const HOUSEHOLD_EXPENSE_CARD_INTENTS = [
        'household_expense_type_prompt',
        'household_expense_option_prompt',
        'household_expense_form',
        'household_expense_created',
        'household_expense_failed',
    ];
    const MANAGE_GUEST_GROUP_CARD_INTENTS = [
        'guest_group_flow',
        'guest_group_preview',
        'guest_group_created',
        'guest_group_failed',
        'view_guest_groups',
        'guest_group_detail',
    ];




    export default {
        name: "Chatbot",
        components: { ChatbotChoresEvents, HouseholdExpenseFlow, ManageGuestGroups, NotificationsChatbot, AddRoomate, VendorChatbot, ManageVendors },

        data() {


            return {
                countryCodeList: [],
                roommateSelectedCountryCodeText: '',
                roommatePhoneValid: false,
                roommatePhoneStepActive: false,
                vendorPhoneValid: false,
                eventGuestPhoneValid: false,
                notificationLoadingMore: false,
                isDragging: false,
                dragMoved: false,
                dragStart: { x: 0, y: 0 },
                iconPos: { x: null, y: null },
                DRAG_THRESHOLD: 8,
                ICON_SIZE: 80,
                STORAGE_KEY: 'spliyt_checklist_icon_pos',
                // Chatbot float (mobile) — mirrors checklist drag, separate position
                chatIsDragging: false,
                chatDragMoved: false,
                chatDragStart: { x: 0, y: 0 },
                chatIconPos: { x: null, y: null },
                CHAT_ICON_SIZE: 60,
                CHAT_STORAGE_KEY: 'spliyt_chatbot_icon_pos',
                isDraggableViewport: false,
                _mql: null,
                _confirmModal: { show: false, title: '', message: '', onConfirm: null },
                _expandedTicketList: {},
                _historyLoaded: false,
                _savingMessage: false, loginSource: localStorage.getItem('loginSource'),
                // In data() return object, add these:
                expenseForm: {
                    title: '',
                    amount: null,
                    assetId: '',
                    categoryId: '',
                    paymentDate: '',
                    vendorId: '',
                    description: '',
                    votingTitle: '',
                    votingDeadline: '',
                    thresholdId: '',
                    votingJustification: '',
                },
                expenseFormError: '',
                expenseFormSubmitting: false,
                expenseFormFiles: [],
                expenseFormPreviews: [],
                expenseFormFileError: '',
                expenseFormUploading: false,
                _ticketPreviewSubmitting: false,

                // Ticket Preview - editable Work Type only
                _ticketPreviewWorkTypes: [],
                _ticketPreviewWorkTypesLoading: false,
                _ticketPreviewWorkTypesLoaded: false,
                _ticketPreviewWorkTypesError: '',

                /** Toggle Chores & Events cards without touching other chatbot flows. */
                choresEventsEnabled: CHORES_EVENTS_ENABLED,

                ticketForm: {
                    subject: '',
                    workTypeId: '',
                    workTypeName: '',
                    priorityId: '',
                    priorityName: '',
                    assetId: '',
                    description: '',
                },
                ticketFormError: '',
                ticketFormSubmitting: false,

                meetingForm: {
                    title: '',
                    assetId: '',
                    assetName: '',
                    durationMinutes: '',
                    meetingDate: null,
                    meetingTime: '',
                    participantIds: [],
                    participantNames: [],
                    description: '',
                },
                meetingFormError: '',
                meetingFormSubmitting: false,

                _meetingSelectedAssetId: '',
                _meetingSelectedAssetName: '',
                _meetingSelectedParticipants: [],
                _attachmentPreviews: [],
                _expenseAttachmentFiles: [],
                _expenseAttachmentUploading: false,
                _expenseAttachmentError: null,
                _expandedMeetingParticipants: {},

                guestGroupGuestDraft: {
                    fullName: '',
                    email: '',
                    countryCode: '',
                    countryCodeText: '',
                    phoneNumber: '',
                    fullPhoneNumber: ''
                },
                guestGroupPhoneValid: false,

                _lastSelectedWorkType: { id: '', name: '' },



                searchModel: {
                    searchItem: null,
                    status: '1',
                    sortColumn: 'ModifiedOn',
                    sortDir: 'desc',
                    pageIndex: 0,
                    pageSize: 10,
                    userId: localStorage.getItem("userId"),
                    companyId: localStorage.getItem("companyId")
                },
                _optionsCache: {},
                hasPurchasedAsset: true,
                userType: localStorage.getItem('userType'),
                _manageAssetsService: null,
                isChecklistOpen: false,
                isOnboardingStatusLoaded: false,
                _onboardingHasPendingSteps: false,
                checklistFrameMounted: false,
                checklistFrameLoaded: false,
                checklistFrameLoading: false,
                checklistUrl: "/onboardinglist?checklistPopup=true",
                checklistFloatGif,
                _attachmentFiles: [],
                _attachmentUploading: false,
                _attachmentError: null,
                _attachmentUploadedNames: [],
                isOpen: false,
                userInput: "",
                isTyping: false,
                hasWelcomed: false,
                messages: [],
                username: "",
                token: "",
                companyId: "",
                userId: "",
                sessionId: "",
                ModuleType: "",
                activeImage: null,
                showImagePopup: false,
                zoomLevel: 1,
                API_URL: process.env.VUE_APP_OnboardingChatApiUrl || "https://briktokbotapi.talygen.com/query/",
                STAGE_API_BASE: process.env.VUE_APP_WebApiBaseUrl || "https://api.spliyt.com/apigateway",
                md: null, showChecklistIcon: false,
                CHAT_COMPANY_ID: "",
                TICKET_WORKTYPE_MASTER_STAGE: "00Test",
                _lastUserQuery: "",
            };
        },

        computed: {
            hasPendingOnboardingSteps() {
                return this._onboardingHasPendingSteps === true;
            },
            checklistPosition() {
                if (!this.isDraggableViewport || this.iconPos.x === null) return {};
                return {
                    left: `${this.iconPos.x}px`,
                    top: `${this.iconPos.y}px`,
                    right: 'auto',
                    bottom: 'auto',
                    position: 'fixed',
                };
            },
            chatBotPosition() {
                if (!this.isDraggableViewport || this.chatIconPos.x === null) return {};
                return {
                    left: `${this.chatIconPos.x}px`,
                    top: `${this.chatIconPos.y}px`,
                    right: 'auto',
                    bottom: 'auto',
                    position: 'fixed',
                };
            },
            lastUserMessageIndex() {
                for (let i = this.messages.length - 1; i >= 0; i--) {
                    if (this.messages[i].from === 'user') return i;
                }
                return -1;
            },
            isInputDisabled() {
                // Find the last bot message
                if (this.getExpenseDescWordCount() > 200) return true;

                const lastBot = [...this.messages].reverse().find(m => m.from === 'bot');
                if (!lastBot) return false;

                const type = lastBot.type;
                const payload = lastBot.payload;

                // Add Roommate phone step:
                // detect the actual active roommate phone card directly from the last bot message.
                // This does not depend on exact backend wording.
                const roommatePhoneCardActive =
                    (
                        (type === 'roommate_flow' || type === 'roommate_phone_prompt') &&
                        this.getRoommateMode(type, lastBot) === 'phone'
                    );

                if (roommatePhoneCardActive || this.roommatePhoneStepActive) {
                    return !this.roommatePhoneValid;
                }

                // Manage Vendor phone step:
                // keep normal chatbot typing disabled until the required phone digits are complete.
                const vendorPhoneCardActive =
                    type === 'vendor_flow' &&
                    this.isManageVendorPhonePrompt(lastBot);

                if (vendorPhoneCardActive) {
                    return !this.vendorPhoneValid;
                }

                // Event Guest phone step:
                // keep normal chatbot typing disabled until the required phone digits are complete.
                const eventGuestPhoneCardActive =
                    type === 'event_flow' &&
                    (() => {
                        const text = String(
                            lastBot?.payload?.response ||
                            lastBot?.text ||
                            ''
                        ).toLowerCase();

                        return (
                            text.includes('phone number') ||
                            text.includes('phone no') ||
                            text.includes("guest's phone") ||
                            text.includes('guest’s phone')
                        );
                    })();

                if (eventGuestPhoneCardActive) {
                    return !this.eventGuestPhoneValid;
                }

                // Guest Group phone step:
                // disable the normal chat box while the phone card is active,
                // matching the existing Roommate / Vendor / Event Guest behavior.
                const guestGroupPhoneCardActive =
                    type === 'guest_group_flow' &&
                    (() => {
                        const text = String(
                            lastBot?.payload?.response ||
                            lastBot?.text ||
                            ''
                        )
                            .replace(/<[^>]*>/g, ' ')
                            .replace(/\*\*/g, '')
                            .toLowerCase();

                        return (
                            text.includes('phone number') ||
                            text.includes('phone no') ||
                            text.includes("guest's phone") ||
                            text.includes('guest’s phone')
                        );
                    })();

                if (guestGroupPhoneCardActive) {
                    return !this.guestGroupPhoneValid;
                }

                // Disable when there's an active dropdown/picker

                if (type === 'general_query' && lastBot._options?.length) return true;
                // ✅ Freeze input when meeting preview has no participants selected
                if (type === 'meeting_form_preview') {
                    return !(lastBot._previewParticipants?.length);
                }

                if (type === 'ticket_attachment_upload') return true;
                if (type === 'expense_attachment_upload') return true;
                if (type === 'ticket_lookup_pending') return true;

                if (type === 'document_vault_doctype_prompt') return true;
                if (type === 'document_vault_coowner_prompt') return true;
                if (type === 'document_vault_upload_prompt') return true;
                if (type === 'document_vault_preview') return true;
                return false;
            },
            imageZoomStyle() {
                return {
                    transform: `scale(${this.zoomLevel})`,
                    transition: 'transform 0.2s ease',
                    cursor: this.zoomLevel > 1 ? 'zoom-out' : 'zoom-in'
                };
            },
            currentDate() {
                const d = new Date();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${month}-${day}-${year}`;
            }
        },



        mounted() {
            // ...existing mounted logic
            this._mql = window.matchMedia('(max-width: 1024px)'); // covers phone + tablet
            this.isDraggableViewport = this._mql.matches;
            this._mql.addEventListener('change', this._onBreakpointChange);

            if (this.isDraggableViewport) {
                this._restoreIconPosition();
                this._restoreChatIconPosition();
            }
            window.addEventListener('resize', this._clampIconToViewport);

            this._optionsCache = {};
            this.$refs.chatMessages?.addEventListener('retry', () => {
                if (this._lastUserQuery) {
                    this.userInput = this._lastUserQuery;
                    this.sendMessage();
                }
            });
            this._ticketDescriptionInput = "";
            this._ticketDescriptionError = "";
            this._meetingDescriptionInput = "";
            this._meetingDescriptionError = "";
            this._manageAssetsService = new ManageAssetsService();
            this.md = new MarkdownIt({ html: true, linkify: true, typographer: true, breaks: true });
            this.refreshChecklistIconVisibility();
            this.onChecklistAutoOpenRequest = () => {
                this.openChecklistIfIncomplete();
            };

            const userInfoRaw = localStorage.getItem("userinfo");
            const userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : null;

            // ✅ All fields from userInfo.data (note the nested .data structure)
            const userData = userInfo?.data || {};

            this.username = userData.userName || "Briktok";
            this.companyId = userData.companyId || "";
            this.userId = userData.id || "";
            console.log("mounted userId:", this.userId);
            this.userEmail = userData.email || "";
            this.userPhone = userData.phoneNumber || "";
            this.token = localStorage.getItem("access_token") || localStorage.getItem("token") || "";
            this.ModuleType = userInfo?.packageName;
            this.sessionId = this.getSessionId();
            this.CHAT_COMPANY_ID = userData.companyId || "";
            document.addEventListener("keydown", this.handleEscapeKey);
            window.addEventListener("storage", this.handleChecklistStorageChange);
            window.addEventListener(CHECKLIST_PROGRESS_EVENT, this.onChecklistProgressUpdated);
            window.addEventListener(CHECKLIST_AUTO_OPEN_REQUEST_EVENT, this.onChecklistAutoOpenRequest);
            this.openChecklistIfIncomplete();
        },
        beforeUnmount() {
            this._mql?.removeEventListener('change', this._onBreakpointChange);
            window.removeEventListener('resize', this._clampIconToViewport);
        },
        beforeDestroy() {
            document.removeEventListener("keydown", this.handleEscapeKey);
            window.removeEventListener("storage", this.handleChecklistStorageChange);
            window.removeEventListener(CHECKLIST_PROGRESS_EVENT, this.onChecklistProgressUpdated);
            window.removeEventListener(CHECKLIST_AUTO_OPEN_REQUEST_EVENT, this.onChecklistAutoOpenRequest);
        },
        created() {
            this.checkAssetPurchaseStatus();
            this.GetCountryCodeList();
        },

        methods: {
            removeGuestFromGroup(data) {
                if (!data || !data.guestGroupMapId) {
                    return;
                }

                const guestName = data.guestName || 'Guest';
                const groupName = data.groupName || '';

                const command =
                    '__GUEST_GROUP_GUEST_DELETE__' +
                    encodeURIComponent(data.guestGroupMapId) +
                    '|' +
                    encodeURIComponent(data.guestId || '') +
                    '|' +
                    encodeURIComponent(data.guestGroupId || '') +
                    '|' +
                    encodeURIComponent(guestName) +
                    '|' +
                    encodeURIComponent(groupName);

                this._sendTicketChoice(
                    `${guestName} Remove`,
                    command
                );
            },
            addGuestToGroup(data) {
                if (!data || !data.guestGroupId) {
                    return;
                }

                const groupName = data.groupName || '';

                const command =
                    '__GUEST_GROUP_ADD__' +
                    data.guestGroupId +
                    '|' +
                    encodeURIComponent(groupName);

                this._sendTicketChoice(
                    `Add Guest to ${groupName}`,
                    command
                );
            },
            isManageVendorPhonePrompt(msg) {
                const type = msg?.type || msg?.Intent || '';

                if (type !== 'vendor_flow') {
                    return false;
                }

                const response =
                    msg?.payload?.response ||
                    msg?.response ||
                    msg?.text ||
                    '';

                const text = String(response)
                    .replace(/<[^>]*>/g, ' ')
                    .replace(/\*\*/g, '')
                    .toLowerCase()
                    .trim();

                return (
                    text.includes('contact number') ||
                    text.includes('contact no') ||
                    text.includes('phone number') ||
                    text.includes('phone no') ||
                    text.includes('mobile number') ||
                    text.includes('mobile')
                );
            },
            confirmManageVendor(prefilled) {
                if (!prefilled) return;

                const firstName = String(
                    prefilled.firstName ||
                    prefilled.FirstName ||
                    ''
                ).trim();

                const lastName = String(
                    prefilled.lastName ||
                    prefilled.LastName ||
                    ''
                ).trim();

                const fullName = String(
                    prefilled.vendorName ||
                    prefilled.VendorName ||
                    `${firstName} ${lastName}`.trim()
                ).trim();

                const payload = {
                    ...prefilled,

                    // Keep chatbot keys
                    vendorName: fullName,
                    firstName,
                    lastName,

                    // Also send portal/API keys so vendors created from chatbot
                    // can be opened correctly in the existing Edit Vendor page.
                    VendorName: fullName,
                    FirstName: firstName,
                    LastName: lastName,
                    VendorCompanyName:
                        prefilled.VendorCompanyName ||
                        prefilled.companyName ||
                        '',
                    Email: prefilled.Email || prefilled.email || '',
                    UserName:
                        prefilled.UserName ||
                        prefilled.userName ||
                        prefilled.email ||
                        '',
                    Phone: prefilled.Phone || prefilled.phone || '',
                    AssignPropId:
                        prefilled.AssignPropId ||
                        prefilled.assetId ||
                        prefilled.assetID ||
                        '',
                    WorkTypeId:
                        prefilled.WorkTypeId ||
                        prefilled.workTypeCategoryId ||
                        '',
                    ServiceId:
                        prefilled.ServiceId ||
                        prefilled.serviceId ||
                        '',
                    state:
                        prefilled.state ||
                        prefilled.stateId ||
                        '',
                    countryCode:
                        prefilled.countryCode ||
                        prefilled.countryCodeId ||
                        '',
                    address:
                        prefilled.address ||
                        prefilled.Address ||
                        '',
                    city:
                        prefilled.city ||
                        prefilled.City ||
                        '',
                    zipCode:
                        prefilled.zipCode ||
                        prefilled.ZipCode ||
                        ''
                };

                this._sendTicketChoice(
                    'Confirm & Register',
                    '__VENDOR_SUBMIT__' + JSON.stringify(payload)
                );
            },

            cancelManageVendor() {
                this._sendTicketChoice(
                    'Cancel',
                    'cancel'
                );
            },

            toggleManageVendorStatus(data) {
                if (!data || !data.vendorId) return;

                const newStatus = data.isActive === true;
                const vendorName = String(data.vendorName || 'Vendor').trim();

                this._sendTicketChoice(
                    `Mark "${vendorName}" as ${newStatus ? 'Active' : 'Inactive'}`,
                    `__VENDOR_STATUS_TOGGLE__${encodeURIComponent(data.vendorId)}|${newStatus ? 'true' : 'false'}|${encodeURIComponent(vendorName)}`
                );
            },

            onManageVendorPhoneValidityChange(isValid) {
                this.vendorPhoneValid = isValid === true;
            },

            submitManageVendorPhone(phoneNumber) {
                if (!phoneNumber) return;

                // The phone step is complete. Reset the temporary validity flag
                // before the backend moves to the next vendor question/card.
                this.vendorPhoneValid = false;

                this._sendTicketChoice(
                    phoneNumber,
                    phoneNumber
                );
            },

            isRoommatePhoneResponse(response) {
                const text = String(response || '')
                    .replace(/\*\*/g, '')
                    .toLowerCase();

                return (
                    text.includes('phone number') &&
                    text.includes('for them')
                );
            },
            isRoommatePhonePrompt(msg) {
                const response =
                    msg?.payload?.response ||
                    msg?.response ||
                    msg?.text ||
                    '';

                const cleanText = String(response)
                    .replace(/\*\*/g, '')
                    .toLowerCase();

                return (
                    cleanText.includes('phone number') &&
                    cleanText.includes('for them')
                );
            },
            onRoommatePhoneValidityChange(isValid, sourceMsg) {
                const lastBot = [...this.messages]
                    .reverse()
                    .find(m => m.from === 'bot');

                // Only the CURRENT roommate phone card can control
                // the main chatbot input. Older roommate cards are ignored.
                if (sourceMsg && lastBot && sourceMsg !== lastBot) {
                    return;
                }

                this.roommatePhoneStepActive = true;
                this.roommatePhoneValid = isValid === true;
            },
            submitRoommatePhone(data) {
                this.roommatePhoneStepActive = false;

                let phoneNumber = String(data?.phoneNumber || '').trim();

                // IMPORTANT:
                // preserve exactly what user selected from country dropdown
                this.roommateSelectedCountryCodeText =
                    String(data?.countryCodeText || '').trim();

                const digits = phoneNumber
                    .replace(/\D/g, '')
                    .slice(-10);

                if (digits.length === 10) {
                    phoneNumber =
                        `(${digits.slice(0, 3)}) ` +
                        `${digits.slice(3, 6)}-` +
                        `${digits.slice(6)}`;
                }

                this._sendTicketChoice(
                    phoneNumber,
                    phoneNumber
                );
            },
            isRoommateCardIntent(type) {
                return ROOMMATE_CARD_INTENTS.includes(type);
            },

            getRoommateMode(type, msg) {

                // Phone number prompt is currently returned by backend as roommate_flow
                if (
                    type === 'roommate_flow' &&
                    this.isRoommatePhonePrompt(msg)
                ) {
                    return 'phone';
                }

                switch (type) {
                    case 'roommate_phone_prompt':
                        return 'phone';

                    case 'roommate_form':
                        return 'form';

                    case 'roommate_preview':
                        return 'preview';

                    case 'roommate_created':
                        return 'success';

                    case 'roommate_failed':
                        return 'error';

                    case 'view_roommates':
                        return 'list';

                    default:
                        return '';
                }
            },
            submitRoommate(prefilled) {
                const command =
                    '__ROOMMATE_SUBMIT__' +
                    JSON.stringify(prefilled || {});

                this._sendTicketChoice(
                    'Confirm & Add',
                    command
                );
            },

            cancelRoommate() {
                this._sendTicketChoice(
                    'Cancel',
                    'cancel'
                );
            },

            removeRoommate(payload) {
                const roommate = payload?.roommate || {};
                const assetID = payload?.assetID || '';

                const shareHistoryId =
                    roommate.shareHistoryId ||
                    roommate.ShareHistoryId ||
                    '';

                const roommateName =
                    roommate.name ||
                    roommate.shareholderName ||
                    roommate.roommateName ||
                    'Roommate';

                const command =
                    '__ROOMMATE_DELETE__' +
                    encodeURIComponent(shareHistoryId) +
                    '|' +
                    encodeURIComponent(roommateName) +
                    '|' +
                    encodeURIComponent(assetID);

                this._sendTicketChoice(
                    `Remove "${roommateName}"`,
                    command
                );
            },
            loadMoreNotifications(data) {
                if (!data || this.notificationLoadingMore) return;

                this.notificationLoadingMore = true;

                const pageNumber = data.pageNumber || 1;
                const pageSize = data.pageSize || 15;

                this._sendTicketChoice(
                    'Load More Notifications',
                    `__NOTIFICATION_LOAD_MORE__${JSON.stringify({
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                        loadedCount: data.loadedCount || 0,
                        totalCount: data.totalCount || 0
                    })}`
                );

                this.$nextTick(() => {
                    this.notificationLoadingMore = false;
                });
            },
            isEventGuestPhonePrompt(msg) {
                if (!msg || msg.type !== 'event_flow') {
                    return false;
                }

                const text = String(
                    msg?.payload?.response ||
                    msg?.text ||
                    ''
                )
                    .replace(/<[^>]*>/g, ' ')
                    .replace(/\*\*/g, '')
                    .toLowerCase();

                return (
                    text.includes('phone number') ||
                    text.includes('phone no') ||
                    text.includes("guest's phone") ||
                    text.includes('guest’s phone')
                );
            },
            async GetCountryCodeList() {
                try {
                    const response = await UserService.countryList(
                        'countryCode',
                        '00Test',
                        localStorage.getItem('companyId')
                    );

                    this.countryCodeList = response?.data || [];

                    console.log(
                        'Roommate Country Code List:',
                        this.countryCodeList
                    );

                } catch (error) {
                    console.error(
                        'Country code load failed:',
                        error
                    );

                    this.countryCodeList = [];
                }
            },
            markNotificationAsRead(data) {
                if (!data || !data.notification) return;

                const notification = data.notification;

                const notificationId =
                    notification.notificationId ||
                    notification.NotificationId ||
                    notification.id;

                if (!notificationId) return;

                const newIsRead = data.isRead;

                this._sendTicketChoice(
                    newIsRead ? 'Mark as Read' : 'Mark as Unread',
                    `__NOTIFICATION_READ_STATUS__${JSON.stringify({
                        notificationId: notificationId,
                        isRead: newIsRead
                    })}`
                );
            },

            viewNotificationDetail(notification) {
                if (!notification) return;

                const notificationId =
                    notification.notificationId ||
                    notification.id ||
                    notification.NotificationId;

                if (!notificationId) return;

                this._sendTicketChoice(
                    'View Notification',
                    `__NOTIFICATION_DETAIL__${notificationId}`
                );
            },

            isNotificationChatbotIntent(type) {
                return isNotificationIntent(type);
            },
            isVendorChatbotIntent(type) {
                return isVendorIntent(type);
            },
            toggleVendorStatus(data) {
                if (!data) return;

                const vendorId = data.vendorId || '';
                const vendorName = data.vendorName || 'Vendor';
                const newStatus = data.isActive === true;

                if (!vendorId) return;

                const cmd =
                    '__VENDOR_STATUS_TOGGLE__' +
                    encodeURIComponent(vendorId) +
                    '|' +
                    (newStatus ? 'true' : 'false') +
                    '|' +
                    encodeURIComponent(vendorName);

                const displayText =
                    `Mark "${vendorName}" as ${newStatus ? 'Active' : 'Inactive'}`;

                this._sendTicketChoice(
                    displayText,
                    cmd
                );
            },

            getGuestGroupDraft(currentMsg) {
                const draft = {
                    ...(this.guestGroupGuestDraft || {})
                };

                const currentIndex = this.messages.indexOf(currentMsg);

                if (currentIndex <= 0) {
                    return draft;
                }

                // Read the answers already entered in this same Guest Group flow.
                // We match each previous user reply with the bot question immediately
                // before it, so Full Name / Email are restored into the Add Guest form.
                for (let i = currentIndex - 1; i >= 0; i--) {
                    const userMessage = this.messages[i];

                    if (!userMessage || userMessage.from !== 'user') {
                        continue;
                    }

                    const answer = String(
                        userMessage.text ||
                        userMessage.message ||
                        ''
                    ).trim();

                    if (!answer) {
                        continue;
                    }

                    let promptText = '';

                    for (let j = i - 1; j >= 0; j--) {
                        const previous = this.messages[j];

                        if (previous?.from === 'bot') {
                            promptText = String(
                                previous?.payload?.response ||
                                previous?.response ||
                                previous?.text ||
                                ''
                            )
                                .replace(/<[^>]*>/g, ' ')
                                .replace(/\*\*/g, '')
                                .replace(/\s+/g, ' ')
                                .toLowerCase()
                                .trim();

                            break;
                        }
                    }

                    if (
                        !draft.email &&
                        (
                            promptText.includes('email address') ||
                            promptText.includes('email')
                        )
                    ) {
                        draft.email = answer;
                        continue;
                    }

                    if (
                        !draft.fullName &&
                        (
                            promptText.includes('full name') ||
                            promptText.includes("guest's name") ||
                            promptText.includes('guest name') ||
                            (
                                promptText.includes('name') &&
                                !promptText.includes('group name')
                            )
                        )
                    ) {
                        draft.fullName = answer;
                    }

                    if (draft.fullName && draft.email) {
                        break;
                    }
                }

                return draft;
            },

            onGuestGroupPhoneValidityChange(value) {
                this.guestGroupPhoneValid = value === true;
            },

            submitGuestPhoneNumber(data) {
                if (!data) return;

                // Backward-compatible: older ManageGuestGroups versions
                // can still emit a plain phone string.
                if (typeof data === 'string') {
                    this.guestGroupPhoneValid = false;

                    this._sendTicketChoice(
                        data,
                        data
                    );
                    return;
                }

                const fullPhoneNumber =
                    String(
                        data.fullPhoneNumber ||
                        data.phoneNumber ||
                        ''
                    ).trim();

                if (!fullPhoneNumber) return;

                // Keep the editable guest values while the backend
                // advances from the phone step to Guest Group Summary.
                this.guestGroupGuestDraft = {
                    fullName: String(data.fullName || '').trim(),
                    email: String(data.email || '').trim(),
                    countryCode: data.countryCode || '',
                    countryCodeText: String(data.countryCodeText || '').trim(),
                    phoneNumber: String(data.phoneNumber || '').trim(),
                    fullPhoneNumber: fullPhoneNumber
                };

                // Existing backend flow is unchanged:
                // the phone answer is still sent exactly as before.
                this.guestGroupPhoneValid = false;

                this._sendTicketChoice(
                    fullPhoneNumber,
                    fullPhoneNumber
                );
            },
            onEventGuestPhoneValidityChange(isValid) {
                this.eventGuestPhoneValid = isValid === true;
            },

            submitEventGuestPhone(phoneNumber) {
                if (!phoneNumber) return;

                this._sendTicketChoice(
                    phoneNumber,
                    phoneNumber
                );
            },
            viewGuestGroupDetail(group) {
                if (!group?.guestGroupId) return;

                this._sendTicketChoice(
                    `View ${group.groupName}`,
                    `__GUEST_GROUP_DETAIL__${group.guestGroupId}|${encodeURIComponent(group.groupName || '')}`
                );
            },
            confirmGuestGroup(prefilled) {
                if (!prefilled) return;

                this._sendTicketChoice(
                    'Confirm & Save',
                    '__GUEST_GROUP_SUBMIT__' + JSON.stringify(prefilled)
                );
            },
            selectChoreFrequency(frequency) {
                this._sendTicketChoice(
                    frequency,
                    '__CHORE_FIELD__frequency|' + encodeURIComponent(frequency)
                );
            },

            selectChoreRoommates(roommateIds) {
                this._sendTicketChoice(
                    `${roommateIds.length} roommate(s) selected`,
                    '__CHORE_FIELD__roommates|' + roommateIds.join(',')
                );
            },

            selectChoreStatusUpdate(value, label) {
                if (!this.choresEventsEnabled || !value) return;

                // Send exactly the same value the user would have typed manually.
                // This keeps the existing backend chore-status flow unchanged.
                this._sendTicketChoice(
                    label || String(value),
                    String(value)
                );
            },
            isHouseholdExpenseCardIntent(type) {
                return HOUSEHOLD_EXPENSE_CARD_INTENTS.includes(type);
            },
            isManageGuestGroupCardIntent(type) {
                return MANAGE_GUEST_GROUP_CARD_INTENTS.includes(type);
            },
            chooseHouseholdExpenseType(type) {
                this._sendTicketChoice(
                    type === 'recurring' ? 'Recurring' : 'One Time',
                    `__HH_EXP_TYPE__${type}`
                );
            },
            //chooseHouseholdExpenseOption(label, value) {
            //    this._sendTicketChoice(
            //        String(label || value || ''),
            //        String(value || label || '')
            //    );
            //},
            chooseHouseholdExpenseOption(label, value) {
                this._sendTicketChoice(
                    String(label || value || ''),
                    String(value || label || '')
                );
            },
            //submitHouseholdExpense(payload) {
            //    const message = { ...payload };

            //    if (message.attachment) {
            //        message.attachmentName = message.attachment.name;
            //        message.attachment = null;
            //    }

            //    this._sendTicketChoice(
            //        '✅ Confirm & Submit Expense',
            //        //'__HH_EXP_SUBMIT__' + JSON.stringify(message)
            //       '__HH_EXP_SUBMIT__' + JSON.stringify(message)
            //    );
            //},
            async submitHouseholdExpense(payload) {
                const message = { ...payload };
                const file = message.attachment;

                message.attachment = null;
                message.attachmentName = file ? file.name : null;

                if (file) {
                    const dataBase64 = await new Promise((resolve, reject) => {
                        const reader = new FileReader();

                        reader.onload = () => resolve(reader.result.split(',')[1]);
                        reader.onerror = reject;

                        reader.readAsDataURL(file);
                    });

                    await this._sendRaw(
                        '__HH_EXP_FILE__' + JSON.stringify({
                            fileName: file.name,
                            contentType: file.type,
                            dataBase64: dataBase64
                        })
                    );
                }

                this._sendTicketChoice(
                    'Confirm & Submit Expense',
                    '__HH_EXP_SUBMIT__' + JSON.stringify(message)
                );
            },
            cancelHouseholdExpense() {
                this._sendTicketChoice('✕ Cancel', 'cancel');
            },
            // ─── Document Vault ──────────────────────────────────────────────────────
            _onBreakpointChange() {
                this.isDraggableViewport = this._mql.matches;
                if (!this.isDraggableViewport) {
                    // leaving mobile/tablet — reset to default CSS-anchored corner position
                    this.iconPos = { x: null, y: null };
                    this.isDragging = false;
                    this.chatIconPos = { x: null, y: null };
                    this.chatIsDragging = false;
                } else {
                    this._restoreIconPosition();
                    this._restoreChatIconPosition();
                }
            },

            handleChecklistClick() {
                if (this.dragMoved) {
                    this.dragMoved = false;
                    return;
                }
                this.toggleChecklist();
            },

            handleChatClick() {
                if (this.chatDragMoved) {
                    this.chatDragMoved = false;
                    return;
                }
                this.toggleChat();
            },

            onDragStart(e) {
                if (!this.isDraggableViewport) return;
                const touch = e.touches[0];
                const rect = e.currentTarget.getBoundingClientRect();
                if (this.iconPos.x === null) {
                    this.iconPos.x = rect.left;
                    this.iconPos.y = rect.top;
                }
                this.dragStart = {
                    x: touch.clientX - this.iconPos.x,
                    y: touch.clientY - this.iconPos.y,
                };
                this.dragMoved = false;
                this.isDragging = true;
            },

            onDragMove(e) {
                if (!this.isDraggableViewport || !this.isDragging) return;
                const touch = e.touches[0];
                const nextX = touch.clientX - this.dragStart.x;
                const nextY = touch.clientY - this.dragStart.y;

                const movedDistance = Math.hypot(
                    touch.clientX - (this.dragStart.x + this.iconPos.x),
                    touch.clientY - (this.dragStart.y + this.iconPos.y)
                );
                if (movedDistance > this.DRAG_THRESHOLD) {
                    this.dragMoved = true;
                }
                this.iconPos = this._clamp(nextX, nextY);
            },

            onDragEnd() {
                if (!this.isDraggableViewport || !this.isDragging) return;
                this.isDragging = false;
                if (this.dragMoved) {
                    this._snapToEdge();
                }
            },

            onChatDragStart(e) {
                if (!this.isDraggableViewport) return;
                const touch = e.touches[0];
                const rect = e.currentTarget.getBoundingClientRect();
                if (this.chatIconPos.x === null) {
                    this.chatIconPos.x = rect.left;
                    this.chatIconPos.y = rect.top;
                }
                this.chatDragStart = {
                    x: touch.clientX - this.chatIconPos.x,
                    y: touch.clientY - this.chatIconPos.y,
                };
                this.chatDragMoved = false;
                this.chatIsDragging = true;
            },

            onChatDragMove(e) {
                if (!this.isDraggableViewport || !this.chatIsDragging) return;
                const touch = e.touches[0];
                const nextX = touch.clientX - this.chatDragStart.x;
                const nextY = touch.clientY - this.chatDragStart.y;

                const movedDistance = Math.hypot(
                    touch.clientX - (this.chatDragStart.x + this.chatIconPos.x),
                    touch.clientY - (this.chatDragStart.y + this.chatIconPos.y)
                );
                if (movedDistance > this.DRAG_THRESHOLD) {
                    this.chatDragMoved = true;
                }
                this.chatIconPos = this._clampChat(nextX, nextY);
            },

            onChatDragEnd() {
                if (!this.isDraggableViewport || !this.chatIsDragging) return;
                this.chatIsDragging = false;
                if (this.chatDragMoved) {
                    this._snapChatToEdge();
                }
            },

            _clamp(x, y) {
                const maxX = window.innerWidth - this.ICON_SIZE;
                const maxY = window.innerHeight - this.ICON_SIZE;
                return {
                    x: Math.min(Math.max(x, 0), Math.max(maxX, 0)),
                    y: Math.min(Math.max(y, 0), Math.max(maxY, 0)),
                };
            },

            _clampChat(x, y) {
                const maxX = window.innerWidth - this.CHAT_ICON_SIZE;
                const maxY = window.innerHeight - this.CHAT_ICON_SIZE;
                return {
                    x: Math.min(Math.max(x, 0), Math.max(maxX, 0)),
                    y: Math.min(Math.max(y, 0), Math.max(maxY, 0)),
                };
            },

            _snapToEdge() {
                if (this.iconPos.x === null) return;
                const midpoint = window.innerWidth / 2;
                this.iconPos.x =
                    this.iconPos.x + this.ICON_SIZE / 2 < midpoint
                        ? 12
                        : window.innerWidth - this.ICON_SIZE - 12;
                this._saveIconPosition();
            },

            _snapChatToEdge() {
                if (this.chatIconPos.x === null) return;
                const midpoint = window.innerWidth / 2;
                this.chatIconPos.x =
                    this.chatIconPos.x + this.CHAT_ICON_SIZE / 2 < midpoint
                        ? 12
                        : window.innerWidth - this.CHAT_ICON_SIZE - 12;
                this._saveChatIconPosition();
            },

            _clampIconToViewport() {
                if (!this.isDraggableViewport) return;
                if (this.iconPos.x !== null) {
                    this.iconPos = this._clamp(this.iconPos.x, this.iconPos.y);
                }
                if (this.chatIconPos.x !== null) {
                    this.chatIconPos = this._clampChat(this.chatIconPos.x, this.chatIconPos.y);
                }
            },

            _saveIconPosition() {
                try {
                    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.iconPos));
                } catch (_err) {
                    /* ignore */
                }
            },

            _restoreIconPosition() {
                try {
                    const raw = localStorage.getItem(this.STORAGE_KEY);
                    if (!raw) return;
                    const parsed = JSON.parse(raw);
                    if (typeof parsed.x === 'number' && typeof parsed.y === 'number') {
                        this.iconPos = this._clamp(parsed.x, parsed.y);
                    }
                } catch (_err) {
                    /* ignore */
                }
            },

            _saveChatIconPosition() {
                try {
                    localStorage.setItem(this.CHAT_STORAGE_KEY, JSON.stringify(this.chatIconPos));
                } catch (_err) {
                    /* ignore */
                }
            },

            _restoreChatIconPosition() {
                try {
                    const raw = localStorage.getItem(this.CHAT_STORAGE_KEY);
                    if (!raw) return;
                    const parsed = JSON.parse(raw);
                    if (typeof parsed.x === 'number' && typeof parsed.y === 'number') {
                        this.chatIconPos = this._clampChat(parsed.x, parsed.y);
                    }
                } catch (_err) {
                    /* ignore */
                }
            },
            getDocTypeOptions(msg) {
                const types = msg.payload?.document_vault_data?.doc_types || [];
                return types.map(dt => ({
                    id: dt.Id || dt.id,
                    name: dt.DocumentType || dt.documentType || '',
                })).filter(dt => dt.name);
            },


            submitDocTypePick(name, id) {
                const cmd = `__DOC_TYPE__${encodeURIComponent(name)}|${encodeURIComponent(id)}`;
                this._sendTicketChoice(name, cmd);
            },

            getDocCoOwnerOptions(msg) {
                const raw = msg.payload?.document_vault_data?.co_owners;
                const items = Array.isArray(raw) ? raw : (raw?.data || raw?.result || []);
                return items.map(u => ({
                    label: (u.text || u.fullName || u.name || '').replace(/\(.*?\)/g, '').trim(),
                })).filter(u => u.label);
            },

            submitDocCoOwnerPick(displayLabel, value) {
                this._sendTicketChoice(displayLabel, value);
            },

            onDocVaultFileChange(event, msg) {
                const file = event.target.files?.[0];
                if (!file) return;
                const allowedExts = ['.pdf', '.xlsx', '.csv', '.docx', '.doc', '.pptx', '.ppt', '.txt', '.xls'];
                const ext = '.' + file.name.split('.').pop().toLowerCase();
                if (!allowedExts.includes(ext)) {
                    msg._docFileError = `File type "${ext}" is not allowed.`;
                    msg._docFile = null;
                    event.target.value = '';
                    return;
                }
                if (file.size > 8 * 1024 * 1024) {
                    msg._docFileError = 'File exceeds the 8MB limit.';
                    msg._docFile = null;
                    event.target.value = '';
                    return;
                }
                msg._docFileError = null;
                msg._docFile = file;
            },

            async submitDocVaultFile(msg) {
                if (!msg._docFile) return;
                msg._docUploading = true;
                try {
                    const base64Data = await new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result.split(',')[1]);
                        reader.onerror = reject;
                        reader.readAsDataURL(msg._docFile);
                    });
                    const payload = JSON.stringify({
                        fileName: msg._docFile.name,
                        contentType: msg._docFile.type || 'application/octet-stream',
                        dataBase64: base64Data,
                    });
                    this.messages.push({ from: 'user', text: 'File uploaded successfully' });
                    this._saveChatMessage('user', 'File uploaded successfully', 'text', null);
                    msg._confirmed = true;
                    await this._sendRaw('__DOC_FILE__' + payload);
                } catch (e) {
                    msg._docFileError = 'Error reading file. Please try again.';
                } finally {
                    msg._docUploading = false;
                }
            },

            getDocPrefilled(msg) {
                return msg.payload?.document_vault_data?.prefilled || {};
            },


            getDocCoOwnerText(msg) {
                const pre = this.getDocPrefilled(msg);
                if (pre.isAllCoOwners) return 'All co-owners';
                return (pre.coOwnerNames && pre.coOwnerNames.length) ? pre.coOwnerNames.join(', ') : '—';
            },

            onDocPreviewFileChange(event, msg) {
                const file = event.target.files?.[0];
                if (!file) return;
                if (file.size > 8 * 1024 * 1024) {
                    alert('File too large (max 8MB).');
                    event.target.value = '';
                    return;
                }
                msg._docAttachFile = file;
            },
            async confirmDocVaultSave(msg) {
                const pre = { ...this.getDocPrefilled(msg) };
                pre.isSignMandatory = !!msg._docEsign;
                pre.isActive = msg._docActive !== false;

                this.messages.push({ from: 'user', text: ' Save & Upload' });
                this._saveChatMessage('user', ' Save & Upload', 'text', null);
                msg._confirmed = true;

                const doSubmit = async (filePayload) => {
                    await this._sendRaw('__DOC_SUBMIT__' + JSON.stringify({ ...pre, ...filePayload }));
                };

                if (msg._docAttachFile) {
                    try {
                        const base64Data = await new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onload = () => resolve(reader.result.split(',')[1]);
                            reader.onerror = reject;
                            reader.readAsDataURL(msg._docAttachFile);
                        });
                        await doSubmit({
                            fileName: msg._docAttachFile.name,
                            contentType: msg._docAttachFile.type || 'application/octet-stream',
                            dataBase64: base64Data,
                        });
                    } catch (e) {
                        this.messages.push({ from: 'bot', type: 'text', text: 'Error reading file. Please try again.' });
                    }
                } else {
                    await doSubmit({});
                }
            },
            cancelDocVaultPreview(msg) {
                msg._confirmed = true;
                this._sendTicketChoice('✖ Cancel', 'cancel');
            },

            getDocuments(msg) {
                return msg.payload?.document_vault_data?.documents || [];
            },

            isDocumentListItemOpen(msg, idx) {
                if (!msg._expandedDocuments) msg._expandedDocuments = {};
                return !!msg._expandedDocuments[idx];
            },
            toggleDocumentListItem(msg, idx) {
                if (!msg._expandedDocuments) msg._expandedDocuments = {};
                msg._expandedDocuments[idx] = !msg._expandedDocuments[idx];
            },

            getDocumentDownloadUrl(d) {
                if (!d.fileName) return '#';
                return `${this.STAGE_API_BASE}/ManageAsset/DownloadRequiredDoc/${this.userId}/${this.companyId}/${encodeURIComponent(d.fileName)}/false`;
            },

            // ── Delete / status-toggle now go through a styled in-app modal
            //    instead of the native browser confirm() popup. ──
            showDocumentEsignMandatoryPopup(d) {
                if (!d) return;

                const currentStatus = d.isSignMandatory === true;
                const newStatus = !currentStatus;

                this.showConfirmModal(
                    'eSign Mandatory',
                    `Are you sure you want to make eSign ${newStatus ? 'Mandatory' : 'Optional'} for "${d.docTitle || 'Document'}"?`,
                    () => {
                        const documentId = String(d.documentId || '').trim();
                        const docTitle = String(d.docTitle || 'Document').trim();

                        if (!documentId) return;

                        this._sendTicketChoice(
                            `Mark eSign for "${docTitle}" as ${newStatus ? 'Mandatory' : 'Optional'}`,
                            `__DOC_MANDATORY_TOGGLE__${encodeURIComponent(documentId)}|${newStatus ? 'true' : 'false'}|${encodeURIComponent(docTitle)}`
                        );
                    }
                );
            },

            confirmDocumentEsignToggle(d) {
                if (!d) return;

                const newStatus = !d.isSignMandatory;

                this.showConfirmModal(
                    'Change eSign Mandatory',
                    `Are you sure you want to set eSign Mandatory to ${newStatus ? 'Yes' : 'No'} for "${d.docTitle || 'Document'}"?`,
                    () => {
                        // Update only the listing state.
                        // No unverified backend command is introduced.
                        d.isSignMandatory = newStatus;

                        if (!newStatus) {
                            d.isEsigned = false;
                        }
                    }
                );
            },

            confirmDocumentDelete(d) {
                this.showConfirmModal(
                    'Delete Document',
                    `Are you sure you want to delete document "${d.docTitle}"?`,
                    () => {
                        this.messages.push({ from: 'user', text: `Delete "${d.docTitle}"` });
                        this._saveChatMessage('user', `Delete "${d.docTitle}"`, 'text', null);
                        const cmd = `__DOC_DELETE__${encodeURIComponent(d.documentId || '')}|${encodeURIComponent(d.docTitle || '')}`;
                        this._sendRaw(cmd);
                    }
                );
            },
            confirmDocumentStatusToggle(d) {
                const newStatus = !(d.isActive !== false);
                const actionWord = newStatus ? 'active' : 'in-active';

                this.showConfirmModal(
                    'Change Document Status',
                    `Are you sure you want to mark "${d.docTitle}" as ${actionWord}?`,
                    () => {
                        this.messages.push({ from: 'user', text: `Mark "${d.docTitle}" as ${newStatus ? 'Active' : 'Inactive'}` });
                        this._saveChatMessage('user', `Mark "${d.docTitle}" as ${newStatus ? 'Active' : 'Inactive'}`, 'text', null);
                        const cmd = `__DOC_STATUS_TOGGLE__${encodeURIComponent(d.documentId || '')}|${newStatus ? 'true' : 'false'}|${encodeURIComponent(d.docTitle || '')}`;
                        this._sendRaw(cmd);
                    }
                );
            },

            // ── Generic custom confirm modal (reusable for anything else too) ──
            showConfirmModal(title, message, onConfirm) {
                this._confirmModal = {
                    show: true,
                    title: title || 'Confirmation',
                    message,
                    onConfirm
                };
            },
            closeConfirmModal() {
                this._confirmModal.show = false;
                this._confirmModal.title = '';
                this._confirmModal.message = '';
                this._confirmModal.onConfirm = null;
            },
            acceptConfirmModal() {
                const cb = this._confirmModal.onConfirm;
                this._confirmModal.show = false;
                this._confirmModal.title = '';
                this._confirmModal.message = '';
                this._confirmModal.onConfirm = null;
                if (cb) cb();
            },


            //for doc vault

            getVisibleTickets(msg) {
                const tickets = msg.payload?.ticket_data?.tickets || [];
                const key = this.messages.indexOf(msg);
                const expanded = this._expandedTicketList[key];
                return expanded ? tickets : tickets.slice(0, 5);
            },

            toggleTicketListExpand(key) {
                this._expandedTicketList[key] = !this._expandedTicketList[key];
            },

            isTicketListExpanded(key) {
                return !!this._expandedTicketList[key];
            },
            //booking asset
            getBookingNights(pre) {
                if (!pre?.checkinDate || !pre?.checkoutDate) return '—';
                try {
                    const inD = new Date(pre.checkinDate);
                    const outD = new Date(pre.checkoutDate);
                    const diff = Math.max(0, (outD - inD) / 86400000);
                    return diff;
                } catch { return '—'; }
            },
            getBookingStatusColor(status) {
                const k = (status || '').toLowerCase();
                if (k === 'approved' || k === 'confirmed') return '#16a34a';
                if (k === 'rejected' || k === 'cancelled') return '#dc2626';
                return '#d97706';
            },
            confirmBookingPreview(msg) {
                const pre = msg.payload?.booking_data?.prefilled || msg.payload?.booking_data || {};
                msg._confirmed = true;
                this._sendTicketChoice(' Confirm & Book', '__BOOKING_SUBMIT__' + JSON.stringify(pre));
            },
            cancelBookingPreview() {
                this._sendTicketChoice('✕ Cancel', 'cancel');
            },
            //booking asset helper
            getBookingNights(pre) {
                if (!pre?.checkinDate || !pre?.checkoutDate) return '—';
                try {
                    const inD = new Date(pre.checkinDate);
                    const outD = new Date(pre.checkoutDate);
                    const diff = Math.max(0, (outD - inD) / 86400000);
                    return diff;
                } catch { return '—'; }
            },
            getBookingStatusColor(status) {
                const k = (status || '').toLowerCase();
                if (k === 'approved' || k === 'confirmed') return '#16a34a';
                if (k === 'rejected' || k === 'cancelled') return '#dc2626';
                return '#d97706';
            },
            confirmBookingPreview(msg) {
                const pre = msg.payload?.booking_data?.prefilled || msg.payload?.booking_data || {};
                msg._confirmed = true;
                this._sendTicketChoice(' Confirm & Book', '__BOOKING_SUBMIT__' + JSON.stringify(pre));
            },
            cancelBookingPreview() {
                this._sendTicketChoice('✕ Cancel', 'cancel');
            },
            // ── Chores & Events (isolated; toggle via choresEventsEnabled) ──
            isChoresEventsCardIntent,
            confirmChorePreview(msg) {
                if (!this.choresEventsEnabled) return;
                const pre = msg.payload?.chore_data?.prefilled || {};
                msg._confirmed = true;
                this._sendTicketChoice(' Save Chore', '__CHORE_SUBMIT__' + JSON.stringify(pre));
            },
            deleteChoreItem(c) {
                if (!this.choresEventsEnabled || !c) return;
                this._sendTicketChoice(
                    `Delete ${c.title}`,
                    `__CHORE_DELETE__${encodeURIComponent(c.id)}|${encodeURIComponent(c.title || '')}`
                );
            },
            confirmEventPreview(msg) {
                if (!this.choresEventsEnabled) return;
                const pre = msg.payload?.event_data?.prefilled || {};
                msg._confirmed = true;
                this._sendTicketChoice('Confirm & Create', '__EVENT_SUBMIT__' + JSON.stringify(pre));
            },
            cancelChoresEventsCard() {
                if (!this.choresEventsEnabled) return;
                this._sendTicketChoice('✕ Cancel', 'cancel');
            },
            addEventGuest(e) {
                if (!this.choresEventsEnabled || !e) return;
                this._sendTicketChoice(
                    `Add Guest to ${e.title}`,
                    `__EVENT_ADD_GUEST__${e.eventId}|${encodeURIComponent(e.title || '')}`
                );
            },

            selectEventGuestSource(source) {
                if (!this.choresEventsEnabled || !source) return;

                const value = String(source).toLowerCase();

                this._sendTicketChoice(
                    value === 'roommate' ? 'Roommates' : 'Another Person',
                    `__EVENT_GUEST_SOURCE__${value}`
                );
            },

            selectEventGuestRoommate(roommate) {
                if (!this.choresEventsEnabled || !roommate) return;

                const id =
                    roommate.id ||
                    roommate.value ||
                    roommate.userId ||
                    roommate.UserId ||
                    '';

                const name =
                    roommate.name ||
                    roommate.text ||
                    roommate.label ||
                    roommate.fullName ||
                    'Roommate';

                if (!id) return;

                this._sendTicketChoice(
                    name,
                    `__EVENT_GUEST_ROOMMATE_PICK__${encodeURIComponent(id)}|${encodeURIComponent(name)}`
                );
            },

            selectEventGuestInvite(method) {
                if (!this.choresEventsEnabled || !method) return;

                const value = String(method).toLowerCase();
                const label = value === 'sms' ? 'SMS' : 'Email';

                this._sendTicketChoice(
                    label,
                    `__EVENT_GUEST_INVITE__${value}`
                );
            },
            viewEventDetail(e) {
                if (!this.choresEventsEnabled || !e) return;
                this._sendTicketChoice(`View ${e.title}`, `__EVENT_DETAIL__${e.eventId}`);
            },
            cancelEventItem(e) {
                if (!this.choresEventsEnabled || !e) return;

                if (e.isCancelled) {
                    this._sendTicketChoice(
                        `Reopen ${e.title}`,
                        `__EVENT_REOPEN__${e.eventId}|${encodeURIComponent(e.title || '')}`
                    );
                    return;
                }

                this._sendTicketChoice(
                    `Cancel ${e.title}`,
                    `__EVENT_CANCEL__${e.eventId}|${encodeURIComponent(e.title || '')}`
                );
            },
            deleteEventItem(e) {
                if (!this.choresEventsEnabled || !e) return;
                this._sendTicketChoice(
                    `Delete ${e.title}`,
                    `__EVENT_DELETE__${e.eventId}|${encodeURIComponent(e.title || '')}`
                );
            },

            deleteEventGuest(data) {
                if (
                    !this.choresEventsEnabled ||
                    !data ||
                    !data.eventId ||
                    !data.guestId
                ) return;

                const guestName =
                    String(data.guestName || 'Guest').trim();

                this._sendTicketChoice(
                    `Remove "${guestName}"`,
                    `__EVENT_GUEST_DELETE__${encodeURIComponent(data.eventId)}|${encodeURIComponent(data.guestId)}|${encodeURIComponent(guestName)}`
                );
            },

            duplicateEventItem(e) {
                if (!this.choresEventsEnabled || !e) return;

                this._sendTicketChoice(
                    `Duplicate ${e.title}`,
                    `__EVENT_DUPLICATE__${e.eventId}|${encodeURIComponent(e.title || '')}`
                );
            },
            isMeetingCancelAborted(response) {
                if (!response) return false;
                return /stopped|no problem|keep all|not cancel/i.test(response);
            },
            getFirstCancelMeetingError(text) {
                if (!text) return null;

                // Clean markdown bold
                const clean = text.replace(/\*\*/g, '').trim();

                // Only show if it's an error response (contains "isn't" or "invalid" or "not in the list")
                if (!/isn't|invalid|not in the list|couldn't|could not/i.test(clean)) return null;

                // Return just the first sentence/line before the numbered list
                const firstLine = clean
                    .split(/\n\n|\n\d+\./)[0]  // stop before blank line or "1."
                    .replace(/<[^>]*>/g, '')    // strip HTML
                    .trim();

                return firstLine || null;
            },
            formatVotingDate(dateStr) {
                if (!dateStr) return '—';
                try {
                    const d = new Date(dateStr);
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const dd = String(d.getDate()).padStart(2, '0');
                    const yyyy = d.getFullYear();
                    return `${mm}-${dd}-${yyyy}`;
                } catch { return dateStr; }
            },

            getVotingStatusBadgeStyle(status) {
                if (!status) return '';
                const s = status.toLowerCase();
                if (s === 'passed') return 'background:#dcfce7; color:#16a34a;';
                if (s === 'failed') return 'background:#fee2e2; color:#dc2626;';
                if (s === 'pending') return 'background:#fef3c7; color:#b45309;';
                return 'background:#f1f5f9; color:#64748b;';
            },
            parseCancelMeetingList(text) {
                if (!text) return [];

                const cleanText = text
                    .replace(/<br\s*\/?>/gi, ' ')  // ← ADD THIS first
                    .replace(/<[^>]*>/g, ' ')
                    .replace(/\*\*/g, '')
                    .replace(/\s+/g, ' ')
                    .trim();

                const lines = [];
                let m;

                // Match: "1. Title — 06-22-2026 at 11:44 PM"
                const regex1 = /(\d+)\.\s+(.+?)\s*[—–]\s*(\d{2}-\d{2}-\d{4}\s+at\s+\d{1,2}:\d{2}\s*(?:AM|PM)?(?:\s*UTC)?)/gi;
                while ((m = regex1.exec(cleanText)) !== null) {
                    lines.push({
                        number: m[1].trim(),
                        title: m[2].trim(),
                        time: m[3].replace(/\bUTC\b/gi, '').trim(),
                    });
                }

                if (lines.length) return lines;

                // Try format: "1. title — 06-21-2026 05:45 AM" (no "at")
                const regex2 = /(\d+)\.\s+(.+?)\s*[—–]\s*(\d{2}-\d{2}-\d{4}\s+\d{1,2}:\d{2}\s*(?:AM|PM)?)/gi;
                while ((m = regex2.exec(cleanText)) !== null) {
                    lines.push({
                        number: m[1].trim(),
                        title: m[2].trim(),
                        time: m[3].replace(/\bUTC\b/gi, '').trim(),
                    });
                }

                if (lines.length) return lines;

                // Fallback: just grab numbered lines, skip instruction lines
                const regex3 = /(\d+)\.\s+([^\n]+)/g;
                while ((m = regex3.exec(cleanText)) !== null) {
                    const title = m[2].trim();
                    if (/please reply|type.{0,5}no|meeting number|exact meeting/i.test(title)) continue;
                    lines.push({ number: m[1], title, time: null });
                }

                return lines;
            },
            getSubscriptionFeatures(description) {
                if (!description || typeof description !== 'string') return [];
                try {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = description;
                    const items = tempDiv.querySelectorAll('li');
                    const features = [];
                    items.forEach(item => {
                        const text = item.textContent.trim();
                        if (text) features.push(text);
                    });
                    if (features.length) return features;
                    // Fallback: plain text
                    const plain = description.replace(/<[^>]*>/g, ' ').trim();
                    return plain ? [plain] : [];
                } catch {
                    return [];
                }
            },
            sendTicketStatusUpdateChoice(number, label, msg) {
                if (msg?._confirmed) return;

                if (msg) {
                    msg._confirmed = true;
                }

                const cleanLabel = label.charAt(0).toUpperCase() + label.slice(1);
                this._sendTicketChoice(`${number}. ${cleanLabel}`, number);
            },

            getVotingExpenses(payload) {
                return payload?.expense_data?.expenses || [];
            },

            getVotingStatusClass(status) {
                if (!status) return 'due-expense-status-pending';
                const s = status.toLowerCase();
                if (s === 'passed') return 'due-expense-status-paid';
                if (s === 'failed') return 'due-expense-status-overdue';
                return 'due-expense-status-pending';
            },

            // In methods:
            getTicketStatusClass(status) {
                if (!status) return '';
                return 'tp-ticket-status-' + status.toLowerCase().replace(/\s+/g, '');
            },
            // ─── Save a single message to DB ────────────────────────────────────────────
            async _saveChatMessage(messageFrom, messageText, messageType, payload) {
                try {
                    const model = {
                        sessionId: this.sessionId,
                        userId: this.userId,
                        companyId: this.companyId,
                        messageFrom: messageFrom,
                        messageText: messageText || '',
                        messageType: messageType || 'text',
                        payloadJson: payload ? JSON.stringify(payload) : null,
                    };

                    await FrondEndService.SaveChatMessage(model);

                } catch (err) {
                    // Non-blocking — don't interrupt chat if save fails
                    console.warn('[chatbot] SaveChatMessage failed:', err?.message);
                }
            },

            // ─── Load last 3 conversation pairs on open ──────────────────────────────────
            async _loadChatHistory() {
                if (this._historyLoaded) return;
                if (!this.userId || !this.companyId) return;
                const sessionId = localStorage.getItem('session_id');
                if (!sessionId) {
                    console.warn('[chatbot] No session_id in localStorage, skipping history load.');
                    this._historyLoaded = true;
                    return;
                }

                try {
                    const res = await FrondEndService.GetChatHistory(
                        this.userId,
                        this.companyId,
                        sessionId,   // ← pass sessionId
                        3
                    );
                    const responseData = res?.data;

                    if (responseData?.statusCode !== 200) {
                        this._historyLoaded = true;
                        return;
                    }

                    let historyMessages = [];
                    if (Array.isArray(responseData?.data)) {
                        historyMessages = responseData.data.flat();
                    } else if (Array.isArray(responseData?.result)) {
                        historyMessages = responseData.result.flat();
                    }
                    historyMessages.reverse();
                    if (!historyMessages.length) {
                        this._historyLoaded = true;
                        return;
                    }

                    // ✅ Insert history AFTER welcome message (index 1 onwards)
                    // Find welcome message index
                    const welcomeIndex = this.messages.findIndex(m => m.type === 'welcome');
                    const insertAt = welcomeIndex !== -1 ? welcomeIndex + 1 : this.messages.length;

                    const historyToInsert = [];

                    // ✅ Divider AFTER welcome, BEFORE history
                    /*   historyToInsert.push({
                           from: 'bot',
                           type: 'text',
                           text: `<div class="chat-history-divider"><span>— Previous Conversations —</span></div>`
                       });*/

                    for (const row of historyMessages) {
                        const messageFrom = row.messageFrom || row.MessageFrom || '';
                        const messageText = row.messageText || row.MessageText || '';
                        const messageType = row.messageType || row.MessageType || 'text';
                        const payloadJson = row.payloadJson || row.PayloadJson || null;

                        if (messageFrom === 'user') {
                            historyToInsert.push({
                                from: 'user',
                                text: messageText,
                                _fromHistory: true,
                            });
                        } else if (messageFrom === 'bot') {
                            const payload = payloadJson
                                ? this._safeParseJson(payloadJson)
                                : null;

                            const type = messageType || 'text';

                            // ✅ These types restore fine as rich cards
                            const richRestorableTypes = [
                                'view_events_guestlist',
                                'view_events_duplicate',
                                'event_guest_source_prompt',
                                'event_guest_roommate_prompt',
                                'event_guest_invite_prompt',
                                'Hotel_search', 'ticket_menu', 'ticket_flow', 'ticket_guide',
                                'ticket_created', 'ticket_api_error',
                                'expense_flow', 'expense_created', 'expense_api_error',
                                'meeting_scheduled', 'meeting_created', 'meeting_api_error', 'meeting_flow',
                                'due_expense_list', 'ticket_details', 'ticket_status', 'ticket_details_result',
                                'ticket_status_result', 'ticket_attachment_upload', 'expense_attachment_upload',
                                'ticket_lookup_pending', 'expense_form', 'ticket_form', 'meeting_preview',
                                'meeting_conflict', 'meeting_form', 'meeting_form_preview', 'view_meetings',
                                'ticket_vendor_result', 'ticket_status_failed', 'ticket_vendor_failed', 'ticket_preview', 'view_tickets', 'meeting_failed', 'ticket_creation_restricted',
                                'cancel_meeting_empty', 'cancel_meeting_list', 'meeting_cancelled',
                                'cancel_meeting_cancelled', 'cancel_failed',
                                'ticket_status_update_flow', 'ticket_status_updated', 'ticket_status_update_failed',
                                'due_expense_voting_list', 'due_expense_voting_empty', 'due_expense_voting_failed',
                                'view_subscription', 'view_subscription_failed', 'view_subscription_empty',
                                'view_subscription', 'view_subscription_failed', 'view_subscription_empty',
                                'booking_preview', 'booking_created', 'booking_failed', 'view_bookings', 'document_vault_flow', 'document_vault_doctype_prompt', 'document_vault_upload_prompt',
                                'document_vault_coowner_prompt', 'document_vault_created', 'document_vault_failed',
                                'document_vault_cancelled', 'view_documents', 'view_documents_empty',
                                'document_deleted', 'document_delete_failed',
                                'document_status_updated', 'document_status_update_failed',
                                ...(CHORES_EVENTS_ENABLED ? CHORES_EVENTS_CARD_INTENTS : []), ...HOUSEHOLD_EXPENSE_CARD_INTENTS, ...MANAGE_GUEST_GROUP_CARD_INTENTS, ...NOTIFICATION_CARD_INTENTS, ...ROOMMATE_CARD_INTENTS, ...VENDOR_CARD_INTENTS, ...MANAGE_VENDOR_CARD_INTENTS,
                            ];

                            if (payload && richRestorableTypes.includes(type)) {

                                // ✅ Rich card — restore with _confirmed + _fromHistory
                                historyToInsert.push({
                                    from: 'bot',
                                    type: type,
                                    payload: payload,
                                    text: messageText || '',
                                    _confirmed: true,
                                    _fromHistory: true,
                                });
                            } else {
                                // ✅ Everything else (forms, flows, plain text) → show as plain text
                                // This avoids broken interactive cards from old sessions
                                historyToInsert.push({
                                    from: 'bot',
                                    type: 'text',
                                    text: messageText || '',
                                    _fromHistory: true,
                                });
                            }
                        }
                    }

                    // ✅ Divider after history
                    /*historyToInsert.push({
                        from: 'bot',
                        type: 'text',
                        text: `<div class="chat-history-divider"><span>— New Conversation —</span></div>`
                    });*/

                    // ✅ Splice history into messages AFTER the welcome card
                    this.messages.splice(insertAt, 0, ...historyToInsert);

                    this._historyLoaded = true;
                    this.scrollToBottom();
                    this.$nextTick(() => { this.addImageClickListeners(); });

                } catch (err) {
                    console.warn('[chatbot] GetChatHistory failed:', err?.message);
                    this._historyLoaded = true;
                }
            },
            // ─── Safe JSON parse ─────────────────────────────────────────────────────────
            _safeParseJson(str) {
                try {
                    return str ? JSON.parse(str) : null;
                } catch {
                    return null;
                }
            },
            getExpenseDescWordCount() {
                const text = this.expenseForm?.description || '';
                return text.trim() === '' ? 0 : text.trim().split(/\s+/).filter(w => w.length > 0).length;
            },
            formatExpenseDate(dateStr) {
                if (!dateStr) return '—';
                try {
                    const clean = String(dateStr).split('T')[0].trim();

                    // Handle yyyy-mm-dd → mm-dd-yyyy
                    if (/^\d{4}-\d{2}-\d{2}$/.test(clean)) {
                        const parts = clean.split('-');
                        return `${parts[1]}-${parts[2]}-${parts[0]}`;
                    }

                    // Already mm-dd-yyyy
                    if (/^\d{2}-\d{2}-\d{4}$/.test(clean)) return clean;

                    // Fallback: parse any date
                    const d = new Date(clean);
                    if (isNaN(d.getTime())) return dateStr;
                    const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
                    const dd = String(d.getUTCDate()).padStart(2, '0');
                    const yyyy = d.getUTCFullYear();
                    return `${mm}-${dd}-${yyyy}`;

                } catch {
                    return dateStr;
                }
            },
            formatCurrencyUS(value) {
                if (value === null || value === undefined || value === '') return '—';
                try {
                    const num = parseFloat(value);
                    if (isNaN(num)) return value;
                    return num.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    });
                } catch {
                    return value;
                }
            },
            isMeetingCompleted(status) {
                if (!status) return false;
                const s = status.toLowerCase().trim();
                return s === 'completed' || s === 'complete' || s === 'done' || s === 'ended' || s === 'finished';
            },

            getMeetingStatusLabel(status) {
                if (!status) return '';
                const s = status.toLowerCase().trim();
                if (s === 'scheduled') return '🟢 Scheduled';
                if (s === 'completed' || s === 'complete' || s === 'done' || s === 'ended' || s === 'finished') return '✅ Completed';
                if (s === 'cancelled' || s === 'canceled') return '🔴 Cancelled';
                if (s === 'ongoing' || s === 'in progress') return '🔵 In Progress';
                return status.charAt(0).toUpperCase() + status.slice(1);
            },

            getMeetingStatusStyle(status) {
                if (!status) return '';
                const s = status.toLowerCase().trim();
                if (s === 'scheduled') {
                    return 'background:#d1fae5; color:#065f46; padding:1px 8px; border-radius:10px; font-size:10px; font-weight:600;';
                }
                if (s === 'completed' || s === 'complete' || s === 'done' || s === 'ended' || s === 'finished') {
                    return 'background:#e2e8f0; color:#475569; padding:1px 8px; border-radius:10px; font-size:10px; font-weight:600;';
                }
                if (s === 'cancelled' || s === 'canceled') {
                    return 'background:#fee2e2; color:#991b1b; padding:1px 8px; border-radius:10px; font-size:10px; font-weight:600;';
                }
                if (s === 'ongoing' || s === 'in progress') {
                    return 'background:#dbeafe; color:#1e40af; padding:1px 8px; border-radius:10px; font-size:10px; font-weight:600;';
                }
                return 'background:#f1f5f9; color:#64748b; padding:1px 8px; border-radius:10px; font-size:10px; font-weight:600;';
            },
            extractDateFromDateTime(dateTimeStr) {
                if (!dateTimeStr) return '—';
                try {
                    // Handle ISO "2026-06-01T16:14:00"
                    if (dateTimeStr.includes('T')) {
                        return dateTimeStr.split('T')[0]; // "2026-06-01" — convertUTCToLocalTime handles this format
                    }
                    // Handle "06-01-2026 16:14"
                    return dateTimeStr.split(' ')[0] || '—';
                } catch {
                    return '—';
                }
            },

            isCardDisabled(msg) {
                const msgIndex = this.messages.indexOf(msg);
                if (msgIndex === -1) return false;

                // ✅ Confirmed in this session (not from history) — always disabled
                if (msg._confirmed && !msg._fromHistory) return true;

                // ✅ Scan all messages AFTER this card
                for (let i = msgIndex + 1; i < this.messages.length; i++) {
                    const m = this.messages[i];

                    // Any user message after this card → disable
                    if (m.from === 'user') return true;

                    // ✅ NEW: Any result/outcome card after this card → disable
                    // This handles the case where _confirmed wasn't set (history restore,
                    // race conditions, page reload mid-flow)
                    if (m.from === 'bot') {
                        const outcomeTypes = [
                            'ticket_created', 'ticket_api_error',
                            'expense_created', 'expense_api_error',
                            'meeting_created', 'meeting_api_error', 'meeting_failed',
                            'household_expense_created',
                            'household_expense_failed',
                            ...CHORES_EVENTS_OUTCOME_TYPES,
                        ];
                        if (outcomeTypes.includes(m.type)) return true;
                    }
                }

                return false;
            },
            formatTo12Hours(timeStr) {
                if (!timeStr) return '—';
                try {
                    const [hourStr, minuteStr] = timeStr.split(':');
                    let hour = parseInt(hourStr, 10);
                    const minute = String(minuteStr || '0').padStart(2, '0');
                    const ampm = hour >= 12 ? 'PM' : 'AM';
                    hour = hour % 12 || 12;
                    return `${hour}:${minute} ${ampm}`;
                } catch {
                    return timeStr;
                }
            },
            formatTimeTo12Hour(timeStr) {
                if (!timeStr) return '—';
                try {
                    const tzRaw = (localStorage.getItem('TimeZone') || 'UTC').trim();

                    console.log('[formatTimeTo12Hour] tzRaw:', tzRaw, '| timeStr:', timeStr);

                    const tzMap = {
                        'India Standard Time': 'Asia/Kolkata',
                        'Eastern Standard Time': 'America/New_York',
                        'US Eastern Standard Time': 'America/New_York',
                        'Central Standard Time': 'America/Chicago',
                        'US Central Standard Time': 'America/Chicago',
                        'Mountain Standard Time': 'America/Denver',
                        'Pacific Standard Time': 'America/Los_Angeles',
                        'UTC': 'UTC',
                        'Greenwich Standard Time': 'Europe/London',
                        'W. Europe Standard Time': 'Europe/Berlin',
                        'Central Europe Standard Time': 'Europe/Budapest',
                        'E. Europe Standard Time': 'Europe/Nicosia',
                        'Central European Time': 'Europe/Paris',
                        'Romance Standard Time': 'Europe/Paris',
                        'China Standard Time': 'Asia/Shanghai',
                        'Japan Standard Time': 'Asia/Tokyo',
                        'Arabian Standard Time': 'Asia/Dubai',
                        'Arab Standard Time': 'Asia/Riyadh',
                        'AUS Eastern Standard Time': 'Australia/Sydney',
                        'Singapore Standard Time': 'Asia/Singapore',
                        'Korea Standard Time': 'Asia/Seoul',
                        'SE Asia Standard Time': 'Asia/Bangkok',
                        'Bangladesh Standard Time': 'Asia/Dhaka',
                        'Pakistan Standard Time': 'Asia/Karachi',
                        'Sri Lanka Standard Time': 'Asia/Colombo',
                        'Nepal Standard Time': 'Asia/Kathmandu',
                        'Myanmar Standard Time': 'Asia/Rangoon',
                        'N. Central Asia Standard Time': 'Asia/Novosibirsk',
                        'Russian Standard Time': 'Europe/Moscow',
                        'Egypt Standard Time': 'Africa/Cairo',
                        'South Africa Standard Time': 'Africa/Johannesburg',
                        'Brazil Standard Time': 'America/Sao_Paulo',
                        'Argentina Standard Time': 'America/Argentina/Buenos_Aires',
                        'Canada Central Standard Time': 'America/Regina',
                        'Atlantic Standard Time': 'America/Halifax',
                    };

                    const [hourStr, minuteStr] = timeStr.split(':');
                    const now = new Date();
                    const utcDate = new Date(Date.UTC(
                        now.getFullYear(),
                        now.getMonth(),
                        now.getDate(),
                        parseInt(hourStr, 10),
                        parseInt(minuteStr || '0', 10),
                        0
                    ));

                    // 1. Try IANA from map
                    const ianaZone = tzMap[tzRaw];
                    console.log('[formatTimeTo12Hour] ianaZone from map:', ianaZone);

                    if (ianaZone) {
                        const result = utcDate.toLocaleTimeString('en-US', {
                            hour: 'numeric',
                            minute: '2-digit',
                            hour12: true,
                            timeZone: ianaZone
                        });
                        console.log('[formatTimeTo12Hour] result:', result);
                        return result;
                    }

                    // 2. Try tzRaw directly as IANA
                    try {
                        return utcDate.toLocaleTimeString('en-US', {
                            hour: 'numeric',
                            minute: '2-digit',
                            hour12: true,
                            timeZone: tzRaw
                        });
                    } catch (_) {
                        // 3. Parse offset manually from "(UTC+5:30)" pattern
                        const offsetMatch = tzRaw.match(/UTC([+-])(\d{1,2}):(\d{2})/);
                        if (offsetMatch) {
                            const sign = offsetMatch[1] === '+' ? 1 : -1;
                            const offsetMinutes = sign * (parseInt(offsetMatch[2], 10) * 60 + parseInt(offsetMatch[3], 10));
                            const localTime = new Date(utcDate.getTime() + offsetMinutes * 60000);
                            let h = localTime.getUTCHours();
                            const m = String(localTime.getUTCMinutes()).padStart(2, '0');
                            const ampm = h >= 12 ? 'PM' : 'AM';
                            h = h % 12 || 12;
                            return `${h}:${m} ${ampm}`;
                        }
                    }

                    // 4. Absolute fallback
                    let hour = parseInt(hourStr, 10);
                    const minute = String(minuteStr || '0').padStart(2, '0');
                    const ampm = hour >= 12 ? 'PM' : 'AM';
                    hour = hour % 12 || 12;
                    return `${hour}:${minute} ${ampm}`;

                } catch (e) {
                    console.error('[formatTimeTo12Hour] error:', e);
                    const [hourStr, minuteStr] = timeStr.split(':');
                    let hour = parseInt(hourStr, 10);
                    const minute = String(minuteStr || '0').padStart(2, '0');
                    const ampm = hour >= 12 ? 'PM' : 'AM';
                    hour = hour % 12 || 12;
                    return `${hour}:${minute} ${ampm}`;
                }
            },
            toggleMeetingPreviewParticipant(msg, user) {
                if (!msg._previewParticipants) msg._previewParticipants = [];
                const id = String(user.value);
                const idx = msg._previewParticipants.indexOf(id);
                if (idx === -1) {
                    msg._previewParticipants.push(id);
                } else {
                    msg._previewParticipants.splice(idx, 1);
                }
            },
            getTicketStatusColor(status) {
                const k = (status || '').toLowerCase();
                if (k === 'open') return '#1d4ed8';
                if (k === 'closed' || k === 'resolved') return '#16a34a';
                return '#d97706';
            },

            getTicketPriorityColor(priority) {
                const k = (priority || '').toLowerCase();
                if (k === 'critical') return '#dc2626';
                if (k === 'high') return '#ea580c';
                if (k === 'medium') return '#d97706';
                return '#16a34a';
            },

            isTicketListItemOpen(msg, idx) {
                if (!msg._expandedTickets) msg._expandedTickets = {};
                return !!msg._expandedTickets[idx];
            },

            toggleTicketListItem(msg, idx) {
                if (!msg._expandedTickets) msg._expandedTickets = {};
                msg._expandedTickets[idx] = !msg._expandedTickets[idx];
            },
            cancelExpenseForm() {
                const msg = [...this.messages].reverse()
                    .find(m => m.from === 'bot' && m.type === 'expense_form');
                if (msg) msg._confirmed = true;
                this._sendTicketChoice('✕ Cancel', 'cancel');
            },
            getMeetingPreviewParticipantList(msg) {
                const coOwners = msg.payload?.meeting_data?.co_owners || [];
                const prefilled = msg.payload?.meeting_data?.prefilled || {};
                const preselectedIds = prefilled.participant_user_ids || [];

                const users = coOwners.map(u => {
                    const value = String(u.userId || u.UserId || u.id || u.Id || u.value || '');
                    const rawName = u.fullName || u.userName || u.name || u.Name
                        || u.text || u.masterName || u.email || 'Unknown';
                    const label = rawName
                        .replace(/\(\s*co-owner\s*\)/gi, '')
                        .replace(/\s+/g, ' ')
                        .trim();
                    return { value, label };
                }).filter(u => u.value);

                // ✅ Auto-select only on first render (when _previewParticipants not yet set)
                if (!msg._previewParticipants) {
                    if (preselectedIds.length) {
                        // Prefilled has specific participant IDs → select only those
                        msg._previewParticipants = users
                            .filter(u => preselectedIds.includes(u.value))
                            .map(u => u.value);
                    } else {
                        // No prefilled IDs → select all
                        msg._previewParticipants = users.map(u => u.value);
                    }
                }

                return { users };
            },

            isMeetingPreviewParticipantChecked(msg, value) {
                return (msg._previewParticipants || []).includes(String(value));
            },
            isAllMeetingPreviewSelected(msg) {
                const list = this.getMeetingPreviewParticipantList(msg)?.users || [];
                if (!list.length) return false;
                return list.every(u => (msg._previewParticipants || []).includes(u.value));
            },
            isSomeMeetingPreviewSelected(msg) {
                const list = this.getMeetingPreviewParticipantList(msg)?.users || [];
                const selected = msg._previewParticipants?.length || 0;
                return selected > 0 && selected < list.length;
            },
            toggleAllMeetingPreviewParticipants(msg, event) {
                const users = this.getMeetingPreviewParticipantList(msg).users;
                msg._previewParticipants = event.target.checked
                    ? users.map(u => u.value)
                    : [];
            },
            confirmMeetingPreviewWithParticipants(msg) {
                const pre = msg.payload?.meeting_data?.prefilled || {};
                const coOwners = msg.payload?.meeting_data?.co_owners || [];
                const selectedIds = msg._previewParticipants || [];

                if (!selectedIds.length) {
                    this.$toast?.error('Please select at least one participant.')
                        || alert('Please select at least one participant.');
                    return;
                }

                const selectedNames = coOwners
                    .filter(u => {
                        const id = String(u.userId || u.UserId || u.id || u.Id || u.value || '');
                        return selectedIds.includes(id);
                    })
                    .map(u => {
                        const rawName = u.fullName || u.userName || u.name || u.Name
                            || u.text || u.masterName || u.email || 'Unknown';
                        return rawName.replace(/\(\s*co-owner\s*\)/gi, '').replace(/\s+/g, ' ').trim();
                    });

                // ✅ Use the prefilled meetingDateTime as-is — backend already gave it in UTC
                // DO NOT add userTimezone here — backend reads it from top-level body via _sendRaw
                const payload = {
                    meetingTitle: pre.meeting_title || pre.meetingTitle || '',
                    assetID: pre.assetID || pre.assetId || '',
                    assetName: pre.asset_name || pre.assetName || '',
                    durationMinutes: parseInt(pre.duration_minutes || 30),
                    meetingDateTime: pre.meeting_datetime_utc || (function () {
                        const [mm, dd, yyyy] = (pre.meeting_date || "").split("-");
                        const time = pre.meeting_time || "00:00";
                        if (yyyy && mm && dd) {
                            return `${yyyy}-${mm}-${dd}T${time}:00+00:00`;
                        }
                        return pre.meeting_date + " " + pre.meeting_time;
                    })(),
                    coOwnerIds: selectedIds,
                    coOwnerNames: selectedNames,
                    description: pre.description || '',

                };

                msg._confirmed = true;
                this._sendTicketChoice('✔ Confirm & Book', '__MTG_SUBMIT__' + JSON.stringify(payload));
            },
            getTicketPreviewPriorityIcon(priority) {
                const p = (priority || '').toLowerCase();
                if (p === 'critical') return { icon: '🔴', bg: '#fee2e2', color: '#b91c1c' };
                if (p === 'high') return { icon: '🟠', bg: '#fff3e0', color: '#e65100' };
                if (p === 'medium') return { icon: '🟡', bg: '#fffde7', color: '#f59e0b' };
                return { icon: '🟢', bg: '#e8f5e9', color: '#2e7d32' };
            },

            getTicketPreviewCurrentWorkTypeName(msg) {
                const ticketData = msg?.payload?.ticket_data || {};
                const pre = ticketData?.prefilled || {};

                return String(
                    pre.workTypeName
                    || pre.workType
                    || ticketData.workTypeName
                    || ticketData.workType
                    || this._lastSelectedWorkType?.name
                    || ''
                ).trim();
            },

            getTicketPreviewWorkTypeValue(msg) {
                const pre = msg?.payload?.ticket_data?.prefilled || {};

                const currentId = String(
                    pre.workTypeId
                    || pre.workTypeID
                    || this._lastSelectedWorkType?.id
                    || ''
                ).trim();

                if (currentId) return currentId;

                const currentName = this.getTicketPreviewCurrentWorkTypeName(msg);
                const matched = this._ticketPreviewWorkTypes.find(
                    x => String(x.text || '').trim().toLowerCase() === currentName.toLowerCase()
                );

                if (matched) return matched.value;

                // Keeps the previously selected backend value visible
                // until the real dropdown id is resolved.
                return currentName ? '__current_worktype__' : '';
            },

            shouldShowTicketPreviewCurrentWorkType(msg) {
                const currentName = this.getTicketPreviewCurrentWorkTypeName(msg);
                if (!currentName) return false;

                const currentValue = this.getTicketPreviewWorkTypeValue(msg);

                return !this._ticketPreviewWorkTypes.some(
                    x => String(x.value) === String(currentValue)
                );
            },

            normalizeTicketPreviewWorkTypes(apiResponse) {
                const root = apiResponse?.data ?? apiResponse ?? {};

                let rows = [];

                if (Array.isArray(root)) {
                    rows = root;
                } else if (Array.isArray(root.data)) {
                    rows = root.data;
                } else if (Array.isArray(root.result)) {
                    rows = root.result;
                } else if (Array.isArray(root.responseData)) {
                    rows = root.responseData;
                } else if (Array.isArray(root.response)) {
                    rows = root.response;
                } else if (Array.isArray(root.items)) {
                    rows = root.items;
                }

                return rows.map(x => {
                    const value = String(
                        x?.value
                        ?? x?.Value
                        ?? x?.id
                        ?? x?.Id
                        ?? x?.key
                        ?? x?.Key
                        ?? x?.masterId
                        ?? x?.MasterId
                        ?? x?.masterID
                        ?? x?.MasterID
                        ?? x?.customFieldId
                        ?? x?.CustomFieldId
                        ?? ''
                    ).trim();

                    const text = String(
                        x?.text
                        ?? x?.Text
                        ?? x?.label
                        ?? x?.Label
                        ?? x?.name
                        ?? x?.Name
                        ?? x?.masterName
                        ?? x?.MasterName
                        ?? x?.customFieldValue
                        ?? x?.CustomFieldValue
                        ?? ''
                    ).trim();

                    return { value, text };
                }).filter(x => x.value && x.text);
            },

            async loadTicketPreviewWorkTypes(msg) {
                if (this._ticketPreviewWorkTypesLoaded || this._ticketPreviewWorkTypesLoading) {
                    return;
                }

                this._ticketPreviewWorkTypesLoading = true;
                this._ticketPreviewWorkTypesError = '';

                try {
                    const companyId = String(
                        this.companyId
                        || localStorage.getItem('companyId')
                        || 'C5D46FD3-8698-4F6E-AC9C-97A1AE5906B3'
                    ).trim();

                    const userId = String(
                        this.userId
                        || localStorage.getItem('userId')
                        || '1504a0dc-dbec-49ab-984e-a2451a27a596'
                    ).trim();

                    const url =
                        `${this.STAGE_API_BASE}/Common/GetCustomFieldsDropDownList/0/63BD5A78-0C29-4E7D-B0B6-3B3267E0C418/TicketStageWorkType/null/null/${companyId}/${userId}`;

                    const response = await axios.get(url);
                    const options = this.normalizeTicketPreviewWorkTypes(response);

                    this._ticketPreviewWorkTypes = options;
                    this._ticketPreviewWorkTypesLoaded = true;

                    // Match current backend Work Type name to its id when preview
                    // does not contain workTypeId.
                    const pre = msg?.payload?.ticket_data?.prefilled || {};
                    if (!pre.workTypeId && !pre.workTypeID) {
                        const currentName = this.getTicketPreviewCurrentWorkTypeName(msg);
                        const match = options.find(
                            x => x.text.toLowerCase() === currentName.toLowerCase()
                        );

                        if (match) {
                            pre.workTypeId = match.value;
                            pre.workTypeID = match.value;
                            pre.workTypeName = match.text;
                            this._lastSelectedWorkType = {
                                id: match.value,
                                name: match.text
                            };
                        }
                    }
                } catch (err) {
                    console.error('Ticket Preview Work Type API error:', err);
                    this._ticketPreviewWorkTypesError = 'Unable to load Work Types.';
                } finally {
                    this._ticketPreviewWorkTypesLoading = false;
                }
            },

            onTicketPreviewWorkTypeChange(msg, event) {
                const selectedId = String(event?.target?.value || '').trim();
                if (!selectedId || selectedId === '__current_worktype__' || selectedId === '__loading__') return;

                const selected = this._ticketPreviewWorkTypes.find(
                    x => String(x.value) === selectedId
                );

                if (!selected) return;

                const pre = msg?.payload?.ticket_data?.prefilled || {};

                pre.workTypeId = selected.value;
                pre.workTypeID = selected.value;
                pre.workTypeName = selected.text;

                this._lastSelectedWorkType = {
                    id: selected.value,
                    name: selected.text
                };
            },

            async confirmAndSubmitTicketPreview(msg) {
                if (this._ticketPreviewSubmitting) return;
                this._ticketPreviewSubmitting = true;

                const pre = msg?.payload?.ticket_data?.prefilled || {};

                try {
                    // ✅ Upload file first if one was selected
                    let attachmentPath = pre.attachmentPath || null;

                    if (this._attachmentFiles.length) {
                        this._attachmentUploading = true;
                        this._attachmentError = null;
                        try {
                            const formData = new FormData();
                            for (const f of this._attachmentFiles) {
                                formData.append("file", f);
                            }
                            const response = await this._manageAssetsService.SaveTicketFile(formData);
                            if (response?.data?.statusCode === 200) {
                                attachmentPath = response.data.responseMessage;
                                const displayNames = this._attachmentFiles.map(f => f.name).join(', ');
                                this.scrollToBottom();
                            } else {
                                this._attachmentError = response?.data?.responseMessage || "Upload failed.";
                                return; // ✅ Stop — don't submit if upload failed
                            }
                        } catch (err) {
                            console.error("Attachment upload error:", err);
                            this._attachmentError = "Upload failed. Please check your connection.";
                            return; // ✅ Stop — don't submit if upload failed
                        } finally {
                            this._attachmentUploading = false;
                        }
                    }

                    // ✅ Now submit ticket with attachment path
                    const payload = JSON.stringify({
                        subject: pre.subject || '',
                        assetID: pre.assetID || pre.assetId || '',
                        assetName: pre.assetName || '',
                        workTypeId: pre.workTypeId || pre.workTypeID || this._lastSelectedWorkType.id || '',
                        workTypeName: pre.workTypeName || this._lastSelectedWorkType.name || '',
                        priorityId: pre.priorityId || '',
                        priorityName: pre.priorityName || '',
                        description: pre.description || '',
                        attachmentPath: attachmentPath,
                    });
                    this.messages.push({ from: "user", text: ' Confirm & Submit' });
                    this._saveChatMessage('user', 'Confirm & Submit', 'text', null);


                    await this._sendRaw('__TICKET_SUBMIT__' + payload);
                    msg._confirmed = true;
                    // ✅ Reset all attachment state
                    this._attachmentFiles = [];
                    this._attachmentPreviews = [];
                    this._attachmentUploadedNames = [];
                    this._attachmentError = null;

                } finally {
                    this._ticketPreviewSubmitting = false;
                }
            },

            cancelTicketPreview() {
                this._sendTicketChoice('✖ Cancel', 'cancel');
            },

            // ✅ Reuse existing upload method — triggered from preview card
            triggerTicketPreviewAttachment() {
                const input = this.$refs.ticketPreviewFileInput;
                if (input) input.click();
            },

            async onTicketPreviewAttachmentChange(event, msg) {
                // ✅ Reuse exact same validation + upload as existing ticket attachment
                await this.onAttachmentFileChange(event);
                if (this._attachmentFiles.length) {
                    await this.submitAttachmentUpload();
                }
            },
            formatMessage(text) {
                if (!text) return '';

                // Protect common abbreviations and time formats
                const protectedPatterns = [
                    /\b(e\.g\.|i\.e\.|etc\.)/gi,
                    /\b([0-9]{1,2})\.([0-9]{2})\s?(AM|PM)\b/gi, // 6.00 PM
                    /\b([0-9]{1,2}):([0-9]{2})\s?(AM|PM)\b/gi  // 6:00 PM
                ];

                let protectedText = text;

                protectedPatterns.forEach(pattern => {
                    protectedText = protectedText.replace(pattern, match =>
                        match.replace(/\./g, '__DOT__')
                    );
                });

                // Add line breaks after sentence endings
                protectedText = protectedText.replace(
                    /([.?!:])\s+/g,
                    '$1<br><br>'
                );

                // Restore protected dots
                protectedText = protectedText.replace(/__DOT__/g, '.');

                return protectedText;
            },
            // Toggle meeting details (for collapsible items)
            isMeetingListItemOpen(msg, index) {
                if (!msg._expandedMeetings) msg._expandedMeetings = {};
                return !!msg._expandedMeetings[index];
            },

            toggleMeetingListItem(msg, index) {
                if (!msg._expandedMeetings) msg._expandedMeetings = {};
                msg._expandedMeetings[index] = !msg._expandedMeetings[index];
            },
            isViewMeetingsMessage(msg) {
                if (!msg || msg.type !== 'meeting_chat') return false;
                return (
                    msg.payload?.Intent === 'view_meetings' &&
                    msg.payload?.meeting_data?.meetings !== undefined
                );
            },

            toggleMeetingDetail(msg, idx) {
                if (!msg._openMeetingDetails) {
                    msg._openMeetingDetails = {};
                }
                msg._openMeetingDetails[idx] = !msg._openMeetingDetails[idx];
            },

            isMeetingDetailOpen(msg, idx) {
                return !!msg._openMeetingDetails?.[idx];
            },
            isMeetingConflictPrompt(text) {
                if (!text || typeof text !== 'string') return false;
                const lower = text.toLowerCase();
                return lower.includes('conflict') ||
                    lower.includes('already scheduled') ||
                    lower.includes('slot also has a conflict');
            },
            // Detect when backend asks to re-enter date/time
            isDateTimeReprompt(text) {
                if (!text || typeof text !== 'string') return false;
                const lower = text.toLowerCase();
                return lower.includes("couldn't parse") ||
                    lower.includes("could not parse") ||
                    (lower.includes("new date") && lower.includes("new time"));
            },
            parseMeetingConflicts(text) {
                if (!text) return [];
                const conflicts = [];
                const rawLines = text.split('\n').map(l => l.trim()).filter(Boolean);
                const newFormatRegex = /^(.+?)\s+already has a meeting\s+"([^"]+)"\s+from\s+(.+?)\s+to\s+(.+?)(?:\s*UTC)?\.?\s*$/i;
                const contextDate = this.meetingForm?.meetingDate
                    ? this.formatDateMDY(this.meetingForm.meetingDate)
                    : null;
                const bulletRegex =
                    /^-\s*(.+?)\s+—\s+\*\*(.+?)\*\*\s+on\s+(.+)$/i;

                // Strips common timezone abbreviations (CDT, CST, EST, EDT, PST, PDT, MST, MDT, UTC, GMT, etc.)
                const stripTz = (str) => str.trim().replace(/\s*\b(?:UTC|GMT|[A-Z]{2,4}T)\s*$/, '').trim();

                for (const line of rawLines) {
                    const clean = line.replace(/<[^>]*>/g, '');
                    const m = clean.match(bulletRegex);
                    if (m) {
                        const [, personName, title, details] = m;
                        conflicts.push({
                            title: title.trim(),
                            details: stripTz(details) // no personName, no timezone
                        });
                    }
                }
                if (conflicts.length) return conflicts;

                // Legacy format
                for (const line of rawLines) {
                    if (line.includes('**')) {
                        const titleMatch = line.match(/\*\*(.+?)\*\*/);
                        const title = titleMatch ? titleMatch[1].trim() : null;
                        if (!title || /schedule conflict detected/i.test(title)) continue;
                        const timeMatch = line.match(/\((.+?)\)/);
                        const rawDetails = timeMatch ? timeMatch[1].trim() : line.replace(/\*\*/g, '').trim();
                        conflicts.push({ title, details: stripTz(rawDetails) });
                    }
                }
                if (conflicts.length) return conflicts;

                conflicts.push({
                    title: "Meeting Conflict",
                    details: "The selected time slot is already booked"
                });
                return conflicts;
            },
            getMeetingPreviewParticipants(msg) {
                const pre = msg?.payload?.meeting_data?.prefilled || {};
                const coOwners = msg?.payload?.meeting_data?.co_owners || [];

                // ✅ Use co_owner_names if available
                if (pre.co_owner_names?.length) {
                    return pre.co_owner_names.join(', ');
                }

                // ✅ Fallback — match participant_user_ids against co_owners list
                const ids = pre.participant_user_ids || [];
                if (ids.length && coOwners.length) {
                    return coOwners
                        .filter(c => ids.includes(c.value))
                        .map(c => c.text)
                        .join(', ') || '—';
                }

                // ✅ Show all co_owners if no ids
                if (coOwners.length) {
                    return coOwners.map(c => c.text).join(', ');
                }

                return '—';
            },

            async confirmMeetingPreview(msg) {
                const pre = msg?.payload?.meeting_data?.prefilled || {};
                const coOwners = msg?.payload?.meeting_data?.co_owners || [];

                const ids = coOwners.map(c => c.value).join(',');
                const names = coOwners.map(c => c.text).join(',');

                const payload = {
                    meetingTitle: pre.meeting_title || '',
                    assetID: pre.assetID || '',
                    assetName: pre.asset_name || '',
                    durationMinutes: pre.duration_minutes || '',
                    meetingDate: pre.meeting_date || '',
                    meetingTime: pre.meeting_time || '',
                    participantIds: ids,
                    participantNames: names,
                    description: pre.description || '',
                };

                this._sendTicketChoice('✔ Confirm & Book', '__MTG_SUBMIT__' + JSON.stringify(payload));
            },

            cancelMeetingPreview() {
                this._sendTicketChoice('✖ Cancel Meeting', 'cancel');
            },
            isMeetingDaysStep(payload) {
                return payload?.response?.toLowerCase().includes('date') ||
                    payload?.meeting_data?.showDatePicker;
            },

            isMeetingTimeStep(payload) {
                return payload?.response?.toLowerCase().includes('time') ||
                    payload?.meeting_data?.showTimePicker;
            },

            isMeetingDurationStep(payload) {
                return payload?.response?.toLowerCase().includes('duration') ||
                    payload?.meeting_data?.showDurationPicker;
            },

            isMeetingDescriptionPrompt(response) {
                return /describe|purpose|agenda|details/i.test(response);
            },

            getMeetingParticipantsList(msg) {
                return msg.payload?.meeting_data?.participants ||
                    msg.payload?.meeting_data?.coOwnerNames || [];
            },

            toggleMeetingParticipantsExpand(index) {
                // implement expand/collapse logic
                this._expandedMeetingParticipants = this._expandedMeetingParticipants || {};
                this.$set(this._expandedMeetingParticipants, index,
                    !this._expandedMeetingParticipants[index]);
            },

            formatDateMDY(datetime) {
                if (!datetime) return '';
                const d = new Date(datetime);
                return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
            },
            extractTimeFromDateTime(dateTimeStr) {
                if (!dateTimeStr) return '—';
                try {
                    // Handle ISO "2026-06-01T16:14:00"
                    if (dateTimeStr.includes('T')) {
                        return dateTimeStr.split('T')[1].substring(0, 5); // "16:14"
                    }
                    // Handle "06-01-2026 16:14"
                    return dateTimeStr.split(' ')[1] || '—';
                } catch {
                    return '—';
                }
            },

            getMeetingAllLabel(msg) {
                return msg.payload?.meeting_data?.showAllCoOwners ?
                    "Select All Company Users" : "Select Participants";
            },
            getMeetingParticipantsList(msg) {
                const names = msg?.payload?.meeting_data?.coOwnerNames || [];
                return Array.isArray(names) ? names : (typeof names === 'string' ? names.split(',').map(n => n.trim()) : []);
            },

            formatDateMDY(dateTimeStr) {
                if (!dateTimeStr) return '—';
                return dateTimeStr.split(' ')[0] || dateTimeStr; // "05-25-2026"
            },
            /*extractTimeFromDateTime(dateTimeStr) {
                if (!dateTimeStr) return '—';
                const parts = dateTimeStr.split(' ');
                return parts[1] || '—'; // "12:00"
            },*/
            meetingConflictReschedule(msg) {
                const label = '📅 Choose another time';
                this.messages.push({ from: 'user', text: '📅 Choose another time' });
                this.scrollToBottom();
                this._saveChatMessage('user', label, 'text', null);
                this._sendRaw('__MTG_RESCHEDULE__');
            },

            meetingConflictProceed(msg) {
                const label = 'Proceed anyway';

                this.messages.push({ from: 'user', text: 'Proceed anyway' });
                this.scrollToBottom();
                this._saveChatMessage('user', label, 'text', null);
                this._sendRaw('__MTG_KEEP_TIME__');
            },
            getTicketFormAssets(msg) { return msg?.payload?.ticket_data?.assets || []; },
            getTicketFormWorktypes(msg) { return msg?.payload?.ticket_data?.worktypes || []; },
            getTicketFormPriorities(msg) {
                const ORDER = ['critical', 'high', 'medium', 'low'];
                return [...(msg?.payload?.ticket_data?.priorities || [])].sort((a, b) => {
                    const ai = ORDER.indexOf((a.text || '').toLowerCase());
                    const bi = ORDER.indexOf((b.text || '').toLowerCase());
                    return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
                });
            },

            async submitTicketFormCard(msg) {
                const f = this.ticketForm;

                if (!f.subject || !f.workTypeId || !f.priorityId || !f.assetId) {
                    this.ticketFormError = 'Please fill in all required fields (Subject, Work Type, Priority, Asset).';
                    return;
                }

                this.ticketFormError = '';
                this.ticketFormSubmitting = true;

                // Resolve names
                const assets = this.getTicketFormAssets(msg);
                const worktypes = this.getTicketFormWorktypes(msg);
                const priorities = this.getTicketFormPriorities(msg);

                const assetName = assets.find(a => a.Id === f.assetId)?.Name || '';
                const workTypeName = worktypes.find(w => w.value === f.workTypeId)?.text || '';
                this._lastSelectedWorkType = { id: f.workTypeId, name: workTypeName }; // ← ADD THIS
                const priorityName = priorities.find(p => p.value === f.priorityId)?.text || '';

                const payload = {
                    subject: f.subject,
                    workTypeId: f.workTypeId,
                    workTypeName,
                    priorityId: f.priorityId,
                    priorityName,
                    assetId: f.assetId,
                    assetName,
                    description: f.description,
                };

                try {
                    await this._sendRaw('__TICKET_SUBMIT__' + JSON.stringify(payload));
                } finally {
                    this.ticketFormSubmitting = false;
                }
            },






            formatDateMDY(dateStr) {
                if (!dateStr) return '—';
                try {
                    const d = new Date(dateStr);
                    const month = String(d.getMonth() + 1).padStart(2, '0');
                    const day = String(d.getDate()).padStart(2, '0');
                    const year = d.getFullYear();
                    return `${month}-${day}-${year}`;
                } catch { return dateStr; }
            },
            async checkAssetPurchaseStatus() {
                try {
                    const userInfoRaw = localStorage.getItem("userinfo");
                    const userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : null;
                    const userData = userInfo?.data || {};

                    const userType = userData.userType;
                    debugger
                    // ✅ Only check isAssetAssigned for usertype21 (Asset Manager)
                    // ✅ Hide bot for usertype02 and usertype05 regardless
                    if (userType === 'usertype21') {

                        this.hasPurchasedAsset = userData.isAssetAssigned === true;
                        console.log('[chatbot] User is', userType, '- bot hidden');
                        return;
                    }
                    if (userType === 'usertype05') {
                        try {

                            const response = await FrondEndService.GetOwnedPropertList(this.searchModel);
                            const data = response?.data?.data;

                            if (this.$filters.IsNull(data, false) != null && data.length > 0) {
                                this.hasPurchasedAsset = true;  // ✅ Has assets - show bot
                                console.log('[chatbot] usertype05 - assets found, bot visible');
                            } else {
                                this.hasPurchasedAsset = false; // ❌ No assets - hide bot
                                console.log('[chatbot] usertype05 - no assets assigned, bot hidden');
                            }
                        } catch (apiError) {
                            console.error('[chatbot] usertype05 API error:', apiError);
                            this.hasPurchasedAsset = false;
                        }
                        return;
                    }

                    // ✅ Default - show bot for all other usertypes
                    this.hasPurchasedAsset = true;
                    console.log('[chatbot] userType:', userType, '- bot visible');

                } catch (error) {
                    console.error('Error checking asset assignment:', error);
                    this.hasPurchasedAsset = false;
                }
            },

            submitMeetingDescription() {
                const text = this._meetingDescriptionInput.trim();
                const wordCount = text.split(/\s+/).filter(w => w.length > 0).length;

                if (wordCount < 5) {
                    this._meetingDescriptionError = `Minimum 5 words required. You have ${wordCount}.`;
                    return;
                }
                if (wordCount > 250) {
                    this._meetingDescriptionError = `Maximum 250 words allowed. You have ${wordCount}.`;
                    return;
                }

                this._meetingDescriptionError = "";
                this._meetingDescriptionInput = "";
                this._sendTicketChoice(text, text);
            },
            isMeetingDescriptionPrompt(text, payload) {
                if (payload?.meeting_data?.step === 'description') return true;
                if (!text) return false;
                return /meeting.*description|meeting purpose|describe.*meeting|min\s*(?:5\b|50).*max\s*250/i.test(text);
            },
            answerTicketAttachment(answer) {
                const label = answer === 'yes' ? '✅ Yes, Upload Attachment' : '⏭ No, Skip';
                this._sendTicketChoice(label, answer);
            },
            isTicketAttachmentPrompt(text) {
                if (!text) return false;
                return /upload an attachment|upload.*attachment.*yes.*no|attachment.*yes.*no/i.test(text);
            },
            answerDocumentUpload(answer) {
                const label = answer === 'yes' ? '✅ Yes, Upload Documents' : '⏭ No, Skip';
                this._sendTicketChoice(label, answer);
            },
            isDocumentUploadPrompt(text) {
                if (!text) return false;
                return /upload any documents|reply.*yes.*no|upload.*documents/i.test(text);
            },
            isVotingJustificationPrompt(text) {
                if (!text) return false;
                return /voting justification/i.test(text);
            },

            submitExpenseDescription(msg) {
                const text = this._expenseDescriptionInput.trim();
                const wordCount = text.split(/\s+/).filter(w => w.length > 0).length;

                if (wordCount < 5) {
                    this._expenseDescriptionError = `Minimum 5 words required. You have ${wordCount}.`;
                    return;
                }
                if (wordCount > 250) {
                    this._expenseDescriptionError = `Maximum 250 words allowed. You have ${wordCount}.`;
                    return;
                }

                this._expenseDescriptionError = "";
                this._expenseDescriptionInput = "";
                this._sendTicketChoice(text, text);
            },
            isExpenseDescriptionPrompt(text) {
                if (!text) return false;
                return /expense description|voting justification|expense about.*min\s*50|min 50.*max 250/i.test(text);
            },
            skipExpenseVendor() {
                this._sendTicketChoice("⏭ Skip Vendor", "skip");
            },
            cleanTicketDetailResponse(text) {
                if (!text) return '—';
                // Remove the ticket number from the plain text since it's already in the header
                return text.replace(/\b\d{14}-\d+\b\.?/g, '').replace(/\s+/g, ' ').trim();
            },
            sendTicketLookupChoice(number, label) {
                // Capitalize first letter of label
                const cleanLabel = label.charAt(0).toUpperCase() + label.slice(1);
                this._sendTicketChoice(`${number}. ${cleanLabel}`, number);
            },



            onExpenseAttachmentFileChange(event) {
                const files = Array.from(event.target.files || []);
                if (!files.length) return;

                // Same extensions as expense page
                const allowedExts = ['.pdf', '.xlsx', '.csv', '.docx', '.doc', '.pptx', '.ppt', '.txt', '.xls'];
                const maxSize = 20 * 1024 * 1024;

                for (const f of files) {
                    const ext = '.' + f.name.split('.').pop().toLowerCase();
                    if (!allowedExts.includes(ext)) {
                        this._expenseAttachmentError = `File "${f.name}" type not allowed.`;
                        return;
                    }
                    if (f.size > maxSize) {
                        this._expenseAttachmentError = `File "${f.name}" exceeds 20MB limit.`;
                        return;
                    }
                }

                this._expenseAttachmentError = null;
                this._expenseAttachmentFiles = files;
            },

            async submitExpenseAttachment() {
                if (!this._expenseAttachmentFiles.length) {
                    this._expenseAttachmentError = "Please select at least one file.";
                    return;
                }

                this._expenseAttachmentUploading = true;
                this._expenseAttachmentError = null;

                const companyId = this.companyId || localStorage.getItem('companyId');
                const userId = this.userId || localStorage.getItem('userId');

                try {
                    // ✅ Upload all files in parallel
                    const uploadPromises = this._expenseAttachmentFiles.map(async (f) => {
                        const fd = new FormData();
                        fd.append('file', f);
                        const r = await this._manageAssetsService.SaveDocument(companyId, userId, fd);
                        const sc = r?.data?.statusCode ?? r?.data?.StatusCode;
                        if (sc === 200 && r?.data?.responseMessage) {
                            return String(r.data.responseMessage);
                        }
                        throw new Error(r?.data?.responseMessage || 'Upload failed');
                    });

                    const uploadedPaths = await Promise.all(uploadPromises);
                    const filePaths = uploadedPaths.join(',');

                    const displayNames = this._expenseAttachmentFiles.map(f => f.name).join(', ');
                    this.messages.push({ from: "user", text: `${displayNames}` });
                    this.scrollToBottom();

                    await this._sendRaw(`__EXPENSE_ATTACHMENT__${filePaths}`);

                    this._expenseAttachmentFiles = [];
                    this._expenseAttachmentError = null;

                } catch (err) {
                    console.error('[expense attachment] error:', err?.response?.data || err);
                    this._expenseAttachmentError = `Upload failed (${err?.response?.status || err?.message || 'error'}). Please try again.`;
                } finally {
                    this._expenseAttachmentUploading = false;
                }
            },
            applyOnboardingPendingState(hasPending) {
                this._onboardingHasPendingSteps = hasPending === true;
                this.isOnboardingStatusLoaded = true;
                this.showChecklistIcon = this.hasPendingOnboardingSteps;
                if (!this.hasPendingOnboardingSteps && this.isChecklistOpen) {
                    this.isChecklistOpen = false;
                    if (window.parent?.document?.body) {
                        window.parent.document.body.classList.remove('onboarding-open');
                    }
                }
            },
            refreshChecklistIconVisibility() {
                const isChecklistCompleted = String(localStorage.getItem("isCheckListOnboardingstep") || "").trim().toLowerCase() === "true";
                const stored = this.readChecklistStateFromStorage();
                const allDone = isChecklistCompleted || stored?.allDone === true;

                if (allDone) {
                    this.applyOnboardingPendingState(false);
                    return;
                }

                if (!this.isOnboardingStatusLoaded) {
                    this.showChecklistIcon = false;
                    return;
                }

                if (stored && Number(stored.pendingCount) > 0) {
                    this.applyOnboardingPendingState(true);
                    return;
                }

                this.showChecklistIcon = this.hasPendingOnboardingSteps;
                if (!this.hasPendingOnboardingSteps && this.isChecklistOpen) {
                    this.isChecklistOpen = false;
                    if (window.parent?.document?.body) {
                        window.parent.document.body.classList.remove('onboarding-open');
                    }
                }
            },
            onChecklistProgressUpdated(event) {
                const companyId = localStorage.getItem('companyId');
                const updatedCompanyId = event?.detail?.companyId ?? event?.companyId;
                if (updatedCompanyId && companyId && String(updatedCompanyId) !== String(companyId)) {
                    return;
                }
                this.refreshChecklistIconVisibility();
            },
            handleChecklistStorageChange(event) {
                if (!event?.key) {
                    return;
                }
                const companyId = localStorage.getItem('companyId') || '00000000-0000-0000-0000-000000000000';
                const stateKey = `onboarding_checklist_state_${companyId}`;
                if (event.key === "isCheckListOnboardingstep" || event.key === stateKey) {
                    this.refreshChecklistIconVisibility();
                }
            },
            preloadChecklistFrame() {
                if (!this.showChecklistIcon || this.checklistFrameMounted) {
                    return;
                }
                this.checklistFrameMounted = true;
                this.checklistFrameLoading = true;
                this.checklistFrameLoaded = false;
            },
            onChecklistFrameLoad() {
                this.checklistFrameLoaded = true;
                this.checklistFrameLoading = false;
            },
            canShowOnboardingChecklist() {
                return this.isOnboardingStatusLoaded
                    && this.hasPendingOnboardingSteps
                    && this.userType === 'usertype02';
            },
            isOnboardingStepPending(step) {
                if (!step) {
                    return false;
                }
                if (step.isCompleted === true) {
                    return false;
                }
                const status = String(step.stepStatus ?? '').trim().toLowerCase();
                return !['completed', 'complete', 'done', '1', 'true', 'skipped', 'skiped'].includes(status);
            },
            hasPendingOnboardingStep(steps) {
                return Array.isArray(steps) && steps.some((step) => this.isOnboardingStepPending(step));
            },
            isChecklistMarkedCompleted() {
                return String(localStorage.getItem('isCheckListOnboardingstep') || '').trim().toLowerCase() === 'true';
            },
            readChecklistStateFromStorage() {
                try {
                    const companyId = this.companyId || localStorage.getItem('companyId') || '00000000-0000-0000-0000-000000000000';
                    const raw = localStorage.getItem(`onboarding_checklist_state_${companyId}`);
                    return raw ? JSON.parse(raw) : null;
                } catch (e) {
                    return null;
                }
            },
            async resolveHasPendingOnboardingStep() {
                if (this.isChecklistMarkedCompleted()) {
                    return false;
                }
                const stored = this.readChecklistStateFromStorage();
                if (stored?.allDone === true) {
                    return false;
                }

                const companyId = this.companyId || localStorage.getItem('companyId');
                if (!companyId) {
                    return false;
                }

                try {
                    const response = await onboardingService.getOnboardingSteps(companyId, 'checkList');
                    const payload = response?.data;
                    const items = Array.isArray(payload)
                        ? payload
                        : (Array.isArray(payload?.result) ? payload.result : []);
                    return this.hasPendingOnboardingStep(items);
                } catch (e) {
                    return Number(stored?.pendingCount) > 0;
                }
            },
            async openChecklistIfIncomplete() {
                if (this._checklistAutoOpenInFlight) {
                    return;
                }
                this._checklistAutoOpenInFlight = true;
                try {
                    this.refreshChecklistIconVisibility();
                    if (this.isOnboardingStatusLoaded && !this.hasPendingOnboardingSteps) {
                        this.isChecklistOpen = false;
                        return;
                    }
                    if (this.userType !== 'usertype02') {
                        this.applyOnboardingPendingState(false);
                        return;
                    }
                    if (this.isOnboardingStatusLoaded && !shouldAutoOpenChecklist()) {
                        return;
                    }

                    const hasPending = await this.resolveHasPendingOnboardingStep();
                    this.applyOnboardingPendingState(hasPending);
                    if (!hasPending || !this.canShowOnboardingChecklist()) {
                        this.isChecklistOpen = false;
                        return;
                    }
                    if (!shouldAutoOpenChecklist()) {
                        return;
                    }

                    this.preloadChecklistFrame();
                    this.isChecklistOpen = true;
                } finally {
                    this._checklistAutoOpenInFlight = false;
                }
            },
            toggleChecklist() {
                if (!this.canShowOnboardingChecklist()) {
                    return;
                }
                const willOpen = !this.isChecklistOpen;
                if (willOpen) {
                    this.preloadChecklistFrame();
                    this.isChecklistOpen = true;
                    return;
                }
                recordChecklistCloseTime();
                this.isChecklistOpen = false;
                if (window.parent?.document?.body) {
                    window.parent.document.body.classList.remove('onboarding-open');
                }
            },
            onAttachmentFileChange(event) {
                const files = Array.from(event.target.files || []);
                if (!files.length) return;

                const allowedImageExts = ['.png', '.gif', '.jpeg', '.jpg'];
                const allowedVideoExts = ['.mp4', '.mov', '.avi', '.webm', '.mkv'];
                const allowedImageTypes = ['image/png', 'image/gif', 'image/jpeg'];
                const allowedVideoTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/webm', 'video/x-matroska'];

                const maxImageSize = 5 * 1024 * 1024;   // 5MB
                const maxVideoSize = 50 * 1024 * 1024;   // 50MB

                for (const f of files) {
                    const ext = '.' + f.name.split('.').pop().toLowerCase();
                    const isImage = allowedImageExts.includes(ext);
                    const isVideo = allowedVideoExts.includes(ext);

                    if (!isImage && !isVideo) {
                        this._attachmentError = `File "${f.name}" is not allowed. Only images (PNG, GIF, JPEG, JPG) and videos (MP4, MOV, AVI, WEBM, MKV) are accepted.`;
                        event.target.value = '';
                        this._attachmentFiles = [];
                        return;
                    }

                    if (isImage && f.size > maxImageSize) {
                        this._attachmentError = `Image "${f.name}" exceeds the 5MB limit.`;
                        event.target.value = '';
                        this._attachmentFiles = [];
                        return;
                    }

                    if (isVideo && f.size > maxVideoSize) {
                        this._attachmentError = `Video "${f.name}" exceeds the 50MB limit.`;
                        event.target.value = '';
                        this._attachmentFiles = [];
                        return;
                    }
                }

                this._attachmentError = null;
                this._attachmentFiles = files;

                // Previews — images get thumbnail, videos get a video preview
                this._attachmentPreviews = [];
                for (const f of files) {
                    const ext = '.' + f.name.split('.').pop().toLowerCase();
                    const isImage = allowedImageExts.includes(ext);

                    if (isImage) {
                        // existing canvas thumbnail logic
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            const img = new Image();
                            img.onload = () => {
                                const canvas = document.createElement('canvas');
                                canvas.width = 400;
                                canvas.height = 400;
                                const ctx = canvas.getContext('2d');
                                const size = Math.min(img.width, img.height);
                                const sx = (img.width - size) / 2;
                                const sy = (img.height - size) / 2;
                                ctx.drawImage(img, sx, sy, size, size, 0, 0, 400, 400);
                                this._attachmentPreviews.push({
                                    name: f.name,
                                    type: 'image',
                                    thumb: canvas.toDataURL('image/jpeg', 0.85)
                                });
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(f);
                    } else {
                        // Video — use object URL for inline preview
                        this._attachmentPreviews.push({
                            name: f.name,
                            type: 'video',
                            thumb: URL.createObjectURL(f)
                        });
                    }
                }
            },
            async submitAttachmentUpload() {
                if (!this._attachmentFiles.length) {
                    this._attachmentError = "Please select at least one file.";
                    return;
                }

                this._attachmentUploading = true;
                this._attachmentError = null;

                try {
                    const formData = new FormData();
                    for (const f of this._attachmentFiles) {
                        formData.append("file", f);
                    }

                    const response = await this._manageAssetsService.SaveTicketFile(formData);

                    if (response?.data?.statusCode === 200) {
                        const uploadedFileName = response.data.responseMessage;

                        // ✅ Store so confirmAndSubmitTicketPreview can read it
                        this._attachmentUploadedNames = [uploadedFileName];

                        const displayNames = this._attachmentFiles.map(f => f.name).join(', ');
                        this.messages.push({ from: "user", text: `📎 ${displayNames}` });
                        this.scrollToBottom();

                        // ✅ Clear file selection — attachment is now stored in _attachmentUploadedNames
                        this._attachmentFiles = [];
                        this._attachmentPreviews = [];

                    } else {
                        this._attachmentError = response?.data?.responseMessage || "Upload failed. Please try again.";
                    }
                } catch (err) {
                    console.error("Attachment upload error:", err);
                    this._attachmentError = "Upload failed. Please check your connection.";
                } finally {
                    this._attachmentUploading = false;
                }
            },



            parseDueExpenses(responseText) {
                if (!responseText) return [];
                // Remove the "Due Expenses:" header line
                const body = responseText.replace(/^Due Expenses:\s*/i, '');
                // Split on "- Description:" to get each block
                const blocks = body.split(/\n-\s+Description:/).filter(s => s.trim());

                return blocks.map(block => {
                    const get = (key) => {
                        const match = block.match(new RegExp(key + ':\\s*([^\\n]+)', 'i'));
                        return match ? match[1].trim() : '—';
                    };
                    const normalizeCurrency = (val) => {
                        if (!val || val === '—') return '—';
                        // Remove ₹, $, €, £, ¥ and any other currency symbols
                        const cleaned = val.replace(/[₹$€£¥₩฿₫₪₺₴₦]/g, '').trim();
                        return cleaned ? `$${cleaned}` : '—';
                    };

                    // First line is the description value (after "- Description:")
                    const firstLine = block.split('\n')[0].trim();
                    return {
                        description: firstLine || '—',
                        asset: get('Asset'),
                        totalAmount: normalizeCurrency(get('Total Amount')),
                        myShare: normalizeCurrency(get('My Share')),
                        dueDate: get('Due Date'),
                        status: get('Status'),
                        expenseId: get('Expense ID'),
                        shareId: get('Expense Share ID'),
                        assetId: get('Asset ID'),
                        receipt: get('Receipt'),
                    };
                });
            },
            toggleMeetingParticipantsExpand(msgIndex) {
                const current = this._expandedMeetingParticipants[msgIndex] || false;
                this._expandedMeetingParticipants = {
                    ...this._expandedMeetingParticipants,
                    [msgIndex]: !current
                };
            },

            getMeetingParticipantsList(msg) {
                const meetingData = msg?.payload?.meeting_data || {};

                // Try different possible field names from backend
                let names = meetingData.coOwnerNames ||
                    meetingData.participantNames ||
                    meetingData.coOwners ||
                    [];

                if (typeof names === 'string') {
                    names = names.split(',').map(n => n.trim()).filter(Boolean);
                }

                return Array.isArray(names) ? names : [];
            },
            formatDueDate(dateStr) {
                if (!dateStr || dateStr === '—') return '—';
                try {
                    const d = new Date(dateStr);
                    const month = String(d.getMonth() + 1).padStart(2, '0');
                    const day = String(d.getDate()).padStart(2, '0');
                    const year = d.getFullYear();
                    return `${month}-${day}-${year}`;
                } catch { return dateStr; }
            },

            submitMeetingAssetPick(id, name) {
                // Save selected asset id for co-owner API
                this._meetingSelectedAssetId = id;
                this._meetingSelectedAssetName = name;
                const cmd = `__BK_MEETING_ASSET__${encodeURIComponent(id)}|${encodeURIComponent(name)}`;
                this._sendTicketChoice(name, cmd);
            },
            // Add these methods
            getExpenseFlowIcon(text) {
                if (!text) return "💰";
                const lower = text.toLowerCase();
                if (lower.includes("title") || lower.includes("what is the title")) return "📝";
                if (lower.includes("asset") || lower.includes("property")) return "🏠";
                if (lower.includes("category")) return "🏷️";
                if (lower.includes("amount") || lower.includes("cost")) return "💲";
                if (lower.includes("vendor")) return "🏪";
                if (lower.includes("description")) return "📋";
                return "💰";
            },

            isExpenseAssetPrompt(text) {
                if (!text) return false;
                return /asset|property/i.test(text);
            },

            isExpenseCategoryPrompt(text) {
                if (!text) return false;
                return /category/i.test(text);
            },

            isExpenseVendorPrompt(text) {
                if (!text) return false;
                return /vendor/i.test(text);
            },


            //// ─── Auto-assign ticket after creation ───────────────────────────────────────
            //async assignTicketAfterCreation(ticketId) {
            //    try {
            //        const userId = this.userId || localStorage.getItem('userId') || '';
            //        const companyId = this.companyId || localStorage.getItem('companyId') || '';
            //        const userInfo = JSON.parse(localStorage.getItem('userinfo') || '{}');
            //        const firstName = userInfo?.data?.firstName || '';
            //        const lastName = userInfo?.data?.lastName || '';

            //        // Step 1 — Get vendor list for this ticket
            //        const vendorRes = await FrondEndService.assignvendorList(
            //            ticketId,
            //            '00test',
            //            'CreatedOn', 'desc',
            //            0, 1,
            //            userId,
            //            companyId,
            //            'Assign'
            //        );

            //        const vendorData = vendorRes?.data;
            //        if (!vendorData || vendorData.length === 0) {
            //            console.warn('No vendors available to auto-assign for ticket:', ticketId);
            //            return;
            //        }

            //        // Step 2 — Assign first available vendor
            //        const selectedVendor = vendorData[0];
            //        const vendorList = [{
            //            ticketId: ticketId,
            //            vendorId: selectedVendor.Id,
            //            vendoraspnetuserId: selectedVendor.vendoraspnetuserId,
            //            vendorPhoneNumber: selectedVendor.PhoneNumber,
            //        }];

            //        const jsonModel = {
            //            Json: JSON.stringify(vendorList),
            //            userId: userId,
            //            companyId: companyId,
            //            firstName: firstName,
            //            lastName: lastName,
            //            ticketName: selectedVendor.Ticket_Number,
            //            vendorPhoneNumber: selectedVendor.PhoneNumber,
            //        };

            //        const assignRes = await FrondEndService.assignvendor(jsonModel);
            //        console.log('Ticket auto-assigned successfully:', assignRes?.data);

            //    } catch (error) {
            //        // Non-blocking — don't show error to user, just log it
            //        console.error('Auto-assign failed:', error?.response || error);
            //    }
            //},
            isDescriptionPrompt(text) {
                if (!text) return false;
                return /descri(be|ption)|detail \(max\s*500|issue in detail|min 50|max 250/i.test(text);
            },

            cancelTicket() {
                this.messages.push({ from: "user", text: "Cancel ticket" });
                this.scrollToBottom();
                this._sendRaw("cancel");
            },
            getPriorityIcon(priority) {
                const p = (priority || '').toLowerCase();
                if (p === 'critical') return '🔴';
                if (p === 'high') return '🟠';
                if (p === 'medium') return '🟡';
                return '🟢';
            },





            getTicketQuestionTitle(text) {
                if (!text) return "Please choose one:";
                return text.split(/\r?\n/)[0].trim();
            },
            isWorkTypePrompt(text) {
                if (!text) return false;
                if (/\bpriority\b/i.test(text)) return false;
                return (
                    /what type of work/i.test(text) ||
                    /type of work is needed/i.test(text) ||
                    /work\s+type/i.test(text) ||
                    (
                        /work/i.test(text) &&
                        /dropdown/i.test(text)
                    )
                );
            },

            isPriorityPrompt(text) {
                if (!text) return false;
                return (
                    !/what\s+type\s+of\s+work/i.test(text) &&
                    (
                        /what\s+is\s+the\s+priority/i.test(text) ||
                        /tell me the priority/i.test(text) ||
                        /priority of your ticket/i.test(text) ||
                        (
                            /\bpriority\b/i.test(text) &&
                            /dropdown/i.test(text)
                        ) ||
                        (
                            /\bpriority\b/i.test(text) &&
                            (
                                /please\s+choose\s+one/i.test(text) ||
                                /tap\s+an\s+option/i.test(text) ||
                                /didn'?t\s+recognize[^.\n]*priority/i.test(text)
                            )
                        )
                    )
                );
            },

            isAssetPrompt(text) {
                if (!text) return false;
                // Asset prompt: no numbered options AND matches asset/property keywords
                const hasNumbered = /^\d+\.\s+.+$/m.test(text);
                return !hasNumbered && /asset|property/i.test(text);
            },



            // Returns icon based on question text (mirrors vanilla JS appendTicketMessage)
            getTicketFlowIcon(text) {
                if (!text) return "💬";
                if (/subject/i.test(text)) return "📝";
                if (this.isWorkTypePrompt(text)) return "🔧";
                if (/priority/i.test(text) || this.isPriorityPrompt(text)) return "⚡";
                if (/asset|property/i.test(text)) return "🏠";
                if (/descri/i.test(text)) return "📋";
                if (/sorry|didn't recognize|did not recognize/i.test(text)) return "⚠️";
                return "💬";
            },

            // Extracts "1. Label\n2. Label" style options from response text
            getNumberedOptions(text) {
                if (!text) return [];
                const options = [];
                const regex = /^\d+\.\s+(.+)$/gm;
                let m;
                while ((m = regex.exec(text)) !== null) {
                    options.push(m[1].trim());
                }
                return options;
            },

            // Returns filtered options for a message (used in v-for with search)
            getFilteredOptions(msg) {
                if (!msg._options) return [];
                const q = (msg._searchQuery || "").trim().toLowerCase();
                if (!q) return msg._options;
                return msg._options.filter(item =>
                    item.label.toLowerCase().includes(q)
                );
            },


            isExpenseThresholdPrompt(text) {
                if (!text) return false;
                return /threshold/i.test(text);
            },



            submitTicketWorkTypePick(label, value) {
                this._lastSelectedWorkType = { id: value, name: label }; // ← ADD THIS
                const cmd = `__BK_WTNATIVE__${encodeURIComponent(label)}|${encodeURIComponent(value)}`;
                this._sendTicketChoice(label, cmd);
            },
            submitTicketPriorityPick(label, value) {
                const cmd = `__BK_PNATIVE__${encodeURIComponent(label)}|${encodeURIComponent(value)}`;
                this._sendTicketChoice(label, cmd);
            },


            getFilteredOptions(msg) {
                if (!msg._options) return [];
                const q = (msg._searchQuery || "").trim().toLowerCase();
                if (!q) return msg._options;
                return msg._options.filter(item =>
                    item.label.toLowerCase().includes(q)
                );
            },
            submitExpenseThresholdPick(label, value) {
                //const cmd = `__BK_EXP_THRESHOLD__${encodeURIComponent(label)}|${encodeURIComponent(value)}`;
                const cmd = `${encodeURIComponent(value)}`;
                this._sendTicketChoice(label, cmd);
            },
            // Sends a display label to chat + a hidden API command (mirrors sendTicketChoice)
            _sendTicketChoice(displayLabel, apiCommand) {
                this.messages.push({ from: "user", text: displayLabel });
                this.scrollToBottom();
                // ✅ ADD THIS — save the button click as a user message
                this._saveChatMessage('user', displayLabel, 'text', null);
                // Store command, then fire sendMessage with it directly
                this._pendingApiCommand = apiCommand;
                this._sendRaw(apiCommand);
            },

            // Low-level: posts a raw query string to the API without touching userInput
            async _sendRaw(query) {
                this.isTyping = true;
                this.scrollToBottom();

                const tzMap = {
                    'India Standard Time': 'Asia/Kolkata',
                    'Eastern Standard Time': 'America/New_York',
                    'US Eastern Standard Time': 'America/New_York',
                    'Central Standard Time': 'America/Chicago',
                    'US Central Standard Time': 'America/Chicago',
                    'Mountain Standard Time': 'America/Denver',
                    'Pacific Standard Time': 'America/Los_Angeles',
                    'UTC': 'UTC',
                    'Greenwich Standard Time': 'Europe/London',
                    'W. Europe Standard Time': 'Europe/Berlin',
                    'Central Europe Standard Time': 'Europe/Budapest',
                    'E. Europe Standard Time': 'Europe/Nicosia',
                    'Central European Time': 'Europe/Paris',
                    'Romance Standard Time': 'Europe/Paris',
                    'China Standard Time': 'Asia/Shanghai',
                    'Japan Standard Time': 'Asia/Tokyo',
                    'Arabian Standard Time': 'Asia/Dubai',
                    'Arab Standard Time': 'Asia/Riyadh',
                    'AUS Eastern Standard Time': 'Australia/Sydney',
                    'Singapore Standard Time': 'Asia/Singapore',
                    'Korea Standard Time': 'Asia/Seoul',
                    'SE Asia Standard Time': 'Asia/Bangkok',
                    'Bangladesh Standard Time': 'Asia/Dhaka',
                    'Pakistan Standard Time': 'Asia/Karachi',
                    'Sri Lanka Standard Time': 'Asia/Colombo',
                    'Nepal Standard Time': 'Asia/Kathmandu',
                    'Myanmar Standard Time': 'Asia/Rangoon',
                    'N. Central Asia Standard Time': 'Asia/Novosibirsk',
                    'Russian Standard Time': 'Europe/Moscow',
                    'Egypt Standard Time': 'Africa/Cairo',
                    'South Africa Standard Time': 'Africa/Johannesburg',
                    'Brazil Standard Time': 'America/Sao_Paulo',
                    'Argentina Standard Time': 'America/Argentina/Buenos_Aires',
                    'Canada Central Standard Time': 'America/Regina',
                    'Atlantic Standard Time': 'America/Halifax',
                };
                const rawTz = localStorage.getItem("TimeZone") || "UTC";
                const userType = localStorage.getItem("userType");
                const ianaTimezone = tzMap[rawTz] || rawTz;
                const isonboarding = localStorage.getItem("IsOnboardingCompleted") == "true" ? true : false;

                // LocalStorage fallback values for chatbot request parameters.
                let storedUserInfo = {};
                try {
                    storedUserInfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
                } catch (e) {
                    storedUserInfo = {};
                }

                const storedUserData = storedUserInfo?.data || {};

                const body = {
                    user_query: query,
                    lang: "en",
                    session_id: this.sessionId,
                    username:
                        this.username ||
                        storedUserData.userName ||
                        localStorage.getItem("username") ||
                        "",
                    token:
                        this.token ||
                        localStorage.getItem("access_token") ||
                        localStorage.getItem("token") ||
                        "",
                    companyId:
                        this.companyId ||
                        localStorage.getItem("companyId") ||
                        storedUserData.companyId ||
                        "",
                    userId:
                        this.userId ||
                        localStorage.getItem("userId") ||
                        storedUserData.id ||
                        "",
                    onBehalfEmail:
                        this.userEmail ||
                        localStorage.getItem("userEmail") ||
                        storedUserData.email ||
                        "",
                    onBehalfPhone:
                        this.userPhone ||
                        localStorage.getItem("userPhone") ||
                        storedUserData.phoneNumber ||
                        "",
                    userTimezone: ianaTimezone,
                    userType: userType,
                    assetType: 'Household',
                    isOnboardingCompleted: isonboarding
                };

                try {
                    const res = await axios.post(this.API_URL, body);
                    this.isTyping = false;
                    await this._handleBotResponse(res.data);
                } catch (err) {
                    this.isTyping = false;
                    this._pushError(err);
                } finally {
                    this.isTyping = false;
                    this.scrollToBottom();

                }
            },

            // ─── Ticket menu buttons ──────────────────────────────────────────────────

            sendTicketGuide() {
                const query = this._lastUserQuery || "how to create a ticket";
                this.messages.push({ from: "user", text: "📋 Ticket Guide" });
                this.scrollToBottom();
                this._sendRaw(`__ticket_guide__:${query}`);
            },

            startTicketCreation() {
                this.messages.push({ from: "user", text: "🎫 Create Ticket" });
                this.scrollToBottom();
                this._sendRaw("__start_ticket__");
            },


            // ─── Core send ────────────────────────────────────────────────────────────

            async sendMessage(skipUserBubble = false) {
                if (!this.userInput.trim()) return;

                const question = this.userInput.trim();
                this.userInput = "";

                // Track last real user query for ticket guide context
                if (!question.startsWith("__")) {
                    this._lastUserQuery = question;
                }

                this.messages.push({ from: "user", text: question });
                this.scrollToBottom();
                await this._saveChatMessage('user', question, 'text', null);

                // Vendor Active / Inactive listing:
                // If a vendor list is already loaded in this chat, filter that list
                // immediately when the user explicitly asks for active/inactive vendors.
                // If no vendor list exists yet, keep the original backend request unchanged.
                const normalizedQuestion = String(question || '').toLowerCase();

                const asksVendorList =
                    /\bvendor(?:s)?\b/.test(normalizedQuestion) ||
                    /\blist\b/.test(normalizedQuestion) ||
                    /\bshow\b/.test(normalizedQuestion) ||
                    /\bdisplay\b/.test(normalizedQuestion) ||
                    /\bget\b/.test(normalizedQuestion);

                const wantsInactiveVendorList =
                    asksVendorList &&
                    /\binactive\b|\bin-active\b/.test(normalizedQuestion);

                const wantsActiveVendorList =
                    asksVendorList &&
                    !wantsInactiveVendorList &&
                    /\bactive\b/.test(normalizedQuestion);

                if (wantsActiveVendorList || wantsInactiveVendorList) {
                    const previousVendorList = [...this.messages]
                        .reverse()
                        .find(message =>
                            message?.from === 'bot' &&
                            message?.type === 'vendor_list' &&
                            Array.isArray(message?.payload?.vendor_data?.vendors)
                        );

                    if (previousVendorList) {
                        const vendorData =
                            previousVendorList.payload?.vendor_data || {};

                        const allVendors =
                            Array.isArray(vendorData.vendors)
                                ? vendorData.vendors
                                : [];

                        const filteredVendors = allVendors.filter(vendor => {
                            const value =
                                vendor?.isActive ??
                                vendor?.IsActive ??
                                vendor?.active ??
                                vendor?.Active;

                            const isActive =
                                value === true ||
                                value === 1 ||
                                String(value || '').toLowerCase() === 'true' ||
                                String(value || '').toLowerCase() === 'active';

                            return wantsActiveVendorList
                                ? isActive
                                : !isActive;
                        });

                        const filteredMessage = {
                            from: 'bot',
                            type: 'vendor_list',
                            text: '',
                            payload: {
                                Intent: 'vendor_list',
                                response: '',
                                vendor_data: {
                                    ...vendorData,
                                    heading: wantsActiveVendorList
                                        ? 'Active Vendors'
                                        : 'Inactive Vendors',
                                    vendors: filteredVendors
                                }
                            }
                        };

                        this.messages.push(filteredMessage);
                        this.scrollToBottom();

                        await this._saveChatMessage(
                            'bot',
                            '',
                            'vendor_list',
                            filteredMessage.payload
                        );

                        this.$nextTick(() => {
                            this.addImageClickListeners();
                            this.scrollToBottom();
                        });

                        return;
                    }
                }

                await this._sendRaw(question);
            },
            getTicketLookupOptions(text) {
                if (!text) return [];
                const options = [];

                // Format 1: "1. Status" or "1) Status"
                const numberedRegex = /^\s*(\d+)[.)]\s+(.+)$/gm;
                let m;
                while ((m = numberedRegex.exec(text)) !== null) {
                    options.push({ number: m[1], label: m[2].trim() });
                }
                if (options.length) return options;

                // Format 2: **1** for status
                const boldRegex = /\*\*(\d+)\*\*\s+for\s+([^,.\n*]+)/gi;
                while ((m = boldRegex.exec(text)) !== null) {
                    options.push({ number: m[1], label: m[2].trim() });
                }
                if (options.length) return options;

                // Format 3: "1" for X
                const quotedRegex = /[""'](\d+)[""']\s+for\s+([^,.\n"']+)/gi;
                while ((m = quotedRegex.exec(text)) !== null) {
                    options.push({ number: m[1], label: m[2].trim() });
                }
                if (options.length) return options;

                // ✅ ADD THIS — Format 4: plain "1 for Status" (newline-separated)
                const plainForRegex = /^\s*(\d+)\s+for\s+(.+)$/gmi;
                while ((m = plainForRegex.exec(text)) !== null) {
                    options.push({ number: m[1], label: m[2].trim() });
                }

                return options;
            },
            convertUTCToLocalTime(timeStr, dateStr) {
                if (!timeStr) return '—';
                try {
                    const tzMap = {
                        'India Standard Time': 'Asia/Kolkata',
                        'Eastern Standard Time': 'America/New_York',
                        'US Eastern Standard Time': 'America/New_York',
                        'Central Standard Time': 'America/Chicago',
                        'US Central Standard Time': 'America/Chicago',
                        'Mountain Standard Time': 'America/Denver',
                        'Pacific Standard Time': 'America/Los_Angeles',
                        'UTC': 'UTC',
                        'Greenwich Standard Time': 'Europe/London',
                        'W. Europe Standard Time': 'Europe/Berlin',
                        'Central Europe Standard Time': 'Europe/Budapest',
                        'E. Europe Standard Time': 'Europe/Nicosia',
                        'Central European Time': 'Europe/Paris',
                        'Romance Standard Time': 'Europe/Paris',
                        'China Standard Time': 'Asia/Shanghai',
                        'Japan Standard Time': 'Asia/Tokyo',
                        'Arabian Standard Time': 'Asia/Dubai',
                        'Arab Standard Time': 'Asia/Riyadh',
                        'AUS Eastern Standard Time': 'Australia/Sydney',
                        'Singapore Standard Time': 'Asia/Singapore',
                        'Korea Standard Time': 'Asia/Seoul',
                        'SE Asia Standard Time': 'Asia/Bangkok',
                        'Bangladesh Standard Time': 'Asia/Dhaka',
                        'Pakistan Standard Time': 'Asia/Karachi',
                        'Sri Lanka Standard Time': 'Asia/Colombo',
                        'Nepal Standard Time': 'Asia/Kathmandu',
                        'Myanmar Standard Time': 'Asia/Rangoon',
                        'N. Central Asia Standard Time': 'Asia/Novosibirsk',
                        'Russian Standard Time': 'Europe/Moscow',
                        'Egypt Standard Time': 'Africa/Cairo',
                        'South Africa Standard Time': 'Africa/Johannesburg',
                        'Brazil Standard Time': 'America/Sao_Paulo',
                        'Argentina Standard Time': 'America/Argentina/Buenos_Aires',
                        'Canada Central Standard Time': 'America/Regina',
                        'Atlantic Standard Time': 'America/Halifax',
                    };

                    const rawTz = localStorage.getItem('TimeZone') || 'UTC';
                    const ianaZone = tzMap[rawTz] || rawTz;

                    // Build UTC date object from date + time
                    // dateStr can be "2026-05-29" or "05-29-2026"
                    let year, month, day;
                    if (dateStr && dateStr.includes('-')) {
                        const parts = dateStr.split('-');
                        if (parts[0].length === 4) {
                            // "2026-05-29"
                            [year, month, day] = parts.map(Number);
                        } else {
                            // "05-29-2026"
                            [month, day, year] = parts.map(Number);
                        }
                    } else {
                        const now = new Date();
                        year = now.getUTCFullYear();
                        month = now.getUTCMonth() + 1;
                        day = now.getUTCDate();
                    }

                    const [hour, minute] = timeStr.split(':').map(Number);

                    // Create UTC date
                    const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, 0));

                    // Convert to user's local timezone
                    return utcDate.toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit',
                        hour12: true,
                        timeZone: ianaZone,
                    });

                } catch (e) {
                    console.error('convertUTCToLocalTime error:', e);
                    // Fallback: just show 12hr format without conversion
                    const [h, m] = timeStr.split(':').map(Number);
                    const ampm = h >= 12 ? 'PM' : 'AM';
                    const h12 = h % 12 === 0 ? 12 : h % 12;
                    return `${h12}:${String(m).padStart(2, '0')} ${ampm}`;
                }
            },
            getTicketLookupQuestion(text) {
                if (!text) return '';
                return text
                    .replace(/\*\*/g, '')
                    .split(/\n\s*\d+/)[0]          // split before first numbered item
                    .replace(/reply with[:\s]*/i, '') // remove "Please reply with:"
                    .replace(/please\s*/i, '')
                    .trim() || 'What would you like to check?';
            },
            async _handleBotResponse(data) {
                this.isTyping = false;

                // Reset roommate phone lock when backend moves to another step.
                if (
                    data?.Intent !== 'roommate_phone_prompt' &&
                    !(
                        data?.Intent === 'roommate_flow' &&
                        this.isRoommatePhoneResponse(data?.response || '')
                    )
                ) {
                    this.roommatePhoneStepActive = false;
                    this.roommatePhoneValid = false;
                }

                const richIntents = [
                    'event_flow',
                    'event_guest_source_prompt',
                    'event_guest_roommate_prompt',
                    'view_events_guestlist',
                    'view_events_duplicate',
                    'event_guest_invite_prompt',
                    'chore_status_update_flow',
                    'Hotel_search', 'ticket_menu', 'ticket_flow', 'ticket_guide',
                    'ticket_created', 'ticket_api_error',
                    'expense_flow', 'expense_created', 'expense_api_error',
                    'meeting_scheduled', 'meeting_created', 'meeting_api_error', 'meeting_flow',
                    'due_expense_list', 'ticket_details', 'ticket_status', 'ticket_details_result',
                    'ticket_status_result', 'ticket_attachment_upload', 'expense_attachment_upload',
                    'ticket_lookup_pending', 'expense_form', 'ticket_form', 'meeting_preview',
                    'meeting_conflict', 'meeting_form', 'meeting_form_preview', 'view_meetings',
                    'ticket_vendor_result', 'ticket_status_failed', 'ticket_vendor_failed', 'ticket_preview', 'view_tickets', 'meeting_failed', 'ticket_creation_restricted',
                    'cancel_meeting_empty', 'cancel_meeting_list', 'meeting_cancelled',
                    'cancel_meeting_cancelled', 'cancel_failed',
                    'ticket_status_update_flow', 'ticket_status_updated', 'ticket_status_update_failed',
                    'due_expense_voting_list', 'due_expense_voting_empty', 'due_expense_voting_failed',
                    'view_subscription', 'view_subscription_failed', 'view_subscription_empty',
                    'view_subscription', 'view_subscription_failed', 'view_subscription_empty',
                    'booking_preview', 'booking_created', 'booking_failed', 'view_bookings',
                    'document_vault_flow',
                    'document_vault_doctype_prompt',
                    'document_vault_upload_prompt',
                    'document_vault_coowner_prompt',
                    'document_vault_created',
                    'document_vault_failed',
                    'document_vault_cancelled',
                    'view_documents',
                    'view_documents_empty',
                    'document_deleted',
                    'document_delete_failed',
                    'document_status_updated',
                    'document_status_update_failed',
                    ...(CHORES_EVENTS_ENABLED ? CHORES_EVENTS_CARD_INTENTS : []),
                    ...MANAGE_GUEST_GROUP_CARD_INTENTS,
                    ...NOTIFICATION_CARD_INTENTS,
                    ...ROOMMATE_CARD_INTENTS,
                    ...VENDOR_CARD_INTENTS,
                    'vendor_list_failed',
                    'vendor_status_updated',
                    'vendor_status_update_failed',
                    ...MANAGE_VENDOR_CARD_INTENTS,
                ];
                // Add Roommate - phone number prompt
                // Add Roommate - phone number prompt
                if (data.Intent === 'roommate_flow') {

                    const roommatePhoneMsg = {
                        from: 'bot',
                        type: 'roommate_flow',
                        text: data.response || '',
                        payload: data
                    };

                    if (this.isRoommatePhonePrompt(roommatePhoneMsg)) {

                        this.messages.push(roommatePhoneMsg);

                        this.scrollToBottom();

                        await this._saveChatMessage(
                            'bot',
                            data.response || '',
                            'roommate_flow',
                            data
                        );

                        this.$nextTick(() => {
                            this.addImageClickListeners();
                        });

                        this.isTyping = false;
                        return;
                    }
                }
                // Special case ONLY for Household Expense Vendor question.
                // Backend returns this step as `household_expense_flow`, while the
                // normal expense flow also uses the same intent. Do NOT globally add
                // household_expense_flow to HOUSEHOLD_EXPENSE_CARD_INTENTS because
                // that breaks the existing start/type flow.
                if (
                    data.Intent === 'household_expense_flow' &&
                    /any\s+\*\*?vendor\*\*?\s+for\s+this\s+expense|any\s+vendor\s+for\s+this\s+expense|select\s+vendor/i.test(
                        String(data.response || '')
                    )
                ) {
                    const vendorText = String(data.response || '');
                    const vendorOptions = [];
                    const vendorRegex = /^\s*(\d+)\.\s+(.+?)\s*$/gm;
                    let vendorMatch;

                    while ((vendorMatch = vendorRegex.exec(vendorText)) !== null) {
                        const label = String(vendorMatch[2] || '')
                            .replace(/\*\*/g, '')
                            .trim();

                        if (!label) continue;

                        vendorOptions.push({
                            text: label,
                            value: String(vendorMatch[1]),
                        });
                    }

                    const vendorMsg = {
                        from: 'bot',
                        type: 'household_expense_option_prompt',
                        text: data.response || '',
                        payload: {
                            ...data,
                            Intent: 'household_expense_option_prompt',
                            household_expense_data: {
                                ...(data.household_expense_data || {}),
                                options: vendorOptions,
                            },
                        },
                    };

                    this.messages.push(vendorMsg);
                    this.scrollToBottom();

                    await this._saveChatMessage(
                        'bot',
                        data.response || '',
                        'household_expense_option_prompt',
                        vendorMsg.payload
                    );

                    this.$nextTick(() => {
                        this.addImageClickListeners();
                    });

                    this.isTyping = false;
                    return;
                }

                if (this.isHouseholdExpenseCardIntent(data.Intent)) {
                    const msg = {
                        from: 'bot',
                        type: data.Intent,
                        text: data.response || '',
                        payload: data,
                    };

                    this.messages.push(msg);
                    this.scrollToBottom();

                    await this._saveChatMessage(
                        'bot',
                        data.response || '',
                        data.Intent,
                        data
                    );

                    this.$nextTick(() => {
                        this.addImageClickListeners();
                    });

                    this.isTyping = false;
                    return;
                }
                if (data.Intent === 'document_vault_preview') {
                    const pre = data.document_vault_data?.prefilled || {};
                    const msg = {
                        from: 'bot',
                        type: 'document_vault_preview',
                        payload: data,
                        _docEsign: !!pre.isSignMandatory,
                        _docActive: pre.isActive !== false,
                        _docAttachFile: null,
                        _docShowAttach: false,
                    };
                    this.messages.push(msg);
                    this.scrollToBottom();
                    await this._saveChatMessage('bot', data.response || '', 'document_vault_preview', data);
                    this.$nextTick(() => { this.addImageClickListeners(); });
                    this.isTyping = false;
                    return;
                }
                if (data.Intent === 'due_expense_list') {
                    const msg = {
                        from: 'bot',
                        type: 'due_expense_list',
                        payload: data
                    };
                    this.messages.push(msg);
                    this.scrollToBottom();

                    setTimeout(() => this.scrollToBottom(), 100);
                    setTimeout(() => this.scrollToBottom(), 300);
                    await this._saveChatMessage('bot', data.response || '', 'due_expense_list', data);

                    this.$nextTick(() => { this.addImageClickListeners(); });
                    this.isTyping = false;
                    return;
                }
                if (
                    data.Intent === 'booking_dates_blocked' ||
                    data.Intent === 'view_bookings_empty' ||
                    data.Intent === 'view_bookings_failed' ||
                    data.Intent === 'booking_cancelled'
                ) {
                    const rawText = data.response || (
                        data.Intent === 'booking_dates_blocked' ? "Selected dates are not available. Please choose different dates." :
                            data.Intent === 'view_bookings_empty' ? "You have no bookings at the moment." :
                                data.Intent === 'view_bookings_failed' ? "Unable to fetch your bookings. Please try again." :
                                    "Booking cancelled."
                    );
                    const text = this.formatBotResponse(rawText);   // ← ADD THIS — converts ** to <strong>
                    this.messages.push({ from: 'bot', type: data.Intent, text, payload: data });
                    this.scrollToBottom();
                    await this._saveChatMessage('bot', rawText, data.Intent, data);  // save the raw text, not HTML
                    this.isTyping = false;
                    return;
                }
                if (
                    data.Intent === 'guest_group_flow' ||
                    data.Intent === 'guest_group_preview' ||
                    data.Intent === 'guest_group_created' ||
                    data.Intent === 'guest_group_failed' ||
                    data.Intent === 'guest_group_cancelled' ||
                    data.Intent === 'view_guest_groups' ||
                    data.Intent === 'view_guest_groups_empty' ||
                    data.Intent === 'view_guest_groups_failed' ||
                    data.Intent === 'guest_group_detail' ||
                    data.Intent === 'guest_group_detail_failed' ||
                    data.Intent === 'guest_group_guest_delete_failed'
                ) {
                    const rawText = data.response || '';

                    const text = this.formatBotResponse(rawText);

                    this.messages.push({
                        from: 'bot',
                        type: data.Intent,
                        text,
                        payload: data
                    });

                    this.scrollToBottom();

                    await this._saveChatMessage(
                        'bot',
                        rawText,
                        data.Intent,
                        data
                    );

                    this.isTyping = false;
                    return;
                }

                // ── booking_preview ──────────────────────────────────────────────────────
                if (data.Intent === 'booking_preview') {
                    const msg = { from: 'bot', type: 'booking_preview', payload: data };
                    this.messages.push(msg);
                    this.scrollToBottom();
                    await this._saveChatMessage('bot', data.response || '', 'booking_preview', data);
                    this.$nextTick(() => { this.addImageClickListeners(); });
                    this.isTyping = false;
                    return; // ← this is critical, without it execution falls through
                }
                if (
                    data.Intent === 'cancel_meeting_empty' ||
                    data.Intent === 'cancel_meeting_list' ||
                    data.Intent === 'meeting_cancelled' ||
                    data.Intent === 'cancel_meeting_cancelled' ||
                    data.Intent === 'cancel_failed'
                ) {
                    const msg = {
                        from: 'bot',
                        type: data.Intent,
                        payload: data,
                        text: data.formal_response || data.response || ''
                    };
                    this.messages.push(msg);
                    this.scrollToBottom();
                    await this._saveChatMessage('bot', msg.text, data.Intent, data);
                    this.$nextTick(() => { this.addImageClickListeners(); });
                    this.isTyping = false;
                    return;
                }

                // ── ticket_status_update_flow / ticket_status_updated / ticket_status_update_failed ──
                if (
                    data.Intent === 'ticket_status_update_flow' ||
                    data.Intent === 'ticket_status_updated' ||
                    data.Intent === 'ticket_status_update_failed'
                ) {
                    const msg = {
                        from: 'bot',
                        type: data.Intent,
                        payload: data,
                        text: data.formal_response || data.response || ''
                    };
                    this.messages.push(msg);
                    this.scrollToBottom();
                    await this._saveChatMessage('bot', msg.text, data.Intent, data);
                    this.$nextTick(() => { this.addImageClickListeners(); });
                    this.isTyping = false;
                    return;
                }

                // ── due_expense_voting_list / due_expense_voting_empty / due_expense_voting_failed ──
                if (
                    data.Intent === 'due_expense_voting_list' ||
                    data.Intent === 'due_expense_voting_empty' ||
                    data.Intent === 'due_expense_voting_failed'
                ) {
                    const msg = {
                        from: 'bot',
                        type: data.Intent,
                        payload: data,
                        text: data.response || ''
                    };
                    this.messages.push(msg);
                    this.scrollToBottom();
                    await this._saveChatMessage('bot', msg.text, data.Intent, data);
                    this.$nextTick(() => { this.addImageClickListeners(); });
                    this.isTyping = false;
                    return;
                }
                if (data.Intent === 'view_tickets_empty' || data.Intent === 'view_tickets_failed') {
                    const text = data.response || (data.Intent === 'view_tickets_empty'
                        ? "You don't have any open tickets at the moment."
                        : "Sorry, I couldn't fetch your tickets. Please try again.");
                    this.messages.push({ from: 'bot', type: data.Intent, text });
                    this.scrollToBottom();
                    await this._saveChatMessage('bot', text, data.Intent, null);
                    this.isTyping = false;
                    return;
                }
                if (
                    data.Intent === 'view_subscription_failed' ||
                    data.Intent === 'view_subscription_empty'
                ) {
                    const text = data.response || (
                        data.Intent === 'view_subscription_failed'
                            ? "Sorry, I couldn't fetch your subscription details. Please try again."
                            : "You don't have an active subscription at the moment."
                    );
                    this.messages.push({ from: 'bot', type: data.Intent, text });
                    this.scrollToBottom();
                    await this._saveChatMessage('bot', text, data.Intent, null);
                    this.isTyping = false;
                    return;
                }

                if (data.Intent === 'view_subscription') {
                    const msg = {
                        from: 'bot',
                        type: 'view_subscription',
                        payload: data
                    };
                    this.messages.push(msg);
                    this.scrollToBottom();
                    await this._saveChatMessage('bot', data.response || '', 'view_subscription', data);
                    this.$nextTick(() => { this.addImageClickListeners(); });
                    this.isTyping = false;
                    return;
                }
                // ── ticket_preview ───────────────────────────────────────────────────────
                if (data.Intent === 'ticket_preview' && data.ticket_data) {
                    const pre = (data.ticket_data.prefilled)
                        ? data.ticket_data.prefilled
                        : data.ticket_data || {};

                    // ✅ Mirror exactly what vanilla JS _currentTicketPayload does
                    data.ticket_data.prefilled = {
                        subject: pre.subject || '',
                        assetID: pre.assetID || pre.assetId || '',
                        assetName: pre.assetName || '',
                        workTypeId: pre.workTypeId || pre.workTypeID || '',
                        workTypeName: pre.workTypeName || pre.workType || data.ticket_data.workTypeName || data.ticket_data.workType || '',
                        priorityId: pre.priorityId || '',
                        priorityName: pre.priorityName || 'High',
                        description: pre.description || '',
                        attachmentPath: pre.attachmentPath || null,
                    };

                    // ✅ Reset attachment state for fresh card
                    this._attachmentFiles = [];
                    this._attachmentPreviews = [];
                    this._attachmentUploadedNames = [];
                    this._attachmentError = null;
                    this._ticketPreviewSubmitting = false;
                }
                // ── meeting_preview ──────────────────────────────────────────────────────
                if (data.Intent === 'meeting_preview') {
                    this.meetingForm = {
                        title: '', assetId: '', assetName: '', durationMinutes: '',
                        meetingDate: null, meetingTime: '', participantIds: [],
                        participantNames: [], description: '',
                    };
                    this.meetingFormError = '';
                    this.meetingFormSubmitting = false;

                    const pre = data.meeting_data?.prefilled || {};
                    if (pre.meetingTitle) this.meetingForm.title = pre.meetingTitle;
                    if (pre.durationMinutes) this.meetingForm.durationMinutes = String(pre.durationMinutes);
                    if (pre.assetID) this.meetingForm.assetId = pre.assetID;
                    if (pre.assetName) this.meetingForm.assetName = pre.assetName;
                    if (pre.description) this.meetingForm.description = pre.description;

                    if (pre.meetingDateTime) {
                        const parts = pre.meetingDateTime.split(' ');
                        if (parts[0]) {
                            const [mm, dd, yyyy] = parts[0].split('-');
                            this.meetingForm.meetingDate = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
                        }
                        if (parts[1]) this.meetingForm.meetingTime = parts[1];
                    }

                    const meetingMsg = {
                        from: 'bot', type: 'meeting_preview', payload: data,
                        _assets: data.meeting_data?.assets || [],
                        _participants: [], _loadingParticipants: true,
                    };

                    this.messages.push(meetingMsg);
                    this.scrollToBottom();
                    await this._saveChatMessage(
                        'bot',
                        data.response || '',
                        'meeting_preview',
                        data
                    );
                    const msgIndex = this.messages.length - 1;
                    const preCoOwners = data.meeting_data?.co_owners || [];

                    if (preCoOwners.length) {
                        const normalized = preCoOwners.map(c => ({
                            value: String(c.value || c.Id || ''),
                            label: String(c.text || c.masterName || c.Name || ''),
                        })).filter(x => x.value && x.label);
                        this.messages[msgIndex]._participants = normalized;
                        this.messages[msgIndex]._loadingParticipants = false;
                        this.meetingForm.participantIds = normalized.map(p => p.value);
                    } else {
                        this.messages[msgIndex]._participants = [];
                        this.messages[msgIndex]._loadingParticipants = false;
                    }

                    this.$nextTick(() => { this.addImageClickListeners(); });
                    this.isTyping = false;
                    return;
                }

                // ── ticket_form ──────────────────────────────────────────────────────────
                if (data.Intent === 'ticket_form' && data.ticket_data) {
                    const pre = data.ticket_data.prefilled || {};
                    const assets = data.ticket_data.assets || [];
                    const worktypes = data.ticket_data.worktypes || [];
                    const priorities = data.ticket_data.priorities || [];

                    const matchedPriority = priorities.find(p =>
                        (p.text ?? p.label ?? '').toLowerCase() === (pre.priorityName ?? '').toLowerCase()
                    );
                    const matchedWorktype = worktypes.find(w =>
                        (w.text ?? w.label ?? '').toLowerCase() === (pre.workTypeName ?? '').toLowerCase()
                    );

                    this.ticketForm = {
                        subject: pre.subject || '',
                        workTypeId: pre.workTypeId || matchedWorktype?.value || worktypes[0]?.value || '',
                        workTypeName: pre.workTypeName || matchedWorktype?.text || worktypes[0]?.text || '',
                        priorityId: pre.priorityId || matchedPriority?.value || priorities[0]?.value || '',
                        priorityName: pre.priorityName || matchedPriority?.text || priorities[0]?.text || '',
                        assetId: pre.assetId || assets[0]?.Id || '',
                        description: pre.description || '',
                    };
                    this.ticketFormError = '';
                    this.ticketFormSubmitting = false;
                }

                // ── meeting_form ─────────────────────────────────────────────────────────
                if (data.Intent === 'meeting_form') {
                    const hasPrefilled = !!(data.meeting_data?.prefilled);
                    if (hasPrefilled) {
                        this.messages.push({ from: 'bot', type: 'meeting_form_preview', payload: data });
                        this.scrollToBottom();
                        await this._saveChatMessage(
                            'bot',
                            data.response || '',
                            'meeting_form_preview',
                            data
                        );
                        this.$nextTick(() => { this.addImageClickListeners(); });
                        this.isTyping = false;
                        return;
                    }
                    // Blank form — push with empty participants
                    const msg = {
                        from: 'bot', type: 'meeting_form', payload: data,
                        _assets: data.meeting_data?.assets || [],
                        _participants: [], _loadingParticipants: false,
                    };
                    this.messages.push(msg);
                    this.meetingForm = {
                        title: '', assetId: '', assetName: '', durationMinutes: '',
                        meetingDate: null, meetingTime: '', participantIds: [], description: '',
                    };
                    this.meetingFormError = '';
                    this.meetingFormSubmitting = false;

                    this.scrollToBottom();
                    setTimeout(() => this.scrollToBottom(), 100);
                    setTimeout(() => this.scrollToBottom(), 300);
                    await this._saveChatMessage(
                        'bot',
                        data.response || '',
                        'meeting_form',
                        data
                    );
                    return;
                }
                if (data.Intent === 'meeting_flow') {
                    const response = data.response || '';
                    const isConflict = /conflict|already has a meeting|slot also has a conflict/i.test(response);

                    if (isConflict) {
                        this.messages.push({
                            from: 'bot',
                            type: 'meeting_conflict_inline',
                            payload: data
                        });
                        this.scrollToBottom();
                        await this._saveChatMessage(
                            'bot',
                            data.response || '',
                            'meeting_flow',
                            data
                        );
                        this.$nextTick(() => { this.addImageClickListeners(); });
                        this.isTyping = false;
                        return;
                    }
                    // fall through to normal meeting_flow handling
                }
                // ======================================================
                // MANAGE VENDOR - ONLY CONTACT NUMBER USES RICH UI
                // ======================================================
                if (data.Intent === 'vendor_flow') {

                    const vendorFlowMsg = {
                        from: 'bot',
                        type: 'vendor_flow',
                        text: data.response || '',
                        payload: data
                    };

                    // Contact Number question -> ManageVendors.vue
                    if (this.isManageVendorPhonePrompt(vendorFlowMsg)) {

                        this.messages.push(vendorFlowMsg);

                        await this._saveChatMessage(
                            'bot',
                            data.response || '',
                            'vendor_flow',
                            data
                        );

                        this.scrollToBottom();

                        setTimeout(() => {
                            this.scrollToBottom();
                        }, 100);

                        this.$nextTick(() => {
                            this.addImageClickListeners();
                        });

                        this.isTyping = false;
                        return;
                    }

                    // All other vendor_flow questions:
                    // Vendor Name / Company Name / Email etc.
                    // Continue normally to existing plain-text fallback.
                }
                if (data.Intent === 'combined_dues_list') {
                    this.messages.push({
                        from: 'bot',
                        type: 'combined_dues_list',
                        text: data.response || '',
                        payload: data
                    });

                    this.scrollToBottom();
                    setTimeout(() => this.scrollToBottom(), 100);

                    await this._saveChatMessage(
                        'bot',
                        data.response || '',
                        'combined_dues_list',
                        data
                    );

                    this.$nextTick(() => {
                        this.addImageClickListeners();
                    });

                    this.isTyping = false;
                    return;
                }
                // Vendor active / inactive successful list.
                // The API can return Intent=vendor_list with both active and inactive
                // records even when the user asks "inactive list" or "active list".
                // Filter only that response by isActive. Normal vendor_list is unchanged.
                if (
                    data.Intent === 'vendor_list' &&
                    Array.isArray(data?.vendor_data?.vendors)
                ) {
                    const query = String(this._lastUserQuery || '').toLowerCase();

                    const wantsInactive =
                        /\binactive\b|\bin-active\b/.test(query);

                    const wantsActive =
                        !wantsInactive &&
                        /\bactive\b/.test(query);

                    if (wantsActive || wantsInactive) {
                        const filteredVendors = data.vendor_data.vendors.filter(vendor => {
                            const value =
                                vendor?.isActive ??
                                vendor?.IsActive ??
                                vendor?.active ??
                                vendor?.Active;

                            const isActive =
                                value === true ||
                                value === 1 ||
                                String(value ?? '').toLowerCase() === 'true' ||
                                String(value ?? '').toLowerCase() === 'active';

                            return wantsActive ? isActive : !isActive;
                        });

                        data = {
                            ...data,
                            response: wantsActive
                                ? `Here are your active vendors (${filteredVendors.length} found).`
                                : `Here are your inactive vendors (${filteredVendors.length} found).`,
                            vendor_data: {
                                ...data.vendor_data,
                                heading: wantsActive
                                    ? 'Active Vendors'
                                    : 'Inactive Vendors',
                                vendors: filteredVendors
                            }
                        };
                    }
                }

                // Vendor active / inactive list fallback.
                // If backend returns vendor_list_failed for a status-filter query,
                // reuse the most recent successfully loaded vendor_list and filter it locally.
                // This does not affect normal vendor_list or other failed responses.
                if (data.Intent === 'vendor_list_failed') {
                    const query = String(this._lastUserQuery || '').toLowerCase();

                    const wantsInactive = /\binactive\b/.test(query);
                    const wantsActive = !wantsInactive && /\bactive\b/.test(query);

                    if (wantsActive || wantsInactive) {
                        const previousVendorList = [...this.messages]
                            .reverse()
                            .find(message =>
                                message?.from === 'bot' &&
                                message?.type === 'vendor_list' &&
                                Array.isArray(message?.payload?.vendor_data?.vendors)
                            );

                        if (previousVendorList) {
                            const previousData = previousVendorList.payload?.vendor_data || {};
                            const previousVendors = previousData.vendors || [];

                            const filteredVendors = previousVendors.filter(vendor => {
                                const isActive =
                                    vendor?.isActive === true ||
                                    vendor?.IsActive === true ||
                                    vendor?.isActive === 1 ||
                                    vendor?.IsActive === 1 ||
                                    String(vendor?.isActive ?? vendor?.IsActive ?? '')
                                        .toLowerCase() === 'true';

                                return wantsActive ? isActive : !isActive;
                            });

                            data = {
                                ...data,
                                Intent: 'vendor_list',
                                response: '',
                                vendor_data: {
                                    ...previousData,
                                    heading: wantsActive
                                        ? 'Active Vendors'
                                        : 'Inactive Vendors',
                                    vendors: filteredVendors
                                }
                            };
                        }
                    }
                }

                // ── richIntents ──────────────────────────────────────────────────────────
                if (data.Intent && richIntents.includes(data.Intent)) {


                    // expense_form — initialize form state
                    if (data.Intent === 'expense_form' && data.expense_data?.prefilled) {
                        const pre = data.expense_data.prefilled;
                        console.log("dfssssssssssssss")
                        console.log(pre)
                        const assets = data.expense_data.assets || [];
                        const categories = data.expense_data.categories || [];
                        const vendors = data.expense_data.vendors || [];
                        const thresholds = data.expense_data.thresholds || [];

                        const matchedCategory = categories.find(c =>
                            (c.text ?? c.masterName ?? '').toLowerCase() === (pre.categoryName ?? '').toLowerCase()
                        );
                        const preAmount = pre.amount || null;

                        this.expenseForm = {
                            title: pre.expenseTitle || '',
                            amount: preAmount,
                            assetId: pre.assetID || (assets.length === 1 ? assets[0].Id : '') || '',
                            categoryId: pre.categoryId || matchedCategory?.value || (categories.length === 1 ? categories[0].value : '') || '',
                            paymentDate: pre.expensePaymentDate ? pre.expensePaymentDate.split('T')[0] : '',

                            vendorId: pre.vendorId || '',
                            description: pre.description || '',
                            votingTitle: pre.votingTitle || '',
                            votingDeadline: pre.votingDeadline ? new Date(pre.votingDeadline).toISOString().split('T')[0] : '',
                            thresholdId: pre.thresholdId || (preAmount > 500 ? thresholds[0]?.value || '' : '') || '',
                            votingJustification: pre.votingJustification || '',
                        };
                        console.log("expenseForm")
                        console.log(this.expenseForm)
                        this.expenseFormError = '';
                        this.expenseFormSubmitting = false;
                    }

                    // ticket_created — fix missing fields
                    if ((data.Intent === 'ticket_created' || data.Intent === 'ticket_api_error') && data.ticket_data) {
                        if (!data.ticket_data.ticketNumber) {
                            data.ticket_data.ticketNumber =
                                data.ticket_data.api?.raw?.ticket_Number ||
                                data.ticket_data.api?.ticket_number || null;
                        }
                    }
                    if (data.Intent === 'ticket_created') {
                        if (!data.ticket_data.workTypeName && this._lastSelectedWorkType.name) {
                            data.ticket_data.workTypeName = this._lastSelectedWorkType.name;
                            data.ticket_data.workType = this._lastSelectedWorkType.id;
                        }
                        const ticketId = data.ticket_data?.ticketNumber;
                        //    if (ticketId) this.assignTicketAfterCreation(ticketId);
                    }

                    // push message
                    // Fix roommate country code before rendering preview
                    if (
                        data.Intent === 'roommate_preview' &&
                        data.roommate_data?.prefilled
                    ) {
                        const pre = data.roommate_data.prefilled;

                        if (
                            !pre.countryCodeText ||
                            pre.countryCodeText === 'Loading…' ||
                            pre.countryCodeText === 'Loading...'
                        ) {
                            pre.countryCodeText =
                                this.roommateSelectedCountryCodeText || '';
                        }
                    }

                    // push message
                    const msg = {
                        from: "bot",
                        type: data.Intent,
                        payload: data
                    };

                    this.messages.push(msg);

                } else {
                    // plain text fallback
                    const botText = data.response || data.answer || data.message
                        || (typeof data === 'string' ? data : "We're having trouble right now. Please try again shortly");
                    const formattedHtml = this.formatBotResponse(botText);
                    this.messages.push({ from: "bot", type: "text", text: formattedHtml });
                }
                if (data.Intent === 'expense_cancelled' || data.Intent === 'ticket_cancelled') {
                    // Ticket attachment state
                    this._attachmentFiles = [];
                    this._attachmentPreviews = [];
                    this._attachmentUploadedNames = [];
                    this._attachmentError = null;

                    // Expense attachment state
                    this.expenseFormFiles = [];
                    this.expenseFormFileError = '';
                    this.expenseFormUploading = false;
                }
                const lastMsg = this.messages[this.messages.length - 1];
                if (lastMsg && lastMsg.from === 'bot') {
                    await this._saveChatMessage(
                        'bot',
                        lastMsg.text || data.response || '',
                        lastMsg.type || 'text',
                        lastMsg.payload || null
                    );
                }
                this.scrollToBottom();
                setTimeout(() => this.scrollToBottom(), 100);
                setTimeout(() => this.scrollToBottom(), 300);
                this.$nextTick(() => { this.addImageClickListeners(); });
            },
            getDueExpenses(payload) {
                // ✅ New structured format from expense_data.expenses
                const structured = payload?.expense_data?.expenses;
                if (structured && Array.isArray(structured) && structured.length) {
                    return structured.map(e => ({
                        description: e.title || '—',
                        asset: e.asset || '—',
                        totalAmount: e.amount != null ? `$${e.amount}` : '—',
                        myShare: e.myShare != null ? `$${e.myShare}` : '—',
                        dueDate: e.dueDate || '—',
                        status: e.status || '—',
                        expenseId: e.expenseId || '—',
                    }));
                }

                // ✅ Fallback: old text-parse format from payload.response
                return this.parseDueExpenses(payload?.response);
            },
            _pushError(err) {

                let icon = "⚠️";
                let msg = "Server not reachable. Please try again later.";
                if (err.response) {
                    const status = err.response.status;
                    if (status === 401 || status === 403) {
                        icon = "🔒";
                        msg = "You don't have permission to do that. Please log in again.";
                    } else if (status === 404) {
                        icon = "🔍";
                        msg = "The service could not be found. Please try again later.";
                    } else if (status === 429) {
                        icon = "⏳";
                        msg = "Too many requests. Please wait a moment and try again.";
                    } else if (status >= 500) {
                        msg = "We're having trouble right now. Please try again shortly.";
                    } else {
                        msg = "We're having trouble right now. Please try again shortly.";
                    }
                } else if (err.request) {
                    msg = "We're having trouble right now. Please try again shortly.";
                } else {
                    msg = "We're having trouble right now. Please try again shortly.";
                }

                const html = `
        <div class="chat-error-box">
            <span class="chat-error-icon">${icon}</span>
            <div class="chat-error-text">
                <strong>Oops!</strong>
                <p>${msg}</p>
            </div>

        </div>
    `;
                /*<button class="chat-error-retry" onclick="this.closest('.chat-error-box').dispatchEvent(new CustomEvent('retry', {bubbles:true}))">
                    🔄 Retry
                </button>*/
                // I've commented this out for now.
                //this._saveChatMessage('bot', msg, 'text', null);
                this.messages.push({ from: "bot", type: "text", text: html });


            },
            async fetchOptionsForMsgOrSkip(msg, type) {
                const url = this.buildApiUrl(type);
                if (!url) return;

                try {
                    const res = await axios.get(url, {
                        headers: this.token ? { Authorization: `Bearer ${this.token}` } : {}
                    });

                    const items = this.normalizeItems(res.data, type);

                    if (!items.length) {
                        // ✅ No items — remove the card that was just pushed and silently skip
                        const idx = this.messages.indexOf(msg);
                        if (idx !== -1) this.messages.splice(idx, 1);
                        await this._sendRaw("skip");
                        return;
                    }

                    // ✅ Has items — load normally into the existing card
                    const reactiveMsg = this.messages.find(m => m === msg) || msg;
                    reactiveMsg._options = items;
                    reactiveMsg._filteredOptions = [...items];
                    reactiveMsg._loadingOptions = false;

                } catch (e) {
                    console.error(`[fetchOptionsForMsgOrSkip] ${type} error:`, e);
                    // ✅ On error — also remove card and skip silently
                    const idx = this.messages.indexOf(msg);
                    if (idx !== -1) this.messages.splice(idx, 1);
                    await this._sendRaw("skip");
                }
            },
            // ─── Meeting helpers (per-message, not computed) ──────────────────────────




            // ─── Hotel helpers ────────────────────────────────────────────────────────

            groupedHotels(payload) {
                const map = {};
                (payload?.sqlData || []).forEach(room => {
                    const hid = room.hotel_id;
                    if (!map[hid]) {
                        map[hid] = { hotel_name: room.hotel_name, location: room.location, amenities: room.amenities, rooms: [] };
                    }
                    let images = room.images
                        ? room.images.replace(/\\/g, '/').split(',').map(i => i.trim()).filter(Boolean)
                        : [];
                    if (!images.length) images = ["https://via.placeholder.com/400x250?text=No+Image"];
                    map[hid].rooms.push({
                        room_type: room.room_type, bed_type: room.bed_type,
                        price: room.price_per_night, availability: room.is_available, images
                    });
                });
                return map;
            },

            handleBookingClick(room, hotel) {
                alert(`Want to book ${room.room_type} at ${hotel.hotel_name}`);
            },

            // ─── Ticket helpers ───────────────────────────────────────────────────────

            getTicketNumber(payload) {
                return payload?.ticket_data?.ticketNumber || "PENDING";
            },

            parseCarts(payload) {
                try {
                    return typeof payload.sqlData === 'string' ? JSON.parse(payload.sqlData) : payload.sqlData || [];
                } catch { return []; }
            },

            // ─── Markdown / HTML ──────────────────────────────────────────────────────

            processHtmlTags(html) {
                if (!html) return "";
                html = html.replace(/<img\s+([^>]*?)(?:>|\/>)/gi, (match, attributes) => {
                    const srcMatch = attributes.match(/src=['"]([^'"]+)['"]/i);
                    const src = srcMatch ? srcMatch[1] : '';
                    const altMatch = attributes.match(/alt=['"]([^'"]*)['"]/i);
                    const alt = altMatch ? altMatch[1] : '';
                    if (src) {
                        return `<div class="chat-image-wrapper" data-image-url="${src}">
                        <img src="${src}" alt="${alt}" loading="lazy" class="clickable-image"
                             style="max-width:100%;max-height:200px;width:auto;height:auto;object-fit:contain;" />
                    </div>`;
                    }
                    return match;
                });
                html = html.replace(/<a\s+([^>]*)>(.*?)<\/a>/gi, (match, attributes, text) => {
                    const hrefMatch = attributes.match(/href=['"]([^'"]+)['"]/i);
                    const href = hrefMatch ? hrefMatch[1] : '#';
                    return `<a href="${href}" class="chat-link" target="_blank" rel="noopener noreferrer">${text}</a>`;
                });
                return html;
            },

            convertMarkdownToHtml(text) {
                if (!text) return "";
                return this.processHtmlTags(this.md.render(text));
            },

            formatBotResponse(text) {
                if (!text) return "";
                const protectedBlocks = [];
                let processedText = text;

                processedText = processedText.replace(/---IMAGE_URLS_START---([\s\S]*?)---IMAGE_URLS_END---/g, (match, content) => {
                    const images = content.split("\n").map(u => u.trim()).filter(u => u.startsWith("http")).map(u => `![image](${u})`).join("\n\n");
                    const placeholder = `__PROTECTED_BLOCK_${protectedBlocks.length}__`;
                    protectedBlocks.push({ type: 'image', content: images });
                    return placeholder;
                });

                processedText = processedText.replace(/---VIDEO_URL_START---([\s\S]*?)---VIDEO_URL_END---/g, (match, content) => {
                    const videos = content.split("\n").map(u => u.trim()).filter(u => u.startsWith("http")).map(u => `[Video Link](${u})`).join("\n\n");
                    const placeholder = `__PROTECTED_BLOCK_${protectedBlocks.length}__`;
                    protectedBlocks.push({ type: 'video', content: videos });
                    return placeholder;
                });

                let html = this.convertMarkdownToHtml(processedText);

                protectedBlocks.forEach((block, index) => {
                    const placeholder = `__PROTECTED_BLOCK_${index}__`;
                    if (block.type === 'image') {
                        const imageUrls = block.content.match(/!\[image\]\((.*?)\)/g) || [];
                        let imageHtml = '';
                        imageUrls.forEach(img => {
                            const url = img.match(/\((.*?)\)/)[1];
                            imageHtml += `<div class="chat-image-wrapper" data-image-url="${url}">
                            <img src="${url}" alt="Response image" loading="lazy" class="clickable-image"
                                 style="max-width:100%;max-height:200px;width:auto;height:auto;object-fit:contain;" />
                        </div>`;
                        });
                        html = html.replace(placeholder, imageHtml);
                    } else if (block.type === 'video') {
                        const videoUrls = block.content.match(/\[Video Link\]\((.*?)\)/g) || [];
                        let videoHtml = '';
                        videoUrls.forEach(video => {
                            const url = video.match(/\((.*?)\)/)[1];
                            videoHtml += `<div class="chat-video-wrapper">
                            <video controls preload="metadata" style="max-width:100%;max-height:200px;">
                                <source src="${url}" type="video/mp4">
                            </video>
                        </div>`;
                        });
                        html = html.replace(placeholder, videoHtml);
                    }
                });
                return html;
            },

            // ─── UI helpers ───────────────────────────────────────────────────────────

            scrollToBottom() {
                const el = this.$refs.chatMessages;
                if (!el) return;

                // Immediate
                el.scrollTop = el.scrollHeight;

                // After Vue renders
                this.$nextTick(() => {
                    el.scrollTop = el.scrollHeight;

                    // After browser paints (handles dynamic content like cards/images)
                    requestAnimationFrame(() => {
                        el.scrollTop = el.scrollHeight;

                        // Double rAF — catches late-rendering rich cards
                        requestAnimationFrame(() => {
                            el.scrollTop = el.scrollHeight;
                        });
                    });
                });
            },

            handleKeyDown(event) {
                if (event.key === "Enter" && !event.shiftKey) {
                    event.preventDefault();
                    this.sendMessage();
                }
            },

            handleEscapeKey(event) {
                if (event.key === "Escape" && this.showImagePopup) this.closeImagePopup();
            },

            handleWheelZoom(event) {
                event.deltaY < 0 ? this.zoomIn() : this.zoomOut();
            },

            toggleChat() {
                this.isOpen = !this.isOpen;

                if (this.isOpen) {
                    if (!this.hasWelcomed) {
                        this.hasWelcomed = true;

                        // ✅ Step 1 — Push welcome message FIRST (always on top)
                        this.messages.push({
                            from: 'bot',
                            type: 'welcome',
                            text: 'Hello! I am SpliytGenie. How can I help you?'
                        });

                        // ✅ Step 2 — Load history BELOW the welcome message
                        this._loadChatHistory().then(() => {
                            this.scrollToBottom();
                        });

                    } else {
                        this.scrollToBottom();
                    }
                }
            },
            zoomIn() { if (this.zoomLevel < 3) this.zoomLevel += 0.25; },
            zoomOut() { if (this.zoomLevel > 0.5) this.zoomLevel -= 0.25; },
            resetZoom() { this.zoomLevel = 1; },

            openImagePopup(imageUrl) {
                this.activeImage = imageUrl;
                this.showImagePopup = true;
                this.zoomLevel = 1;
                document.body.style.overflow = 'hidden';
            },

            closeImagePopup() {
                this.showImagePopup = false;
                this.activeImage = null;
                this.zoomLevel = 1;
                document.body.style.overflow = '';
            },

            addImageClickListeners() {
                const images = document.querySelectorAll('.chat-image-wrapper .clickable-image');
                images.forEach(img => {
                    img.removeEventListener('click', this.handleImageClick);
                    img.addEventListener('click', this.handleImageClick);
                });
            },

            handleImageClick(event) {
                event.stopPropagation();
                if (event.target.src) this.openImagePopup(event.target.src);
            },

            getSessionId() {
                let session = localStorage.getItem("session_id");
                if (!session) {
                    session = Math.random().toString(36).substring(2);
                    localStorage.setItem("session_id", session);
                }
                return session;


                //var session = Math.random().toString(36).substring(2);
                //localStorage.setItem("session_id", session);

                //return session;
            },
            /* // ─── Expense choice submission ────────────────────────────────────────────────
             submitExpenseAssetPick(id, name) {
                 const cmd = `__EXP_ASSET__${JSON.stringify({ id: id, name: name })}`;
                 this._sendTicketChoice(name, cmd);
             },

             submitExpenseCategoryPick(label, value) {
                 const cmd = `__EXP_CATEGORY__${JSON.stringify({ id: value, name: label })}`;
                 this._sendTicketChoice(label, cmd);
             },

             submitExpenseVendorPick(label, value) {
                 const cmd = `__EXP_VENDOR__${JSON.stringify({ id: value, name: label })}`;
                 this._sendTicketChoice(label, cmd);
             },
             submitExpenseThresholdPick(label, value) {
                 const cmd = `__EXP_THRESHOLD__${JSON.stringify({ id: value, name: label })}`;
                 this._sendTicketChoice(label, cmd);
             },*/
            // Extracts ticket number like "20260506073006-1051" from response text
            extractTicketNumber(text) {
                if (!text) return '—';
                // Match **1034 format (bold short number)
                const boldMatch = text.match(/\*\*(\d+)/);
                if (boldMatch) return boldMatch[1].trim();
                // Match #1034 format
                const hashMatch = text.match(/#(\d+)/);
                if (hashMatch) return hashMatch[1].trim();
                // Match long format: 20260508103551-1004
                const plainMatch = text.match(/\b(\d{14}-\d+)\b/);
                if (plainMatch) return plainMatch[1].trim();
                return '—';
            },

            // Parses "Key: Value" lines from ticket details response
            parseTicketDetails(text) {
                if (!text) return [];
                // Remove first line (the "Ticket XX details:" line)
                const lines = text.split('\n').filter(l => l.trim() && !l.includes('details:') && !l.startsWith('Ticket **'));
                return lines
                    .map(line => {
                        const idx = line.indexOf(':');
                        if (idx === -1) return null;
                        return {
                            label: line.substring(0, idx).trim(),
                            value: line.substring(idx + 1).trim() || '—'
                        };
                    })
                    .filter(Boolean);
            },

            // Extracts status value from "status is: Open"
            extractTicketStatus(text) {
                if (!text) return '—';
                // Match "status is Open" or "status is: Open"
                const match = text.match(/status\s+is:?\s*([A-Za-z\s]+?)(?:\.|$)/i);
                return match ? match[1].trim() : '—';
            },
            extractVendor(msg) {
                // Prefer ticket_data if available
                const vendor = msg.payload?.ticket_data?.vendor;
                if (vendor) return vendor;
                // Fallback: parse from response text
                const match = (msg.payload?.response || '').match(/:\s*(.+)$/);
                return match ? match[1].trim() : 'Not Assigned';
            },

            extractVendorStatus(msg) {
                return msg.payload?.ticket_data?.status || '—';
            },
            isMeetingDaysStep(payload) {
                return payload?.meeting_data?.step === 'meeting_date';
            },

            isMeetingTimeStep(payload) {
                return payload?.meeting_data?.step === 'meeting_time';
            },

            isMeetingDurationStep(payload) {
                return payload?.meeting_data?.step === 'duration_minutes';
            },

            // Generate 15-min interval time options


            // Filter out past times if date is today


            getMeetingDurationOptions() {
                const options = [];
                for (let m = 15; m <= 240; m += 15) {
                    const h = Math.floor(m / 60);
                    const min = m % 60;
                    let label = '';
                    if (h > 0 && min > 0) label = `${h}h ${min}min`;
                    else if (h > 0) label = `${h} hour${h > 1 ? 's' : ''}`;
                    else label = `${min} min`;
                    options.push({ label, value: String(m) });
                }
                return options;
            },






            // Generate datalist options for 15-min intervals





            submitMeetingParticipants() {
                if (!this._meetingSelectedParticipants.length) return;

                const ids = this._meetingSelectedParticipants.map(p => p.value).join(',');
                const names = this._meetingSelectedParticipants.map(p => p.label).join(',');

                // ✅ Exact format bot expects
                const cmd = `__BK_MEETING_PARTICIPANTS__${ids}|${names}`;

                const displayLabel = this._meetingSelectedParticipants.length === 1
                    ? this._meetingSelectedParticipants[0].label
                    : `${this._meetingSelectedParticipants.length} participants selected`;

                this._sendTicketChoice(displayLabel, cmd);
            },

            getMeetingAllLabel(msg) {
                // Check if this specific meeting step had an asset selected
                const assetId = msg?.payload?.meeting_data?.collected?.asset_name  // GUID is in asset_name
                    || msg?.payload?.meeting_data?.assetId
                    || '';
                // assetId field has the name "Puerto Escondido..." — check asset_name for GUID
                const hasAsset = !!this._meetingSelectedAssetId ||
                    !!(msg?.payload?.meeting_data?.collected?.asset_name);
                return hasAsset ? 'All Co-owners' : 'All Users';
            },
            getExpenseFormAssets(msg) {
                // ✅ Merge payload + cache so dropdown always has options
                const fromPayload = msg?.payload?.expense_data?.assets || [];
                const fromCache = (this._optionsCache['expense_asset'] || []).map(c => ({
                    Id: c.value, Name: c.label
                }));
                const merged = fromPayload.length ? fromPayload : fromCache;
                return merged;
            },

            getExpenseFormCategories(msg) {
                const fromPayload = msg?.payload?.expense_data?.categories || [];
                const fromCache = this._optionsCache['expense_category'] || [];
                const source = fromPayload.length ? fromPayload : fromCache;
                return source.map(c => ({
                    value: String(c.value ?? c.Value ?? c.id ?? c.Id ?? ''),
                    text: String(c.text ?? c.label ?? c.masterName ?? c.name ?? ''),
                }));
            },
            getExpenseFormVendors(msg) { return msg?.payload?.expense_data?.vendors || []; },
            getExpenseFormThresholds(msg) { return msg?.payload?.expense_data?.thresholds || []; },

            async submitExpenseFormCard(msg) {
                const f = this.expenseForm;
                const pre = msg?.payload?.expense_data?.prefilled || {};

                // ✅ FIX — use prefilled value if form field is empty (read-only display case)
                const resolvedAssetId = f.assetId || pre.assetID || '';
                const resolvedCategoryId = f.categoryId || pre.categoryId || '';
                const resolvedTitle = f.title || pre.expenseTitle || '';
                const resolvedAmount = f.amount ?? pre.amount ?? null;
                const resolvedPaymentDate = f.paymentDate || pre.expensePaymentDate || '';
                const resolvedVendorId = f.vendorId || pre.vendorId || '';
                const resolvedThresholdId = f.thresholdId || pre.thresholdId || '';
                const resolvedVotingTitle = f.votingTitle || pre.votingTitle || '';
                const resolvedVotingDeadline = f.votingDeadline || pre.votingDeadline || '';

                // ✅ Word limit check
                const wordCount = this.getExpenseDescWordCount();
                if (wordCount > 200) {
                    this.expenseFormError = `Description exceeds 200 word limit (${wordCount} words). Please shorten it.`;
                    return;
                }

                // ✅ FIX — validate using resolved values, not just f.*
                if (!resolvedTitle || !resolvedAmount || !resolvedAssetId || !resolvedCategoryId || !resolvedPaymentDate) {
                    this.expenseFormError = 'Please fill in all required fields.';
                    console.log('[expense] validation failed:', {
                        resolvedTitle, resolvedAmount, resolvedAssetId,
                        resolvedCategoryId, resolvedPaymentDate
                    });
                    return;
                }

                if (resolvedAmount > 500 && (!resolvedVotingTitle || !resolvedVotingDeadline || !resolvedThresholdId)) {
                    this.expenseFormError = 'Voting Title, Deadline and Threshold are required for amounts over $500.';
                    return;
                }

                this.expenseFormError = '';
                this.expenseFormSubmitting = true;
                this.expenseFormUploading = this.expenseFormFiles.length > 0;

                // ✅ Upload files in parallel
                let filePaths = '';
                if (this.expenseFormFiles.length) {
                    try {
                        this.expenseFormUploading = true;
                        const companyId = this.companyId || localStorage.getItem('companyId');
                        const userId = this.userId || localStorage.getItem('userId');

                        const uploadPromises = this.expenseFormFiles.map(async (file) => {
                            const fd = new FormData();
                            fd.append('file', file);
                            const r = await this._manageAssetsService.SaveDocument(companyId, userId, fd);
                            const sc = r?.data?.statusCode ?? r?.data?.StatusCode;
                            if (sc === 200 && r?.data?.responseMessage) return String(r.data.responseMessage);
                            throw new Error(r?.data?.responseMessage || `Upload failed for ${file.name}`);
                        });

                        const uploadedPaths = await Promise.all(uploadPromises);
                        filePaths = uploadedPaths.join(',');

                    } catch (err) {
                        this.expenseFormFileError = `File upload failed: ${err?.message || 'Please try again.'}`;
                        this.expenseFormSubmitting = false;
                        this.expenseFormUploading = false;
                        return;
                    } finally {
                        this.expenseFormUploading = false;
                    }
                }

                // ✅ Resolve names from ALL possible sources
                const payloadAssets = msg?.payload?.expense_data?.assets || [];
                const cachedAssets = this._optionsCache['expense_asset'] || [];
                const allAssets = [...payloadAssets, ...cachedAssets];
                const assetName = allAssets.find(a =>
                    String(a.Id ?? a.id ?? a.value ?? '') === String(resolvedAssetId)
                )?.Name || pre.assetName || '';

                const payloadCats = (msg?.payload?.expense_data?.categories || []).map(c => ({
                    value: String(c.value ?? c.Value ?? c.id ?? c.Id ?? ''),
                    text: String(c.text ?? c.label ?? c.masterName ?? c.name ?? ''),
                }));
                const cachedCats = (this._optionsCache['expense_category'] || []).map(c => ({
                    value: String(c.value ?? ''),
                    text: String(c.label ?? c.text ?? ''),
                }));
                const allCats = [...payloadCats, ...cachedCats];
                const categoryName = allCats.find(c =>
                    String(c.value) === String(resolvedCategoryId)
                )?.text || pre.categoryName || '';

                const payloadVendors = (msg?.payload?.expense_data?.vendors || []).map(v => ({
                    value: String(v.value ?? v.id ?? v.Id ?? ''),
                    text: String(v.text ?? v.label ?? v.name ?? ''),
                }));
                const allVendors = [...payloadVendors];
                const vendorName = allVendors.find(v =>
                    String(v.value) === String(resolvedVendorId)
                )?.text || pre.vendorName || '';

                const payloadThresholds = (msg?.payload?.expense_data?.thresholds || []).map(t => ({
                    value: String(t.value ?? t.id ?? t.Id ?? ''),
                    text: String(t.text ?? t.label ?? t.masterName ?? ''),
                }));
                const allThresholds = [...payloadThresholds];
                const thresholdName = allThresholds.find(t =>
                    String(t.value) === String(resolvedThresholdId)
                )?.text || pre.thresholdName || '';

                const payload = {
                    expenseTitle: resolvedTitle,
                    amount: resolvedAmount,
                    assetID: resolvedAssetId,
                    assetName,
                    categoryId: resolvedCategoryId,
                    categoryName,
                    vendorId: resolvedVendorId || '',
                    vendorName,
                    expensePaymentDate: resolvedPaymentDate,
                    description: f.description || '',
                    fileUploadFile: filePaths || null,
                    votingTitle: resolvedAmount > 500 ? resolvedVotingTitle : null,
                    votingDeadline: resolvedAmount > 500 ? resolvedVotingDeadline : null,
                    thresholdId: resolvedAmount > 500 ? resolvedThresholdId : null,
                    thresholdName: resolvedAmount > 500 ? thresholdName : null,
                    votingJustification: resolvedAmount > 500 ? (f.votingJustification || pre.votingJustification || '') : null,
                };

                try {
                    this.expenseFormFiles = [];
                    this.expenseFormFileError = '';
                    await this._sendRaw('__EXP_SUBMIT__' + JSON.stringify(payload));
                    msg._confirmed = true;
                } finally {
                    this.expenseFormSubmitting = false;
                }
            },
            onExpenseFormFileChange(event) {
                const files = Array.from(event.target.files || []);
                if (!files.length) return;

                const allowedExts = [
                    '.pdf', '.xlsx', '.csv', '.docx', '.doc',
                    '.pptx', '.ppt', '.txt', '.xls',
                    '.png', '.jpg', '.jpeg', '.gif'
                ];
                const maxSize = 20 * 1024 * 1024;

                for (const f of files) {
                    const ext = '.' + f.name.split('.').pop().toLowerCase();
                    if (!allowedExts.includes(ext)) {
                        this.expenseFormFileError = `File "${f.name}" type not allowed.`;
                        event.target.value = '';
                        return;
                    }
                    if (f.size > maxSize) {
                        this.expenseFormFileError = `File "${f.name}" exceeds 20MB limit.`;
                        event.target.value = '';
                        return;
                    }
                }

                this.expenseFormFileError = '';
                // ✅ Append — don't replace existing selections
                this.expenseFormFiles = [...this.expenseFormFiles, ...files];
                event.target.value = '';
            },

            removeExpenseFormFile(index) {
                this.expenseFormFiles = this.expenseFormFiles.filter((_, i) => i !== index);
            },
            getMeetingFormAssets(msg) {
                const raw = msg?.payload?.meeting_data?.assets || [];
                return [
                    { value: '', label: 'None (optional)' },
                    ...raw.map(a => ({
                        value: String(a.Id ?? a.id ?? a.value ?? ''),
                        label: String(a.Name ?? a.name ?? a.label ?? ''),
                    })).filter(x => x.value)
                ];
            },

            getMeetingFormParticipants(msg) {
                return msg._participants || [];
            },

            async onMeetingFormAssetChange(msg) {
                const msgIndex = this.messages.indexOf(msg);
                if (msgIndex === -1) return;

                this.meetingForm.participantIds = [];
                this.messages[msgIndex]._loadingParticipants = true;

                const assetId = this.meetingForm.assetId;
                this._meetingSelectedAssetId = assetId;

                const type = assetId ? 'meeting_coowner' : 'meeting_users';
                const url = this.buildApiUrl(type);

                try {
                    const res = await axios.get(url, {
                        headers: this.token ? { Authorization: `Bearer ${this.token}` } : {}
                    });
                    const users = this.normalizeItems(res.data, type);
                    this.messages[msgIndex]._participants = users;
                    this.meetingForm.participantIds = users.map(u => u.value); // auto-select all
                } catch (e) {
                    console.warn('[meeting asset change] participants load failed:', e.message);
                    this.messages[msgIndex]._participants = [];
                } finally {
                    this.messages[msgIndex]._loadingParticipants = false;
                }
            },

            async submitMeetingFormCard(msg) {
                const f = this.meetingForm;
                this.meetingFormError = '';

                // Validate
                if (!f.title.trim()) {
                    this.meetingFormError = 'Meeting title is required.'; return;
                }
                if (!f.durationMinutes) {
                    this.meetingFormError = 'Please select a duration.'; return;
                }
                if (!f.meetingDate) {
                    this.meetingFormError = 'Please select a meeting date.'; return;
                }
                if (!f.meetingTime) {
                    this.meetingFormError = 'Please select a meeting time.'; return;
                }
                if (!f.participantIds.length) {
                    this.meetingFormError = 'Please select at least one participant.'; return;
                }
                const descWords = f.description.trim().split(/\s+/).filter(w => w.length).length;
                /*  if (descWords < 5) {
                      this.meetingFormError = `Description needs at least 5 words (you have ${descWords}).`; return;
                  }*/

                // Format date mm-dd-yyyy
                const dateFormatted = this.formatDateMDY(f.meetingDate);

                // Format time to "11:00 AM"
                const [h, m] = f.meetingTime.split(':').map(Number);
                const hour12 = h % 12 === 0 ? 12 : h % 12;
                const ampm = h < 12 ? 'AM' : 'PM';
                const mStr = String(m).padStart(2, '0');
                const timeFormatted = `${hour12}:${mStr} ${ampm}`;

                // Get participant names
                const allParticipants = this.getMeetingFormParticipants(msg);
                const selectedNames = allParticipants
                    .filter(p => f.participantIds.includes(p.value))
                    .map(p => p.label)
                    .join(',');

                const payload = {
                    meetingTitle: f.title.trim(),
                    assetID: f.assetId || '',
                    assetName: f.assetId
                        ? (this.getMeetingFormAssets(msg).find(a => a.value === f.assetId)?.label || '')
                        : '',
                    durationMinutes: f.durationMinutes,
                    meetingDate: dateFormatted,
                    meetingTime: timeFormatted,
                    participantIds: f.participantIds.join(','),
                    participantNames: selectedNames,
                    description: f.description.trim(),
                };

                this.meetingFormSubmitting = true;
                try {
                    await this._sendRaw('__MTG_SUBMIT__' + JSON.stringify(payload));
                    // Reset form
                    this.meetingForm = {
                        title: '', assetId: '', assetName: '',
                        durationMinutes: '', meetingDate: null,
                        meetingTime: '', participantIds: [], description: '',
                    };
                } finally {
                    this.meetingFormSubmitting = false;
                }
            },
        }
    };
</script>





<style scoped>

    /* Markdown and HTML content styling */
    .bot-message {
        line-height: 1.6;
        word-wrap: break-word;
        max-width: 100%;
        /*        overflow-x: hidden;*/
    }

        .bot-message h1,
        .bot-message h2,
        .bot-message h3 {
            margin-top: 0.5em;
            margin-bottom: 0.25em;
        }

        .bot-message p {
            margin-bottom: 0.5em;
        }

        .bot-message ul,
        .bot-message ol {
            margin: 0.5em 0;
            padding-left: 1.5em;
        }

        .bot-message li {
            margin: 0.25em 0;
        }

        .bot-message code {
            background-color: rgba(0, 0, 0, 0.05);
            padding: 0.2em 0.4em;
            border-radius: 3px;
            font-family: monospace;
            font-size: 0.9em;
        }

        .bot-message pre {
            background-color: rgba(0, 0, 0, 0.05);
            padding: 0.5em;
            border-radius: 5px;
            overflow-x: auto;
        }

            .bot-message pre code {
                background-color: transparent;
                padding: 0;
            }

        .bot-message blockquote {
            border-left: 3px solid #ccc;
            margin: 0.5em 0;
            padding-left: 1em;
            color: #666;
        }

        /* Link styling */
        .bot-message .chat-link,
        .bot-message a:not(.chat-link) {
            color: #0066cc;
            text-decoration: underline;
            font-weight: 500;
            transition: color 0.2s ease;
        }

            .bot-message .chat-link:hover,
            .bot-message a:not(.chat-link):hover {
                color: #004499;
                text-decoration: none;
            }

            .bot-message .chat-link:visited,
            .bot-message a:not(.chat-link):visited {
                color: #6c3483;
            }

        /* Table styling */
        .bot-message table {
            border-collapse: collapse;
            width: 100%;
            margin: 0.5em 0;
            display: block;
            overflow-x: auto;
        }

        .bot-message th,
        .bot-message td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
        }

        .bot-message th {
            background-color: #f2f2f2;
        }

    /* Image styling - Fits within chat without scroll */
    .chat-image-wrapper {
        margin: 0.75em 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        cursor: pointer;
        border-radius: 8px;
        overflow: hidden;
        background: #f5f5f5;
    }

        .chat-image-wrapper img {
            max-width: 100% !important;
            max-height: 200px !important;
            width: auto !important;
            height: auto !important;
            object-fit: contain !important;
            border-radius: 8px;
            cursor: pointer;
            transition: transform 0.2s ease;
            display: block;
        }

            .chat-image-wrapper img:hover {
                transform: scale(1.02);
            }

    /* Video styling */
    .chat-video-wrapper {
        margin: 0.75em 0;
        display: flex;
        justify-content: center;
    }

        .chat-video-wrapper video {
            max-width: 100%;
            max-height: 200px;
            border-radius: 8px;
        }

    /* Image Popup Modal Styles */
    .image-popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.95);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        animation: fadeIn 0.3s ease;
    }

    .image-popup-container {
        position: relative;
        max-width: 90vw;
        max-height: 90vh;
        animation: zoomIn 0.3s ease;
    }

    .image-popup-content {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: auto;
        max-width: 90vw;
        max-height: 85vh;
    }

    .image-popup-container img {
        max-width: 100%;
        max-height: 85vh;
        object-fit: contain;
        border-radius: 8px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    }

    .image-popup-close {
        position: absolute;
        top: -40px;
        right: 0;
        background: none;
        border: none;
        color: white;
        font-size: 32px;
        cursor: pointer;
        padding: 8px;
        transition: transform 0.2s ease;
        z-index: 10001;
    }

        .image-popup-close:hover {
            transform: scale(1.1);
        }

    .image-popup-zoom-controls {
        position: absolute;
        bottom: -50px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 16px;
        background: rgba(0, 0, 0, 0.7);
        padding: 8px 16px;
        border-radius: 32px;
        z-index: 10001;
    }

    .zoom-btn {
        background: none;
        border: none;
        color: white;
        font-size: 24px;
        cursor: pointer;
        padding: 4px 12px;
        transition: all 0.2s ease;
        border-radius: 4px;
    }

        .zoom-btn:hover {
            background: rgba(255, 255, 255, 0.2);
            transform: scale(1.05);
        }

    .reset-btn {
        background: none;
        border: none;
        color: white;
        font-size: 16px;
        cursor: pointer;
        padding: 4px 12px;
        transition: all 0.2s ease;
        border-radius: 4px;
    }

        .reset-btn:hover {
            background: rgba(255, 255, 255, 0.2);
        }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes zoomIn {
        from {
            transform: scale(0.8);
            opacity: 0;
        }

        to {
            transform: scale(1);
            opacity: 1;
        }
    }

    /* Responsive */
    @media (max-width: 768px) {
        .chat-image-wrapper img {
            max-height: 150px !important;
        }

        .chat-video-wrapper video {
            max-height: 150px;
        }

        .bot-message {
            font-size: 14px;
        }

        .image-popup-zoom-controls {
            bottom: -40px;
        }

        .zoom-btn {
            font-size: 20px;
            padding: 2px 8px;
        }
    }

    @media (max-width: 480px) {
        .due-expense-wrapper {
            min-width: 0;
            width: 100%;
            max-width: 100%;
        }

        .due-expense-list-header {
            padding: 12px 14px;
        }

        .due-expense-header {
            padding: 11px 14px 7px;
        }

        .due-expense-body {
            padding: 0 14px 11px;
        }
    }
</style>

<style>
    .checklist-popup-mode #app {
        padding-top: 0px !important;
    }

    .progress-height {
        height: auto !important;
    }

    .checklist-popup-mode #app .page-body-wrapper {
        padding: 0px;
        background: #ffffff !important;
        border: none;
    }

    .progress {
        border-radius: 50px !important;
        font-size: 15px;
        background: #fff !important;
        border: 1px solid #5178dd !important;
        text-align: left;
        text-indent: 10px;
    }

    .progress-bar-gradient {
        background: #5178dd !important;
        text-align: left !important;
        text-indent: 10px;
    }

    .checklist-popup-mode .page-body-wrapper .page-body {
        margin-top: 0px !important;
        background: #fff !important;
    }

    .onboarding-page {
        padding: 0px !important;
    }

    .step-header {
        padding: 5px !important;
        border-bottom: 1px solid #f4f5f7 !important;
    }

    .card.step-item .card-body {
        padding: 0px 10px !important;
    }

    .step-header:hover {
        background: #f4f5f7 !important;
    }

    .step-number {
        width: 35px !important;
        height: 35px !important;
        border: 1px solid #e4e8eb;
    }

    .step-circle-pending i {
        display: none !important;
    }

    div.step-circle-completed {
        background: #059669;
        border-color: #059669;
    }

    .step-circle-completed i {
        font-size: 21px;
        color: #fff !important;
    }

    /* ==================== ROOT VARIABLES ==================== */
    :root {
        --clr-primary: #111827; /* dark navy — header, buttons */
        --clr-accent: #e8960e; /* golden amber — highlights */
        --clr-accent-light: #fef3d0;
        --clr-bg: #f0ebe0; /* warm cream background */
        --clr-surface: #ffffff; /* white cards */
        --clr-bot-bubble: #f5f0e8; /* warm off-white for bot messages */
        --clr-text: #1a1f2e;
        --clr-text-muted: #6b7280;
        --clr-border: #e2ddd6;
        --clr-success: #16a34a;
        --clr-danger: #dc2626;
        --radius-pill: 22px;
        --radius-card: 14px;
        --shadow-card: 0 2px 10px rgba(17,24,39,0.10);
    }
    /* Global styles - not scoped */
    /*   * {
         box-sizing: border-box;
         font-family: 'Poppins', sans-serif;
     }*/

    /* Chat Icon */
    .chat-bot-icon {
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 9999;
        cursor: pointer;
    }

    .bot-icon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        box-shadow: 0 6px 20px rgba(0,0,0,0.35);
        pointer-events: none;
        user-select: none;
        -webkit-user-drag: none;
    }

    .chat-bot-icon.is-dragging {
        cursor: grabbing;
        transition: none;
    }

    /* Chat Container */
    .chat-container {
        position: fixed;
        bottom: 90px;
        right: 20px;
        width: 500px; /* slightly wider for better look */
        height: 560px;
        background-color: var(--clr-bg); /* fallback color */
        background-image: url("https://appfilemedia.talygen.com/Upload/UnifiedCommunication/b924ddd1-eb57-4b6a-b526-c3741726c174.png");
        background-size: cover; /* important */
        background-position: center; /* important */
        background-repeat: no-repeat;
        border-radius: 18px;
        box-shadow: 0 15px 50px rgba(0, 0, 0, 0.25);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        z-index: 99999;
        border: 1px solid rgba(255,255,255,0.6); /* subtle border */
    }

        .chat-container.open {
            transform: translateY(0);
        }

        .chat-container .chat-input {
            display: flex;
            gap: 5px;
            position: absolute;
            bottom: 0;
            width: 100%;
            background: var(--clr-surface);
            padding: 6px 16px;
            border-top: 2px solid var(--clr-border);
            border-radius: 0 0 10px 10px;
        }
    /* Header */
    .chat-header {
        background: #122341;
        color: #fff;
        padding: 12px 14px;
        display: flex;
        align-items: center;
        gap: 10px;
    }

        .chat-header .bot-avatar {
            width: 38px;
            height: 38px;
            border-radius: 50%;
        }

        .chat-header .title {
            font-size: 14px;
            font-weight: 500;
        }

        .chat-header span {
            display: block;
            font-size: 11px;
            opacity: 0.8;
        }

    .close-btn {
        margin-left: auto;
        background: none;
        border: none;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
    }

    /* Messages */
    .chat-messages {
        flex: 1;
        padding: 16px;
        overflow-y: auto;
        padding-bottom: 80px;
        scroll-behavior: auto !important;
        /*        background: #fff;*/
    }

    .welcome-card {
        display: flex;
        align-items: center;
        gap: 10px;
        background: #fff;
        border-radius: 12px;
        padding: 10px 14px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        max-width: 280px;
        margin: 10px;
    }


    .welcome-bot-img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
        flex-shrink: 0;
    }

    .welcome-card-content {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .welcome-title {
        font-size: 12px;
        font-weight: 700;
        color: #1a1a2e;
        margin: 0;
    }

    .welcome-text {
        font-size: 12px;
        color: #4b5563;
        margin: 0;
        line-height: 1.5;
    }

        .welcome-text strong {
            color: #3b4fc4;
            font-weight: 700;
        }

    .welcome-card p {
        font-size: 13px;
        color: #333;
        line-height: 1.5;
        margin: 0;
    }

    /* Message Row */
    .message-row {
        display: flex;
        margin-bottom: 12px;
        align-items: flex-end;
    }

        .message-row.bot {
            justify-content: flex-start;
        }

        .message-row.user {
            justify-content: flex-end;
        }

    .bot-avatar-msg {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 8px;
    }

    /* Bubbles */
    .message {
        max-width: 88%;
        padding: 10px 14px;
        font-size: 13px;
        line-height: 1.45;
    }

    .bot-message {
        background: white;
        color: #333;
        border-radius: 14px 14px 14px 0px;
        overflow-x: hidden;
    }

    .user-message {
        background: #122341;
        color: #ffffff;
        border-radius: 14px;
    }

    /* Typing Indicator */
    .typing-indicator {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 6px;
    }

        .typing-indicator span {
            width: 6px;
            height: 6px;
            background: #999;
            border-radius: 50%;
            animation: blink 1.4s infinite both;
        }

            .typing-indicator span:nth-child(2) {
                animation-delay: .2s
            }

            .typing-indicator span:nth-child(3) {
                animation-delay: .4s
            }

    @keyframes blink {
        0% {
            opacity: .2
        }

        20% {
            opacity: 1
        }

        100% {
            opacity: .2
        }
    }

    /* Input */
    .chat-input {
        display: flex;
        align-items: center;
        padding: 10px;
        background: #f2f2f2 !important;
        border-top: 1px solid #ddd;
    }

        .chat-input textarea {
            flex: 1;
            resize: none;
            border: none !important;
            outline: none;
            font-size: 13px;
            height: 40px;
            background: #f2f2f2 !important;
        }

    .send-btn {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background: #122341;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    /* Online Status */
    .chat-header .status {
        display: flex !important;
        align-items: center;
        gap: 6px;
        font-size: 11px;
        opacity: 0.9;
    }

    .online-dot {
        width: 8px;
        height: 8px;
        background-color: #00d26a;
        border-radius: 50%;
        display: inline-block;
        box-shadow: 0 0 6px rgba(0, 210, 106, 0.9);
    }

    /* Mobile */
    @media (max-width: 480px) {
        .chat-container {
            width: 95%;
            right: 2.5%;
            height: 92vh;
            bottom: 7px;
        }
    }

    .meeting-flow-card {
        background: var(--clr-surface);
        border-radius: var(--radius-card);
        overflow: visible !important;
        box-shadow: var(--shadow-card);
        min-width: 230px;
    }

    .meeting-flow-card {
        overflow: visible !important;
    }

    .meeting-flow-header {
        background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);
        color: #fff;
        padding: 12px 16px;
        display: flex;
        align-items: center;
        gap: 10px;
        border-bottom: 2px solid var(--clr-accent);
        border-radius: 14px;
    }

        .meeting-flow-header .mf-icon {
            font-size: 18px;
            flex-shrink: 0;
        }

        .meeting-flow-header span {
            font-size: 13px;
            font-weight: 600;
            line-height: 1.4;
        }

    .meeting-flow-hint {
        padding: 10px 16px 14px;
        font-size: 11px;
        color: var(--clr-text-muted);
        display: flex;
        align-items: center;
        gap: 6px;
        border-top: 1px solid var(--clr-border);
    }



    .message.bot img:not(.bot-avatar):not(.menu-img):not(.carousel-image):not(.room-images),
    .markdown-content img {
        max-width: 100%;
        height: auto;
        border-radius: 6px;
        cursor: zoom-in;
        display: block;
        margin: 5px;
        transition: opacity 0.15s;
    }

        .message.bot img:not(.bot-avatar):not(.menu-img):not(.carousel-image):not(.room-images):hover,
        .markdown-content img:hover {
            opacity: 0.82;
        }
    /*
         .message.bot {
             background-color: var(--clr-surface);
             color: var(--clr-text);
             margin-right: auto;
             text-align: left;
             border-radius: 4px 18px 18px 18px;
             box-shadow: var(--shadow-card);
             padding: 10px 14px;
         }
     */
    .meeting-preview-card {
        background: var(--clr-surface);
        border-radius: var(--radius-card);
        overflow: hidden;
        box-shadow: var(--shadow-card);
        min-width: 240px;
        font-size: 12px;
    }

    .meeting-preview-header {
        background: linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65));
        color: #fff;
        padding: 14px 16px 12px;
        display: flex;
        align-items: center;
        gap: 10px;
    }

        .meeting-preview-header .mp-icon {
            font-size: 22px;
        }

        .meeting-preview-header h4 {
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: white;
        }

        .meeting-preview-header p {
            margin: 2px 0 0;
            font-size: 11px;
            opacity: 0.75;
        }

    .meeting-preview-number {
        background: var(--clr-accent);
        color: var(--clr-primary);
        font-size: 11px;
        font-weight: 700;
        padding: 3px 10px;
        border-radius: 20px;
        margin-left: auto;
        white-space: nowrap;
    }

    .meeting-preview-body {
        padding: 14px 16px;
    }

    .meeting-preview-row {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        padding: 7px 0;
        border-bottom: 1px solid var(--clr-border);
    }

        .meeting-preview-row:last-child {
            border-bottom: none;
        }

    .mp-label {
        font-weight: 600;
        color: var(--clr-text-muted);
        min-width: 90px;
        font-size: 11px;
        padding-top: 1px;
    }

    .mp-value {
        color: var(--clr-text);
        font-size: 12px;
        flex: 1;
        word-break: break-word;
    }

    .mp-status-badge {
        display: inline-block;
        padding: 2px 10px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 700;
        background: #d1fae5;
        color: #065f46;
    }

    .mp-status-failed {
        background: #fee2e2;
        color: #dc2626;
    }

    .meeting-preview-footer {
        background: #f8f6f2;
        padding: 10px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid var(--clr-border);
    }

        .meeting-preview-footer span {
            font-size: 11px;
            color: var(--clr-text-muted);
        }

        .meeting-preview-footer .mp-check {
            color: #16a34a;
            font-weight: 700;
            font-size: 13px;
        }

        .meeting-preview-footer .mp-failed {
            color: #dc2626;
            font-weight: 700;
            font-size: 13px;
        }

    .meeting-preview-error {
        background: #fff5f5;
        border-top: 1px solid #fecaca;
        padding: 10px 16px;
        display: flex;
        gap: 8px;
        align-items: flex-start;
    }

        .meeting-preview-error .mp-err-icon {
            font-size: 15px;
            flex-shrink: 0;
        }

        .meeting-preview-error p {
            margin: 0;
            font-size: 11px;
            color: #dc2626;
            line-height: 1.5;
        }

    .mp-zoom-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: #6498f2;
        color: #fff;
        text-decoration: none;
        border-radius: 8px;
        padding: 5px 12px;
        font-size: 11px;
        font-weight: 600;
        transition: background 0.15s;
    }

        .mp-zoom-btn:hover {
            background: #1a6fd4;
            color: #fff;
        }
    /* ── Ticket menu card ── */
    .ticket-menu-card {
        background: #fff;
        border-radius: 14px;
        padding: 16px 18px;
        box-shadow: 0 2px 10px rgba(11,74,63,0.10);
        min-width: 220px;
    }

        .ticket-menu-card p {
            margin: 0 0 14px;
            font-size: 13px;
            color: #333;
            font-weight: 500;
        }

    .ticket-menu-actions {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .ticket-menu-btn {
        display: flex;
        align-items: center;
        gap: 10px;
        border: none;
        border-radius: 22px;
        padding: 11px 18px;
        font-size: 13px;
        font-family: 'Poppins', sans-serif;
        font-weight: 600;
        cursor: pointer;
        transition: transform 0.15s, box-shadow 0.15s;
        width: 100%;
        text-align: left;
    }

        .ticket-menu-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .ticket-menu-btn:active {
            transform: translateY(0);
        }

        .ticket-menu-btn.btn-guide {
            background: #f0faf7;
            border: 2px solid var(--clr-primary);
            color: var(--clr-primary);
        }

        .ticket-menu-btn.btn-create {
            background: var(--clr-primary);
            border: 2px solid var(--clr-primary);
            color: #ffffff;
        }

        .ticket-menu-btn .btn-icon {
            font-size: 18px;
        }

    /* ── Ticket preview card ── */
    .ticket-preview-card {
        background: var(--clr-surface);
        border-radius: var(--radius-card);
        overflow: hidden;
        box-shadow: var(--shadow-card);
        min-width: 240px;
        font-size: 12px;
    }

    .ticket-preview-header {
        background: linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65));
        color: #fff;
        padding: 14px 16px 12px;
        display: flex;
        align-items: center;
        gap: 10px;
    }

        .ticket-preview-header .tp-icon {
            font-size: 22px;
        }

        .ticket-preview-header h4 {
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: white;
        }

        .ticket-preview-header p {
            margin: 2px 0 0;
            font-size: 11px;
            opacity: 0.75;
        }

    .ticket-preview-number {
        background: var(--clr-accent);
        color: var(--clr-primary);
        font-size: 11px;
        font-weight: 700;
        padding: 3px 10px;
        border-radius: 20px;
        margin-left: auto;
        white-space: nowrap;
    }

    .ticket-preview-body {
        padding: 14px 16px;
    }

    .ticket-preview-row {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        padding: 7px 0;
        border-bottom: 1px solid var(--clr-border);
    }

        .ticket-preview-row:last-child {
            border-bottom: none;
        }

    .tp-label {
        font-weight: 600;
        color: var(--clr-text-muted);
        min-width: 78px;
        font-size: 11px;
        padding-top: 1px;
    }

    .tp-value {
        color: var(--clr-text);
        font-size: 12px;
        flex: 1;
        word-break: break-word;
        text-align: end;
    }

    .tp-priority-badge {
        display: inline-block;
        padding: 2px 10px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 700;
    }

    .tp-priority-critical {
        background: #fee2e2;
        color: #dc2626;
    }

    .tp-priority-high {
        background: #ffedd5;
        color: #ea580c;
    }

    .tp-priority-medium {
        background: #fef9c3;
        color: #b45309;
    }

    .tp-priority-low {
        background: #dcfce7;
        color: #16a34a;
    }

    .tp-status-badge {
        display: inline-block;
        padding: 2px 10px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 700;
        background: #dbeafe;
        color: #1d4ed8;
        border: none !important;
    }

    .ticket-preview-footer {
        background: #f8f6f2;
        padding: 10px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid var(--clr-border);
    }

        .ticket-preview-footer span {
            font-size: 11px;
            color: var(--clr-text-muted);
        }

        .ticket-preview-footer .tp-check {
            color: #16a34a;
            font-weight: 700;
            font-size: 13px;
        }

        .ticket-preview-footer .tp-failed {
            color: #dc2626;
            font-weight: 700;
            font-size: 13px;
        }

    .tp-status-failed {
        background: #fee2e2;
        color: #dc2626;
    }

    .ticket-preview-error {
        background: #fff5f5;
        border-top: 1px solid #fecaca;
        padding: 10px 16px;
        display: flex;
        gap: 8px;
        align-items: flex-start;
    }

        .ticket-preview-error .tp-err-icon {
            font-size: 15px;
            flex-shrink: 0;
        }

        .ticket-preview-error p {
            margin: 0;
            font-size: 11px;
            color: #dc2626;
            line-height: 1.5;
        }
    /* ── Ticket flow card (questions + options) ── */
    .ticket-flow-card {
        background: var(--clr-surface);
        border-radius: 14px 14px 14px 0px;
        overflow: hidden;
        box-shadow: var(--shadow-card);
        min-width: 230px;
    }

    .ticket-flow-header {
        background: white;
        color: black;
        padding: 12px 16px;
        display: flex;
        align-items: center;
        gap: 10px;
    }

        .ticket-flow-header .tf-icon {
            font-size: 18px;
            flex-shrink: 0;
        }

        .ticket-flow-header span {
            font-size: 13px;
            line-height: 1.4;
        }

    .ticket-flow-options {
        padding: 10px 12px;
        display: flex;
        flex-direction: column;
        gap: 7px;
    }

    .ticket-option-btn {
        background: #f8f8f8;
        border: 1.5px solid var(--clr-border);
        color: var(--clr-text);
        border-radius: 10px;
        padding: 11px 14px;
        font-size: 13px;
        font-family: 'Poppins', sans-serif;
        font-weight: 500;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: background 0.18s, color 0.18s, border-color 0.18s, transform 0.12s, box-shadow 0.18s;
        width: 100%;
        text-align: left;
    }

        .ticket-option-btn:hover {
            background: var(--clr-primary);
            border-color: var(--clr-primary);
            color: #ffffff;
            transform: translateX(4px);
            box-shadow: 0 4px 12px rgba(17,24,39,0.18);
        }

        .ticket-option-btn:active {
            transform: translateX(2px);
        }

        .ticket-option-btn .tf-arrow {
            font-size: 14px;
            opacity: 0.4;
            transition: opacity 0.15s;
        }

        .ticket-option-btn:hover .tf-arrow {
            opacity: 1;
        }

    .ticket-flow-hint {
        padding: 10px 16px 14px;
        font-size: 11px;
        color: var(--clr-text-muted);
        display: flex;
        align-items: center;
        gap: 6px;
        border-top: 1px solid var(--clr-border);
    }



    .message.bot.ticket-message {
        padding: 4px 6px;
        background: transparent;
        box-shadow: none;
    }

    .ticket-flow-card {
        background: var(--clr-surface);
        border-radius: var(--radius-card);
        overflow: hidden;
        box-shadow: var(--shadow-card);
        min-width: 230px;
    }



    .ticket-flow-header .tf-icon {
        font-size: 18px;
        flex-shrink: 0;
    }



    .ticket-flow-options {
        padding: 10px 12px;
        display: flex;
        flex-direction: column;
        gap: 7px;
    }

    .ticket-option-btn {
        background: #f8f8f8;
        border: 1.5px solid var(--clr-border);
        color: var(--clr-text);
        border-radius: 10px;
        padding: 11px 14px;
        font-size: 13px;
        font-family: 'Poppins', sans-serif;
        font-weight: 500;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: background 0.18s, color 0.18s, border-color 0.18s, transform 0.12s, box-shadow 0.18s;
        width: 100%;
        text-align: left;
    }

        .ticket-option-btn:hover {
            background: var(--clr-primary);
            border-color: var(--clr-primary);
            color: #ffffff;
            transform: translateX(4px);
            box-shadow: 0 4px 12px rgba(17,24,39,0.18);
        }

        .ticket-option-btn:active {
            transform: translateX(2px);
        }

        .ticket-option-btn .tf-arrow {
            font-size: 14px;
            opacity: 0.4;
            transition: opacity 0.15s;
        }

        .ticket-option-btn:hover .tf-arrow {
            opacity: 1;
        }

    .ticket-flow-hint {
        padding: 10px 16px 14px;
        font-size: 11px;
        color: var(--clr-text-muted);
        display: flex;
        align-items: center;
        gap: 6px;
        border-top: 1px solid var(--clr-border);
    }

    .ticket-flow-hint-meta {
        padding: 0 16px 14px;
        font-size: 10px;
        color: var(--clr-text-muted);
        line-height: 1.5;
    }

    .ticket-cancel-inline {
        display: inline;
        background: none;
        border: none;
        color: var(--clr-primary);
        text-decoration: underline;
        cursor: pointer;
        font: inherit;
        font-weight: 600;
        padding: 0;
        margin-left: 6px;
    }

    /* ── Ticket flow: asset list as stacked cards (same pattern as work-type options) ── */
    .ticket-asset-picker {
        padding: 0;
        font-size: 12px;
        font-family: 'Poppins', sans-serif;
        background: var(--clr-surface);
    }

    .ticket-asset-loading {
        text-align: center;
        color: var(--clr-text-muted);
        font-size: 11px;
        padding: 14px 16px;
    }

    .ticket-asset-picker .ticket-asset-error {
        text-align: center;
        color: var(--clr-danger);
        font-size: 11px;
        padding: 14px 16px;
    }

    .ticket-asset-loaded {
        display: flex;
        flex-direction: column;
        gap: 0;
        padding-bottom: 4px;
    }

    .ticket-asset-search-wrap {
        padding: 12px 12px 10px;
    }

    .ticket-asset-search {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #e0e0e0;
        border-radius: 12px;
        padding: 12px 16px;
        font-size: 13px;
        font-weight: 500;
        font-family: 'Poppins', sans-serif;
        color: var(--clr-text);
        background: #f9f9f9;
        text-align: left;
        transition: border-color 0.15s, box-shadow 0.15s;
    }

        .ticket-asset-search::placeholder {
            color: var(--clr-text-muted);
            text-align: left;
            font-weight: 400;
        }

        .ticket-asset-search:focus {
            outline: none;
            border-color: var(--clr-accent);
            background: var(--clr-surface);
            box-shadow: 0 0 0 2px rgba(232, 150, 14, 0.15);
        }
    /* Matches reference: spaced cards with arrow — extends .ticket-option-btn */
    .ticket-asset-options {
        display: flex;
        flex-direction: column;
        gap: 9px;
        padding: 4px 12px 18px;
        /* Use most of the viewport so short master lists show every row; long lists scroll inside */
        max-height: clamp(280px, calc(100vh - 200px), 900px);
        overflow-y: auto;
        overflow-x: hidden;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        scrollbar-color: #c4c0b8 #f5f5f5;
    }

    .ticket-option-btn.ticket-asset-card {
        background: #f8f8f8;
        border: 1px solid #e0e0e0;
        border-radius: 14px;
        padding: 16px 18px;
        font-size: 13px;
        font-weight: 600;
        color: #333;
    }

        .ticket-option-btn.ticket-asset-card .tf-arrow {
            color: #9ca3af;
            font-weight: 400;
        }

        .ticket-option-btn.ticket-asset-card:hover .tf-arrow {
            color: #fff;
            opacity: 1;
        }

    .ticket-asset-options::-webkit-scrollbar {
        width: 8px;
    }

    .ticket-asset-options::-webkit-scrollbar-thumb {
        background: #c4c0b8;
        border-radius: 4px;
    }

    .ticket-asset-picker .ticket-asset-fallback.ticket-flow-hint {
        margin-top: 6px;
        padding-top: 12px;
        justify-content: center;
        text-align: center;
    }

    /* ── Images inside bot chat bubbles ── */


    /* ── Image lightbox overlay ── */
    #imagePopupOverlay {
        display: none;
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.88);
        z-index: 99999;
        align-items: center;
        justify-content: center;
        cursor: zoom-out;
    }

        #imagePopupOverlay.active {
            display: flex;
        }

        #imagePopupOverlay #popupImage {
            max-width: 90vw;
            max-height: 90vh;
            object-fit: contain;
            border-radius: 10px;
            box-shadow: 0 8px 40px rgba(0,0,0,0.7);
            cursor: default;
        }

    #imagePopupClose {
        position: fixed;
        top: 14px;
        right: 22px;
        color: #fff;
        font-size: 36px;
        font-weight: 300;
        line-height: 1;
        cursor: pointer;
        background: none;
        border: none;
        z-index: 100000;
        text-shadow: 0 2px 6px rgba(0,0,0,0.6);
    }

        #imagePopupClose:hover {
            color: #f55;
        }

    .ticket-flow-hint-meta {
        margin-top: 8px;
        padding: 8px 12px;
        background: #fff8e1;
        border-left: 3px solid #f9a825;
        border-radius: 6px;
        font-size: 12px;
        color: #555;
        line-height: 1.5;
    }

    .ticket-cancel-inline {
        display: inline;
        background: none;
        border: none;
        color: #d32f2f;
        font-weight: 600;
        font-size: 12px;
        cursor: pointer;
        padding: 0;
        text-decoration: underline;
    }

        .ticket-cancel-inline:hover {
            color: #b71c1c;
        }

    .meeting-asset-skip-wrap {
        width: 100%;
        margin-bottom: 10px;
    }

    .meeting-asset-skip-btn {
        width: 100%;
        display: block;
        padding: 10px 16px;
        background: transparent;
        border: 2px dashed #cbd5e1;
        border-radius: 10px;
        color: #64748b;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        text-align: center;
        transition: all 0.2s ease;
    }

        .meeting-asset-skip-btn:hover {
            border-color: #94a3b8;
            background: #f1f5f9;
            color: #475569;
        }

    .due-expense-wrapper {
        display: flex;
        flex-direction: column;
        gap: 0;
        width: 100%;
        min-width: 300px;
        max-width: 390px;
        background: #ffffff;
        padding: 0;
        border: 1px solid rgba(203, 213, 225, 0.75);
        border-radius: 14px;
        overflow: hidden;
        box-sizing: border-box;
        box-shadow: 0 8px 24px rgba(15, 35, 65, 0.14);
    }

    .due-expense-list-header {
        width: 100%;
        min-height: 58px;
        padding: 12px 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        background: linear-gradient(135deg, #163f73 0%, #102a4d 100%);
        color: #ffffff;
        font-size: 14px;
        font-weight: 700;
    }

    .due-expense-count {
        min-width: 28px;
        height: 28px;
        padding: 0 7px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border: 1px solid rgba(255, 255, 255, 0.35);
        border-radius: 14px;
        color: #ffffff;
        font-size: 11px;
        font-weight: 600;
    }

    .due-expense-card {
        width: 100%;
        background: #ffffff;
        border: 0;
        border-bottom: 1px solid #e5e7eb;
        border-radius: 0;
        overflow: hidden;
        box-sizing: border-box;
    }

        .due-expense-card:last-child {
            border-bottom: 0;
        }

    .due-expense-header {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 12px 16px 8px;
        background: #ffffff;
        border-bottom: 0;
    }

    .due-expense-icon {
        font-size: 22px;
    }

    .due-expense-header-text {
        min-width: 0;
        flex: 1;
    }

    .due-expense-header h4 {
        margin: 0;
        font-size: 13px;
        font-weight: 700;
        line-height: 1.35;
        color: #1e2d45;
        word-break: break-word;
    }

    .due-expense-header p {
        margin: 3px 0 0;
        font-size: 11px;
        line-height: 1.35;
        color: #64748b;
        word-break: break-word;
    }

    .due-expense-status-badge {
        margin-left: auto;
        padding: 3px 10px;
        border-radius: 20px;
        font-size: 11px;
        font-weight: 600;
        background: #fff3cd;
        color: #856404;
    }

        .due-expense-status-badge.due-expense-status-pending {
            background: #fff3cd;
            color: #856404;
        }

        .due-expense-status-badge.due-expense-status-approved {
            background: #d1e7dd;
            color: #0a5c36;
        }

        .due-expense-status-badge.due-expense-status-rejected {
            background: #f8d7da;
            color: #842029;
        }

    .due-expense-body {
        padding: 0 16px 12px;
        display: flex;
        flex-direction: column;
        gap: 0;
    }

    .due-expense-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 13px;
        gap: 8px;
    }

    .due-expense-label {
        color: var(--color-text-secondary, #888);
        font-weight: 500;
        min-width: 120px;
        flex-shrink: 0;
    }

    .due-expense-value {
        color: var(--color-text-primary, #333);
        text-align: right;
        word-break: break-word;
    }

    .due-expense-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 16px;
        background: var(--color-background-tertiary, #f9f9f9);
        border-top: 1px solid var(--color-border-tertiary, #e0e0e0);
        font-size: 11px;
        color: var(--color-text-secondary, #888);
    }

    .due-expense-ref {
        font-weight: 500;
    }

    .tp-section-divider {
        border-top: 1px solid var(--color-border-tertiary, #e0e0e0);
        margin-top: 6px;
        padding-top: 8px;
    }

    .tp-section-label {
        font-weight: 600;
        color: var(--color-text-primary) !important;
        font-size: 12px;
    }

    .due-expense-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
    }

    .due-expense-list-header {
        width: 100%;
        min-height: 54px;
        padding: 11px 14px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        gap: 10px !important;
        box-sizing: border-box;
        background: linear-gradient( 135deg, #0f66b8 0%, #122341 100% ) !important;
        color: #ffffff !important;
        border-radius: 14px 14px 0 0;
        font-size: 14px !important;
        font-weight: 700 !important;
    }

    .due-expense-count {
        padding: 4px 9px !important;
        border-radius: 14px !important;
        background: #f5a500 !important;
        color: #111827 !important;
        font-size: 10px !important;
        font-weight: 700 !important;
    }

    .due-expense-card {
        background: var(--color-background-secondary, #fff);
        border: 1px solid var(--color-border-tertiary, #e0e0e0);
        border-radius: 12px;
        overflow: hidden;
    }

    .due-expense-header {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 10px 14px;
        background: var(--color-background-tertiary, #f9f9f9);
        border-bottom: 1px solid var(--color-border-tertiary, #e0e0e0);
    }

    .due-expense-icon {
        font-size: 20px;
        flex-shrink: 0;
        margin-top: 2px;
    }

    .due-expense-header-text {
        flex: 1;
        min-width: 0;
    }

        .due-expense-header-text h4 {
            margin: 0 0 2px;
            font-size: 13px;
            font-weight: 600;
            color: var(--color-text-primary);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .due-expense-header-text p {
            margin: 0;
            font-size: 11px;
            color: var(--color-text-secondary);
        }

    .due-expense-status-badge {
        flex-shrink: 0;
        padding: 3px 10px;
        border-radius: 20px;
        font-size: 11px;
        font-weight: 600;
    }

    .due-expense-status-pending {
        background: #fff3cd;
        color: #856404;
    }

    .due-expense-status-approved {
        background: #d1e7dd;
        color: #0a5c36;
    }

    .due-expense-status-rejected {
        background: #f8d7da;
        color: #842029;
    }

    .due-expense-body {
        padding: 10px 14px;
        display: flex;
        flex-direction: column;
        gap: 7px;
    }

    .due-expense-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 12px;
        gap: 8px;
    }

    .due-expense-label {
        color: var(--color-text-secondary, #888);
        font-weight: 500;
        min-width: 90px;
        flex-shrink: 0;
    }

    .due-expense-value {
        color: var(--color-text-primary, #333);
        text-align: right;
        word-break: break-word;
    }

    .due-expense-id {
        font-weight: 600;
    }


    .due-expense-total {
        color: #16a34a !important;
        font-weight: 700 !important;
    }

    .due-expense-share {
        color: #dc2626 !important;
        font-weight: 700 !important;
    }

    .due-expense-assetid {
        font-size: 10px;
        color: var(--color-text-secondary);
        word-break: break-all;
        text-align: right;
    }

    .due-expense-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 14px;
        background: var(--color-background-tertiary, #f9f9f9);
        border-top: 1px solid var(--color-border-tertiary, #e0e0e0);
        font-size: 11px;
        color: var(--color-text-secondary);
    }

    .due-expense-share-ref {
        font-weight: 500;
    }

    .tp-ticket-status-open {
        background: #d1e7dd;
        color: #0a5c36;
    }

    .tp-ticket-status-closed {
        background: #f8d7da;
        color: #842029;
    }

    .tp-ticket-status-pending {
        background: #fff3cd;
        color: #856404;
    }

    .tp-ticket-status-resolved {
        background: #cfe2ff;
        color: #084298;
    }


    .meeting-date-picker-wrap {
        padding: 10px;
        overflow: visible !important;
        position: relative;
    }

    .meeting-date-input {
        width: 100%;
        padding: 8px 12px;
        border: 1px solid var(--color-border-secondary, #ccc);
        border-radius: 8px;
        font-size: 13px;
        color: var(--color-text-primary);
        background: var(--color-background-secondary);
        outline: none;
    }

        .meeting-date-input:focus {
            border-color: var(--color-border-primary, #888);
        }

    .meeting-submit-btn {
        padding: 8px 16px;
        background: var(--color-background-tertiary, #f0f0f0);
        border: 1px solid var(--color-border-secondary, #ccc);
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
        color: var(--color-text-primary);
        cursor: pointer;
        transition: background 0.15s;
    }

        .meeting-submit-btn:hover:not(:disabled) {
            background: var(--color-border-secondary, #e0e0e0);
        }

        .meeting-submit-btn:disabled {
            opacity: 0.4;
            cursor: not-allowed;
        }


    .meeting-time-options {
        max-height: 200px;
        overflow-y: auto;
    }

    .meeting-time-picker-wrap {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 10px;
    }

    .meeting-time-field {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .meeting-time-label {
        font-size: 12px;
        font-weight: 500;
        color: var(--color-text-secondary);
    }

    .meeting-time-input {
        width: 100%;
        padding: 10px 12px;
        border: 1px solid var(--color-border-secondary, #ccc);
        border-radius: 8px;
        font-size: 14px;
        color: var(--color-text-primary);
        background: var(--color-background-secondary);
        outline: none;
        cursor: pointer;
        transition: border-color 0.15s;
    }

        .meeting-time-input:focus {
            border-color: var(--color-border-primary, #888);
        }

    .meeting-time-input-error {
        border-color: #d9534f !important;
    }

    .meeting-time-intervals {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;
    }

    .meeting-time-intervals-label {
        font-size: 11px;
        color: var(--color-text-secondary);
    }

    .meeting-time-chip {
        background: var(--color-background-tertiary, #f0f0f0);
        color: var(--color-text-secondary);
        border-radius: 20px;
        padding: 2px 8px;
        font-size: 11px;
        font-weight: 500;
    }

    .meeting-time-error {
        font-size: 12px;
        color: #d9534f;
        background: #fdf0f0;
        border: 1px solid #f5c6cb;
        border-radius: 6px;
        padding: 6px 10px;
    }

    .meeting-select-all-wrap {
        padding: 8px 4px;
        border-bottom: 1px solid var(--color-border-tertiary, #e0e0e0);
        margin-bottom: 6px;
    }

    .meeting-select-all-label {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        user-select: none;
        padding: 4px 0;
    }

    .meeting-select-all-checkbox,
    .meeting-participant-checkbox {
        width: 18px;
        height: 18px;
        border: 2px solid var(--color-border-secondary, #ccc);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 700;
        flex-shrink: 0;
        transition: all 0.15s;
        color: #fff;
        background: transparent;
    }

    .meeting-checkbox-checked {
        background: #4a90e2;
        border-color: #4a90e2;
    }

    .meeting-select-all-text {
        font-size: 13px;
        font-weight: 600;
        color: var(--color-text-primary);
    }

    .meeting-select-all-count {
        font-size: 11px;
        font-weight: 400;
        color: var(--color-text-secondary);
        margin-left: 4px;
    }

    .meeting-participant-list {
        display: flex;
        flex-direction: column;
        gap: 4px;
        max-height: 240px;
        overflow-y: auto;
    }

    .meeting-participant-row {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px 10px;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.12s;
        border: 1px solid transparent;
    }

        .meeting-participant-row:hover:not(.meeting-participant-disabled) {
            background: var(--color-background-tertiary, #f5f5f5);
        }

    .meeting-participant-selected {
        background: #eef4fd;
        border-color: #b8d4f5;
    }

    .meeting-participant-disabled {
        cursor: not-allowed;
        opacity: 0.85;
    }

    .meeting-participant-name {
        flex: 1;
        font-size: 13px;
        color: var(--color-text-primary);
    }

    .meeting-participant-lock {
        font-size: 11px;
        opacity: 0.5;
    }

    .meeting-participant-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 4px 4px;
        border-top: 1px solid var(--color-border-tertiary, #e0e0e0);
        margin-top: 6px;
    }

    .meeting-participant-summary {
        font-size: 12px;
        color: var(--color-text-secondary);
    }

    .mp-participant-chip {
        display: block;
        font-size: 12px;
        color: #374151;
        padding: 2px 0;
        line-height: 1.5;
    }

    .mp-read-more-btn {
        display: inline-block;
        margin-top: 6px;
        padding: 4px 10px;
        font-size: 11px;
        color: #3b82f6;
        background: #eff6ff;
        border: 1px solid #bfdbfe;
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.2s;
    }

        .mp-read-more-btn:hover {
            background: #dbeafe;
            color: #1d4ed8;
        }
    /* Attachment Upload Card */
    .attachment-upload-card {
        background: var(--card-bg, #fff);
        border: 1px solid var(--border-color, #e2e8f0);
        border-radius: 12px;
        overflow: hidden;
        max-width: 420px;
        font-size: 13px;
    }

    .attachment-upload-header {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 14px 16px;
        background: #1a273d;
        color: #fff;
    }

        .attachment-upload-header .au-icon {
            font-size: 22px;
            margin-top: 2px;
        }

        .attachment-upload-header h4 {
            margin: 0 0 2px;
            font-size: 14px;
            font-weight: 600;
            color: white;
        }

        .attachment-upload-header p {
            margin: 0;
            font-size: 12px;
            opacity: 0.85;
        }

    .attachment-upload-body {
        padding: 14px 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    /* Hide native input, style the label as a button */
    .au-file-input {
        display: none;
    }

    .au-file-label {
        cursor: pointer;
        display: inline-block;
    }

    .au-file-btn {
        display: inline-block;
        padding: 8px 16px;
        background: #f1f5f9;
        border: 1.5px dashed #94a3b8;
        border-radius: 8px;
        color: #475569;
        font-size: 13px;
        transition: background 0.2s;
    }

        .au-file-btn:hover {
            background: #e2e8f0;
        }

    .au-file-preview {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
    }

    .au-file-chip {
        background: #eff6ff;
        border: 1px solid #bfdbfe;
        color: #1d4ed8;
        border-radius: 20px;
        padding: 3px 10px;
        font-size: 11px;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .au-error {
        color: #dc2626;
        font-size: 12px;
        margin: 0;
    }

    .au-note {
        color: #94a3b8;
        font-size: 11px;
    }

    .attachment-upload-footer {
        display: flex;
        gap: 10px;
        padding: 12px 16px;
        border-top: 1px solid #f1f5f9;
        background: #fafafa;
    }

    .au-submit-btn {
        flex: 1;
        padding: 8px 14px;
        background: #1a273d;
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 13px;
        cursor: pointer;
        transition: background 0.2s;
    }

        .au-submit-btn:hover:not(:disabled) {
            background: #4f46e5;
        }

        .au-submit-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

    .au-skip-btn {
        padding: 8px 14px;
        background: transparent;
        color: #64748b;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        font-size: 13px;
        cursor: pointer;
        transition: background 0.2s;
    }

        .au-skip-btn:hover:not(:disabled) {
            background: #f1f5f9;
        }

        .au-skip-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

    .checklist-icon {
        position: fixed;
        bottom: 88px;
        right: 18px;
        z-index: 9999;
        width: 80px;
        height: 80px;
        padding: 0;
        border: none;
        border-radius: 50%;
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0 12px 28px rgba(8, 24, 56, 0.32);
        overflow: visible;
        transition: transform 0.22s ease, box-shadow 0.22s ease;
        animation: checklist-float-attention 2.8s ease-in-out infinite;
    }

    .checklist-icon__gif {
        width: 80px;
        height: 80px;
        display: block;
        border-radius: 50%;
        pointer-events: none;
        user-select: none;
        -webkit-user-drag: none;
    }

    @keyframes checklist-float-attention {
        0%, 100% {
            transform: translateY(0);
        }

        50% {
            transform: translateY(-5px);
        }
    }

    .checklist-icon:hover,
    .checklist-icon:focus-visible {
        transform: translateY(-3px) scale(1.06);
        box-shadow: 0 16px 34px rgba(8, 24, 56, 0.42);
        outline: none;
        animation: none;
    }

    .checklist-icon:active {
        transform: translateY(0) scale(0.97);
        animation: none;
    }

    .checklist-container {
        position: fixed;
        bottom: 168px;
        right: 20px;
        width: min(460px, calc(100vw - 26px));
        height: min(74vh, 620px);
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 22px 60px rgba(8, 19, 45, 0.32);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        z-index: 9999;
        border: 1px solid #e5eaf4;
        opacity: 0;
        transform: translateY(12px) scale(0.98);
        pointer-events: none;
        transition: opacity 0.22s ease, transform 0.22s ease;
    }

    .checklist-container--visible {
        opacity: 1;
        transform: translateY(0) scale(1);
        pointer-events: auto;
    }

    .checklist-header {
        background: linear-gradient(135deg, #122341 0%, #2b5aa8 100%);
        color: #fff;
        padding: 12px 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }

    .checklist-title-wrap {
        display: flex;
        align-items: center;
        gap: 10px;
        min-width: 0;
    }

    .checklist-header-icon {
        width: 34px;
        height: 34px;
        border-radius: 10px;
        display: grid;
        place-items: center;
        border: 1px solid rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.14);
        flex: 0 0 auto;
        font-size: 16px;
    }

    .checklist-header .title {
        font-size: 14px;
        font-weight: 700;
        line-height: 1.2;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .checklist-subtitle {
        display: block;
        margin-top: 2px;
        font-size: 11px;
        color: rgba(255, 255, 255, 0.82);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .checklist-close-btn {
        width: 30px;
        height: 30px;
        border-radius: 8px;
        border: 1px solid rgba(255, 255, 255, 0.28);
        background: rgba(255, 255, 255, 0.12);
        color: #fff;
        display: grid;
        place-items: center;
        cursor: pointer;
        flex: 0 0 auto;
    }

        .checklist-close-btn:hover {
            background: rgba(255, 255, 255, 0.2);
        }

    .checklist-body {
        flex: 1;
        background: #fff;
        padding: 0;
        position: relative;
        min-height: 0;
    }

    .checklist-body__loading {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background: #fff;
        color: #64748b;
        font-size: 13px;
        z-index: 1;
    }

    .checklist-body__spinner {
        width: 28px;
        height: 28px;
        border: 3px solid #e2e8f0;
        border-top-color: #2b5aa8;
        border-radius: 50%;
        animation: checklist-spin 0.7s linear infinite;
    }

    @keyframes checklist-spin {
        to {
            transform: rotate(360deg);
        }
    }

    .checklist-frame {
        width: 100%;
        height: 100%;
        border: 0;
        border-radius: 0;
        background: #fff;
        display: block;
    }

    .section-label {
        display: none;
    }

    .checklist-section-divider {
        height: 1px;
        margin: 12px 0;
        background: #e2e8f0;
    }

    #body {
        background: #fff !important;
    }

    .card {
        box-shadow: none !important;
        margin-bottom: 0px !important;
    }

        .card.step-item {
            margin-bottom: 0px !important;
        }

    @media (max-width: 767px) {
        .checklist-icon {
            right: 12px;
            bottom: 180px;
            width: 72px;
            height: 72px;
        }

        .checklist-icon__gif {
            width: 72px;
            height: 72px;
        }

        .checklist-container {
            right: 12px;
            bottom: 146px;
            width: calc(100vw - 24px);
            height: 72vh;
        }
    }

    .au-file-chip--green {
        background: #f0fdf4;
        border: 1px solid #86efac;
        color: #15803d;
    }

    .au-submit-btn--green {
        background: #1a273d;
    }

        .au-submit-btn--green:hover:not(:disabled) {
            background: #15803d;
        }

    /* Collected summary strip */
    .attachment-upload-summary {
        padding: 10px 16px;
        background: #f8fafc;
        border-bottom: 1px solid #e2e8f0;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .au-summary-row {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
    }

    .au-summary-label {
        color: #94a3b8;
        font-weight: 500;
    }

    .au-summary-value {
        color: #334155;
        font-weight: 600;
        text-align: right;
        max-width: 60%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .meeting-unselect-btn {
        padding: 5px 12px;
        background: #fff;
        color: #dc2626;
        border: 1.5px solid #fecaca;
        border-radius: 6px;
        font-size: 11px;
        font-weight: 500;
        cursor: pointer;
        white-space: nowrap;
        transition: background 0.15s;
        flex-shrink: 0;
    }

        .meeting-unselect-btn:hover {
            background: #fef2f2;
            border-color: #dc2626;
        }

    .ticket-search-hint {
        margin: 4px 0 0 2px;
        font-size: 11px;
        color: #94a3b8;
        font-style: italic;
    }

    .chat-input-disabled textarea {
        background: #f1f5f9;
        color: #94a3b8;
        cursor: not-allowed;
        border-color: #e2e8f0;
    }

    .chat-input-disabled .send-btn {
        background: #cbd5e1;
        cursor: not-allowed;
        pointer-events: none;
    }

    .chat-input-disabled {
        opacity: 0.7;
    }

    .tp-error-badge {
        background: #fee2e2 !important;
        color: #dc2626 !important;
        border: 1px solid #fca5a5;
        font-size: 11px;
        font-weight: 600;
    }

    .tp-error-simple {
        background: #fff7ed;
        border: 1px solid #fed7aa;
        border-radius: 8px;
        padding: 10px 12px;
        margin: 8px 0 0;
        display: flex;
        gap: 8px;
        align-items: flex-start;
    }

        .tp-error-simple p {
            margin: 0;
            font-size: 12px;
            color: #92400e;
            line-height: 1.5;
        }

    .au-thumb-preview {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin: 8px 0;
    }

    .au-thumb-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
    }

    .au-thumb-img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 8px;
        border: 2px solid #e2e8f0;
    }

    .au-thumb-name {
        font-size: 10px;
        color: #64748b;
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
    }

    .tp-info-box {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        background: #f0f9ff;
        border: 1px solid #bae6fd;
        border-radius: 8px;
        padding: 12px 14px;
        margin: 4px 0;
    }

    .tp-info-icon {
        font-size: 16px;
        flex-shrink: 0;
        margin-top: 1px;
    }

    .tp-info-box p {
        margin: 0;
        font-size: 13px;
        color: #0c4a6e;
        line-height: 1.5;
    }

    .exp-desc-wrap {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 10px;
    }

    .exp-desc-textarea {
        width: 100%;
        border: 1.5px solid #e0e4f0;
        border-radius: 8px;
        padding: 10px 12px;
        font-size: 13.5px;
        resize: vertical;
        outline: none;
        transition: border 0.2s;
        font-family: inherit;
    }

        .exp-desc-textarea:focus {
            border-color: #3b4fc4;
        }

    .exp-desc-meta {
        font-size: 12px;
        text-align: right;
    }

    .exp-wc-ok {
        color: #22c55e;
        font-weight: 600;
    }

    .exp-wc-danger {
        color: #ef4444;
        font-weight: 600;
    }

    .exp-desc-error {
        color: #ef4444;
        font-size: 12px;
        margin: 0;
    }

    .doc-upload-prompt {
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .doc-upload-question {
        font-size: 13.5px;
        color: #374151;
        font-weight: 500;
        margin: 0;
    }

    .doc-upload-btns {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .doc-btn {
        padding: 10px 16px;
        border-radius: 8px;
        font-size: 13.5px;
        font-weight: 600;
        border: none;
        cursor: pointer;
        text-align: left;
        transition: opacity 0.15s;
    }

        .doc-btn:hover {
            opacity: 0.85;
        }

    .doc-btn-yes {
        background: #1b283d;
        color: #fff;
    }

    .doc-btn-no {
        background: #f3f4f6;
        color: #374151;
        border: 1px solid #e5e7eb;
    }

    .meeting-blocked-card {
        background: #fff;
        border: 1.5px solid #fee2e2;
        border-radius: 12px;
        overflow: hidden;
        max-width: 420px;
        box-shadow: 0 4px 16px rgba(239,68,68,0.08);
    }

    .mb-header {
        display: flex;
        align-items: center;
        gap: 12px;
        background: #fef2f2;
        padding: 14px 16px;
        border-bottom: 1px solid #fee2e2;
    }

    .mb-icon {
        font-size: 1.8rem;
    }

    .mb-header h4 {
        margin: 0 0 2px 0;
        font-size: 15px;
        font-weight: 700;
        color: #b91c1c;
    }

    .mb-header p {
        margin: 0;
        font-size: 12px;
        color: #ef4444;
    }

    .mb-body {
        padding: 14px 16px;
    }

        .mb-body p {
            font-size: 13.5px;
            color: #4b5563;
            margin: 0;
            line-height: 1.6;
        }

    .mb-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 16px;
        background: #fef2f2;
        font-size: 12px;
        color: #9ca3af;
        border-top: 1px solid #fee2e2;
    }

    .mb-badge {
        color: #ef4444;
        font-weight: 600;
        font-size: 12px;
    }

    .expense-form-card {
        background: #fff;
        border-radius: 14px;
        box-shadow: 0 2px 12px rgba(0,0,0,0.10);
        overflow: hidden;
        max-width: 480px;
        font-family: inherit;
        font-size: 13px;
    }

    .ef-form-header {
        background: linear-gradient(135deg, #122341, #1e2d45);
        color: #fff;
        padding: 14px 18px;
        display: flex;
        align-items: center;
        gap: 10px;
        border-radius: 14px 14px 0 0;
    }

    .ef-form-icon {
        font-size: 22px;
    }

    .ef-form-header h4 {
        margin: 0 0 2px 0;
        font-size: 14px;
        font-weight: 700;
        color: white;
    }

    .ef-form-header p {
        margin: 0;
        font-size: 11px;
        opacity: 0.8;
    }

    .ef-form-body {
        padding: 16px 18px;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .ef-form-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }

    .ef-form-field {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .ef-form-full {
        grid-column: 1 / -1;
    }

    .ef-form-field label {
        font-weight: 600;
        font-size: 11px;
        color: #555;
    }

    .ef-required {
        color: #ef4444;
    }

    .ef-form-optional {
        color: #9ca3af;
        font-weight: 400;
    }

    .ef-input {
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 8px 10px;
        font-size: 13px;
        font-family: inherit;
        outline: none;
        transition: border 0.2s;
        width: 100%;
        box-sizing: border-box;
    }

        .ef-input:focus {
            border-color: #3b4fc4;
        }

    .ef-textarea {
        resize: vertical;
        min-height: 60px;
    }

    .ef-voting-section {
        background: #fffbeb;
        border: 1px solid #fde68a;
        border-radius: 10px;
        padding: 12px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .ef-voting-badge {
        font-size: 11px;
        color: #b45309;
        font-weight: 600;
    }

    .ef-form-error {
        color: #ef4444;
        font-size: 12px;
        margin: 0;
    }

    .ef-form-submit {
        background: #122341;
        color: #fff;
        border: none;
        border-radius: 10px;
        padding: 12px;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        font-family: inherit;
        transition: opacity 0.15s;
    }

        .ef-form-submit:hover {
            opacity: 0.9;
        }

        .ef-form-submit:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }

    .ef-file-remove {
        margin-left: 6px;
        cursor: pointer;
        color: #ef4444;
        font-weight: 700;
        font-size: 11px;
    }

        .ef-file-remove:hover {
            opacity: 0.7;
        }

    .chat-error-box {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        background: #fff7ed;
        border: 1px solid #fed7aa;
        border-radius: 12px;
        padding: 12px 14px;
        max-width: 100%;
    }

    .chat-error-icon {
        font-size: 20px;
        flex-shrink: 0;
        margin-top: 2px;
    }

    .chat-error-text {
        flex: 1;
    }

        .chat-error-text strong {
            font-size: 13px;
            color: #92400e;
            display: block;
            margin-bottom: 2px;
        }

        .chat-error-text p {
            margin: 0;
            font-size: 12px;
            color: #b45309;
            line-height: 1.5;
        }

    .chat-error-retry {
        flex-shrink: 0;
        background: #f97316;
        color: white;
        border: none;
        border-radius: 8px;
        padding: 6px 10px;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        white-space: nowrap;
        align-self: center;
        transition: background 0.2s;
    }

        .chat-error-retry:hover {
            background: #ea580c;
        }

    .meeting-date-formatted {
        font-size: 12px;
        color: #6366f1;
        font-weight: 600;
        margin: 4px 0 8px;
        padding: 4px 10px;
        background: #eef2ff;
        border-radius: 6px;
        display: inline-block;
    }
    /* Calendar input wrapper */
    .meeting-calendar-input {
        width: 100% !important;
        display: block !important;
    }

        .meeting-calendar-input .p-datepicker {
            width: 260px !important;
            min-width: unset !important;
            font-size: 11px !important;
            padding: 6px !important;
            position: absolute !important;
            z-index: 9999 !important;
            left: 0 !important;
            right: unset !important;
            box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
            border-radius: 10px !important;
        }

        .meeting-calendar-input .p-datepicker-header {
            padding: 4px 6px !important;
            font-size: 12px !important;
        }

        .meeting-calendar-input .p-datepicker-title {
            font-size: 12px !important;
            font-weight: 600 !important;
        }

        .meeting-calendar-input .p-datepicker-prev,
        .meeting-calendar-input .p-datepicker-next {
            width: 24px !important;
            height: 24px !important;
        }

        .meeting-calendar-input .p-datepicker table {
            font-size: 11px !important;
        }

            .meeting-calendar-input .p-datepicker table td {
                padding: 1px !important;
            }

                .meeting-calendar-input .p-datepicker table td > span {
                    width: 28px !important;
                    height: 28px !important;
                    font-size: 11px !important;
                    border-radius: 50% !important;
                }

            .meeting-calendar-input .p-datepicker table th {
                padding: 2px !important;
                font-size: 10px !important;
            }

        .meeting-calendar-input .p-inputtext {
            font-size: 12px !important;
            padding: 8px 10px !important;
            border-radius: 8px !important;
            border: 1.5px solid #e2e8f0 !important;
            width: 100% !important;
        }

            .meeting-calendar-input .p-inputtext:focus {
                border-color: #6366f1 !important;
                box-shadow: none !important;
                outline: none !important;
            }

        .meeting-calendar-input .p-highlight {
            background: #6366f1 !important;
            color: white !important;
        }

        .meeting-calendar-input .p-disabled {
            opacity: 0.4 !important;
            cursor: not-allowed !important;
        }

        .meeting-calendar-input.p-calendar {
            width: 100% !important;
            display: block !important;
        }

        .meeting-calendar-input .p-datepicker {
            width: 100% !important;
            min-width: unset !important;
            position: static !important; /* inline — no floating */
            box-shadow: none !important;
            border: 1px solid #e2e8f0 !important;
            border-radius: 10px !important;
            font-size: 11px !important;
            padding: 6px !important;
        }

        .meeting-calendar-input .p-datepicker-header {
            padding: 4px 6px !important;
            font-size: 12px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
        }

        .meeting-calendar-input .p-datepicker-title {
            font-size: 12px !important;
            font-weight: 600 !important;
        }

        .meeting-calendar-input .p-datepicker-prev,
        .meeting-calendar-input .p-datepicker-next {
            width: 24px !important;
            height: 24px !important;
            display: flex !important;
            cursor: pointer !important;
        }

        .meeting-calendar-input .p-datepicker table {
            width: 100% !important;
            font-size: 11px !important;
        }

            .meeting-calendar-input .p-datepicker table th {
                padding: 2px !important;
                font-size: 10px !important;
                text-align: center !important;
            }

            .meeting-calendar-input .p-datepicker table td {
                padding: 1px !important;
                text-align: center !important;
            }

                .meeting-calendar-input .p-datepicker table td > span {
                    width: 28px !important;
                    height: 28px !important;
                    font-size: 11px !important;
                    border-radius: 50% !important;
                    display: inline-flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                }

        .meeting-calendar-input .p-highlight {
            background: #6366f1 !important;
            color: white !important;
        }

        .meeting-calendar-input .p-disabled {
            opacity: 0.4 !important;
            cursor: not-allowed !important;
        }
    /* ─── Expense Form Calendar — fit inside card ───────────────────────── */
    .expense-calendar-input .p-datepicker {
        width: 260px !important;
        min-width: unset !important;
        font-size: 11px !important;
        padding: 6px !important;
        position: absolute !important;
        z-index: 9999 !important;
        box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
        border-radius: 10px !important;
    }

    .expense-calendar-input .p-datepicker-header {
        padding: 4px 6px !important;
        font-size: 12px !important;
    }

    .expense-calendar-input .p-datepicker-title {
        font-size: 12px !important;
        font-weight: 600 !important;
    }

    .expense-calendar-input .p-datepicker-prev,
    .expense-calendar-input .p-datepicker-next {
        width: 24px !important;
        height: 24px !important;
    }

    .expense-calendar-input .p-datepicker table {
        font-size: 11px !important;
    }

        .expense-calendar-input .p-datepicker table td {
            padding: 1px !important;
        }

            .expense-calendar-input .p-datepicker table td > span {
                width: 26px !important;
                height: 26px !important;
                font-size: 11px !important;
                border-radius: 50% !important;
            }

        .expense-calendar-input .p-datepicker table th {
            padding: 2px !important;
            font-size: 10px !important;
        }

    .expense-calendar-input .p-inputtext {
        font-size: 12px !important;
        padding: 8px 10px !important;
        border-radius: 8px !important;
        width: 100% !important;
    }

    .expense-calendar-input .p-highlight {
        background: #6366f1 !important;
        color: white !important;
    }

    .expense-calendar-input .p-disabled {
        opacity: 0.4 !important;
        cursor: not-allowed !important;
    }
    /* Allow calendar popups to overflow their containers */
    .expense-form-card {
        overflow: visible !important;
    }

    .ef-form-body {
        overflow: visible !important;
    }

    .ef-form-row {
        overflow: visible !important;
    }

    .ef-form-field {
        overflow: visible !important;
        position: relative;
    }
    /* Fix inline calendar navigation arrows */
    .meeting-calendar-input .p-datepicker-prev,
    .meeting-calendar-input .p-datepicker-next {
        width: 24px !important;
        height: 24px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        cursor: pointer !important;
        pointer-events: all !important;
        z-index: 10 !important;
        position: relative !important;
        background: transparent !important;
        border: none !important;
        border-radius: 50% !important;
        transition: background 0.15s !important;
    }

        .meeting-calendar-input .p-datepicker-prev:hover,
        .meeting-calendar-input .p-datepicker-next:hover {
            background: #e2e8f0 !important;
        }

        /* Make sure the icon inside is also clickable */
        .meeting-calendar-input .p-datepicker-prev span,
        .meeting-calendar-input .p-datepicker-next span,
        .meeting-calendar-input .p-datepicker-prev .p-icon,
        .meeting-calendar-input .p-datepicker-next .p-icon {
            pointer-events: none !important;
            display: flex !important;
        }

    /* Ensure header doesn't block clicks */
    .meeting-calendar-input .p-datepicker-header {
        pointer-events: all !important;
        position: relative !important;
        z-index: 5 !important;
    }

    /* Ensure nothing overlaps the nav buttons */
    .meeting-calendar-input .p-datepicker-title {
        pointer-events: none !important;
    }

    .meeting-date-picker-wrap .expense-calendar-input .p-datepicker {
        bottom: 100% !important;
        top: unset !important;
        left: 0 !important;
        border-radius: 14px !important;
        box-shadow: 0 -4px 20px rgba(0,0,0,0.15) !important;
    }

    .meeting-preview-actions {
        display: flex;
        gap: 10px;
        padding: 12px 16px;
        background: #f8fafc;
        border-top: 1px solid #e2e8f0;
    }

    .meeting-confirm-btn {
        flex: 1;
        background: linear-gradient(135deg, #0f5aa4, #122341);
        color: #fff;
        border: none;
        border-radius: 10px;
        padding: 12px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        transition: opacity 0.2s;
    }

        .meeting-confirm-btn:hover {
            opacity: 0.9;
        }

    .meeting-cancel-btn {
        flex: 1;
        background: #f1f5f9;
        color: #dc2626;
        border: 2px solid #dc2626;
        border-radius: 10px;
        padding: 12px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s;
    }

        .meeting-cancel-btn:hover {
            background: #fee2e2;
        }
    /* ─── Meeting Conflict Card ──────────────────────────────────────── */
    .meeting-conflict-card {
        background: #fff8f0;
        border: 1px solid #f59e0b;
        border-left: 4px solid #f59e0b;
        border-radius: 14px 14px 14px 0px;
        padding: 14px 16px;
        max-width: 420px;
        font-size: 0.875rem;
    }

    .mc-header {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        margin-bottom: 12px;
    }

    .mc-icon {
        font-size: 1.4rem;
        line-height: 1;
    }



    .mc-header h4 {
        margin: 0 0 2px;
        font-size: 0.95rem;
        font-weight: 700;
        color: #92400e;
    }

    .mc-header p {
        margin: 0;
        font-size: 0.8rem;
        color: #b45309;
    }

    .mc-conflict-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 14px;
    }

    .mc-conflict-row {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        background: #fff3e0;
        border-radius: 8px;
        padding: 8px 10px;
    }

    .mc-conflict-icon {
        font-size: 1rem;
        margin-top: 2px;
    }

    .mc-conflict-title {
        font-size: 0.875rem;
        color: #1a1a1a;
        display: block;
        margin-bottom: 2px;
    }

    .mc-conflict-details {
        margin: 0;
        font-size: 0.78rem;
        color: #666;
    }

    .mc-suggestion {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        background: #fef3c7;
        border-radius: 8px;
        padding: 8px 12px;
        font-size: 0.82rem;
        color: #78350f;
        line-height: 1.5;
    }

        .mc-suggestion p {
            margin: 0;
        }

        .mc-suggestion strong {
            color: #92400e;
        }

    .mc-actions {
        display: flex;
        gap: 8px;
        padding: 10px 14px 14px;
    }

    .mc-btn {
        flex: 1;
        border: none;
        border-radius: 10px;
        padding: 10px;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        font-family: inherit;
        transition: opacity 0.2s;
    }

        .mc-btn:hover {
            opacity: 0.88;
        }

    .mc-btn-proceed {
        background: linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65));
        color: #fff;
    }

    .mc-btn-change {
        background: #f1f5f9;
        color: #1e40af;
        border: 2px solid #1e40af;
    }
    /* ── Meeting Reprompt Card ── */
    .meeting-reprompt-card {
        background: #fff;
        border-radius: 14px 14px 14px 0px;
        box-shadow: 0 4px 15px rgba(0,0,0,0.08);
        overflow: hidden;
        max-width: 420px;
        border: 1px solid #e2e8f0;
    }

    .mr-header {
        background: white;
        padding: 16px 18px;
        display: flex;
        align-items: flex-start;
        gap: 12px;
    }

    .mr-icon {
        font-size: 28px;
        flex-shrink: 0;
        margin-top: 2px;
    }

    .mr-header h4 {
        margin: 0 0 6px 0;
        font-size: 15px;
    }

    .mr-header p {
        margin: 0;
        font-size: 13px;
        opacity: 0.95;
        line-height: 1.4;
    }

    .mr-body {
        padding: 16px 18px;
        background: #f8fafc;
    }

    .mr-hint {
        background: #f0f9ff;
        border: 1px solid #bae6fd;
        border-radius: 10px;
        padding: 14px;
        font-size: 13px;
        color: #1e40af;
        line-height: 1.5;
    }

    .mr-footer {
        padding: 12px 18px;
        background: #f1f5f9;
        text-align: center;
        font-size: 12px;
        color: #64748b;
        border-top: 1px solid #e2e8f0;
    }

    .meeting-preview-card {
        border-radius: 14px 14px 14px 0px;
        overflow: hidden;
        border: 1px solid var(--clr-border, #e5e7eb);
        max-width: 420px;
        background: #fff;
    }

    .meeting-preview-header {
        background: linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65));
        padding: 12px 16px;
        display: flex;
        align-items: center;
        gap: 10px;
        color: #fff;
    }

        .meeting-preview-header h4 {
            margin: 0;
            font-size: 14px;
            font-weight: 600;
        }

    .mp-icon {
        font-size: 1.3rem;
    }

    .meeting-preview-body {
        padding: 0 16px 12px;
    }

        .meeting-preview-body.empty-state {
            padding: 16px;
            text-align: center;
            color: var(--clr-text-muted, #9ca3af);
            font-size: 0.85rem;
        }

    .meeting-list-item {
        padding: 12px;
        border-bottom: 1px solid var(--clr-border, #e5e7eb);
    }

        .meeting-list-item.no-border {
            border-bottom: none;
        }

    .meeting-row-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 8px;
    }

    .meeting-row-main {
        flex: 1;
    }

    .meeting-title {
        font-weight: 600;
        font-size: 13px;
        color: var(--clr-text, #111);
        line-height: 1.3;
    }

    .meeting-time {
        font-size: 11px;
        color: var(--clr-text-muted, #6b7280);
        margin-top: 3px;
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .meeting-toggle-btn {
        background: none;
        border: none;
        color: var(--clr-accent, #2563eb);
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        padding: 4px 8px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 4px;
        margin-top: -2px;
    }

    .chevron {
        font-size: 8px;
        display: inline-block;
        transition: transform 0.2s;
    }

        .chevron.open {
            transform: rotate(180deg);
        }

    .meeting-details-panel {
        padding-top: 8px;
        margin-top: 8px;
        border-top: 1px dashed var(--clr-border, #e5e7eb);
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .mp-row {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        padding: 3px 0;
        font-size: 12px;
    }

    .mp-label {
        min-width: 70px;
        color: var(--clr-text-muted, #6b7280);
        font-weight: 500;
        flex-shrink: 0;
    }

    .mp-value {
        color: var(--clr-text, #111);
        text-align: end;
    }

    .mp-zoom-btn {
        background: #518cf5;
        color: #fff;
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 11px;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-weight: 600;
    }

        .mp-zoom-btn:hover {
            opacity: 0.85;
        }

    .meeting-list-item {
        padding: 12px;
    }

    .ml-item-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 8px;
    }

    .ml-item-main {
        flex: 1;
    }

    .ml-item-title {
        font-size: 13.5px;
        font-weight: 600;
        color: #1e293b;
        line-height: 1.3;
    }

    .ml-item-time {
        font-size: 12px;
        color: #64748b;
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .ml-toggle-btn {
        background: none;
        border: none;
        color: #3b82f6;
        font-size: 11.5px;
        font-weight: 600;
        cursor: pointer;
        padding: 4px 8px;
        border-radius: 6px;
        white-space: nowrap;
    }

        .ml-toggle-btn:hover {
            background: #eff6ff;
        }

    .ml-item-details {
        padding-top: 10px;
        margin-top: 8px;
        border-top: 1px dashed #e2e8f0;
    }

    .tp-subtitle {
        margin: 2px 0 0;
        font-size: 0.75rem;
        opacity: 0.8;
    }

    .tp-ticket-status-open {
        background: #dbeafe;
        color: #1d4ed8;
        border: none;
    }

    .tp-ticket-status-closed {
        background: #dcfce7;
        color: #15803d;
        border: none;
    }

    .tp-ticket-status-pending {
        background: #fef9c3;
        color: #a16207;
        border: none;
    }

    .tp-ticket-status-resolved {
        background: #cfe2ff;
        color: #084298;
        border: none;
    }

    .tp-ticket-status-inprogress {
        background: #ede9fe;
        color: #6d28d9;
        border: none;
    }

    .tp-ticket-status-assigned {
        background: #dcfce7;
        color: #15803d;
        border: none;
    }

    .tp-ticket-status-unassigned {
        background: #fee2e2;
        color: #dc2626;
        border: none;
    }

    .ticket-not-found-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 20px 16px;
        gap: 8px;
    }

    .ticket-not-found-icon {
        font-size: 2rem;
        margin-bottom: 4px;
        opacity: 0.7;
    }

    .ticket-not-found-title {
        margin: 0;
        font-size: 0.95rem;
        font-weight: 700;
        color: #dc2626;
    }

    .ticket-not-found-desc {
        margin: 0;
        font-size: 0.8rem;
        color: #6b7280;
        line-height: 1.5;
    }

    .ticket-not-found-hint {
        margin-top: 6px;
        background: #fef3c7;
        border: 1px solid #fcd34d;
        border-radius: 8px;
        padding: 8px 12px;
        font-size: 0.78rem;
        color: #92400e;
        width: 100%;
    }

    .tp-failed {
        color: #dc2626;
        font-size: 0.75rem;
        font-weight: 600;
    }






    .mr-icon {
        font-size: 1.3rem;
    }

    .mr-body {
        padding: 14px 16px;
    }

        .mr-body p {
            margin: 0;
            font-size: 0.85rem;
            color: #374151;
            line-height: 1.6;
        }

    .mr-footer {
        padding: 8px 16px;
        border-top: 1px solid #f3f4f6;
        font-size: 0.75rem;
        color: #9ca3af;
    }

    .meeting-text {
        white-space: pre-line;
        line-height: 1.7;
    }

    .expense-form-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 18px rgba(0,0,0,0.12);
        overflow: hidden;
        max-width: 380px;
        font-size: 13px;
        font-family: inherit;
    }

    .ef-header {
        background: linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65));
        color: #fff;
        padding: 14px 18px;
        display: flex;
        align-items: center;
        gap: 10px;
        border-radius: 14px 14px 0px 0px;
    }

    .ef-icon {
        font-size: 1.4rem;
    }

    .ef-header h4 {
        margin: 0;
        font-size: 14px;
        font-weight: 700;
        color: white;
    }

    .ef-subtitle {
        margin: 2px 0 0;
        font-size: 11px;
        opacity: 0.8;
    }

    .ef-body {
        padding: 12px 18px;
        display: flex;
        flex-direction: column;
        gap: 0;
    }

    .ef-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        padding: 8px 0;
        gap: 8px;
    }

    .ef-label {
        font-size: 11px;
        font-weight: 600;
        color: #888;
        min-width: 90px;
        flex-shrink: 0;
    }

    .ef-value {
        font-size: 12px;
        font-weight: 600;
        color: #1e2d45;
        text-align: right;
    }

    .ef-required {
        color: #dc2626;
    }

    .ef-optional {
        color: #aaa;
        font-size: 10px;
        font-weight: 400;
    }

    .ef-select {
        border: 1.5px solid #cbd5e1;
        border-radius: 8px;
        padding: 5px 8px;
        font-size: 12px;
        color: #1e2d45;
        background: #f8fafc;
        max-width: 180px;
        cursor: pointer;
        font-family: inherit;
    }

    .ef-voting-section {
        background: #fffbeb;
        border: 1px solid #fde68a;
        border-radius: 10px;
        padding: 10px 12px;
        margin: 8px 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .ef-voting-banner {
        font-size: 11px;
        color: #b45309;
        font-weight: 700;
        margin-bottom: 4px;
    }

    .ef-input-group {
        padding: 8px 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
        border-bottom: 1px solid #f0f0f0;
    }

    .ef-input-label {
        font-size: 11px;
        font-weight: 600;
        color: #888;
    }

    .ef-input {
        border: 1.5px solid #cbd5e1;
        border-radius: 8px;
        padding: 7px 10px;
        font-size: 12px;
        color: #1e2d45;
        background: #f8fafc;
        font-family: inherit;
        width: 100%;
        box-sizing: border-box;
    }

    .ef-textarea {
        border: 1.5px solid #cbd5e1;
        border-radius: 8px;
        padding: 8px 10px;
        font-size: 12px;
        color: #1e2d45;
        background: #f8fafc;
        font-family: inherit;
        width: 100%;
        box-sizing: border-box;
        resize: vertical;
        min-height: 60px;
    }

    .ef-attach-section {
        padding: 10px 0 4px;
    }

    .ef-attach-btn {
        background: #f1f5f9;
        border: 1.5px solid #cbd5e1;
        border-radius: 8px;
        padding: 8px 12px;
        font-size: 12px;
        font-weight: 600;
        color: #1e2d45;
        cursor: pointer;
        font-family: inherit;
        width: 100%;
        text-align: left;
    }

        .ef-attach-btn:hover {
            background: #e2e8f0;
        }

    .ef-attach-optional {
        color: #aaa;
        font-size: 10px;
        font-weight: 400;
        margin-left: 4px;
    }

    .ef-file-list {
        margin-top: 8px;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .ef-file-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f0fdf4;
        border: 1px solid #bbf7d0;
        border-radius: 6px;
        padding: 5px 10px;
        font-size: 11px;
    }

    .ef-file-name {
        color: #166534;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 240px;
    }

    .ef-file-remove {
        background: none;
        border: none;
        color: #dc2626;
        cursor: pointer;
        font-size: 12px;
        padding: 0 4px;
        flex-shrink: 0;
    }

    .ef-error {
        color: #dc2626;
        font-size: 11px;
        margin: 6px 0 0;
        padding: 6px 10px;
        background: #fef2f2;
        border-radius: 6px;
        border: 1px solid #fecaca;
    }

    .ef-footer {
        padding: 10px 18px 14px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .ef-submit-btn {
        background: linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65));
        color: #fff;
        border: none;
        border-radius: 10px;
        padding: 11px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        font-family: inherit;
        width: 100%;
        transition: opacity 0.2s;
    }

        .ef-submit-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }

        .ef-submit-btn:not(:disabled):hover {
            opacity: 0.88;
        }

    .ef-cancel-btn {
        background: none;
        border: none;
        color: #aaa;
        font-size: 12px;
        cursor: pointer;
        font-family: inherit;
        text-decoration: underline;
        text-align: center;
    }

    .mp-participant-row {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 0;
        cursor: pointer;
        font-size: 12px;
        border-bottom: 1px solid #f0f0f0;
    }

    .mp-participant-cb {
        width: 15px;
        height: 15px;
        cursor: pointer;
        accent-color: #0f60ad;
        flex-shrink: 0;
    }

    .mp-participant-hint {
        font-size: 10px;
        color: #999;
        margin-top: 4px;
    }

    .headerforstatus {
        background: linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65)) !important;
        color: white !important;
    }

    /* Ticket Status Update - isolated form styling only */
    .ticket-status-update-form {
        width: 100%;
        max-width: 360px;
        background: #ffffff;
        border: 1px solid #dbe3ec;
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 6px 18px rgba(15, 35, 65, 0.12);
        box-sizing: border-box;
    }

    .ticket-status-update-form__header {
        width: 100%;
        padding: 12px 14px;
        background: linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65));
        color: #ffffff;
        font-size: 13px;
        font-weight: 700;
        line-height: 1.35;
        box-sizing: border-box;
    }

    .ticket-status-update-form__body {
        padding: 12px;
        background: #ffffff;
        box-sizing: border-box;
    }

    .ticket-status-update-question {
        background: #ffffff;
        color: #1f2937;
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        padding: 12px 13px;
        font-size: 13px;
        line-height: 1.5;
        margin-bottom: 10px;
        box-sizing: border-box;
    }

    .ticket-status-update-options {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }

    .ticket-status-update-option {
        width: 100%;
        min-height: 42px;
        padding: 10px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        background: #ffffff;
        color: #1f2937;
        border: 1px solid #d7dce3;
        border-radius: 10px;
        font-family: inherit;
        font-size: 13px;
        font-weight: 600;
        text-align: left;
        box-sizing: border-box;
        transition: background .15s ease, border-color .15s ease;
    }

        .ticket-status-update-option:hover:not(:disabled) {
            background: #f0f7ff;
            border-color: #0f66b8;
        }

        .ticket-status-update-option:disabled {
            cursor: not-allowed;
        }

    .ticket-status-update-option__arrow {
        flex: 0 0 auto;
        color: #a8b0bb;
        font-size: 14px;
        font-weight: 700;
    }

    .chat-history-divider {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 12px 0;
    }

        .chat-history-divider span {
            background: #f1f5f9;
            color: #94a3b8;
            font-size: 11px;
            font-weight: 600;
            padding: 4px 12px;
            border-radius: 20px;
            white-space: nowrap;
        }

    /*        booking asset css*/
    .booking-preview-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 18px rgba(0,0,0,0.12);
        overflow: hidden;
        font-family: inherit;
        width: 100%;
        max-width: 360px;
    }

    .booking-preview-header {
        background: linear-gradient(135deg, rgb(15, 102, 184), rgb(18, 35, 65));
        color: #fff;
        padding: 14px 18px;
        display: flex;
        align-items: center;
        gap: 10px;
    }

        .booking-preview-header h4 {
            margin: 0;
            font-size: 14px;
            font-weight: 700;
        }

        .booking-preview-header p {
            margin: 2px 0 0;
            font-size: 11px;
            opacity: 0.85;
        }

    .bp-icon {
        font-size: 22px;
    }

    .booking-preview-number {
        margin-left: auto;
        background: rgba(255,255,255,0.18);
        padding: 3px 10px;
        border-radius: 20px;
        font-size: 11px;
        font-weight: 700;
        white-space: nowrap;
    }

    .bp-error-badge {
        background: rgba(255,255,255,0.25);
    }

    .booking-preview-body {
        padding: 12px 18px;
    }

    .booking-preview-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        padding: 8px 0;
        gap: 10px;
    }

        .booking-preview-row:last-child {
            border-bottom: none;
        }

    .bp-label {
        color: #888;
        font-size: 11px;
        font-weight: 600;
        min-width: 80px;
    }

    .bp-value {
        color: #1e2d45;
        font-weight: 600;
        font-size: 12px;
        text-align: right;
    }

    .booking-preview-footer {
        background: #f8f6f2;
        padding: 10px 18px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #e2ddd6;
        font-size: 11px;
    }

    .bp-check {
        color: #16a34a;
        font-weight: 700;
    }

    .bp-failed {
        color: #dc2626;
        font-weight: 700;
    }

    .bp-pending {
        color: #f59e0b;
        font-weight: 700;
    }

    .booking-preview-error {
        background: #fef2f2;
        border: 1px solid #fecaca;
        border-radius: 8px;
        padding: 10px;
        margin: 0 16px 12px;
        font-size: 12px;
        color: #dc2626;
        display: flex;
        align-items: flex-start;
        gap: 8px;
    }

    .bp-err-icon {
        flex-shrink: 0;
    }

    .mp-read-more-btn {
        background: none;
        border: none;
        color: var(--clr-accent, #0f66b8);
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        padding: 4px 0;
        text-align: left;
    }

        .mp-read-more-btn:hover {
            text-decoration: underline;
        }

    .doc-esign-toggle-btn {
        min-width: 38px;
        min-height: 20px;
        padding: 1px 9px;
        border-radius: 10px;
        font-size: 10px;
        font-weight: 600;
        line-height: 1.2;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .doc-esign-toggle-btn--yes {
        background: #dcfce7;
        color: #16a34a;
        border: 1px solid #86efac;
    }

    .doc-esign-toggle-btn--no {
        background: #fee2e2;
        color: #dc2626;
        border: 1px solid #fecaca;
    }

    .doc-esign-toggle-btn:hover:not(:disabled) {
        filter: brightness(0.97);
    }

    .doc-esign-toggle-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .tp-worktype-edit-wrap {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 3px;
        width: 58%;
    }

    .tp-worktype-edit-select {
        width: 100%;
        min-height: 30px;
        padding: 4px 28px 4px 8px;
        border: 1px solid #cbd5e1;
        border-radius: 6px;
        background: #ffffff;
        color: #1e2d45;
        font-size: 11px;
        font-weight: 500;
        outline: none;
        cursor: pointer;
    }

        .tp-worktype-edit-select:focus {
            border-color: #1e2d45;
            box-shadow: 0 0 0 2px rgba(30, 45, 69, 0.08);
        }

        .tp-worktype-edit-select:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }

    .tp-worktype-edit-error {
        color: #dc2626;
        font-size: 9px;
        line-height: 1.2;
        text-align: right;
    }

    .doc-esign-mandatory-btn {
        min-height: 20px;
        padding: 1px 8px;
        border: 1px solid #fdba74;
        border-radius: 10px;
        background: #fff7ed;
        color: #c2410c;
        font-size: 10px;
        font-weight: 600;
        line-height: 1.2;
        cursor: pointer;
    }

    .doc-esign-mandatory-btn--yes {
        background: #fff7ed;
        color: #d97706;
        border-color: #fdba74;
    }

    .doc-esign-mandatory-btn--no {
        background: #f8fafc;
        color: #94a3b8;
        border-color: #cbd5e1;
    }

    .doc-esign-mandatory-btn:hover:not(:disabled) {
        background: #ffedd5;
        border-color: #fb923c;
    }

    .doc-esign-mandatory-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .confirm-modal-overlay {
        position: fixed;
        inset: 0;
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
        background: rgba(0, 0, 0, 0.48);
    }

    .confirm-modal-card {
        width: min(380px, calc(100vw - 32px));
        max-width: 380px;
        background: #ffffff;
        border-radius: 6px;
        overflow: hidden;
        box-shadow: 0 8px 28px rgba(0, 0, 0, 0.30);
        text-align: left;
    }

    .confirm-modal-header {
        min-height: 42px;
        display: flex;
        align-items: center;
        padding: 10px 14px;
        box-sizing: border-box;
        background: #132a4e;
        color: #ffffff;
        font-size: 16px;
        font-weight: 600;
        line-height: 1.3;
    }

    .confirm-modal-body {
        padding: 20px 14px 10px;
        background: #ffffff;
    }

    .confirm-modal-message {
        margin: 0;
        color: #222222;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.5;
    }

    .confirm-modal-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 9px;
        margin-top: 20px;
    }

    .confirm-modal-btn {
        min-width: 90px;
        height: 34px;
        padding: 6px 16px;
        border: 0;
        border-radius: 3px;
        font-size: 14px;
        font-weight: 600;
        line-height: 1;
        cursor: pointer;
    }

    .confirm-modal-ok {
        background: #132a4e;
        color: #ffffff;
    }

        .confirm-modal-ok:hover {
            background: #0f223f;
        }

    .confirm-modal-cancel {
        background: #cc3b30;
        color: #ffffff;
    }

        .confirm-modal-cancel:hover {
            background: #b83228;
        }

    @media (max-width: 600px) {
        .confirm-modal-overlay {
            padding: 24px 12px;
            align-items: center;
        }

        .confirm-modal-card {
            width: min(360px, calc(100vw - 24px));
            max-width: 360px;
        }

        .confirm-modal-header {
            font-size: 14px;
        }

        .confirm-modal-message {
            font-size: 13px;
        }

        .confirm-modal-actions {
            margin-top: 18px;
        }

        .confirm-modal-btn {
            min-width: 78px;
        }
    }

    @media (max-width: 1024px) {
        .checklist-icon.is-draggable {
            touch-action: none; /* only block page-scroll-while-dragging on mobile/tablet */
            cursor: grab;
        }

        .chat-bot-icon.is-draggable {
            touch-action: none;
            cursor: grab;
        }
    }

    .checklist-icon.is-dragging {
        cursor: grabbing;
        transition: none;
    }
    /* ============================
    Combined Dues - Match Modules
    ============================ */

    .combined-dues-card {
        width: 100%;
        max-width: 360px;
        background: #fff;
        border-radius: 14px;
        overflow: hidden;
        border: 1px solid #e5e7eb;
        box-shadow: 0 4px 14px rgba(15, 35, 64, 0.10);
    }

    .combined-dues-header {
        background: #132a4e;
        color: #fff;
        padding: 12px 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }

        .combined-dues-header h4 {
            margin: 0;
            color: #fff;
            font-size: 13px;
            font-weight: 700;
            line-height: 1.2;
        }

        .combined-dues-header p {
            margin: 3px 0 0;
            color: rgba(255, 255, 255, 0.78);
            font-size: 9px;
            line-height: 1.3;
        }

    .combined-dues-count {
        min-width: 28px;
        height: 28px;
        padding: 0 8px;
        border-radius: 50px;
        background: rgba(255, 255, 255, 0.18);
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        font-weight: 700;
    }

    .combined-dues-body {
        background: #fff;
        padding: 10px 12px 12px;
        max-height: 380px;
        overflow-y: auto;
    }

    .dues-section {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 9px;
        overflow: hidden;
        margin-bottom: 10px;
    }

        .dues-section:last-child {
            margin-bottom: 0;
        }

    .dues-section-header {
        background: #f8fafc;
        padding: 9px 11px;
        border-bottom: 1px solid #e5e7eb;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #1f2f46;
        font-size: 11px;
        font-weight: 700;
    }

        .dues-section-header > span:last-child {
            background: #132a4e;
            color: #fff;
            min-width: 23px;
            height: 21px;
            padding: 0 6px;
            border-radius: 20px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 9px;
            font-weight: 700;
        }

    .dues-item {
        padding: 9px 11px;
        border-bottom: 1px solid #edf0f4;
    }

        .dues-item:last-child {
            border-bottom: 0;
        }

    .dues-item-left strong {
        display: block;
        color: #1f2f46;
        font-size: 11px;
        font-weight: 600;
        line-height: 1.35;
    }

    .dues-item-left small {
        display: block;
        margin-top: 3px;
        color: #718096;
        font-size: 9.5px;
        line-height: 1.4;
    }

    .dues-amount {
        color: #132a4e;
        font-size: 11px;
        font-weight: 700;
        white-space: nowrap;
    }

    .combined-dues-body::-webkit-scrollbar {
        width: 5px;
    }

    .combined-dues-body::-webkit-scrollbar-thumb {
        background: #b8c1ce;
        border-radius: 10px;
    }
    /* Paid status */
    .due-expense-status-paid {
        background: #dcfce7 !important;
        color: #16a34a !important;
        border: 1px solid #86efac !important;
    }

    /* Unpaid status */
    .due-expense-status-unpaid {
        background: #fee2e2 !important;
        color: #dc2626 !important;
        border: 1px solid #fecaca !important;
    }

    .due-expense-total,
    .due-expense-share {
        color: #dc2626 !important;
        font-weight: 700 !important;
    }
    /* Document Vault prompt headers only */
    .document-vault-prompt-card .document-vault-blue-header {
        background: linear-gradient( 135deg, #0f66b8 0%, #122341 100% ) !important;
        color: #ffffff !important;
        padding: 12px 14px !important;
        border-radius: 12px 12px 0 0 !important;
        font-size: 13px;
        font-weight: 600;
        line-height: 1.4;
    }

        .document-vault-prompt-card .document-vault-blue-header span {
            color: #ffffff !important;
        }
    /* Document Vault - blue question header */
    .ticket-flow-header.document-vault-blue-header {
        background: linear-gradient( 135deg, #0f66b8 0%, #122341 100% ) !important;
        color: #ffffff !important;
        padding: 12px 16px !important;
    }


        .ticket-flow-header.document-vault-blue-header span {
            color: #ffffff !important;
        }
</style>